import React, { useEffect, useState, useCallback, useRef } from "react";
import ReactDOM from "react-dom/client";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PageHeader } from "@/components/Header";
import { Skeleton } from "@/components/ui/skeleton";
import { Textarea } from "@/components/ui/textarea";
// import Chatbot from "@/components/Chatbot";
// import CallingBot from "@/components/Callingbot";
import BotLauncher from "@/components/BotLauncher";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Fragment } from "react";
import { toast } from "sonner";
import { Listbox, Transition } from "@headlessui/react";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";
import { useToast } from "@/hooks/use-toast";
import { endpoints } from "@/config/apiEndpoints";
import axiosInstance from "@/config/axiosInstance";
import Pricing from "@/pages/Pricing";
import AddOnPage from "@/pages/AddOn";
import AssociationAddOn from "@/pages/AssociationAddOn";
import StripePaymentForm from "@/components/StripePaymentForm";
import { Loader2, CreditCard } from "lucide-react";
import { useMemo } from "react";
import FlyerTemplate, {
  type FlyerData,
} from "@/components/templates/FlyerTemplate";
import Template1 from "@/components/templates/Template1";
import Template2 from "@/components/templates/Template2";
import Template3 from "@/components/templates/Template3";
import Template4 from "@/components/templates/Template4";
import Template5 from "@/components/templates/Template5";
import Template6 from "@/components/templates/Template6";
import { useTimezone } from "@/contexts/TimezoneContext";
import { detectUserTimezone, normalizeTimezone } from "@/utils/timezoneDetection";
import html2canvas from "html2canvas";
import Template7 from "@/components/templates/Template7";
import Template8 from "@/components/templates/Template8";
import Template9 from "@/components/templates/Template9";
import Template10 from "@/components/templates/Template10";
import Template11 from "@/components/templates/Template11";

//Servics template
import ServiceTemplate1 from "@/components/ServiceTemplate/ServiceTemplate1";
import ServiceTemplate3 from "@/components/ServiceTemplate/ServiceTemplate3";
import ServiceTemplate2 from "@/components/ServiceTemplate/ServiceTemplate2";
import ServiceTemplate4 from "@/components/ServiceTemplate/ServiceTemplate4";
import { useNavigationWarning } from "@/hooks/useNavigationWarning";
import DraftDialog from "@/components/DraftDialog";
import { DraftProperty } from "@/services/draftService";
import campaignDraftService from "@/services/campaignDraftService";
import MultipleTemplateSelector from "@/components/MultiProperty";
import MultiPropertyPreviewPage from "@/components/MultiPropertyPreviewPage";
import MultipleServiceSelector from "@/components/MultiService";
import MultiServicePreviewPage from "@/components/MultiServicePreviewPage";
import {
  ArrowRight,
  ArrowLeft,
  Home,
  Briefcase,
  Upload,
  Star,
  Search,
  Send,
  Layout,
  Copy,
  RefreshCw,
  Plus,
  Type,
  User,
  MapPin,
  DollarSign,
  AlertCircle,
  Calendar,
  Eye,
  Check,
  Pencil,
  CheckCircle,
  Mail,
  Phone,
  Save,
  FileText,
  Layers,
  AlignLeft,
  Sparkles,
  Wand2,
  X,
  Lightbulb,
  CheckCircle2,
  Trash2,
  Info,
  Lock,
  AlertTriangle,
  Users,
  ShoppingCart,
  XCircle,
  Clock,
  ChevronLeft,
  ChevronRight
} from "lucide-react";
import heroPropertyImage from "@/assets/hero-property.jpg";
import heroproperties from "@/assets/hero-properties.jpg";
import landscaping from "@/assets/property-image.jpg";
import "../styles/fix-preview.css";
import "../styles/template-responsive.css";
// import { EmailEditor as UnlayerEditor } from "react-email-editor";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/dialog";
import axios from "axios";

import PropertyStep from "./PropertyStep";
import { ConfigQuiz } from "@/components/quiz/ConfigQuiz";
import ServiceStep from "../components/Servicestep";
interface PropertyCampaignData {
  address: string;
  mlsImport: boolean;
  description: string;
  agentInfo: string;
  price: string | number | null;
  campaignType: string;
  headline: string;
  image?: string;
  bedrooms?: number | null;
  bathrooms?: number | null;
  area?: number | null;
  text_section?: string;
  agentPhone?: string;
  agentEmail?: string;
  agentName?: string;
  heroImage?: string;
  secondaryImage?: string;
  photos?: string[];
  features?: { id?: number; feature_name: string }[];
}
interface ServiceCampaignData {
  title: string;
  serviceType: string;
  importFlyer: boolean;
  description: string;
  importImage: boolean;
  showCost: boolean;
  templateName?: string;
  service_type?: string;
  heroImage?: string;
  headline?: string;
  features: string[];
  phone?: string;
  email?: string;
  address?: string;
  website?: string;
  photos?: string[];
  image?: string;
  hero_image_url?: string;
}

interface EnhancedImageUpdatePayload {
  title: string;
  serviceType: string;
  importFlyer: boolean;
  description: string;
  importImage: boolean;
  showCost: boolean;
  templateName?: string;
  service_type?: string;
  heroImage?: string;
  headline?: string;
  features: string[];
  phone?: string;
  email?: string;
  address?: string;
  website?: string;
  photos?: string[];
}

interface EnhancedImageUpdatePayload {
  id: string | number;
  originalUrl: string;
  enhancedUrl: string;
  isHero: boolean;
}

interface PropertyData {
  price: number | null;
  address: string;
  state?: string;
  city?: string;
  bedrooms: number | null;
  bathrooms: number | null;
  area: number | null;
  description: string;
  text_section: string;
  headline: string;
  features: { id?: number; feature_name: string }[];
  heroImage: string;
  secondaryImage?: string;
  photos?: string[];
  agentName?: string;
  agentPhone?: string;
  agentEmail?: string;
  list_name?: string;
}
// (No duplicate ServiceCampaignData - consolidated above)
interface Property {
  id: number;
  title: string;
  address: string;
  price: number | null;
  bedrooms: number;
  bathrooms: number;
  sqft: number;
  property_type: string;
  status: string;
  image?: string;
  area: number;
  propertyListType?: {
    id: number;
    list_name: string;
  };
  created_at?: string;
  description?: string;
  text_section?: string;
  headline: string;
  // Optional default subject line stored with the property (backend)
  subject?: string;
  agentName?: string;
  agentPhone?: string;
  agentEmail?: string;
  agent?: { name: string; phone: string; email: string };
}
interface Template {
  id: number;
  name: string;
  category: string;
  style: string;
  rating: number;
  uses: number;
  tag: string;
  description: string;
  component: React.ComponentType<any>;
  photoCount: number;
}
interface State {
  id: number;
  state_name: string;
}
interface AgentList {
  id: string;
  name: string;
  count: number;
  agent_count?: number;
}
// Helper: wait for images inside an element to load
const waitForImages = (el: HTMLElement) => {
  const imgs = Array.from(el.querySelectorAll("img")) as HTMLImageElement[];
  if (!imgs.length) return Promise.resolve();
  return Promise.all(
    imgs.map(
      (img) =>
        new Promise<void>((res) => {
          if (img.complete) return res();
          img.onload = () => res();
          img.onerror = () => res();
        })
    )
  );
};

const shouldProxyCaptureImage = (url: string) => {
  if (!url || url.startsWith("data:") || url.startsWith("blob:")) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    return (
      parsed.hostname.includes("amazonaws.com") ||
      parsed.hostname.includes("mylistiq-production.s3")
    );
  } catch {
    return false;
  }
};

const getCaptureImageUrl = (url: string) => {
  if (!shouldProxyCaptureImage(url)) return url;
  return `${endpoints.image_proxy}?url=${encodeURIComponent(url)}`;
};

const rewriteCaptureImageUrls = (root: HTMLElement) => {
  const rewriteStyleUrls = (value: string) =>
    value.replace(/url\((['"]?)(.*?)\1\)/g, (_match, _quote, rawUrl) => {
      const trimmedUrl = String(rawUrl || "").trim();
      if (!trimmedUrl) return _match;
      return `url("${getCaptureImageUrl(trimmedUrl)}")`;
    });

  root.querySelectorAll("img").forEach((img) => {
    const src = img.getAttribute("src");
    if (src) {
      img.setAttribute("src", getCaptureImageUrl(src));
      img.setAttribute("crossorigin", "anonymous");
    }
    const srcset = img.getAttribute("srcset");
    if (srcset) {
      img.setAttribute(
        "srcset",
        srcset
          .split(",")
          .map((part) => {
            const [srcPart, ...descriptor] = part.trim().split(/\s+/);
            return [getCaptureImageUrl(srcPart), ...descriptor].join(" ");
          })
          .join(", ")
      );
    }
  });

  root.querySelectorAll<HTMLElement>("[background]").forEach((el) => {
    const background = el.getAttribute("background");
    if (background) {
      el.setAttribute("background", getCaptureImageUrl(background));
    }
  });

  root.querySelectorAll<HTMLElement>("[style]").forEach((el) => {
    const style = el.getAttribute("style");
    if (style && style.includes("url(")) {
      el.setAttribute("style", rewriteStyleUrls(style));
    }
  });
};

// Capture screenshot of provided HTML, upload to backend and return the URL
const captureTemplateScreenshot = async (
  htmlString: string
): Promise<string | null> => {
  try {
    const container = document.createElement("div");
    container.style.position = "fixed";
    container.style.left = "-9999px";
    container.style.top = "-9999px";
    // Use a wider capture area for better quality; templates often expect ~800-1200px
    container.style.width = "1200px";
    container.style.zIndex = "-9999";
    container.innerHTML = htmlString;
    container.style.height = "auto";
    container.style.overflow = "visible";
    rewriteCaptureImageUrls(container);
    document.body.appendChild(container);

    // Capture only the template root (first child) so we don't get surrounding markup
    const elementToCapture =
      (container.firstElementChild as HTMLElement) || container;
    // Ensure background is white for social posts and prevent clipping
    elementToCapture.style.background =
      elementToCapture.style.background || "#ffffff";
    elementToCapture.style.overflow =
      elementToCapture.style.overflow || "visible";

    await waitForImages(elementToCapture);

    const scale = Math.min(2, Math.max(1, window.devicePixelRatio || 1));
    const canvas = await html2canvas(elementToCapture as HTMLElement, {
      useCORS: true,
      scale,
      backgroundColor: "#ffffff",
      scrollY: -window.scrollY,
      windowWidth: (elementToCapture as HTMLElement).scrollWidth || 1200,
    });
    const blob: Blob | null = await new Promise((resolve) =>
      canvas.toBlob(resolve as any, "image/jpeg", 0.9)
    );
    if (!blob) {
      document.body.removeChild(container);
      return null;
    }

    // Build FormData for upload
    const fd = new FormData();
    const file = new File([blob], "screenshot.jpg", { type: "image/jpeg" });
    fd.append("image", file);
    const uploadUrl = endpoints.upload_generated_flyer || endpoints.upload_image;
    // Try fetch upload first (some environments prefer fetch for FormData)
    try {
      const fetchResp = await fetch(
        uploadUrl.replace(/127\.0\.0\.1:8000/, ""),
        {
          method: "POST",
          body: fd,
        }
      );
      if (fetchResp.ok) {
        const data = await fetchResp.json();
        if (data?.url) {
          document.body.removeChild(container);
          return data.url;
        }
      }
    } catch (err) {
      console.warn("[captureTemplateScreenshot] fetch upload failed", err);
    }

    // Fallback: try axiosInstance POST (helps when fetch has CORS quirks)
    try {
      const res = await axiosInstance.post(
        uploadUrl.replace(/127\.0\.0\.1:8000/, ""),
        fd,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      document.body.removeChild(container);
      if (res.status >= 200 && res.status < 300 && res.data?.url)
        return res.data.url;
    } catch (err) {
      console.warn("[captureTemplateScreenshot] axios upload failed", err);
    }

    document.body.removeChild(container);
    return null;
  } catch (err) {
    console.error("captureTemplateScreenshot error", err);
    return null;
  }
};

// Replace common {{placeholder}} tokens in HTML with provided data values
const replaceTemplatePlaceholders = (
  html: string,
  data: Record<string, any> = {}
): string => {
  if (!html) return html;
  const fmtPrice = (v: any) => {
    if (v == null || v === "") return "";
    const num =
      typeof v === "number" ? v : Number(String(v).replace(/[^0-9.-]+/g, ""));
    if (isNaN(num)) return String(v);
    return `$${num.toLocaleString()}`;
  };

  return html.replace(/\{\{\s*([^}]+)\s*\}\}/g, (_, key) => {
    const k = key.trim();
    // common keys mapping
    const lookup: Record<string, any> = {
      address: data.address ?? data.property_address ?? "",
      price: fmtPrice(data.price ?? data.list_price ?? ""),
      headline: data.headline ?? data.title ?? "",
      bedrooms: data.bedrooms ?? data.bedroom ?? "",
      bathrooms: data.bathrooms ?? data.bathroom ?? "",
      area: data.area ?? data.sqft ?? "",
      agentName: data.agentName ?? data.agent_name ?? "",
      agentPhone: data.agentPhone ?? data.agent_phone ?? "",
      agentEmail: data.agentEmail ?? data.agent_email ?? "",
      heroImage: data.heroImage ?? data.image ?? "",
      description: data.description ?? "",
      service_type: data.service_type ?? data.serviceType ?? "",
    };
    // return mapped value or attempt direct key lookup
    if (lookup.hasOwnProperty(k)) return lookup[k] ?? "";
    return data[k] ?? "";
  });
};
interface Element {
  id: number;
  type: string;
  content: string;
}
const components = [
  {
    id: "text",
    name: "Text Block",
    icon: Type,
    description: "Add custom text content",
  },
  {
    id: "address",
    name: "Description",
    icon: MapPin,
    description: "Add description",
  },
  {
    id: "price",
    name: "Price",
    icon: DollarSign,
    description: "Property price display",
  },
];

const serviceTypes = [
  "Mortgage Broker",
  "Plumbing",
  "Photography",
  "Staging",
  "General Contractor",
  "Cabinetry",
  "Junk Removal",
  "Wholesaler",
  "Electrical",
  "Landscaping",
  "Cleaning",
];
const templates: Template[] = [
  {
    id: 1,
    name: "Template 1",
    category: "Modern Hero Layout",
    style: "Clean & Professional",
    rating: 4.8,
    uses: 1247,
    tag: "Just Listed",
    description: "",
    component: Template1,
    photoCount: 1,
  },
  {
    id: 2,
    name: "Template 2",
    category: "Luxury Showcase",
    style: "Premium & Elegant",
    rating: 4.9,
    uses: 982,
    tag: "Priced to Sell",
    description: "",
    component: Template2,
    photoCount: 1,
  },
  {
    id: 3,
    name: "Template 3",
    category: "Gallery Focus",
    style: "Image-Driven",
    rating: 4.7,
    uses: 756,
    tag: "Open House",
    description: "",
    component: Template3,
    photoCount: 2,
  },
  {
    id: 4,
    name: "Template 4",
    category: "Traditional Layout",
    style: "Classic & Trustworthy",
    rating: 4.6,
    uses: 634,
    tag: "Seller Motivated",
    description: "",
    // component: Template4,
    component: Template4,
    photoCount: 2,
  },
  {
    id: 5,
    name: "Template 5",
    category: "Split Screen",
    style: "Modern Balance",
    rating: 4.8,
    uses: 523,
    tag: "Just Listed",
    description: "",
    // component: Template5,
    component: Template5,
    photoCount: 3,
  },
  {
    id: 6,
    name: "Template 6",
    category: "Feature-Rich",
    style: "Comprehensive Info",
    rating: 4.9,
    uses: 445,
    tag: "Priced to Sell",
    description: "",
    // component: Template6,
    component: Template7,
    photoCount: 4,
  },

  {
    id: 8,
    name: "Template 8",
    category: "AI Optimized",
    style: "Modern & Smart",
    rating: 5.0,
    uses: 150,
    tag: "AI Selected",
    description: "AI-optimized template",
    component: Template8, // Make sure Template8 is imported at the top
    photoCount: 2,
  },
  {
    id: 9,
    name: "Template 9",
    category: "AI Optimized",
    style: "Professional & Clean",
    rating: 5.0,
    uses: 120,
    tag: "AI Selected",
    description: "AI-optimized template",
    component: Template9, // Make sure Template9 is imported at the top
    photoCount: 4,
  },
  {
    id: 10,
    name: "Template 10",
    category: "AI Optimized",
    style: "Elegant & Modern",
    rating: 5.0,
    uses: 110,
    tag: "AI Selected",
    description: "AI-optimized template",
    component: Template10, // Make sure Template10 is imported at the top
    photoCount: 2,
  },
  {
    id: 11,
    name: "Template 11",
    category: "AI Optimized",
    style: "Premium & Stylish",
    rating: 5.0,
    uses: 100,
    tag: "AI Selected",
    description: "AI-optimized template",
    component: Template11, // Make sure Template11 is imported at the top
    photoCount: 4,
  },
];

//Servics
export const serviceTemplates = [
  {
    id: 1,
    name: "ServiceTemplate 1",
    component: ServiceTemplate1,
    rating: 4.7,
    uses: 620,
    tag: "Finance",
    category: "Service",
    photoCount: 1,
    image: heroPropertyImage,
    style: "Professional",
    description: "Service template for mortgage brokers",
  },
  {
    id: 2,
    name: "ServiceTemplate 2",
    component: ServiceTemplate2,
    rating: 4.6,
    uses: 540,
    tag: "Professional",
    category: "Service",
    photoCount: 1,
    image: heroPropertyImage,
  },
  {
    id: 3,
    name: "ServiceTemplate 3",
    component: ServiceTemplate3,
    rating: 4.8,
    uses: 430,
    tag: "Popular",
    category: "Service",
    photoCount: 2,
    image: [heroPropertyImage, heroPropertyImage],
  },

  {
    id: 4,
    name: "ServiceTemplate 4",
    component: ServiceTemplate4,
    rating: 4.7,
    uses: 620,
    tag: "Finance",
    category: "Service",
    photoCount: 2,
    image: heroPropertyImage,
    style: "Professional",
    description: "Service template for mortgage brokers",
  },

];
// Find the section with AUTO_AI_TEMPLATE_IDS (around line 40-60)
const AUTO_AI_TEMPLATE_IDS = [8, 9, 10, 11];

// ADD THIS RIGHT AFTER:
const AUTO_AI_TEMPLATES: Record<number, any> = {
  8: templates.find((t) => t.id === 8),
  9: templates.find((t) => t.id === 9),
  10: templates.find((t) => t.id === 10),
  11: templates.find((t) => t.id === 11),
};
const MANUAL_PROPERTY_TEMPLATES = templates.filter(
  (template) => !AUTO_AI_TEMPLATE_IDS.includes(template.id)
);

const filterCategories = [
  "All Templates",
  "Modern",
  "Luxury",
  "Traditional",
  "Gallery Focus",
] as const;

const filters = [
  { id: "all", label: "All Templates" },
  { id: "modern", label: "Modern" },
  { id: "luxury", label: "Luxury" },
  { id: "traditional", label: "Traditional" },
  { id: "gallery", label: "Gallery Focus" },
];

// Reusable service template preview component with ResizeObserver to prevent layout stretching or compressing in step 3
const ServiceTemplatePreview = ({
  template,
  serviceDummyData,
  dummyService,
}: {
  template: any;
  serviceDummyData: any;
  dummyService: any;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [dimensions, setDimensions] = useState({ width: 300, height: 220 });

  useEffect(() => {
    if (!containerRef.current) return;

    const measure = () => {
      if (containerRef.current) {
        setDimensions({
          width: containerRef.current.clientWidth,
          height: containerRef.current.clientHeight || 220,
        });
      }
    };

    measure();

    let resizeObserver: ResizeObserver | null = null;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(containerRef.current);
    }

    window.addEventListener("resize", measure);
    return () => {
      window.removeEventListener("resize", measure);
      resizeObserver?.disconnect();
    };
  }, []);

  const TemplateComponent = template.component;
  const designWidth = template.id === 3 ? 840 : 900;
  const scale = dimensions.width / designWidth;

  return (
    <div
      ref={containerRef}
      className="relative h-[140px] sm:h-[180px] md:h-[220px] overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100 rounded-t-lg w-full"
    >
      <div
        className="service-template-clean absolute inset-0 origin-top-left pointer-events-none select-none"
        style={{
          transform: `scale(${scale})`,
          width: `${designWidth}px`,
          height: `${dimensions.height / scale}px`,
        }}
      >
        <TemplateComponent
          serviceData={{
            ...serviceDummyData,

            data: {
              ...serviceDummyData.data,

              // convert feature objects to strings
              features: serviceDummyData.data.features.map(
                (f: any) => f.feature_name || f
              ),
            },

            // normalize top-level features
            features: serviceDummyData.features.map(
              (f: any) => f.feature_name || f
            ),

            service: dummyService,
          }}
          readOnly
        />
      </div>
    </div>
  );
};

// Reusable property template preview component with ResizeObserver to prevent layout stretching or compressing in step 3
const PropertyTemplatePreview = ({
  template,
  propertyData,
}: {
  template: any;
  propertyData: any;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [dimensions, setDimensions] = useState({ width: 300, height: 180 });

  useEffect(() => {
    if (!containerRef.current) return;

    const measure = () => {
      if (containerRef.current) {
        setDimensions({
          width: containerRef.current.clientWidth,
          height: containerRef.current.clientHeight || 180,
        });
      }
    };

    measure();

    let resizeObserver: ResizeObserver | null = null;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(containerRef.current);
    }

    window.addEventListener("resize", measure);
    return () => {
      window.removeEventListener("resize", measure);
      resizeObserver?.disconnect();
    };
  }, []);

  const TemplateComponent = template.component;

  let designWidth = 900;
  if (template.id === 1) designWidth = 760;
  else if (template.id === 2) designWidth = 740;
  else if (template.id === 3) designWidth = 840;
  else if (template.id === 4) designWidth = 828;
  else if (template.id === 5) designWidth = 760;
  else if (template.id === 6) designWidth = 840;

  const scale = dimensions.width / designWidth;

  return (
    <div
      ref={containerRef}
      className="relative h-[120px] sm:h-[150px] md:h-[180px] overflow-hidden bg-white w-full"
    >
      <div
        className="absolute inset-0 origin-top-left pointer-events-none select-none"
        style={{
          transform: `scale(${scale})`,
          width: `${designWidth}px`,
          height: `${dimensions.height / scale}px`,
        }}
      >
        <TemplateComponent
          property={propertyData}
          keyFeatures={[]}
          propertyLists={[]}
        />
      </div>
    </div>
  );
};

export default function CampaignBuilder() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { templateId } = useParams<{ templateId?: string }>();
  const urlParams = new URLSearchParams(window.location.search);
  const propertyIdFromUrl = urlParams.get("property");
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState(1);
  // Guided (quiz-style) builder is the default; users can switch to the classic view.
  const [uiMode, setUiMode] = useState<"quiz" | "classic">(() => {
    try {
      return localStorage.getItem("builder_ui_mode") === "classic" ? "classic" : "quiz";
    } catch {
      return "quiz";
    }
  });
  const TOTAL_STEPS = 9; // Added checkout step
  const INDICATOR_WIDTH = 56; // px (matches screenshot)
  const progressPercent = (currentStep / TOTAL_STEPS) * 100;
  const [campaignType, setCampaignType] = useState<
    "property" | "service" | null
  >(null);
  const [selectedProperty, setSelectedProperty] = useState<Property | null>(
    null
  );
  const [selectedTemplate, setSelectedTemplate] = useState<Template | null>(
    null
  );
  const [isEditingTemplate, setIsEditingTemplate] = useState(false);
  const [isTemplateImageLoading, setIsTemplateImageLoading] = useState(false);
  const imageLoadingTimer = useRef<number | null>(null);
  const [previewRefresh, setPreviewRefresh] = useState(0);
  const [servicePreviewSnapshot, setServicePreviewSnapshot] = useState<Record<string, any> | null>(null);
  const [serviceEditSnapshot, setServiceEditSnapshot] = useState<Record<string, any> | null>(null);
  const [serviceKeyFeaturesSnapshot, setServiceKeyFeaturesSnapshot] = useState<string[]>([]);
  const [customTemplates, setCustomTemplates] = useState<any[]>([]);
  const [isServiceFlow, setIsServiceFlow] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState("All Templates");
  const [selectedDatasets, setSelectedDatasets] = useState<string[]>([]);
  const [properties, setProperties] = useState<Property[]>([]);
  const [loadingProperties, setLoadingProperties] = useState(false);
  const [propertyLists, setPropertyLists] = useState<
    { id: number; list_name: string }[]
  >([]);
  const [keyFeatures, setKeyFeatures] = useState<
    { id: number; feature_name: string; propetyId: number | string }[]
  >([]);
  const [originalKeyFeatures, setOriginalKeyFeatures] = useState<
    { id: number; feature_name: string; propetyId: number | string }[]
  >([]);
  const [loadingLists, setLoadingLists] = useState(false);
  const [loadingFeatures, setLoadingFeatures] = useState(false);
  const [agentLists, setAgentLists] = useState<AgentList[]>([]);
  const [associationSearchQuery, setAssociationSearchQuery] =
    useState<string>("");
  const [selectedPropertyList, setSelectedPropertyList] = useState<string>("");
  const [selectedDateTime, setSelectedDateTime] = useState("");
  const [photoFilter, setPhotoFilter] = useState<"all" | 1 | 2 | 3 | 4>("all");
  const leaveTemplateEditMessage =
    "You have unsaved changes. Do you want to save your changes before leaving this page?";

  const showTemplateImageLoader = (duration = 3000) => {
    if (imageLoadingTimer.current) {
      window.clearTimeout(imageLoadingTimer.current);
    }
    setIsTemplateImageLoading(true);
    imageLoadingTimer.current = window.setTimeout(() => {
      setIsTemplateImageLoading(false);
      imageLoadingTimer.current = null;
    }, duration);
  };

  const [propertyEditSnapshot, setPropertyEditSnapshot] = useState<Record<string, any> | null>(null);
  const [propertyKeyFeaturesSnapshot, setPropertyKeyFeaturesSnapshot] = useState<KeyFeature[]>([]);
  const [showTemplateEditLeaveModal, setShowTemplateEditLeaveModal] = useState(false);
  const [templateEditLeaveAction, setTemplateEditLeaveAction] = useState<(() => void) | null>(null);
  const [isSavingTemplateEditLeave, setIsSavingTemplateEditLeave] = useState(false);

  const handleTemplateImageInputChangeCapture = (
    event: React.ChangeEvent<HTMLDivElement>
  ) => {
    const target = event.target as HTMLInputElement;
    const selectedFile = target.files?.[0];

    if (
      target instanceof HTMLInputElement &&
      target.type === "file" &&
      selectedFile?.type?.startsWith("image/")
    ) {
      showTemplateImageLoader();
    }
  };

  const handleCancelServiceTemplateEdit = () => {
    if (serviceEditSnapshot) {
      const restoredService = {
        ...serviceEditSnapshot,
        features: Array.isArray(serviceEditSnapshot.features)
          ? [...serviceEditSnapshot.features]
          : [],
        photos: Array.isArray(serviceEditSnapshot.photos)
          ? [...serviceEditSnapshot.photos]
          : [],
        photos_urls: Array.isArray(serviceEditSnapshot.photos_urls)
          ? [...serviceEditSnapshot.photos_urls]
          : [],
      };

      setServiceData((prev) => ({
        ...prev,
        ...restoredService,
      }));
      setSelectedService((prev) => (prev ? { ...prev, ...restoredService } : prev));
      setServicePreviewSnapshot(restoredService);
      setServiceKeyFeaturesSnapshot([]);
    }

    setServiceEditSnapshot(null);
    setIsEditingTemplate(false);
    setIsDirty(false);
    setDirtyFields(new Set());
  };

  useEffect(() => {
    return () => {
      if (imageLoadingTimer.current) {
        window.clearTimeout(imageLoadingTimer.current);
      }
    };
  }, []);
  useEffect(() => {
    return () => {
      if (imageLoadingTimer.current) {
        window.clearTimeout(imageLoadingTimer.current);
      }
    };
  }, []);

  // timezone helpers (user-selected timezone from Account Settings)
  const { formatDateTime, toDateInputValue, localToUtcIso, timezone, setTimezone } =
    useTimezone();

  // Utility function to convert UTC ISO string to datetime-local input value
  const utcToDateInputValue = (isoString: string) => {
    return new Date(isoString).toISOString().slice(0, 16);
  };
  const [stepClickTarget, setStepClickTarget] = useState<number | null>(null);
  const [pendingStepNavigationAction, setPendingStepNavigationAction] =
    useState<(() => void) | null>(null);
  const [scheduleOption, setScheduleOption] = useState<"now" | "later">("now");

  // When user switches to 'later', default the schedule to "now" in the user's selected timezone.
  useEffect(() => {
    if (scheduleOption === "later" && !selectedDateTime) {
      const nowInUserTz = toDateInputValue(new Date().toISOString());
      if (nowInUserTz) setSelectedDateTime(nowInUserTz);
    }
  }, [scheduleOption, selectedDateTime, toDateInputValue]);
  const [isDirty, setIsDirty] = useState(false);
  const previewFileInputRef = useRef<HTMLInputElement>(null);
  const hubSectionRef = useRef<HTMLDivElement>(null);
  const [subjectGenCount, setSubjectGenCount] = useState(0);
  const [generationCount, setGenerationCount] = useState(0);
  const [generationCounts, setGenerationCounts] = useState<
    Record<number, number>
  >({});
  const [subject, setSubject] = useState("");
  const [error, setError] = useState("");
  const [isRegenerating, setIsRegenerating] = useState(false);
  const [countLoading, setCountLoading] = useState(false);
  const [planLoading, setPlanLoading] = useState(false);
  const [showPricingModal, setShowPricingModal] = useState(false);
  const [showTrialPaymentModal, setShowTrialPaymentModal] = useState(false);
  const [trialPaymentLoading, setTrialPaymentLoading] = useState(false);
  const [pendingTrialActivation, setPendingTrialActivation] = useState<{
    totalSends: number;
    trialCredits: number;
    planCredits: number;
    totalSelected: number;
  } | null>(null);
  const [trialCreditsToApply, setTrialCreditsToApply] = useState(0);
  const [showAddOnModalType, setShowAddOnModalType] = useState<
    null | "campaign" | "association"
  >(null); // NEW: 'campaign'|'association'
  const [addOnRequiredQuantity, setAddOnRequiredQuantity] = useState<number>(1);

  // Add-on cart state
  const [showAddOnCart, setShowAddOnCart] = useState(false);
  const [cartAddon, setCartAddon] = useState<any>(null);
  const [cartQuantity, setCartQuantity] = useState<number>(1); // units of addon to buy
  const [cartTotal, setCartTotal] = useState<number>(0);
  const [isCreatingCheckout, setIsCreatingCheckout] = useState(false);

  // keep cart total in sync with addon price and quantity
  useEffect(() => {
    if (cartAddon && typeof cartAddon.price !== 'undefined') {
      const price = Number(cartAddon.price || 0);
      setCartTotal(price * (cartQuantity || 0));
    } else {
      setCartTotal(0);
    }
  }, [cartAddon, cartQuantity]);

  const [acceptedTerms, setAcceptedTerms] = useState(false);

  // ============ RECURRING SCHEDULE STATES ============
  const [showRecurringModal, setShowRecurringModal] = useState(false);
  const [recurrenceType, setRecurrenceType] = useState<"daily" | "weekly" | "monthly" | "custom">("weekly");
  const [recurringStartDateTime, setRecurringStartDateTime] = useState("");
  const [recurringEndDateTime, setRecurringEndDateTime] = useState("");
  const [customRecurringDates, setCustomRecurringDates] = useState<string[]>([]);
  const [isRecurringCampaign, setIsRecurringCampaign] = useState(false);
  const [recurringEndDate, setRecurringEndDate] = useState("");
  const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
  const [customCalendarMonth, setCustomCalendarMonth] = useState<string>(() =>
    selectedDateTime ? selectedDateTime.substring(0, 7) : new Date().toISOString().substring(0, 7)
  );
  const [customTime, setCustomTime] = useState<string>("09:00");
  const [customRecurringDateTime, setCustomRecurringDateTime] = useState("");
  const [tempSelectedDates, setTempSelectedDates] = useState<Set<string>>(new Set());
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    return localStorage.getItem('sidebar_collapsed') === 'true';
  });
  const [isSaving, setIsSaving] = useState(false);
  // Keep the custom calendar month in sync when the modal opens or when the selected date changes
  useEffect(() => {
    if (showRecurringModal && recurrenceType === "custom") {
      const baseMonth = selectedDateTime
        ? selectedDateTime.substring(0, 7)
        : new Date().toISOString().substring(0, 7);
      setCustomCalendarMonth(baseMonth);

      // Also sync the custom time
      const baseTime = selectedDateTime
        ? selectedDateTime.substring(11, 16)
        : "09:00";
      setCustomTime(baseTime);
    }
  }, [showRecurringModal, recurrenceType, selectedDateTime]);

  // Pre-populate recurring start datetime with current time in user's timezone when modal opens
  useEffect(() => {
    if (showRecurringModal && !recurringStartDateTime && scheduleOption === "now") {
      // For "Send Now" option, pre-fill with current time in user's timezone
      const nowInUserTz = toDateInputValue(new Date().toISOString());
      if (nowInUserTz) {
        setRecurringStartDateTime(nowInUserTz);
      }
    }
  }, [showRecurringModal, scheduleOption, toDateInputValue]);

  const getRecurringFrequencyLabel = (type: "daily" | "weekly" | "monthly" | "custom") => {
    switch (type) {
      case "daily":
        return "Day";
      case "weekly":
        return "Week";
      case "monthly":
        return "Month";
      case "custom":
        return "selected date";
      default:
        return type;
    }
  };

  const getRecurrenceTypeDisplayLabel = (type: "daily" | "weekly" | "monthly" | "custom") => {
    switch (type) {
      case "daily":
        return "Daily";
      case "weekly":
        return "Weekly";
      case "monthly":
        return "Monthly";
      case "custom":
        return "Custom";
      default:
        return type;
    }
  };

  // ============ CHECKOUT MODAL STATES ============
  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const [checkoutData, setCheckoutData] = useState<any>(null);
  const [isProcessingCheckout, setIsProcessingCheckout] = useState(false);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [recurringReviewAmount, setRecurringReviewAmount] = useState(0);
  const [recurringReviewConfirmed, setRecurringReviewConfirmed] = useState(false);
  const hasRecurringCheckoutData = Boolean(checkoutData?.recurrenceType);
  const [paymentIntentId, setPaymentIntentId] = useState<string | null>(null); //  NEW: Store payment reference
  const [stripeSessionId, setStripeSessionId] = useState<string | null>(null); //  NEW: Store Stripe session ID

  // ============ PROFILE COMPLETION CHECK STATES ============
  const [showProfileIncompleteModal, setShowProfileIncompleteModal] = useState(false);
  const [missingProfileFields, setMissingProfileFields] = useState<string[]>([]);
  const [profileCheckDone, setProfileCheckDone] = useState(false);
  const [userTimezone, setUserTimezone] = useState<string>("");
  const effectiveTimezone =
    normalizeTimezone(userTimezone) || normalizeTimezone(timezone) || "UTC";
  const [engagementScore, setEngagementScore] = useState<number | null>(null);

  const [scheduleDialogOpen, setScheduleDialogOpen] = useState(false);
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
  const [thumbnailUrl, setThumbnailUrl] = useState("");
  const [thumbnailPreview, setThumbnailPreview] = useState("");
  const [userPlan, setUserPlan] = useState<string | null>(null);
  const [extraLaunchCredits, setExtraLaunchCredits] = useState<number>(0);
  // Helper: returns availability days based on plan name
  const getPropertyAvailabilityDays = (planName: string | null): number => {
    if (!planName) return 60;
    const normalized = planName.toLowerCase();
    if (normalized.includes("pro+") || normalized.includes("pro")) return 120;
    return 60;
  };

  // Helper: compute expiry info from creation date string and plan
  const getPropertyExpiry = (
    createdAt?: string | null,
    planName?: string | null
  ): { expiryDate: Date; remainingDays: number; isExpired: boolean } => {
    const availabilityDays = getPropertyAvailabilityDays(planName ?? userPlan);
    if (!createdAt) {
      const d = new Date();
      d.setDate(d.getDate() + availabilityDays);
      return { expiryDate: d, remainingDays: availabilityDays, isExpired: false };
    }
    const created = new Date(createdAt);
    const expiry = new Date(created);
    expiry.setDate(expiry.getDate() + availabilityDays);
    const now = new Date();
    // calculate whole days remaining (ceil to full days)
    const diffMs = expiry.getTime() - now.getTime();
    const remainingDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    return { expiryDate: expiry, remainingDays, isExpired: remainingDays < 0 };
  };

  const formatExpiryMessage = (remainingDays: number): string => {
    if (remainingDays < 0) return "Expired";
    if (remainingDays === 0) return "Expires today";
    if (remainingDays === 1) return "Expires tomorrow";
    if (remainingDays < 7) return `${remainingDays} days left`;
    const weeks = Math.floor(remainingDays / 7);
    return `${weeks} week${weeks > 1 ? "s" : ""} left`;
  };
  const [campaignsSent, setCampaignsSent] = useState<number>(0);
  const [planLimits, setPlanLimits] = useState<Record<string, number>>({});
  const [serviceElements, setServiceElements] = useState<Element[]>([]);
  const [EmailEditor, setEmailEditor] = useState<any>(null);
  const editorRef = useRef<any>(null);
  const [templateName, setTemplateName] = useState("My New Template");
  const [previewMode, setPreviewMode] = useState<"desktop" | "mobile">(
    "desktop"
  );
  const [isEditingFromPreview, setIsEditingFromPreview] = useState(false);
  const [open, setOpen] = useState(false);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  // Add state to track if user has made changes
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showLeaveDialog, setShowLeaveDialog] = useState(false);
  const [showCompleteLaunchDialog, setShowCompleteLaunchDialog] = useState(false);
  // Add these new state variables
  const [showLeaveDraftDialog, setShowLeaveDraftDialog] = useState(false);
  const [draftStepToSave, setDraftStepToSave] = useState<number>(currentStep);
  const [pendingNavigation, setPendingNavigation] = useState<string | null>(
    null
  );
  const resetLeaveDraftDialogState = useCallback(() => {
    setShowLeaveDraftDialog(false);
    setPendingNavigation(null);

    try {
      delete (window as any).__ignoreBeforeUnload;
      delete (window as any).__bypassNav;
    } catch (e) { }

    const restoreInteractivity = () => {
      document.body.style.pointerEvents = "";
      document.body.style.overflow = "";
      document.body.style.removeProperty("pointer-events");
      document.body.style.removeProperty("overflow");

      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    };

    restoreInteractivity();
    window.setTimeout(restoreInteractivity, 0);
    window.requestAnimationFrame(restoreInteractivity);
  }, []);

  useEffect(() => {
    if (!showLeaveDraftDialog && document.body.style.pointerEvents === "none") {
      document.body.style.pointerEvents = "";
    }
  }, [showLeaveDraftDialog]);
  // NEW STATES FOR PROOF EMAIL & APPROVAL
  // `proofSentCount` tracks how many proof emails have been sent so the user
  // can resend multiple times until satisfied.
  const [proofSentCount, setProofSentCount] = useState(0);
  const [isProofApproved, setIsProofApproved] = useState(false);
  const [sendingProof, setSendingProof] = useState(false);
  const [user, setUser] = useState(null);
  // Tracks whether free-trial validation was already performed at Step 5
  const [trialValidated, setTrialValidated] = useState(false);
  const [isProUser, setIsProUser] = useState(false);
  // Track if user is currently on free trial
  const [isOnFreeTrial, setIsOnFreeTrial] = useState(false);
  const [trialEndDate, setTrialEndDate] = useState<Date | null>(null);
  const [associationLimit, setAssociationLimit] = useState<number | null>(null);

  const hasHubAccess = isProUser ||
    (isOnFreeTrial &&
      (user?.plan_name === "Starter" || user?.plan_name === "Starter Annual"));
  const [associationsUsed, setAssociationsUsed] = useState<number>(0);
  const [associationsRemaining, setAssociationsRemaining] = useState<
    number | null
  >(null);
  const [selectedState, setSelectedState] = useState<string>("");
  const [statesList, setStatesList] = useState<
    { id: number; state_name: string }[]
  >([]);
  const [statesLoading, setStatesLoading] = useState<boolean>(true);
  const [loadingStateAssociations, setLoadingStateAssociations] = useState<boolean>(false);
  const selectRef = useRef(null);
  // County suggestions from OpenAI based on property address
  const [countySuggestions, setCountySuggestions] = useState<string[]>([]);
  const [suggestingCounties, setSuggestingCounties] = useState(false);
  // States list is loaded dynamically from the backend (`endpoints.db_states`).
  // The static `usStates` list has been removed to ensure users always see
  // the live data from the LaunchIQ database.
  const [isAutoIQLoading, setIsAutoIQLoading] = useState(false);
  const [autoIQCount, setAutoIQCount] = useState(0);
  const MAX_AUTO_IQ_ATTEMPTS = 3;

  // ============ PLAN & PAYMENT TRACKING STATES ============
  const [planDetails, setPlanDetails] = useState<any>(null);
  const [selectedPricingPlan, setSelectedPricingPlan] = useState<any>(null);
  const [remainingCampaigns, setRemainingCampaigns] = useState<number | null>(null);
  const [extraHubsCredit, setExtraHubsCredit] = useState<number | null>(null);
  const [needsPayment, setNeedsPayment] = useState(false);
  const [paymentCompleted, setPaymentCompleted] = useState(false);
  const [extraCampaignCount, setExtraCampaignCount] = useState(0);
  const [extraAssociationCount, setExtraAssociationCount] = useState(0);
  const [mobileMenuToggle, setMobileMenuToggle] = useState<(() => void) | null>(null);
  const isOneTimePlan = (plan: any) =>
    Boolean(plan?.is_one_time) ||
    plan?.billing_cycle === "one_time" ||
    /one[-_ ]?time/i.test(plan?.name || "");

  const selectedPlanForPayment = selectedPricingPlan || planDetails?.plan;
  const selectedOneTimePlan = isOneTimePlan(selectedPlanForPayment)
    ? selectedPlanForPayment
    : null;
  const selectedOneTimePrice = selectedOneTimePlan
    ? Number(selectedOneTimePlan?.price || 0)
    : 0;

  const getDefaultAddOnUnitPrice = (
    addons: any[],
    limitKey: "campaign_limit" | "association_limit"
  ) => {
    if (!Array.isArray(addons) || addons.length === 0) return 0;

    const valid = addons
      .map((addon: any) => ({
        price: Number(addon.price || 0),
        limit: Number(addon[limitKey] || 0),
      }))
      .filter((addon: any) => addon.price > 0 && addon.limit > 0);

    if (valid.length === 0) return 0;

    const unitAddon = valid.find((addon: any) => addon.limit === 1);
    if (unitAddon) return unitAddon.price;

    return Math.min(
      ...valid.map((addon: any) => addon.price / addon.limit)
    );
  };

  const fetchAddOnUnitPrices = async (planId?: number) => {
    try {
      const planQuery = planId ? `?plan_id=${planId}` : "";
      const [campaignRes, associationRes] = await Promise.all([
        axiosInstance.get(`${endpoints.campaign_add_ons}${planQuery}`),
        axiosInstance.get(`${endpoints.association_add_ons}${planQuery}`),
      ]);

      const campaignAddons = Array.isArray(campaignRes.data?.addons)
        ? campaignRes.data.addons
        : [];
      const associationAddons = Array.isArray(associationRes.data?.addons)
        ? associationRes.data.addons
        : [];

      const campaignPrice = getDefaultAddOnUnitPrice(
        campaignAddons,
        "campaign_limit"
      );
      const associationPrice = getDefaultAddOnUnitPrice(
        associationAddons,
        "association_limit"
      );

      setCampaignAddOnPrice(campaignPrice);
      setAssociationAddOnPrice(associationPrice);
    } catch (error) {
      console.error("[fetchAddOnUnitPrices] failed", error);
      setCampaignAddOnPrice(0);
      setAssociationAddOnPrice(0);
    }
  };

  const calculateBillingDetails = ({
    totalSelected,
    totalSends,
    remainingCamps,
    extraHubsCredit = 0,
    extraLaunchCredits = 0,  // ADD THIS
    isOneTimePlan = selectedOneTimePlan,
    oneTimePlanPrice = selectedOneTimePrice,
  }: {
    totalSelected: number;
    totalSends: number;
    remainingCamps: number;
    extraHubsCredit?: number;
    extraLaunchCredits?: number;  // ADD THIS
    isOneTimePlan?: boolean;
    oneTimePlanPrice?: number;
  }) => {
    const campaignUnitPrice = campaignAddOnPrice;
    const associationUnitPrice = associationAddOnPrice;

    // Combine plan credits + extra launch credits for free launch calculation
    const totalFreeLaunches = Math.max(0, remainingCamps) + Math.max(0, extraLaunchCredits);

    const includedHubsPerSend = totalSelected > 0 ? 1 : 0;
    const extraHubsPerSend = Math.max(0, totalSelected - includedHubsPerSend);
    const totalExtraHubs = totalSends * extraHubsPerSend;

    const extraHubsCreditUsed = Math.min(extraHubsCredit || 0, totalExtraHubs);
    const extraHubsToCharge = totalExtraHubs - extraHubsCreditUsed;
    const associationCharge = extraHubsToCharge * associationUnitPrice;

    // Use combined credits (plan + extra launch credits)
    const freeLaunches = Math.min(totalFreeLaunches, totalSends);
    const paidLaunches = Math.max(0, totalSends - freeLaunches);
    const campaignCharge = paidLaunches * campaignUnitPrice;
    const totalCharge = campaignCharge + associationCharge;

    return {
      totalCharge,
      campaignCharge,
      freeLaunches,
      paidLaunches,
      associationCharge,
      totalExtraHubs,
      extraHubsPerSend,
      extraHubsCreditUsed,
      extraHubsToCharge,
      totalSends,
      totalSelected,
    };
  };

  // ============ ADD-ON PRICING STATES ============
  const [campaignAddOnPrice, setCampaignAddOnPrice] = useState<number>(0);
  const [associationAddOnPrice, setAssociationAddOnPrice] = useState<number>(0);
  const [isMultipleTemplateMode, setIsMultipleTemplateMode] = useState(false);
  const [selectedMultipleTemplates, setSelectedMultipleTemplates] = useState<any[]>([]);
  const [multipleTemplatePropertyData, setMultipleTemplatePropertyData] = useState<any>(null);
  const [multiSelectedProperties, setMultiSelectedProperties] = useState<Property[]>([]);
  // Multi-service state
  const [isMultipleServiceTemplateMode, setIsMultipleServiceTemplateMode] = useState(false);
  const [selectedMultipleServiceTemplates, setSelectedMultipleServiceTemplates] = useState<any[]>([]);
  const [multiSelectedServices, setMultiSelectedServices] = useState<any[]>([]);
  const [propertyData, setPropertyData] = useState<PropertyCampaignData>({
    address: "",
    mlsImport: false,
    description: "",
    agentInfo: "",
    price: null,
    campaignType: "",
    headline: "",
    image: "",
    heroImage: "",
    secondaryImage: "",
    photos: [],
    bedrooms: null,
    bathrooms: null,
    area: null,
    text_section: "",
    agentPhone: "",
    agentEmail: "",
    agentName: "",
    features: [],
  });
  const launchSteps = [
    { title: "Pick Your Launch", subtitle: "Choose launch type" },
    {
      title: "Tell Us About Your Launch",
      subtitle: "Add property details",
    },
    { title: "Pick Your Look", subtitle: "Choose a template" },
    { title: "Preview Template", subtitle: "Review your design" },
    { title: "Choose Your Hub", subtitle: "Choose your recipient groups" },
    { title: "Schedule Your Launch", subtitle: "Choose Launch time" },
    { title: "Complete Payment", subtitle: "Enter payment details" },
    { title: "You're All Set to Launch", subtitle: "Final checks" },
    { title: "Launch Successful!", subtitle: "See your results" },
  ];

  // ============ CHECK PROFILE COMPLETION ON MOUNT ============
  useEffect(() => {
    const checkProfileCompletion = async () => {
      try {
        const res = await axiosInstance.get(endpoints.me);
        const userData = res.data?.user ?? res.data;
        const launchCredits = userData.extra_launch_credits || 0;
        setExtraLaunchCredits(launchCredits);
        // Store user's timezone for time recommendations
        // Auto-detect if not set in profile
        const normalizedUserTimezone = normalizeTimezone(userData.timezone);
        if (normalizedUserTimezone) {
          setUserTimezone(normalizedUserTimezone);
          setTimezone(normalizedUserTimezone);
        } else {
          // Auto-detect timezone if not set in user profile
          const autoDetectedTz = normalizeTimezone(detectUserTimezone()) || "UTC";
          setUserTimezone(autoDetectedTz);
          setTimezone(autoDetectedTz);
          console.warn(
            `User timezone not set in profile. Using auto-detected timezone: ${autoDetectedTz}. ` +
            `Please visit Account Settings to set your actual timezone.`
          );
        }

        // ============ CHECK USER PLAN & REMAINING RESOURCES ============
        if (userData) {
          setPlanDetails(userData);

          // Get remaining campaigns: free + paid
          const remainingCamps = userData.get_remaining_campaigns || 0;
          setRemainingCampaigns(remainingCamps);

          // Get extra hub credits for deduction when launching
          const hubCredits = userData.extra_hubs_credit || 0;
          setExtraHubsCredit(hubCredits);

          // If user has remaining resources (> 0), first one is free
          // Extra usage beyond that requires payment
        }

        const missing: string[] = [];

        if (!userData.first_name) missing.push("First Name");
        if (!userData.last_name) missing.push("Last Name");
        if (!userData.company) missing.push("Company Name");
        if (!userData.phone_number) missing.push("Phone Number");
        if (!userData.avatar) missing.push("Profile Picture");
        if (!userData.company_logo) missing.push("Company Logo");
        // License number is optional — not flagged as missing profile info.
        // Don't mark timezone as missing since we now auto-detect it
        // if (!userData.timezone) missing.push("Timezone");

        if (missing.length > 0) {
          setMissingProfileFields(missing);
          setShowProfileIncompleteModal(true);
        }
      } catch (err) {
        console.error("Error checking profile completion:", err);
      } finally {
        setProfileCheckDone(true);
      }
    };

    if (!profileCheckDone) {
      checkProfileCompletion();
    }
  }, [profileCheckDone]);

  // When user navigates to the Recipients step (Step 5), ensure users
  // without a plan are shown the pricing modal and cannot use LaunchIQ
  useEffect(() => {
    if (currentStep === 5) {
      // If planDetails is loaded and user has no plan, show pricing
      if (planDetails && !planDetails.plan) {
        setShowAddOnModalType("campaign");
        // Ensure LaunchIQ Database is turned off when no plan
        setSendTo((s) => ({ ...s, database: false }));
      }
      // If user is on free trial, disable database access
      if (isOnFreeTrial) {
        setSendTo((s) => ({ ...s, database: false }));
      }
    }
  }, [currentStep, planDetails, isOnFreeTrial]);

  

  // Refetch user plan details after payment completion to ensure database updates are reflected
  useEffect(() => {
    if (paymentIntentId) {
      fetchUserPlan();
    }
  }, [paymentIntentId]);

  // ✅ NEW: Extract and verify Stripe session from URL params
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id") || params.get("session");

    if (sessionId && !stripeSessionId) {
      setStripeSessionId(sessionId);

      // Call verify_payment endpoint to ensure subscription is saved in database
      const verifyPayment = async () => {
        try {
          const res = await axiosInstance.get(`${endpoints.verify_payment}?session_id=${sessionId}`);
          if (res.data.success) {
            // Refresh user data to reflect plan changes
            await fetchUserPlan();
            const { data: refreshedUser } = await axiosInstance.get(endpoints.me);
            setUser(refreshedUser);
            setRemainingCampaigns(refreshedUser.get_remaining_campaigns || 0);
            setExtraHubsCredit(refreshedUser.extra_hubs_credit || 0);
            localStorage.setItem("user", JSON.stringify(refreshedUser));
            sessionStorage.setItem("user", JSON.stringify(refreshedUser));

            params.delete("session_id");
            params.delete("session");
            const cleanUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ""}`;
            window.history.replaceState({}, "", cleanUrl);
            window.location.reload();
          }
        } catch (error) {
          console.error("Failed to verify payment:", error);
        }
      };

      verifyPayment();
    }
  }, []);

  // Allow selecting both recipient groups: LaunchIQ database and/or Hubs
  // When on free trial, database is always disabled (user can only use My Hubs)
  const [sendTo, setSendTo] = useState<{
    database: boolean;
    mycontacts: boolean;
  }>({
    database: false,
    mycontacts: true,
  });
  const [selectedHub, setSelectedHub] = useState<string>("");
  const [hubs, setHubs] = useState<{ id: number; name: string }[]>([]);
  const [hasDraft, setHasDraft] = useState(false);
  const [draft, setDraft] = useState<DraftProperty | null>(null);
  const [propertyDraft, setPropertyDraft] = useState<DraftProperty | null>(null);  // 🆕 Property draft
  const [serviceDraft, setServiceDraft] = useState<DraftProperty | null>(null);    // 🆕 Service draft
  const [isDraftLoading, setIsDraftLoading] = useState(false);
  const [isDraftDeleting, setIsDraftDeleting] = useState(false);
  const [isDraftSaving, setIsDraftSaving] = useState(false);
  const [showDraftPreview, setShowDraftPreview] = useState(false);
  const [showSaveDraftDialog, setShowSaveDraftDialog] = useState(false);
  const [selectedImageFile, setSelectedImageFile] = useState<File | null>(null);
  const [photoFiles, setPhotoFiles] = useState<File[]>([]);

  const [propertyListName, setPropertyListName] = useState<string>("");
  const [isDraftSavedForAddOn, setIsDraftSavedForAddOn] = useState(false);
  const [showDraftRequiredError, setShowDraftRequiredError] = useState(false);
  // Keep recurring checkout totals in sync when the user changes selected datasets
  // after a recurring schedule was applied — this prevents stale totals on the
  // recurring review / payment page when the user returns to Step 5 and edits selections.
  useEffect(() => {
    if (!checkoutData || !checkoutData.recurrenceType) return;

    const totalSelected = sendTo.database ? selectedDatasets.length : 0;
    const totalSends = Number(checkoutData.recurringCount) || 1;

    try {
      const billingNow = calculateBillingDetails({
        totalSelected,
        totalSends,
        remainingCamps: remainingCampaigns ?? 0,
        extraHubsCredit: extraHubsCredit ?? 0,
        extraLaunchCredits: extraLaunchCredits ?? 0,
        isOneTimePlan: checkoutData.selectedOneTimePlan || selectedOneTimePlan,
        oneTimePlanPrice: checkoutData.oneTimePlanPrice || selectedOneTimePrice,
      });

      setCheckoutData((prev: any) => ({
        ...(prev || checkoutData),
        selectedAssociations: totalSelected,
        extraAssociationsCount: billingNow.totalExtraHubs,
        paidLaunchesCount: billingNow.paidLaunches ?? (prev?.paidLaunchesCount ?? 0),
        freeLaunchesCount: billingNow.freeLaunches ?? (prev?.freeLaunchesCount ?? 0),
        reviewTotalCharge: billingNow.totalCharge,
      }));

      // Keep the payment amount in sync as well
      setPaymentAmount(billingNow.totalCharge);
    } catch (e) {
      console.error("Failed to sync recurring checkout totals:", e);
    }
  }, [selectedDatasets, sendTo, checkoutData?.recurringCount, remainingCampaigns, extraHubsCredit, extraLaunchCredits]);
  // ============ DRAFT FUNCTIONS ============
  // Updated save draft handler - use correct variable names from your component
  const handleSaveDraftForAddOn = async () => {
    try {
      await handleSaveDraftBeforePayment(); // Use your existing save function
      setIsDraftSavedForAddOn(true);
      setShowDraftRequiredError(false);
      toast.success("Draft saved! You can now purchase add-ons.");
    } catch (error) {
      toast.error("Failed to save draft. Please try again.");
    }
  };

  // Reset states when modal opens/closes
  useEffect(() => {
    if (showAddOnModalType === "association") {
      setIsDraftSavedForAddOn(false);
      setShowDraftRequiredError(false);
    }
  }, [showAddOnModalType]);
  const handleSaveDraftBeforePayment = async () => {
    setIsDraftSaving(true);
    const isOpenHouse = Boolean(
      selectedProperty?.is_open_house || propertyData.is_open_house
    );

    try {
      // Collect all draft data
      const draftData: SaveDraftData = {
        // 🆕 IMPORTANT: Set campaign_type so it saves to correct database
        campaign_type: campaignType || 'property',
        current_step: currentStep,
      };

      // ========== DETERMINE WHAT TYPE OF DATA TO COLLECT ==========
      const finalCampaignType = campaignType || 'property';

      if (finalCampaignType === 'service') {
        // ========== SERVICE CAMPAIGN DATA ==========
        draftData.title = serviceData?.title || selectedService?.title || "";
        draftData.headline = serviceData?.headline || serviceData?.title || "";
        draftData.service_type = serviceData?.serviceType || serviceData?.service_type || "";
        draftData.description = serviceData?.description || "";
        draftData.phone = serviceData?.phone || "";
        draftData.email = serviceData?.email || "";
        draftData.website = serviceData?.website || "";
        draftData.address = serviceData?.address || "";
        draftData.subject = subject || "";

        // ✅ NEW: Include service features and photos
        const serviceFeatures = (serviceData?.features || []).filter((f: any) => f && f.toString().trim() !== "");
        if (serviceFeatures.length > 0) {
          draftData.features = serviceFeatures;
          draftData.service_features = serviceFeatures;
        }

        // Collect service photos from state (but not blob: URLs which are local previews)
        const servicePhotos: string[] = [];
        const allServicePhotos = serviceData?.photos || [];
        allServicePhotos.forEach((photo: string) => {
          if (isValidPhotoUrl(photo) && !servicePhotos.includes(photo)) {
            servicePhotos.push(photo);
          }
        });
        if (servicePhotos.length > 0 || photoFiles.length === 0) {
          draftData.photos = servicePhotos.length > 0 ? servicePhotos : [];
          draftData.service_photos = servicePhotos.length > 0 ? servicePhotos : [];
        }

        // Handle hero image for service
        if (!selectedImageFile) {
          const heroImage = serviceData?.heroImage || "";
          if (heroImage && isValidPhotoUrl(heroImage)) {
            draftData.hero_image = heroImage;
          }
        }

        if (selectedService?.id) {
          draftData.service_id = selectedService.id;
        }
        if (serviceCampaignId) {
          draftData.service_campaign_id = serviceCampaignId;
        }

        draftData.selected_template_id = selectedServiceTemplate?.id?.toString() || "";

      } else {
        // ========== PROPERTY CAMPAIGN DATA ==========
        draftData.title = propertyData?.headline || selectedProperty?.title || "";
        draftData.address = propertyData?.address || selectedProperty?.address || "";
        draftData.postal_code =
          propertyData?.postalCode || selectedProperty?.postal_code || "";
        draftData.city = propertyData?.city || selectedProperty?.city || "";
        draftData.state = propertyData?.state || selectedProperty?.state || "";
        draftData.price = propertyData?.price || selectedProperty?.price;
        draftData.bedrooms = propertyData?.bedrooms || selectedProperty?.bedrooms;
        draftData.bathrooms = propertyData?.bathrooms || selectedProperty?.bathrooms;
        draftData.property_type =
          propertyData?.propertyType ||
          selectedProperty?.property_type ||
          "Residential";
        draftData.area = propertyData?.sqft || selectedProperty?.area;
        draftData.description =
          propertyData?.description || selectedProperty?.description || "";
        draftData.subject = subject || "";
        draftData.is_open_house = isOpenHouse || false;

        // Photos - include all photo URLs
        draftData.photos = collectAllPhotoUrls();

        // If we have a hero image URL already, send it separately so backend can use it as the draft main image.
        if (!selectedImageFile) {
          let mainImageCandidate = propertyData?.heroImage;
          if (!isValidPhotoUrl(mainImageCandidate) && selectedProperty?.image && isValidPhotoUrl(selectedProperty.image)) {
            mainImageCandidate = selectedProperty.image;
          }
          if (mainImageCandidate && isValidPhotoUrl(mainImageCandidate)) {
            draftData.image_url = mainImageCandidate;
          }
        }

        // Campaign state
        draftData.selected_template_id = selectedTemplate?.id?.toString() || "";

        // Save property draft metadata
        const selectedPropertyListId =
          selectedProperty?.propertyListType?.id ||
          propertyLists.find((list) => list.list_name === selectedPropertyList)?.id;
        if (selectedPropertyListId) {
          draftData.propertyListType = selectedPropertyListId;
        }
        draftData.property_list_name =
          propertyListName || selectedPropertyList || selectedProperty?.propertyListType?.list_name || "";
        if (selectedProperty?.id) {
          draftData.property_id = selectedProperty.id;
        }
      }

      // ========== COMMON FIELDS FOR BOTH ==========
      draftData.selected_datasets = selectedDatasets;
      draftData.selected_custom_datasets = selectedCustomDatasets;
      draftData.send_to = sendTo;

      // Save campaign draft to the DraftCampaign backend table
      const response = await campaignDraftService.saveDraft(buildCampaignDraftPayload(draftData));

      if (response.success) {
        toast({
          title: "Draft Saved!",
          description: "Your launch has been saved. You can continue later.",
          variant: "default",
          duration: 1000
        });

        setShowSaveDraftDialog(false);

        // If an add-on flow was pending (user selected more associations than
        // remaining), open the add-on modal now that the draft is saved.
        // if (addOnRequiredQuantity && addOnRequiredQuantity > 0) {
        //   setIsDraftSavedForAddOn(true);
        //   setShowAddOnModalType("association");
        //   return; // stop further execution
        // }

        // 🔥 Redirect to checkout after saving draft
        const checkoutUrl = sessionStorage.getItem("pendingCheckoutUrl");

        if (checkoutUrl) {
          sessionStorage.removeItem("pendingCheckoutUrl");
          window.location.href = checkoutUrl;
          return; // stop further execution
        }
      } else {
        throw new Error(response.message || "Failed to save draft");
      }
    } catch (error: any) {
      console.error("Error saving draft:", error);

      // 🔥 Handle field validation errors from backend
      const fieldErrors = error.response?.data?.field_errors;
      if (fieldErrors && Array.isArray(fieldErrors)) {
        const errorMessages = fieldErrors.map((err: any) => err.message).join("\n");
        toast({
          title: "Fields Too Long",
          description: errorMessages,
          variant: "destructive",
          duration: 2000
        });
      } else {
        toast({
          title: "Error",
          description: error.response?.data?.error || "Failed to save draft. Please try again.",
          variant: "destructive",
          duration: 1000
        });
      }
    } finally {
      setIsDraftSaving(false);
    }
  };

  // Helper to collect all photo URLs
  const isValidPhotoUrl = (url: string): boolean => {
    if (typeof url !== "string") {
      return false;
    }
    const trimmed = url.trim();
    return (
      trimmed.length > 0 &&
      !trimmed.startsWith("blob:") &&
      !trimmed.startsWith("data:")
    );
  };

  const getFirstValidDraftUrl = (...urls: Array<string | undefined | null>): string => {
    for (const url of urls) {
      if (typeof url === "string" && isValidPhotoUrl(url)) {
        return url.trim();
      }
    }
    return "";
  };

  const collectAllPhotoUrls = (): string[] => {
    const photos: string[] = [];

    // Add hero image URL if it's a URL (not a file)
    if (propertyData?.heroImage && isValidPhotoUrl(propertyData.heroImage)) {
      photos.push(propertyData.heroImage);
    }

    // Add selected property image
    if (selectedProperty?.image && typeof selectedProperty.image === "string" && isValidPhotoUrl(selectedProperty.image)) {
      if (!photos.includes(selectedProperty.image)) {
        photos.push(selectedProperty.image);
      }
    }

    // Add any photos from address lookup
    if (propertyData?.photos && Array.isArray(propertyData.photos)) {
      propertyData.photos.forEach((photo: string) => {
        if (isValidPhotoUrl(photo) && !photos.includes(photo)) {
          photos.push(photo);
        }
      });
    }

    // Add photos from selected property
    if (selectedProperty?.photos && Array.isArray(selectedProperty.photos)) {
      selectedProperty.photos.forEach((photo: string) => {
        if (isValidPhotoUrl(photo) && !photos.includes(photo)) {
          photos.push(photo);
        }
      });
    }

    return photos;
  };

  // Handler for when user uploads an image file
  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedImageFile(file);

      // Create preview URL
      const previewUrl = URL.createObjectURL(file);
      setPropertyData((prev) => ({
        ...prev,
        heroImage: previewUrl,
      }));
    }
  };

  // Handler for additional photo uploads
  const handlePhotoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || []);
    if (files.length > 0) {
      setPhotoFiles((prev) => [...prev, ...files]);

      // Create preview URLs
      const previewUrls = files.map((file) => URL.createObjectURL(file));
      setPropertyData((prev) => ({
        ...prev,
        photos: [...(prev?.photos || []), ...previewUrls],
      }));
    }
  };

  // Check if draft exists on component mount
  const checkForDraft = async () => {
    try {
      setIsDraftLoading(true);

      // Fetch both campaign drafts for property and service
      const { propertyDraft: propDraft, serviceDraft: svcDraft } = await campaignDraftService.getBothDrafts();

      setPropertyDraft(propDraft);
      setServiceDraft(svcDraft);

      // Keep backward compatibility with single draft state, but prioritize
      // service drafts so service users don't accidentally restore a property draft.
      setDraft(svcDraft || propDraft || null);

      const hasBothOrEither = propDraft !== null || svcDraft !== null;
      setHasDraft(hasBothOrEither);
    } catch (error) {
      console.error("Failed to check draft:", error);
      setHasDraft(false);
      setPropertyDraft(null);
      setServiceDraft(null);
    } finally {
      setIsDraftLoading(false);
    }
  };

  // Collect all draft data from current state
  const collectDraftData = (): SaveDraftData => {
    const finalCampaignType = campaignType || 'property';

    if (finalCampaignType === 'service') {
      // ========== SERVICE DRAFT DATA ==========
      const serviceFeatures = (serviceData?.features || []).filter((f: any) => f && f.toString().trim() !== "");
      const servicePhotos: string[] = [];
      (serviceData?.photos || []).forEach((photo: string) => {
        if (isValidPhotoUrl(photo) && !servicePhotos.includes(photo)) {
          servicePhotos.push(photo);
        }
      });

      return {
        campaign_type: 'service',
        title: serviceData?.title || selectedService?.title || "",
        headline: serviceData?.headline || serviceData?.title || "",
        service_type: serviceData?.serviceType || serviceData?.service_type || "",
        description: serviceData?.description || "",
        phone: serviceData?.phone || "",
        email: serviceData?.email || "",
        website: serviceData?.website || "",
        address: serviceData?.address || "",
        subject: subject || "",

        // ✅ NEW: Include service features and photos
        features: serviceFeatures,
        service_features: serviceFeatures,
        photos: servicePhotos,
        service_photos: servicePhotos,
        hero_image: serviceData?.heroImage || "",

        selected_template_id: selectedServiceTemplate?.id
          ? String(selectedServiceTemplate.id)
          : null,
        selected_datasets: selectedDatasets || [],
        selected_custom_datasets: selectedCustomDatasets || [],
        send_to: sendTo,
        current_step: currentStep,
      };
    } else {
      // ========== PROPERTY DRAFT DATA ==========
      return {
        campaign_type: 'property',
        title: propertyData?.headline || selectedProperty?.title || "",
        listing_id: selectedProperty?.listing_id || "",
        address: propertyData?.address || selectedProperty?.address || "",
        postal_code:
          propertyData?.postal_code || selectedProperty?.postal_code || "",
        city: propertyData?.city || selectedProperty?.city || "",
        state: propertyData?.state || selectedProperty?.state || "",
        price: propertyData?.price || selectedProperty?.price || 0,
        bedrooms: propertyData?.bedrooms || selectedProperty?.bedrooms || 0,
        bathrooms: propertyData?.bathrooms || selectedProperty?.bathrooms || 0,
        property_type:
          propertyData?.property_type || selectedProperty?.property_type || "",
        area: propertyData?.area || selectedProperty?.area || 0,
        description:
          propertyData?.description || selectedProperty?.description || "",
        text_section:
          propertyData?.text_section || selectedProperty?.text_section || "",
        subject: subject || "",
        property_list_name: selectedPropertyList || "",
        propertyListType: selectedProperty?.propertyListType?.id || null,
        is_open_house: selectedProperty?.is_open_house || false,
        photos: propertyData?.photos || selectedProperty?.photos || [],
        // Campaign state
        selected_template_id: selectedTemplate?.id
          ? String(selectedTemplate.id)
          : null,
        selected_datasets: selectedDatasets || [],
        selected_custom_datasets: selectedCustomDatasets || [],
        send_to: sendTo,
        current_step: currentStep,
      };
    }
  };

  // Continue to payment without saving draft
  const handleContinueWithoutSaving = () => {
    setShowSaveDraftDialog(false);
    // Redirect to checkout URL if available
    const checkoutUrl = sessionStorage.getItem("pendingCheckoutUrl");
    if (checkoutUrl) {
      sessionStorage.removeItem("pendingCheckoutUrl");
      window.location.href = checkoutUrl;
    } else {
      // Fallback: go to payment step
      setCurrentStep(6);
    }
  };

  // Handle using the draft (restore from case 1)
  const handleUseDraft = async () => {
    if (!draft) {
      toast({
        title: "No Draft Found",
        description: "Could not find draft data.",
        variant: "destructive",
        duration: 1000
      });
      return;
    }

    try {
      toast({
        title: "Restoring Draft",
        description: "Loading your saved campaign...",
        duration: 1000
      });

      //  Get the correct step from draft - MAX Step 6 (don't restore Step 7+)
      let savedStep = draft.current_step || draft.currentStep || 5;

      //  CAP at Step 6 - Don't restore to payment step or beyond
      if (savedStep > 6) {
        savedStep = 6;
      }

      // Get campaign type
      const draftCampaignType = draft.campaign_type || 'property';
      setCampaignType(draftCampaignType as 'property' | 'service');
      setIsServiceFlow(draftCampaignType === 'service');

      // ========== RESTORE ALL DATA BASED ON SAVED STEP ==========

      // ========== STEP 2+ DATA ==========
      if (savedStep >= 2) {
        if (draftCampaignType === 'property') {
          let imageUrl = getFirstValidDraftUrl(
            draft.image_url,
            draft.image,
            draft.hero_image,
            draft.heroImage,
            draft.photos?.[0]
          );

          // The draft's image is only a snapshot captured whenever the draft
          // itself was last saved -- it goes stale the moment Change Image /
          // Edit Image update the live Property record directly, which
          // doesn't re-save this draft snapshot. Always prefer the property's
          // current image so a restored draft shows what's actually saved.
          const propertyIdForImageRefresh = draft.property_id || draft.id;
          if (propertyIdForImageRefresh) {
            try {
              const token = localStorage.getItem("access_token");
              const freshRes = await axiosInstance.get(
                `${endpoints.properties}${propertyIdForImageRefresh}/`,
                { headers: token ? { Authorization: `Bearer ${token}` } : undefined }
              );
              if (freshRes?.data?.image) {
                imageUrl = freshRes.data.image;
              }
            } catch (err) {
              console.warn("Could not refresh property image for draft restore:", err);
            }
          }

          const restoredProperty: Property = {
            id: draft.property_id || draft.id || 0,
            title: draft.title || draft.headline || draft.campaign_name || "",
            address: draft.address || "",
            price: draft.price || null,
            bedrooms: draft.bedrooms || 0,
            bathrooms: draft.bathrooms || 0,
            sqft: draft.area || 0,
            area: draft.area || 0,
            property_type: draft.property_type || "",
            status: draft.status || "draft",
            image: imageUrl,
            description: draft.description || "",
            text_section: draft.text_section || "",
            headline: draft.title || draft.headline || draft.campaign_name || "",
            propertyListType: draft.propertyListType
              ? { id: draft.propertyListType, list_name: draft.property_list_name || "" }
              : undefined,
            is_open_house: draft.is_open_house || false,
          };
          setSelectedProperty(restoredProperty);

          setPropertyData({
            headline: draft.title || draft.headline || draft.campaign_name || "",
            address: draft.address || "",
            price: draft.price || null,
            bedrooms: draft.bedrooms || null,
            bathrooms: draft.bathrooms || null,
            area: draft.area || null,
            description: draft.description || "",
            text_section: draft.text_section || "",
            heroImage: imageUrl,
            photos: draft.photos || [],
            mlsImport: false,
            agentInfo: "",
            campaignType: "property",
            agentPhone: "",
            agentEmail: "",
            agentName: "",
            features: draft.key_features || [],
          });

          if (draft.property_list_name) {
            setSelectedPropertyList(draft.property_list_name);
          }

          if (draft.property_id || draft.id) {
            sessionStorage.setItem("selectedPropertyId", String(draft.property_id || draft.id));
          }

        } else if (draftCampaignType === 'service') {
          const heroImg = getFirstValidDraftUrl(
            draft.hero_image,
            draft.heroImage,
            draft.image_url,
            draft.image
          );

          // 🆕 Load features from service_features or fall back to features
          const normalizedFeatures: string[] = [];
          const sourceFeatures = draft.service_features || draft.features || [];
          if (sourceFeatures && Array.isArray(sourceFeatures)) {
            sourceFeatures.forEach((f: any) => {
              if (typeof f === 'string' && f.trim()) {
                normalizedFeatures.push(f.trim());
              } else if (typeof f === 'object' && f !== null) {
                const name = f.name || f.feature_name || '';
                if (name.trim()) {
                  normalizedFeatures.push(name.trim());
                }
              }
            });
          }

          // 🆕 Load photos from service_photos or photos
          const servicePhotos = draft.service_photos || draft.photos || [];

          setServiceData({
            title: draft.title || draft.campaign_name || "",
            headline: draft.title || draft.headline || draft.campaign_name || "",
            serviceType: draft.service_type || "",
            service_type: draft.service_type || "",
            description: draft.description || "",
            phone: draft.phone || "",
            email: draft.email || "",
            website: draft.website || "",
            address: draft.address || "",
            heroImage: heroImg,
            features: normalizedFeatures,
            photos: servicePhotos,  // 🆕 Load photos
            importFlyer: false,
            importImage: false,
            showCost: false,
            templateName: draft.template_name || "",
          });

          if (draft.service_id) {
            setSelectedService({ id: draft.service_id, title: draft.title } as any);
          }
          if (draft.service_campaign_id) {
            setServiceCampaignId(draft.service_campaign_id);
          }
        }
      }

      // ========== STEP 3+ DATA - Template ==========
      if (savedStep >= 3) {
        if (draft.selected_template_id) {
          if (draftCampaignType === 'property') {
            const foundTemplate = templates.find(t => String(t.id) === String(draft.selected_template_id));
            if (foundTemplate) {
              setSelectedTemplate(foundTemplate);
              setIsAutoAIMode(false);
              setAutoAITemplateId(null);
              sessionStorage.setItem("selectedTemplateId", String(draft.selected_template_id));
            }
          } else {
            const foundTemplate = serviceTemplates.find(t => String(t.id) === String(draft.selected_template_id));
            if (foundTemplate) {
              setSelectedServiceTemplate(foundTemplate);
              sessionStorage.setItem("selectedServiceTemplateId", String(draft.selected_template_id));
            }
          }
        }
      }

      // ========== STEP 4+ DATA - Subject & Features ==========
      if (savedStep >= 4) {
        if (draft.subject || draft.campaign_subject) {
          const restoredSubject = draft.subject || draft.campaign_subject || "";
          setSubject(restoredSubject);
          sessionStorage.setItem("campaignSubject", restoredSubject);
        }

        if (draftCampaignType === 'property' && draft.key_features && Array.isArray(draft.key_features)) {
          const features = draft.key_features.map((f: any) => ({
            id: f.id,
            feature_name: typeof f === 'string' ? f : (f.feature_name || f.name || ''),
            propetyId: draft.property_id || draft.id || 0,
          }));
          setKeyFeatures(features);
          setOriginalKeyFeatures([...features]);
        }
      }

      // ========== STEP 5+ DATA - Recipients ==========
      if (savedStep >= 5) {
        if (draft.selected_datasets && Array.isArray(draft.selected_datasets) && draft.selected_datasets.length > 0) {
          setSelectedDatasets(draft.selected_datasets.map(String));
        }
        if (draft.selected_custom_datasets && Array.isArray(draft.selected_custom_datasets) && draft.selected_custom_datasets.length > 0) {
          setSelectedCustomDatasets(draft.selected_custom_datasets.map(String));
        }
        if (draft.send_to) {
          setSendTo(draft.send_to);
        }
        if (draft.selected_state) {
          setSelectedState(draft.selected_state);
        }
      }

      // ========== STEP 6 DATA - Schedule (MAX STEP TO RESTORE) ==========
      if (savedStep >= 6) {
        if (draft.schedule_option) {
          setScheduleOption(draft.schedule_option as 'now' | 'later');
        }
        if (draft.selected_date_time) {
          setSelectedDateTime(draft.selected_date_time);
        }
        if (draft.is_recurring !== undefined) {
          setIsRecurringCampaign(draft.is_recurring);
        }
        if (draft.recurrence_type) {
          setRecurrenceType(draft.recurrence_type as any);
        }
        if (draft.recurring_end_date) {
          setRecurringEndDate(draft.recurring_end_date);
        }
        if (draft.custom_recurring_dates && Array.isArray(draft.custom_recurring_dates)) {
          setCustomRecurringDates(sortDateStringsAscending(draft.custom_recurring_dates));
        }
        if (draft.accepted_terms !== undefined) {
          setAcceptedTerms(draft.accepted_terms);
        }
      }

      // ❌ STEP 7+ DATA - Payment (NOT RESTORED - User must complete payment fresh)
      // Payment data is intentionally NOT restored for security reasons
      // User will need to go through payment step again
      setPaymentCompleted(false);
      setCheckoutData(null);

      // Hide draft preview
      setShowDraftPreview(false);
      sessionStorage.setItem("draftRestored", "true");


      setCurrentStep(savedStep);

      toast({
        title: "Draft Restored!",
        description: `Continuing from Step ${savedStep}: ${launchSteps[savedStep - 1]?.title}`,
        duration: 1000
      });

    } catch (error) {
      console.error("Error restoring draft:", error);
      toast({
        title: "Error",
        description: "Failed to restore draft. Please try again.",
        variant: "destructive",
      });
    }
  };

  // Delete draft
  const handleDeleteDraft = async () => {
    try {
      setIsDraftDeleting(true);
      await campaignDraftService.deleteDraftByType(campaignType as 'property' | 'service');

      if (campaignType === 'property') {
        setPropertyDraft(null);
      } else {
        setServiceDraft(null);
      }

      const otherDraft = campaignType === 'property' ? serviceDraft : propertyDraft;
      setDraft(otherDraft);
      setHasDraft(otherDraft !== null);

      setShowDraftPreview(false);

      // Clear sessionStorage
      sessionStorage.removeItem("selectedTemplateId");
      sessionStorage.removeItem("campaignDraftState");
      sessionStorage.removeItem("selectedPropertyId");

      toast({
        title: "Draft Deleted",
        description: "Your draft has been deleted successfully.",
        duration: 1000
      });
    } catch (error) {
      console.error("Failed to delete draft:", error);
      toast({
        title: "Error",
        description: "Failed to delete draft. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsDraftDeleting(false);
    }
  };
  const handleBuyPlanClick = () => {
    // Only show draft dialog in step 5
    if (currentStep === 5) {
      setShowSaveDraftDialog(true);
      return;
    }

    // Otherwise go directly to payment
    setCurrentStep(6);
  };

  const handleEndTrialNow = async () => {
    try {
      setTrialPaymentLoading(true);
      const res = await axiosInstance.post(endpoints.endTrialSubscription);

      if (res.data?.checkout_url) {
        window.location.href = res.data.checkout_url;
        return;
      }

      toast({
        title: "Trial ended",
        description:
          res.data?.message ||
          "Your free trial has been ended and payment is being processed immediately.",
        variant: "success",
      });

      setShowTrialPaymentModal(false);

      const { data: refreshedUserRaw } = await axiosInstance.get(endpoints.me);
      const refreshedUser = refreshedUserRaw?.user ?? refreshedUserRaw;
      const trialCredits = pendingTrialActivation?.trialCredits || 0;
      const planCredits =
        getRealPlanCreditsFromUser(refreshedUser) ||
        Number(refreshedUser.get_remaining_campaigns ?? 0) ||
        pendingTrialActivation?.planCredits ||
        0;
      const combinedCredits = planCredits + trialCredits;
      const totalSends = pendingTrialActivation?.totalSends || 1;
      // Prefer the current live selection when available — pendingTrialActivation
      // may be stale if the user returned to Step 5 and changed selections.
      const totalSelected = sendTo.database ? selectedDatasets.length : (pendingTrialActivation?.totalSelected || 0);
      const userExtraHubsCredit = refreshedUser.extra_hubs_credit || 0;
      const billing = calculateBillingDetails({
        totalSelected,
        totalSends,
        remainingCamps: combinedCredits,
        extraHubsCredit: userExtraHubsCredit,
        extraLaunchCredits: refreshedUser?.extra_launch_credits ?? 0,
        isOneTimePlan: selectedOneTimePlan,
        oneTimePlanPrice: selectedOneTimePrice,
      });
      setUser(refreshedUser);
      setRemainingCampaigns(combinedCredits);
      setExtraHubsCredit(userExtraHubsCredit);
      setTrialCreditsToApply(trialCredits);
      setCheckoutData((prev: any) =>
        prev
          ? {
            ...prev,
            campaignNeedsPayment: billing.paidLaunches > 0,
            paidLaunchesCount: billing.paidLaunches ?? 0,
            freeLaunchesCount: billing.freeLaunches ?? 0,
            extraAssociationsCount: billing.totalExtraHubs ?? prev.extraAssociationsCount,
          }
          : prev
      );
      localStorage.setItem("user", JSON.stringify(refreshedUser));
      sessionStorage.setItem("user", JSON.stringify(refreshedUser));
      window.dispatchEvent(new Event("user-updated"));
      setPaymentAmount(billing.totalCharge);
      setNeedsPayment(billing.totalCharge > 0);
      setShowPaymentForm(billing.totalCharge > 0);
      setShowCheckoutModal(false);
      setPendingTrialActivation(null);
      setCurrentStep(billing.totalCharge > 0 ? 7 : 8);
    } catch (err: any) {
      console.error("Failed to end trial now:", err);
      toast({
        title: "Payment failed",
        description:
          err.response?.data?.error ||
          err.message ||
          "Unable to process payment immediately.",
        variant: "destructive",
      });
    } finally {
      setTrialPaymentLoading(false);
    }
  };

  const handleTrialPayNow = () => {
    if ((user as any)?.stripe_subscription_id) {
      handleEndTrialNow();
      return;
    }

    setShowTrialPaymentModal(false);
    setShowPricingModal(true);
  };

  // Check for draft on mount
  useEffect(() => {
    checkForDraft();
  }, []);

  useEffect(() => {
    const fetchHubs = async () => {
      try {
        const res = await axiosInstance.get(endpoints.agent_user);
        setHubs(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Failed to load hubs:", err);
        // toast({
        //   title: "Warning",
        //   description: "Could not load your hubs – using fallback",
        //   variant: "default",
        // });
        // Fallback dummy hubs for testing
        setHubs([
          { id: 1, name: "My Personal Contacts" },
          { id: 2, name: "Sphere of Influence" },
          { id: 3, name: "Past Clients" },
        ]);
      }
    };
    fetchHubs();
  }, [toast]);

  const [serviceData, setServiceData] = useState<ServiceCampaignData>({
    title: "",
    serviceType: "",
    importFlyer: false,
    description: "",
    importImage: false,
    showCost: false,
    templateName: "",
    service_type: "",
    heroImage: "",
    headline: "",
    image: "",
    hero_image_url: "",
    features: [],
    phone: "",
    email: "",
    address: "",
    website: "",
  });
  const [selectedService, setSelectedService] = useState<Property | null>(null);
  const [originalServiceFeatures, setOriginalServiceFeatures] = useState<
    { id?: number; feature_name: string }[]
  >([]);
  const [isAutoAIMode, setIsAutoAIMode] = useState(false);
  const [autoAITemplateId, setAutoAITemplateId] = useState<number | null>(null);
  const [aiPrediction, setAiPrediction] = useState<any | null>(null);
  const [aiLoading, setAiLoading] = useState(false);

  // ============ NEW: Service Campaign Database States ============
  // const [serviceCampaignId, setServiceCampaignId] = useState<number | null>(null);
  // const [isSavingServiceData, setIsSavingServiceData] = useState(false);
  // const [secondaryImage, setSecondaryImage] = useState<string>("");

  // ============ NEW: Service Campaign Database States ============
  const [serviceCampaignId, setServiceCampaignId] = useState<number | null>(null);
  const [isSavingServiceData, setIsSavingServiceData] = useState(false);
  const [secondaryImage, setSecondaryImage] = useState<string>("");

  // ============ HELPER: Convert UTC to User Timezone ============
  const convertUtcToUserTimezone = (utcDateTime: string): { time: string; timezone: string } => {
    try {
      const date = new Date(utcDateTime);
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: effectiveTimezone,
        weekday: "long",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      const formatted = formatter.format(date);
      return { time: formatted, timezone: effectiveTimezone };
    } catch (e) {
      return { time: utcDateTime, timezone: "UTC" };
    }
  };

  const [savedServices, setSavedServices] = useState<any[]>([]);
  const [loadingServices, setLoadingServices] = useState(false);

  const dedupeById = useCallback(<T extends { id?: string | number }>(items: T[]): T[] => {
    const seen = new Set<string>();
    return items.filter((item) => {
      const id = String(item?.id ?? "");
      if (!id) return true;
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  }, []);

  const getFullUrl = useCallback((url: string | null | undefined): string => {
    if (!url) return "";
    if (url.startsWith("http") || url.startsWith("blob:") || url.startsWith("data:")) {
      return url;
    }
    const baseUrl = axiosInstance?.defaults?.baseURL || "";
    return `${baseUrl}${url.startsWith("/") ? "" : "/"}${url}`;
  }, []);

  const [showDraftOverwriteDialog, setShowDraftOverwriteDialog] = useState(false);
  const [pendingDraftSaveCallback, setPendingDraftSaveCallback] = useState<(() => Promise<void>) | null>(null);
  const [existingDraftInfo, setExistingDraftInfo] = useState<{
    title: string;
    step: number;
    type: 'property' | 'service';
    updatedAt?: string;
  } | null>(null);
  const [overwriteConfirmed, setOverwriteConfirmed] = useState(false);
  const [shouldProceedWithSave, setShouldProceedWithSave] = useState(false);
  const [showStep8LeaveWarning, setShowStep8LeaveWarning] = useState(false);

  // ============ FETCH SERVICES - Move to be with other useEffects ============
  useEffect(() => {
    const fetchServices = async () => {
      if (campaignType !== "service") return;

      setLoadingServices(true);
      try {
        const res = await axiosInstance.get(endpoints.service_listings);
        const data = res.data;
        const list = Array.isArray(data) ? data : (data.results || []);
        setSavedServices(dedupeById(list));
      } catch (err) {
        console.error("Failed to load services:", err);
        setSavedServices([]);
      } finally {
        setLoadingServices(false);
      }
    };

    fetchServices();
  }, [campaignType]);

  useEffect(() => {
    setProofSentCount(0);
    setIsProofApproved(false);
  }, [campaignType]);

  const handleSelectServiceTemplate = useCallback((template: any) => {
    // Clear multi-service mode flags when selecting a template in single-template flow
    try {
      sessionStorage.removeItem("isMultiServiceMode");
      sessionStorage.removeItem("multiSelectedServices");
      sessionStorage.removeItem("multiSelectedServiceTemplateIds");
    } catch (e) {
      console.warn("Could not clear multi-service session storage:", e);
    }
    setSelectedMultipleServiceTemplates([]);
    setMultiSelectedServices([]);
    setIsMultipleServiceTemplateMode(false);

    setSelectedServiceTemplate(template);

    try {
      sessionStorage.setItem("selectedServiceTemplateId", String(template.id));
    } catch (e) {
      console.warn("Could not save service template to session");
    }
  }, []);

  const handleServiceSelect = useCallback((service: any) => {
    // Clear multi-service state if we are in the normal single-service flow
    if (!isMultipleServiceTemplateMode) {
      try {
        sessionStorage.removeItem("isMultiServiceMode");
        sessionStorage.removeItem("multiSelectedServices");
        sessionStorage.removeItem("multiSelectedServiceTemplateIds");
      } catch (e) {
        console.warn("Could not clear multi-service session storage:", e);
      }
      setSelectedMultipleServiceTemplates([]);
      setMultiSelectedServices([]);
    }

    const mergedImages = getMergedServiceImageState(service);
    const normalizedService = {
      ...service,
      image: mergedImages.heroImage || service.image || "",
      heroImage:
        mergedImages.heroImage ||
        service.heroImage ||
        service.hero_image_url ||
        service.hero_image ||
        "",
      hero_image_url:
        mergedImages.heroImage ||
        service.hero_image_url ||
        service.heroImage ||
        service.image ||
        "",
      photos: mergedImages.photos,
    };

    // Store the selected service object
    setSelectedService(normalizedService);
    setServicePreviewSnapshot(null);

    // Also store a reference for the service campaign record so we update instead of creating duplicates
    const selectedServiceId = service?.id ? Number(service.id) : null;
    if (selectedServiceId) {
      setServiceCampaignId(selectedServiceId);
      try {
        sessionStorage.setItem("service_campaign_id", String(selectedServiceId));
      } catch (e) {
        console.warn("Could not save service campaign ID to sessionStorage", e);
      }
    }

    // Move to Step 3 (template selection) for normal flow
    if (!isMultipleServiceTemplateMode) {
      setCurrentStep(3);
    }

    // Normalize features to string array
    const normalizedFeatures: string[] = [];
    if (Array.isArray(service.features)) {
      service.features.forEach((f: any) => {
        if (typeof f === 'string' && f.trim()) {
          normalizedFeatures.push(f.trim());
        } else if (typeof f === 'object' && f !== null) {
          const name = f.name || f.feature_name || '';
          if (name.trim()) {
            normalizedFeatures.push(name.trim());
          }
        }
      });
    }

    // Get hero image - check all possible field names
    const heroImageUrl =
      normalizedService.hero_image_url ||
      normalizedService.heroImage ||
      normalizedService.hero_image ||
      normalizedService.image ||
      '';

    // Build complete service data object
    const mappedServiceData = {
      title: service.title || '',
      headline: service.headline || service.title || '',
      serviceType: service.service_type || service.serviceType || '',
      service_type: service.service_type || service.serviceType || '',
      description: service.description || '',
      phone: service.phone || '',
      email: service.email || '',
      website: service.website || '',
      address: service.address || '',
      heroImage: heroImageUrl,
      hero_image_url: heroImageUrl,
      secondaryImage: service.secondary_image || '',
      features: normalizedFeatures,
      photos: mergedImages.photos,
      importFlyer: false,
      importImage: false,
      showCost: false,
      templateName: '',
    };

    // Update serviceData state
    setServiceData(mappedServiceData);

    // Set subject if available
    if (service.subject) {
      setSubject(service.subject);
      try {
        sessionStorage.setItem('campaignSubject', service.subject);
      } catch (e) {
        console.warn('Could not save subject to session');
      }
    }

    // Store service ID for persistence
    try {
      sessionStorage.setItem('selectedServiceId', String(normalizedService.id));
      sessionStorage.setItem('selectedServiceData', JSON.stringify(mappedServiceData));
    } catch (e) {
      console.warn('Could not save service data to session');
    }

    // Move to template selection (Step 3)
    setCurrentStep(3);

    toast({
      title: "Service Selected",
      description: `"${normalizedService.title}" has been selected.`,
      duration: 1000,
    });
  }, [toast, setServiceData, setSubject, setCurrentStep, isMultipleServiceTemplateMode, serviceData]);

  // Handler for Auto AI service selection
  const handleAutoAISelectService = useCallback((service: any, templateId: number) => {
    const mergedImages = getMergedServiceImageState(service);
    const normalizedService = {
      ...service,
      image: mergedImages.heroImage || service.image || "",
      heroImage:
        mergedImages.heroImage ||
        service.heroImage ||
        service.hero_image_url ||
        service.hero_image ||
        "",
      hero_image_url:
        mergedImages.heroImage ||
        service.hero_image_url ||
        service.heroImage ||
        service.image ||
        "",
      photos: mergedImages.photos,
    };

    // Store the selected service
    setSelectedService(normalizedService);

    // Find and set the template
    const template = serviceTemplates.find(t => t.id === templateId);
    if (template) {
      setSelectedServiceTemplate(template);
      try {
        sessionStorage.setItem('selectedServiceTemplateId', String(templateId));
      } catch (e) { }
    }

    // Normalize features
    const normalizedFeatures: string[] = [];
    if (Array.isArray(service.features)) {
      service.features.forEach((f: any) => {
        if (typeof f === 'string' && f.trim()) {
          normalizedFeatures.push(f.trim());
        } else if (typeof f === 'object' && f !== null) {
          const name = f.name || f.feature_name || '';
          if (name.trim()) {
            normalizedFeatures.push(name.trim());
          }
        }
      });
    }

    // Get hero image
    const heroImageUrl =
      normalizedService.hero_image_url ||
      normalizedService.heroImage ||
      normalizedService.hero_image ||
      normalizedService.image ||
      '';

    // Build service data
    const mappedServiceData = {
      title: service.title || '',
      headline: service.headline || service.title || '',
      serviceType: service.service_type || service.serviceType || '',
      service_type: service.service_type || service.serviceType || '',
      description: service.description || '',
      phone: service.phone || '',
      email: service.email || '',
      website: service.website || '',
      address: service.address || '',
      heroImage: heroImageUrl,
      hero_image_url: heroImageUrl,
      secondaryImage: service.secondary_image || '',
      features: normalizedFeatures,
      photos: mergedImages.photos,
      importFlyer: false,
      importImage: false,
      showCost: false,
      templateName: '',
    };

    setServiceData(mappedServiceData);

    // Set subject
    if (service.subject) {
      setSubject(service.subject);
      try {
        sessionStorage.setItem('campaignSubject', service.subject);
      } catch (e) { }
    }

    // Store for persistence
    try {
      sessionStorage.setItem('selectedServiceId', String(normalizedService.id));
      sessionStorage.setItem('selectedServiceData', JSON.stringify(mappedServiceData));
    } catch (e) { }

    // Skip to preview (Step 4)
    setCurrentStep(4);

    toast({
      title: "🎨 AI Template Selected!",
      description: `Template "${template?.name || templateId}" has been automatically selected.`,
      duration: 2000,
    });
  }, [toast, setServiceData, setSubject, setCurrentStep, serviceData]);

  const handleServiceAdd = useCallback((newService: SavedService) => {
    setSavedServices((prev) => {
      const normalizedId = String(newService.id);
      const existingIndex = prev.findIndex((s) => String(s.id) === normalizedId);
      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = newService;
        return updated;
      }
      return [newService, ...prev];
    });
  }, []);

  // Handler for deleting service
  const handleServiceDelete = useCallback((serviceId: string | number) => {
    setSavedServices((prev) =>
      prev.filter((s) => String(s.id) !== String(serviceId))
    );
  }, []);

  const handleServiceUpdate = useCallback((updatedService: any) => {
    const mergedImages = getMergedServiceImageState(updatedService);
    const heroFull = mergedImages.heroImage
      ? getFullUrl(mergedImages.heroImage)
      : getFullUrl(
        updatedService.hero_image_url ||
        updatedService.hero_image ||
        updatedService.image ||
        ""
      );
    const secondaryPhotos = (mergedImages.photos || []).map((p: string) => getFullUrl(p));
    const normalizedFeatures = (updatedService.features || [])
      .map((f: any) =>
        typeof f === "string" ? f.trim() : (f.name || f.feature_name || "").toString().trim()
      )
      .filter((f: string) => f.length > 0);

    const normalizedUpdatedService = {
      ...updatedService,
      title: updatedService.title || "",
      service_type: updatedService.service_type || updatedService.serviceType || "",
      serviceType: updatedService.service_type || updatedService.serviceType || "",
      description: updatedService.description || "",
      phone: updatedService.phone || "",
      email: updatedService.email || "",
      website: updatedService.website || "",
      address: updatedService.address || "",
      image: heroFull,
      heroImage: heroFull,
      hero_image_url: heroFull,
      photos: secondaryPhotos,
      photos_urls: secondaryPhotos,
      features: normalizedFeatures,
    };

    const previewSnapshot = {
      id: normalizedUpdatedService.id,
      title: normalizedUpdatedService.title,
      headline: updatedService.headline || normalizedUpdatedService.title,
      serviceType: normalizedUpdatedService.serviceType,
      service_type: normalizedUpdatedService.service_type,
      description: normalizedUpdatedService.description,
      phone: normalizedUpdatedService.phone,
      email: normalizedUpdatedService.email,
      website: normalizedUpdatedService.website,
      address: normalizedUpdatedService.address,
      heroImage: heroFull,
      hero_image_url: heroFull,
      image: heroFull,
      secondaryImage: secondaryPhotos[0] || "",
      photos: secondaryPhotos,
      photos_urls: secondaryPhotos,
      features: normalizedFeatures,
      subject: updatedService.subject || "",
    };

    setSavedServices((prev) =>
      prev.map((service) =>
        String(service.id) === String(updatedService.id)
          ? normalizedUpdatedService
          : service
      )
    );

    if (String(selectedService?.id) === String(updatedService.id)) {
      setSelectedService(normalizedUpdatedService);
      setServiceData((prev) => ({
        ...prev,
        title: normalizedUpdatedService.title,
        serviceType: normalizedUpdatedService.serviceType,
        description: normalizedUpdatedService.description,
        phone: normalizedUpdatedService.phone,
        email: normalizedUpdatedService.email,
        website: normalizedUpdatedService.website,
        address: normalizedUpdatedService.address,
        heroImage: heroFull,
        hero_image_url: heroFull,
        image: heroFull,
        photos: secondaryPhotos,
        features: normalizedFeatures,
        headline: previewSnapshot.headline,
      }));
      if (secondaryPhotos[0]) {
        setSecondaryImage(secondaryPhotos[0]);
      }
      setServicePreviewSnapshot(previewSnapshot);
      setPreviewRefresh((p) => p + 1);
    }
  }, [selectedService, getFullUrl]);

  // ============ HELPER: Get AI Engagement Score Prediction ============
  // (Moved after recipientCount to avoid initialization errors)
  // Will be defined after recipientCount useMemo

  const handleAutoAISelect = useCallback(
    async (property: SavedProperty, templateId: number) => {
      // ✅ ADD: Clear multi-mode state before setting single Auto AI mode
      try {
        sessionStorage.removeItem("isMultiPropertyMode");
        sessionStorage.removeItem("multiSelectedProperties");
        sessionStorage.removeItem("multiSelectedTemplateIds");
      } catch (e) { }
      setSelectedMultipleTemplates([]);
      setMultiSelectedProperties([]);
      setMultipleTemplatePropertyData(null);
      setIsMultipleTemplateMode(false);

      // ✅ ADD: Reset previous Auto AI selection explicitly
      setIsAutoAIMode(false);
      setAutoAITemplateId(null);
      setSelectedTemplate(null);

      const initialMergedImages = getMergedPropertyImageState(property);
      setSelectedProperty({
        ...property,
        image: initialMergedImages.heroImage || property.image || "",
        heroImage:
          initialMergedImages.heroImage ||
          property.heroImage ||
          property.image ||
          "",
        photos: initialMergedImages.photos,
      });
      if (property?.propertyListType?.list_name) {
        setSelectedPropertyList(property.propertyListType.list_name);
      }

      if (property?.id) {
        try {
          const fresh = await axiosInstance.get(
            `${endpoints.properties}${property.id}/`
          );
          if (fresh?.data) {
            const mergedFreshImages = getMergedPropertyImageState(fresh.data);
            setSelectedProperty({
              ...fresh.data,
              image: mergedFreshImages.heroImage || fresh.data.image || "",
              heroImage:
                mergedFreshImages.heroImage ||
                fresh.data.heroImage ||
                fresh.data.image ||
                "",
              photos: mergedFreshImages.photos,
            });
            if (fresh.data.propertyListType?.list_name) {
              setSelectedPropertyList(fresh.data.propertyListType.list_name);
            }
          }
        } catch (err) {
          console.warn("Failed to refetch property for Auto AI preview:", err);
        }
      }

      // Now set Auto AI mode with fresh values
      setIsAutoAIMode(true);
      setAutoAITemplateId(templateId);

      const selectedAutoTemplate = AUTO_AI_TEMPLATES[templateId];
      if (selectedAutoTemplate) {
        setSelectedTemplate(selectedAutoTemplate);
      }

      setCurrentStep(4);
    },
    [propertyData]
  );

  // Array to track secondary image uploads in campaign
  const fetchUserPlan = async () => {
    try {
      const res = await axiosInstance.get(endpoints.me);

      setUser(res.data);
      setRemainingCampaigns(res.data?.get_remaining_campaigns || 0);
      setExtraHubsCredit(res.data?.extra_hubs_credit || 0);
      const launchCredits = res.data?.extra_launch_credits || 0;
      setExtraLaunchCredits(launchCredits);
      // derive association limits
      let assocLimit = Number(
        res.data?.association_limit ??
        res.data?.get_association_limit ??
        res.data?.associationLimit ??
        0
      );
      const assocUsed = Number(res.data?.associations_used ?? 0);

      // If backend returned 0 but user has a plan, try to fall back to plan definition and active add-ons
      if ((isNaN(assocLimit) || assocLimit === 0) && res.data?.plan_name) {
        try {
          const plansResp = await axiosInstance.get(endpoints.plans);
          const plansList = Array.isArray(plansResp.data)
            ? plansResp.data
            : plansResp.data.results || [];
          const matched = plansList.find(
            (p: any) =>
              String(p.name).toLowerCase() ===
              String(res.data.plan_name).toLowerCase()
          );
          if (matched && (matched.association || matched.association === 0)) {
            assocLimit = Number(matched.association || 0);
          }

          // Add association credits from active add-ons if present
          const activeAddons: number[] = Array.isArray(res.data?.active_addons)
            ? res.data.active_addons
            : [];
          if (activeAddons.length) {
            try {
              const addonsResp = await axiosInstance.get(endpoints.add_ons);
              const addonsList = Array.isArray(addonsResp.data)
                ? addonsResp.data
                : addonsResp.data.addons || [];
              const addonSum = addonsList
                .filter((a: any) => activeAddons.includes(a.id))
                .reduce(
                  (sum: number, a: any) => sum + (Number(a.association) || 0),
                  0
                );
              assocLimit = (Number(assocLimit) || 0) + addonSum;
            } catch (e) {
              console.warn(
                "Failed to fetch add-ons for computing association credits",
                e
              );
            }
          }
        } catch (e) {
          console.warn(
            "Failed to fetch plans for fallback association limit",
            e
          );
        }
      }

      setAssociationLimit(isNaN(assocLimit) ? null : assocLimit);
      setAssociationsUsed(isNaN(assocUsed) ? 0 : assocUsed);
      if (!isNaN(assocLimit) && assocLimit > 0)
        setAssociationsRemaining(Math.max(0, assocLimit - assocUsed));
      else setAssociationsRemaining(null); // null = unlimited

      // derive plan access
      const plan = res.data?.plan_name;

      // SET userPlan STATE - this is used by property availability helpers
      setUserPlan(plan || null);

      // Extract trial information
      const isOnTrial = res.data?.is_in_free_trial || false;
      const trialEnd = res.data?.trial_end_date ? new Date(res.data.trial_end_date) : null;
      setIsOnFreeTrial(isOnTrial);
      setTrialEndDate(trialEnd);

      const isPro =
        plan === "Pro" ||
        plan === "Pro+" ||
        plan === "Pro Annual" ||
        plan === "Pro+ Annual" ||
        res.data?.subscription_status === "active";

      setIsProUser(isPro);

      // ===== FETCH ADD-ON PRICES FROM API =====
      await fetchAddOnUnitPrices(res.data?.plan?.id);
    } catch (error) {
      console.error("Failed to fetch user plan", error);
      setIsProUser(false);
    }
  };

  useEffect(() => {
    fetchUserPlan();
  }, []);

  useEffect(() => {
    const planId = selectedPricingPlan?.id || planDetails?.plan?.id;
    if (planId) {
      fetchAddOnUnitPrices(planId);
    }
  }, [selectedPricingPlan, planDetails?.plan?.id]);



  // Recompute remaining associations taking current selections into account
  useEffect(() => {

    if (associationLimit === null) {
      setAssociationsRemaining(null);
      return;
    }
    const remaining = Math.max(0, (associationLimit ?? 0) - associationsUsed);
    setAssociationsRemaining(remaining);
  }, [associationLimit, associationsUsed]);

  const [secondaryImageUploads, setSecondaryImageUploads] = useState<
    Array<{
      id: string;
      file: File;
      url: string;
      previewUrl: string;
      uploadedAt: Date;
      status: "uploading" | "success" | "failed";
    }>
  >([]);

  // =========================================================================
  // BEST SEND TIME CALCULATION
  // =========================================================================

  const handleAutoIQ = useCallback(async () => {
    if (isAutoIQLoading || autoIQCount >= MAX_AUTO_IQ_ATTEMPTS) return;

    const desc = serviceData.description.trim();

    if (desc.length < 10) {
      toast({
        title: "Description too short",
        description: "Please type at least 10 characters before using Auto IQ.",
        variant: "destructive",
        duration: 1000
      });
      return;
    }

    setIsAutoIQLoading(true);

    try {
      // =========================
      // STEP 1: Improve Description
      // =========================
      const descResp = await axiosInstance.post(
        endpoints.generate_description,
        {
          mode: "service",
          description: desc,
        }
      );

      const improvedDesc = descResp.data?.description?.trim();

      if (!improvedDesc) {
        throw new Error("No description returned from AI");
      }

      setServiceData((prev) => ({
        ...prev,
        description: improvedDesc,
      }));

      // =========================
      // STEP 2: Generate Subject
      // =========================
      const subjectResp = await axiosInstance.post(endpoints.generate_subject, {
        description: improvedDesc,
      });

      const subjects = subjectResp.data?.subjects || [];

      if (subjects.length > 0) {
        setSubject(subjects[0]);
      }

      setAutoIQCount((prev) => prev + 1);

      toast({
        title: "✨ Auto IQ Applied!",
        description:
          "Your description was improved and a subject line was generated from it.",
        duration: 1000
      });
    } catch (err: any) {
      console.error("Service Auto IQ error:", err);

      toast({
        title: "Auto IQ Failed",
        description:
          err.response?.data?.error ||
          "Could not generate content. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsAutoIQLoading(false);
    }
  }, [isAutoIQLoading, autoIQCount, serviceData.description]);

  const designRef = useRef<any>(null);
  const [serviceTemplateName, setServiceTemplateName] = useState(
    "My Service Template"
  );
  const [selectedServiceTemplate, setSelectedServiceTemplate] =
    useState<any>(null);
  const [savingTemplate, setSavingTemplate] = useState(false);
  const [savedServiceTemplateId, setSavedServiceTemplateId] = useState<
    number | null
  >(null);
  const [isGeneratingDesc, setIsGeneratingDesc] = useState(false);
  const [isImprovingText, setIsImprovingText] = useState(false);
  const [isCorrectingGrammar, setIsCorrectingGrammar] = useState(false);
  const [isEnhancingImage, setIsEnhancingImage] = useState(false);
  const [customDesign, setCustomDesign] = useState<{
    html: string;
    design: any;
  } | null>(null);
  const [showCustomServiceType, setShowCustomServiceType] = useState(false);
  const [customServiceType, setCustomServiceType] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  // Initialize custom service type if it exists and is not in the predefined list
  useEffect(() => {
    if (serviceData.serviceType) {
      if (!serviceTypes.includes(serviceData.serviceType)) {
        // It's a custom service type
        setShowCustomServiceType(true);
        setCustomServiceType(serviceData.serviceType);
      } else {
        // It's a predefined service type
        setShowCustomServiceType(false);
        setCustomServiceType("");
      }
    }
  }, [serviceData.serviceType]);

  const handleServiceTypeChange = (value: string) => {
    if (value === "custom") {
      setShowCustomServiceType(true);
      setServiceData((prev) => ({
        ...prev,
        serviceType: customServiceType || "",
        service_type: customServiceType || "",
      }));
    } else {
      setShowCustomServiceType(false);
      setCustomServiceType("");
      setServiceData((prev) => ({
        ...prev,
        serviceType: value,
        service_type: value,
      }));
    }
  };

  // Handle custom service type input
  const handleCustomServiceTypeInput = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    setCustomServiceType(value);
    setServiceData((prev) => ({
      ...prev,
      serviceType: value,
      service_type: value,
    }));
  };

  // Get the display value for select
  const getServiceTypeSelectValue = () => {
    if (showCustomServiceType) {
      return "custom";
    }
    if (serviceTypes.includes(serviceData.serviceType)) {
      return serviceData.serviceType;
    }
    if (
      serviceData.serviceType &&
      !serviceTypes.includes(serviceData.serviceType)
    ) {
      // It's a custom value that was previously saved
      setShowCustomServiceType(true);
      setCustomServiceType(serviceData.serviceType);
      return "custom";
    }
    return "";
  };

  const isValidServiceType = () => {
    if (showCustomServiceType) {
      return customServiceType.trim().length > 0;
    }
    return serviceData.serviceType && serviceData.serviceType.trim().length > 0;
  };

  const handleNextFromEditor = useCallback(() => {
    const editor = editorRef.current?.editor;
    if (!editor || !EmailEditor) {
      toast({ title: "Editor not loaded", variant: "destructive", duration: 1000 });
      return;
    }
    try {
      editor.exportHtml(({ html, design }: { html: string; design: any }) => {
        setCustomDesign({ html, design });
        sessionStorage.setItem("campaign_template_html", html);
        setCurrentStep(4);
      });
    } catch (err) {
      console.error("Failed to export HTML:", err);
      toast({
        title: "Error",
        description: "Failed to export design",
        variant: "destructive",
      });
    }
  }, [EmailEditor, toast]);
  const [contacts, setContacts] = useState<any[]>([]);
  const [customAgentLists, setCustomAgentLists] = useState<AgentList[]>([]);
  const [selectedCustomDatasets, setSelectedCustomDatasets] = useState<
    string[]
  >([]); // group IDs


  const normalizeCustomDatasetIds = useCallback(
    (items: any[] = selectedCustomDatasets) => {
      return Array.from(
        new Set(
          (Array.isArray(items) ? items : [])
            .map((item) => {
              const raw = String(item ?? "").trim();
              if (!raw) return null;
              const match = customAgentLists.find(
                (list: any) =>
                  String(list.id) === raw ||
                  String(list.name || list.company || list.list_name || "").trim() === raw
              );
              return String(match?.id ?? raw);
            })
            .filter(Boolean) as string[]
        )
      );
    },
    [customAgentLists, selectedCustomDatasets]
  );

  // ============ CALCULATE RECIPIENT COUNT (Declared after all dependencies) ============
  const recipientCount = useMemo(() => {
    try {
      let dbCount = 0;
      let customCount = 0;

      // Calculate database (associations) count
      if (sendTo.database && selectedDatasets.length > 0) {
        agentLists.forEach((list) => {
          // Check both string and number comparison for ID matching
          const isSelected = selectedDatasets.some(
            (selectedId) =>
              String(selectedId) === String(list.id) ||
              Number(selectedId) === Number(list.id)
          );

          if (isSelected) {
            const count = Number(list.agent_count || list.count || 0);

            dbCount += count;
          }
        });

      }

      // Calculate custom lists (My Contacts) count
      if (sendTo.mycontacts && selectedCustomDatasets.length > 0) {
        selectedCustomDatasets.forEach((key) => {
          const match = customAgentLists.find((l: any) => {
            return (
              String(l.id) === String(key) ||
              String(l.company || l.list_name || l.name) === String(key)
            );
          });
          if (match) {
            const c = Number(match.count || match.agent_count || match.size || 0);
            customCount += c;
          }
        });
      }

      const total = dbCount + customCount;
      return total;
    } catch (e) {
      console.error("❌ Error calculating recipient count:", e);
      return 0;
    }
  }, [
    sendTo.database,
    sendTo.mycontacts,
    selectedDatasets,
    selectedCustomDatasets,
    agentLists,
    customAgentLists,
  ]);

  const buildCampaignDraftPayload = (draftData: any): any => {
    const payload: any = {
      campaign_type: draftData.campaign_type || 'property',
      status: draftData.status || 'draft',
    };

    if (draftData.campaign_name) payload.campaign_name = draftData.campaign_name;
    if (!payload.campaign_name && draftData.title) payload.campaign_name = draftData.title;
    if (!payload.campaign_name && draftData.headline) payload.campaign_name = draftData.headline;
    if (draftData.campaign_subject) payload.campaign_subject = draftData.campaign_subject;
    if (!payload.campaign_subject && draftData.subject) payload.campaign_subject = draftData.subject;
    if (draftData.description) payload.message = draftData.description;
    if (draftData.template || draftData.template_name) payload.template = draftData.template || draftData.template_name;
    if (draftData.custom_template_id) payload.custom_template_id = Number(draftData.custom_template_id);
    else if (draftData.selected_template_id) payload.custom_template_id = Number(draftData.selected_template_id);
    if (draftData.template_html) payload.html = draftData.template_html;
    if (draftData.image_url) payload.image_url = draftData.image_url;
    if (!payload.image_url && draftData.hero_image) payload.image_url = draftData.hero_image;
    if (draftData.thumbnail_url) payload.thumbnail_url = draftData.thumbnail_url;
    if (draftData.service_type) payload.service_type = draftData.service_type;
    if (draftData.property_id) payload.property_id = draftData.property_id;
    if (draftData.service_id) payload.service_id = draftData.service_id;

    if (Array.isArray(draftData.association_ids) && draftData.association_ids.length > 0) {
      payload.association_ids = draftData.association_ids.map((id: any) => Number(id)).filter((id: number) => !Number.isNaN(id));
    } else if (Array.isArray(draftData.selected_datasets) && draftData.selected_datasets.length > 0) {
      payload.association_ids = draftData.selected_datasets.map((id: any) => Number(id)).filter((id: number) => !Number.isNaN(id));
    }

    if (Array.isArray(draftData.county_ids) && draftData.county_ids.length > 0) {
      payload.county_ids = draftData.county_ids.map((id: any) => Number(id)).filter((id: number) => !Number.isNaN(id));
    }
    if (Array.isArray(draftData.agent_user_ids) && draftData.agent_user_ids.length > 0) {
      payload.agent_user_ids = draftData.agent_user_ids.map((id: any) => Number(id)).filter((id: number) => !Number.isNaN(id));
    }
    if (Array.isArray(draftData.custom_agent_user_ids) && draftData.custom_agent_user_ids.length > 0) {
      payload.custom_agent_user_ids = draftData.custom_agent_user_ids.map((id: any) => Number(id)).filter((id: number) => !Number.isNaN(id));
    }

    if (Array.isArray(draftData.selected_custom_datasets) && draftData.selected_custom_datasets.length > 0) {
      payload.custom_dataset_names = normalizeCustomDatasetIds(draftData.selected_custom_datasets);
    } else if (Array.isArray(draftData.custom_dataset_names) && draftData.custom_dataset_names.length > 0) {
      payload.custom_dataset_names = normalizeCustomDatasetIds(draftData.custom_dataset_names);
    }

    if (draftData.selected_date_time) {
      payload.scheduled_date = draftData.selected_date_time;
    }
    if (draftData.scheduled_date) {
      payload.scheduled_date = draftData.scheduled_date;
    }
    if (draftData.scheduled_timezone) {
      payload.scheduled_timezone = draftData.scheduled_timezone;
    }
    if (draftData.timezone) {
      payload.scheduled_timezone = draftData.timezone;
    }

    if (typeof draftData.is_recurring !== 'undefined') payload.is_recurring = draftData.is_recurring;
    if (draftData.recurrence_type) payload.recurrence_type = draftData.recurrence_type;
    if (draftData.recurring_end_date) payload.recurring_end_date = draftData.recurring_end_date;
    if (Array.isArray(draftData.custom_recurring_dates) && draftData.custom_recurring_dates.length > 0) {
      payload.custom_recurring_dates = draftData.custom_recurring_dates;
    }
    if (typeof recipientCount === 'number') payload.recipient_count = recipientCount;
    if (draftData.payment_intent_id) payload.payment_intent_id = draftData.payment_intent_id;

    const passthroughFields = [
      'title',
      'headline',
      'listing_id',
      'address',
      'postal_code',
      'city',
      'state',
      'price',
      'bedrooms',
      'bathrooms',
      'property_type',
      'area',
      'description',
      'text_section',
      'property_list_name',
      'propertyListType',
      'is_open_house',
      'photos',
      'service_photos',
      'key_features',
      'features',
      'service_features',
      'template_name',
      'selected_template_id',
      'selected_state',
      'send_to',
      'selected_datasets',
      'selected_custom_datasets',
      'selected_date_time',
      'current_step',
      'service_campaign_id',
      'accepted_terms',
      'subject',
    ];

    passthroughFields.forEach((field) => {
      if (typeof draftData[field] !== 'undefined') {
        payload[field] = draftData[field];
      }
    });

    return payload;
  };

  const handleSaveDraftOnLeave = async () => {
    // ========== NEW: CHECK FOR OVERWRITE ==========
    // Skip this check if user already confirmed overwrite
    if (!overwriteConfirmed) {
      const needsOverwriteConfirmation = checkForExistingDraft();

      if (needsOverwriteConfirmation) {
        // Show overwrite dialog and return early
        setShowDraftOverwriteDialog(true);
        return;
      }
    }

    // Reset the flag for next time
    setOverwriteConfirmed(false);
    // ========== END OF NEW CODE ==========

    // ========== YOUR EXISTING CODE BELOW (unchanged) ==========
    setIsDraftSaving(true);

    let stepToSave = draftStepToSave || currentStep;
    if (stepToSave > 7) {
      stepToSave = 7;
    }

    try {
      let finalCampaignType = campaignType;

      if (!finalCampaignType) {
        const hasServiceTitle = serviceData?.title?.trim();
        const hasServiceId = selectedService?.id || serviceCampaignId;
        const hasPropertyTitle = propertyData?.headline?.trim() || selectedProperty?.title?.trim();
        const hasPropertyId = selectedProperty?.id;

        // console.log('[handleSaveDraftOnLeave] Detection:', {
        //   hasServiceTitle,
        //   hasServiceId,
        //   hasPropertyTitle,
        //   hasPropertyId,
        //   campaignType
        // });

        if ((hasServiceTitle || hasServiceId) && !hasPropertyId) {
          finalCampaignType = 'service';
          console.log('[handleSaveDraftOnLeave] ✅ Auto-detected: SERVICE');
        } else {
          finalCampaignType = 'property';
          console.log('[handleSaveDraftOnLeave] ✅ Auto-detected: PROPERTY (or default)');
        }
      } else {
        console.log('[handleSaveDraftOnLeave] ✅ Using explicit campaignType:', finalCampaignType);
      }

      const draftData: any = {
        current_step: stepToSave,
        campaign_type: finalCampaignType,
        status: 'draft',
      };

      console.log('[handleSaveDraftOnLeave] Saving draft with campaign_type:', draftData.campaign_type);

      // ========== STEP 2+ DATA - Property/Service details ==========
      if (stepToSave >= 2) {
        if (finalCampaignType === 'property') {
          draftData.title = propertyData?.headline || selectedProperty?.title || "";
          draftData.headline = propertyData?.headline || selectedProperty?.headline || "";
          draftData.address = propertyData?.address || selectedProperty?.address || "";
          draftData.listing_id = propertyData?.listing_id || selectedProperty?.listing_id || "";
          draftData.postal_code = propertyData?.postalCode || selectedProperty?.postal_code || "";
          draftData.city = propertyData?.city || selectedProperty?.city || "";
          draftData.state = propertyData?.state || selectedProperty?.state || "";
          draftData.price = propertyData?.price || selectedProperty?.price || null;
          draftData.bedrooms = propertyData?.bedrooms || selectedProperty?.bedrooms || null;
          draftData.bathrooms = propertyData?.bathrooms || selectedProperty?.bathrooms || null;
          draftData.area = propertyData?.area || selectedProperty?.area || null;
          draftData.property_type = propertyData?.propertyType || selectedProperty?.property_type || "";
          draftData.status = propertyData?.status || selectedProperty?.status || "draft";
          draftData.description = propertyData?.description || selectedProperty?.description || "";
          draftData.text_section = propertyData?.text_section || selectedProperty?.text_section || "";
          draftData.is_open_house = selectedProperty?.is_open_house || false;

          if (!selectedImageFile) {
            const heroImage = propertyData?.heroImage || selectedProperty?.image || "";
            if (heroImage && isValidPhotoUrl(heroImage)) {
              draftData.image_url = heroImage;
            }
          }

          if (photoFiles.length === 0) {
            const photos: string[] = [];
            const allPhotos = [
              ...(propertyData?.photos || []),
              ...(selectedProperty?.photos || [])
            ];
            allPhotos.forEach((photo: string) => {
              if (isValidPhotoUrl(photo) && !photos.includes(photo)) {
                photos.push(photo);
              }
            });
            if (photos.length > 0) {
              draftData.photos = photos;
            }
          }

          if (selectedPropertyList) {
            const listObj = propertyLists.find(l => l.list_name === selectedPropertyList);
            if (listObj) {
              draftData.propertyListType = listObj.id;
              draftData.property_list_name = listObj.list_name;
            }
          }

          if (selectedProperty?.id) {
            draftData.property_id = selectedProperty.id;
          }

        } else if (finalCampaignType === 'service') {
          draftData.title = serviceData?.title || selectedService?.title || "";
          draftData.headline = serviceData?.headline || serviceData?.title || "";
          draftData.service_type = serviceData?.serviceType || serviceData?.service_type || "";
          draftData.description = serviceData?.description || "";
          draftData.phone = serviceData?.phone || "";
          draftData.email = serviceData?.email || "";
          draftData.website = serviceData?.website || "";
          draftData.address = serviceData?.address || "";

          const features = (serviceData?.features || []).filter((f: any) => f && f.toString().trim() !== "");
          if (features.length > 0) {
            draftData.features = features;
            draftData.service_features = features;
          }

          if (!selectedImageFile) {
            const heroImage = serviceData?.heroImage || "";
            if (heroImage && isValidPhotoUrl(heroImage)) {
              draftData.hero_image = heroImage;
            }
          }

          if (photoFiles.length === 0) {
            const photos: string[] = [];
            const allPhotos = serviceData?.photos || [];
            allPhotos.forEach((photo: string) => {
              if (isValidPhotoUrl(photo) && !photos.includes(photo)) {
                photos.push(photo);
              }
            });
            if (photos.length > 0) {
              draftData.photos = photos;
              draftData.service_photos = photos;
            }
          }

          if (selectedService?.id) {
            draftData.service_id = selectedService.id;
          } else if (serviceCampaignId) {
            draftData.service_id = serviceCampaignId;
          }
          if (serviceCampaignId) {
            draftData.service_campaign_id = serviceCampaignId;
          }
        }
      }

      // ========== STEP 3+ DATA - Template ==========
      if (stepToSave >= 3) {
        if (finalCampaignType === 'property' && selectedTemplate) {
          draftData.selected_template_id = String(selectedTemplate.id);
          draftData.template_name = selectedTemplate.name;

          try {
            const templateHtml = sessionStorage.getItem("campaign_template_html");
            if (templateHtml) {
              draftData.template_html = templateHtml;
            }
          } catch (e) { }

        } else if (finalCampaignType === 'service' && selectedServiceTemplate) {
          draftData.selected_template_id = String(selectedServiceTemplate.id);
          draftData.template_name = selectedServiceTemplate.name;
        }
      }

      // ========== STEP 4+ DATA - Subject and Features ==========
      if (stepToSave >= 4) {
        if (subject && subject.trim() !== "") {
          draftData.subject = subject;
        }

        if (finalCampaignType === 'property' && keyFeatures && keyFeatures.length > 0) {
          draftData.key_features = keyFeatures.map(f => ({
            id: f.id,
            feature_name: f.feature_name
          }));
        }
      }

      // ========== STEP 5+ DATA - Recipients ==========
      if (stepToSave >= 5) {
        draftData.send_to = sendTo;

        if (selectedDatasets.length > 0) {
          draftData.selected_datasets = selectedDatasets;
        }
        if (selectedCustomDatasets.length > 0) {
          draftData.selected_custom_datasets = selectedCustomDatasets;
        }
        if (selectedState) {
          draftData.selected_state = selectedState;
        }
      }

      // ========== STEP 6 DATA - Schedule (MAX STEP TO SAVE) ==========
      if (stepToSave >= 6) {
        draftData.schedule_option = scheduleOption || 'now';

        if (selectedDateTime) {
          draftData.selected_date_time = selectedDateTime;
        }

        draftData.is_recurring = isRecurringCampaign || false;

        if (isRecurringCampaign) {
          draftData.recurrence_type = recurrenceType;
          if (recurringEndDate) {
            draftData.recurring_end_date = recurringEndDate;
          }
          if (customRecurringDates && customRecurringDates.length > 0) {
            draftData.custom_recurring_dates = customRecurringDates;
          }
        }

        draftData.accepted_terms = acceptedTerms || false;
      }

      const campaignPayload = buildCampaignDraftPayload(draftData);
      const response = await campaignDraftService.saveDraft(campaignPayload);

      if (response.data) {
        toast({
          title: "✓ Draft Saved",
          description: `Progress saved at Step ${stepToSave}: ${launchSteps[stepToSave - 1]?.title || 'Unknown'}`,
          variant: "default",
          duration: 1000
        });

        setHasDraft(true);
        setDraft(response.data.data || draftData);

        // ✅ NEW: Update the appropriate draft state
        if (finalCampaignType === 'property') {
          setPropertyDraft(response.data.data || draftData);
        } else {
          setServiceDraft(response.data.data || draftData);
        }
      }

      try {
        sessionStorage.removeItem("campaign_template_html");
        sessionStorage.removeItem("service_custom_template_html");
        sessionStorage.removeItem("campaignSubject");
        sessionStorage.removeItem("selectedTemplateId");
        sessionStorage.removeItem("selectedPropertyId");
      } catch (e) { }

      setHasUnsavedChanges(false);

      // ✅ NEW: Also close overwrite dialog if it was open
      setShowDraftOverwriteDialog(false);
      setExistingDraftInfo(null);

      const target = pendingNavigation;
      setShowLeaveDraftDialog(false);
      setShowDraftOverwriteDialog(false);
      setExistingDraftInfo(null);

      if (!target) {
        try {
          delete (window as any).__ignoreBeforeUnload;
          delete (window as any).__bypassNav;
        } catch (e) { }
        setPendingNavigation(null);
      }
      if (target) {
        console.log('[handleSaveDraftOnLeave] navigating to pendingNavigation (captured):', target);
        // @ts-ignore
        (window as any).__ignoreBeforeUnload = true;
        // @ts-ignore
        (window as any).__bypassNav = true;

        setTimeout(() => {
          try {
            navigate(target);
            setTimeout(() => {
              if (window.location.pathname !== target) {
                console.warn('[handleSaveDraftOnLeave] navigate did not change path, falling back to window.location.href');
                window.location.href = target;
              }
            }, 250);
          } catch (err) {
            console.warn('[handleSaveDraftOnLeave] navigate threw, falling back to location.href', err);
            window.location.href = target;
          } finally {
            setTimeout(() => {
              try {
                // @ts-ignore
                delete (window as any).__ignoreBeforeUnload;
                // @ts-ignore
                delete (window as any).__bypassNav;
              } catch (e) { }
            }, 1000);
          }
        }, 80);

        setPendingNavigation(null);
      } else {
        console.log('[handleSaveDraftOnLeave] no pendingNavigation to navigate to');
      }

    } catch (error: any) {
      console.error('[handleSaveDraftOnLeave] Error:', error);

      // 🔥 Handle field validation errors from backend
      const fieldErrors = error.response?.data?.field_errors;
      if (fieldErrors && Array.isArray(fieldErrors)) {
        const errorMessages = fieldErrors.map((err: any) => err.message).join("\n");
        toast({
          title: "Fields Too Long",
          description: errorMessages,
          variant: "destructive",
          duration: 2000
        });
      } else {
        toast({
          title: "Error Saving Draft",
          description: error.response?.data?.detail || error.response?.data?.error || "Failed to save draft. Please try again.",
          variant: "destructive",
          duration: 1000
        });
      }
    } finally {
      setIsDraftSaving(false);
    }
  };

  const checkForExistingDraft = (): boolean => {
    // Determine which draft type we're saving
    let finalCampaignType = campaignType;

    if (!finalCampaignType) {
      const hasServiceTitle = serviceData?.title?.trim();
      const hasServiceId = selectedService?.id || serviceCampaignId;
      const hasPropertyId = selectedProperty?.id;

      if ((hasServiceTitle || hasServiceId) && !hasPropertyId) {
        finalCampaignType = 'service';
      } else {
        finalCampaignType = 'property';
      }
    }

    // Check if draft already exists for this type
    let existingDraft = null;
    if (finalCampaignType === 'property' && propertyDraft) {
      existingDraft = propertyDraft;
    } else if (finalCampaignType === 'service' && serviceDraft) {
      existingDraft = serviceDraft;
    }

    // If no existing draft, no need for overwrite dialog
    if (!existingDraft) {
      return false;
    }

    // ✅ FIX: Only consider it "same draft" when BOTH IDs are present AND explicitly match
    const isEditingSameDraft = (() => {
      if (finalCampaignType === 'property') {
        const existingId = existingDraft.property_id;
        const currentId = selectedProperty?.id;
        // Both must be present and match
        if (!existingId || !currentId) return false;
        return String(existingId) === String(currentId);
      } else {
        const existingId = existingDraft.service_id;
        const currentId = selectedService?.id || serviceCampaignId;
        // Both must be present and match
        if (!existingId || !currentId) return false;
        return String(existingId) === String(currentId);
      }
    })();

    // If editing the same draft, no overwrite warning needed
    if (isEditingSameDraft) {
      return false;
    }

    // ✅ FIX: Also check if draft title/address matches current data
    // This prevents false positives when IDs are missing but content is the same
    const isSameContent = (() => {
      if (finalCampaignType === 'property') {
        const existingTitle = existingDraft.title || existingDraft.headline || '';
        const currentTitle = propertyData?.headline || selectedProperty?.title || '';
        const existingAddress = existingDraft.address || '';
        const currentAddress = propertyData?.address || selectedProperty?.address || '';
        if (existingTitle && currentTitle && existingTitle === currentTitle) return true;
        if (existingAddress && currentAddress && existingAddress === currentAddress) return true;
        return false;
      } else {
        const existingTitle = existingDraft.title || '';
        const currentTitle = serviceData?.title || selectedService?.title || '';
        if (existingTitle && currentTitle && existingTitle === currentTitle) return true;
        return false;
      }
    })();

    if (isSameContent) {
      return false;
    }

    // Different draft exists — set info and return true to show overwrite dialog
    setExistingDraftInfo({
      title: existingDraft.title || existingDraft.headline || existingDraft.address ||
        (finalCampaignType === 'service' ? 'Untitled Service' : 'Untitled Property'),
      step: existingDraft.current_step || existingDraft.currentStep || existingDraft.step || 1,
      type: finalCampaignType as 'property' | 'service',
      updatedAt: existingDraft.time_since_update || existingDraft.updated_at
    });

    return true;
  };



  // ✅ MODIFIED: Add overwrite check at the beginning of your existing function


  const handleConfirmDraftOverwrite = async () => {
    setShowDraftOverwriteDialog(false);
    setExistingDraftInfo(null);
    setIsDraftSaving(true);

    // ✅ FIX: Don't rely on overwriteConfirmed state (async).
    // Directly call the save logic with overwrite flag passed as parameter.
    try {
      let stepToSave = draftStepToSave || currentStep;
      if (stepToSave > 7) stepToSave = 7;

      let finalCampaignType = campaignType;
      if (!finalCampaignType) {
        const hasServiceTitle = serviceData?.title?.trim();
        const hasServiceId = selectedService?.id || serviceCampaignId;
        const hasPropertyId = selectedProperty?.id;
        if ((hasServiceTitle || hasServiceId) && !hasPropertyId) {
          finalCampaignType = 'service';
        } else {
          finalCampaignType = 'property';
        }
      }

      const draftData: any = {
        current_step: stepToSave,
        campaign_type: finalCampaignType,
        status: 'draft',
      };

      if (stepToSave >= 2) {
        if (finalCampaignType === 'property') {
          draftData.title = propertyData?.headline || selectedProperty?.title || "";
          draftData.headline = propertyData?.headline || selectedProperty?.headline || "";
          draftData.address = propertyData?.address || selectedProperty?.address || "";
          draftData.listing_id = propertyData?.listing_id || selectedProperty?.listing_id || "";
          draftData.postal_code = propertyData?.postalCode || selectedProperty?.postal_code || "";
          draftData.city = propertyData?.city || selectedProperty?.city || "";
          draftData.state = propertyData?.state || selectedProperty?.state || "";
          draftData.price = propertyData?.price || selectedProperty?.price || null;
          draftData.bedrooms = propertyData?.bedrooms || selectedProperty?.bedrooms || null;
          draftData.bathrooms = propertyData?.bathrooms || selectedProperty?.bathrooms || null;
          draftData.area = propertyData?.area || selectedProperty?.area || null;
          draftData.property_type = propertyData?.propertyType || selectedProperty?.property_type || "";
          draftData.description = propertyData?.description || selectedProperty?.description || "";
          draftData.text_section = propertyData?.text_section || selectedProperty?.text_section || "";
          draftData.is_open_house = selectedProperty?.is_open_house || false;

          if (!selectedImageFile) {
            const heroImage = propertyData?.heroImage || selectedProperty?.image || "";
            if (heroImage && isValidPhotoUrl(heroImage)) {
              draftData.image_url = heroImage;
            }
          }

          if (photoFiles.length === 0) {
            const photos: string[] = [];
            const allPhotos = [
              ...(propertyData?.photos || []),
              ...(selectedProperty?.photos || [])
            ];
            allPhotos.forEach((photo: string) => {
              if (isValidPhotoUrl(photo) && !photos.includes(photo)) {
                photos.push(photo);
              }
            });
            if (photos.length > 0) draftData.photos = photos;
          }

          if (selectedPropertyList) {
            const listObj = propertyLists.find(l => l.list_name === selectedPropertyList);
            if (listObj) {
              draftData.propertyListType = listObj.id;
              draftData.property_list_name = listObj.list_name;
            }
          }

          if (selectedProperty?.id) draftData.property_id = selectedProperty.id;

        } else if (finalCampaignType === 'service') {
          draftData.title = serviceData?.title || selectedService?.title || "";
          draftData.headline = serviceData?.headline || serviceData?.title || "";
          draftData.service_type = serviceData?.serviceType || serviceData?.service_type || "";
          draftData.description = serviceData?.description || "";
          draftData.phone = serviceData?.phone || "";
          draftData.email = serviceData?.email || "";
          draftData.website = serviceData?.website || "";
          draftData.address = serviceData?.address || "";

          const features = (serviceData?.features || []).filter((f: any) => f && f.toString().trim() !== "");
          if (features.length > 0) {
            draftData.features = features;
            draftData.service_features = features;
          }

          if (!selectedImageFile) {
            const heroImage = serviceData?.heroImage || "";
            if (heroImage && isValidPhotoUrl(heroImage)) draftData.hero_image = heroImage;
          }

          if (photoFiles.length === 0) {
            const photos: string[] = [];
            (serviceData?.photos || []).forEach((photo: string) => {
              if (isValidPhotoUrl(photo) && !photos.includes(photo)) photos.push(photo);
            });
            if (photos.length > 0) {
              draftData.photos = photos;
              draftData.service_photos = photos;
            }
          }

          if (selectedService?.id) draftData.service_id = selectedService.id;
          if (serviceCampaignId) draftData.service_campaign_id = serviceCampaignId;
        }
      }

      if (stepToSave >= 3) {
        if (finalCampaignType === 'property' && selectedTemplate) {
          draftData.selected_template_id = String(selectedTemplate.id);
          draftData.template_name = selectedTemplate.name;
          try {
            const templateHtml = sessionStorage.getItem("campaign_template_html");
            if (templateHtml) draftData.template_html = templateHtml;
          } catch (e) { }
        } else if (finalCampaignType === 'service' && selectedServiceTemplate) {
          draftData.selected_template_id = String(selectedServiceTemplate.id);
          draftData.template_name = selectedServiceTemplate.name;
        }
      }

      if (stepToSave >= 4) {
        if (subject && subject.trim() !== "") draftData.subject = subject;
        if (finalCampaignType === 'property' && keyFeatures && keyFeatures.length > 0) {
          draftData.key_features = keyFeatures.map(f => ({
            id: f.id,
            feature_name: f.feature_name
          }));
        }
      }

      if (stepToSave >= 5) {
        draftData.send_to = sendTo;
        if (selectedDatasets.length > 0) draftData.selected_datasets = selectedDatasets;
        if (selectedCustomDatasets.length > 0) draftData.selected_custom_datasets = selectedCustomDatasets;
        if (selectedState) draftData.selected_state = selectedState;
      }

      if (stepToSave >= 6) {
        draftData.schedule_option = scheduleOption || 'now';
        if (selectedDateTime) draftData.selected_date_time = selectedDateTime;
        draftData.is_recurring = isRecurringCampaign || false;
        if (isRecurringCampaign) {
          draftData.recurrence_type = recurrenceType;
          if (recurringEndDate) draftData.recurring_end_date = recurringEndDate;
          if (customRecurringDates && customRecurringDates.length > 0) {
            draftData.custom_recurring_dates = customRecurringDates;
          }
        }
        draftData.accepted_terms = acceptedTerms || false;
      }

      const campaignPayload = buildCampaignDraftPayload(draftData);
      const response = await campaignDraftService.saveDraft(campaignPayload);

      if (response.data) {
        toast({
          title: "✓ Draft Saved",
          description: `Progress saved at Step ${stepToSave}: ${launchSteps[stepToSave - 1]?.title || 'Unknown'}`,
          variant: "default",
          duration: 1000
        });

        setHasDraft(true);
        setDraft(response.data.data || draftData);

        if (finalCampaignType === 'property') {
          setPropertyDraft(response.data.data || draftData);
        } else {
          setServiceDraft(response.data.data || draftData);
        }
      }

      // Clear overwrite state
      setOverwriteConfirmed(false);
      setShowDraftOverwriteDialog(false);
      setExistingDraftInfo(null);
      setHasUnsavedChanges(false);

      // Navigate if pending
      const target = pendingNavigation;
      if (target) {
        (window as any).__ignoreBeforeUnload = true;
        (window as any).__bypassNav = true;
        setShowLeaveDraftDialog(false);
        setPendingNavigation(null);

        setTimeout(() => {
          try {
            navigate(target);
            setTimeout(() => {
              if (window.location.pathname !== target) {
                window.location.href = target;
              }
            }, 250);
          } catch (err) {
            window.location.href = target;
          } finally {
            setTimeout(() => {
              try {
                delete (window as any).__ignoreBeforeUnload;
                delete (window as any).__bypassNav;
              } catch (e) { }
            }, 1000);
          }
        }, 80);
      }

    } catch (error: any) {
      console.error('[handleConfirmDraftOverwrite] Error:', error);
      const fieldErrors = error.response?.data?.field_errors;
      if (fieldErrors && Array.isArray(fieldErrors)) {
        const errorMessages = fieldErrors.map((err: any) => err.message).join("\n");
        toast({
          title: "Fields Too Long",
          description: errorMessages,
          variant: "destructive",
          duration: 2000
        });
      } else {
        toast({
          title: "Error Saving Draft",
          description: error.response?.data?.detail || error.response?.data?.error || "Failed to save draft.",
          variant: "destructive",
          duration: 1000
        });
      }
    } finally {
      setIsDraftSaving(false);
    }
  };

  // ✅ Handle canceling the overwrite
  const handleCancelDraftOverwrite = () => {
    setShowDraftOverwriteDialog(false);
    setExistingDraftInfo(null);
  };

  // ✅ Handle using the existing draft instead
  const handleUseExistingDraft = () => {
    setShowDraftOverwriteDialog(false);
    setShowLeaveDraftDialog(false);

    if (existingDraftInfo?.type === 'property' && propertyDraft) {
      setDraft(propertyDraft);
      setCampaignType('property');
      setShowDraftPreview(true);
      setCurrentStep(1);
    } else if (existingDraftInfo?.type === 'service' && serviceDraft) {
      setDraft(serviceDraft);
      setCampaignType('service');
      setShowDraftPreview(true);
      setCurrentStep(1);
    }

    setExistingDraftInfo(null);
    setPendingNavigation(null);

    toast({
      title: "Loading Existing Draft",
      description: "Continue where you left off with your previous draft.",
      duration: 1000
    });
  };
  // ============ HELPER: Get AI Engagement Score Prediction ============
  const getEngagementScorePrediction = useCallback(async () => {
    try {
      setAiLoading(true);

      const price = selectedProperty?.price || propertyData.price || 0;
      const bedrooms = selectedProperty?.bedrooms || propertyData.bedrooms || 0;
      const bathrooms = selectedProperty?.bathrooms || propertyData.bathrooms || 0;
      const area = selectedProperty?.area || propertyData.area || 0;
      const description = selectedProperty?.description || propertyData.description || "";

      const res = await axiosInstance.post("/campaign/generate-engagement-score/", {
        property_price: price,
        bedrooms: bedrooms,
        bathrooms: bathrooms,
        area: area,
        description: description,
        recipient_count: recipientCount,
      });

      if (res.data?.score !== undefined) {
        setEngagementScore(res.data.score);
        return res.data.score;
      }
    } catch (err) {
      console.error("Error getting engagement score:", err);
      // Set a default score on error so it doesn't block the flow
      setEngagementScore(75);
    } finally {
      setAiLoading(false);
    }
  }, [selectedProperty, propertyData, recipientCount]);

  // ============ HELPER: Check if payment is needed ============
  const checkPaymentRequired = useCallback(() => {
    // Compute whether any add-on payment is required for this send.
    // The checkout logic (used later when building `checkoutData`) must match
    // the billing rules:
    // - 1 campaign ("launch") is free while remainingCampaigns > 0.
    // - 1 hub/association is included free with that launch while
    //   remainingCampaigns > 0 (do not charge hubs until remainingCampaigns is 0).
    // - Campaigns require payment if remainingCampaigns === 0 (or missing).

    const remainingCamps = remainingCampaigns ?? 0;

    // Only LaunchIQ Database hubs are billable. User datasets remain free.
    const totalSelected = sendTo.database ? selectedDatasets.length : 0;

    const totalSends =
      (Boolean(checkoutData?.recurrenceType) || isRecurringCampaign) && checkoutData?.recurringCount
        ? Number(checkoutData.recurringCount) || 1
        : 1;

    const totalAvailableCredits = Math.max(0, remainingCamps) + Math.max(0, extraLaunchCredits ?? 0);
    const freeLaunches = Math.min(totalAvailableCredits, totalSends);
    const paidLaunches = Math.max(0, totalSends - freeLaunches);

    // 1 hub/association is included with EACH launch (free or paid)
    const includedHubsPerSend = totalSelected > 0 ? 1 : 0;
    const extraHubsPerSend = Math.max(0, totalSelected - includedHubsPerSend);
    const totalExtraHubs = totalSends * extraHubsPerSend;

    if (paidLaunches > 0 || totalExtraHubs > 0) {
      setExtraCampaignCount(paidLaunches);
      setExtraAssociationCount(totalExtraHubs);
      setNeedsPayment(true);
      return true;
    }

    setNeedsPayment(false);
    setExtraCampaignCount(0);
    setExtraAssociationCount(0);
    return false;
  }, [remainingCampaigns, sendTo, selectedDatasets, selectedCustomDatasets, isRecurringCampaign, checkoutData]);

  // Debug: Log when associations change
  // Monitor recipient count changes
  // useEffect(() => {
  //   console.log("📊 [useEffect] recipientCount changed:", recipientCount, {
  //     step: currentStep,
  //     sendTo,
  //     selectedDatasets,
  //     selectedCustomDatasets,
  //     agentListsLength: agentLists.length,
  //     customAgentListsLength: customAgentLists.length,
  //   });
  // }, [
  //   recipientCount,
  //   currentStep,
  //   sendTo,
  //   selectedDatasets,
  //   selectedCustomDatasets,
  //   agentLists.length,
  //   customAgentLists.length,
  // ]);

  // Monitor when moving to Step 7
  useEffect(() => {
    if (currentStep === 7) {
    }
  }, [
    currentStep,
    recipientCount,
    sendTo,
    selectedDatasets,
    selectedCustomDatasets,
    agentLists,
    customAgentLists,
  ]);

  // When entering Step 7, request OpenAI-based predictions from backend
  useEffect(() => {
    const fetchAiPrediction = async () => {
      if (currentStep !== 7) return;
      if (recipientCount <= 0) return;
      setAiLoading(true);
      try {
        const recipients_summary = {
          recipient_count: recipientCount,
          associations: selectedDatasets,
          hubs: selectedCustomDatasets,
        };

        const campaign_info = {
          campaignType,
          subject,
          template: selectedTemplate?.name || null,
          // Include property-level details so AI prediction uses them
          property: selectedProperty
            ? {
              id: selectedProperty.id,
              title: selectedProperty.title || selectedProperty.headline || "",
              headline: selectedProperty.headline || selectedProperty.title || "",
              address: selectedProperty.address || "",
              city: selectedProperty.city || "",
              state: selectedProperty.state || "",
              price: selectedProperty.price || selectedProperty.list_price || null,
              description: selectedProperty.description || "",
            }
            : {
              title: propertyData.headline || "",
              address: propertyData.address || "",
              city: "",
              state: selectedState || "",
              price: propertyData.price || null,
              description: propertyData.description || propertyData.text_section || "",
            },
          scheduleOption,
          selectedDateTime,
        };

        const res = await axiosInstance.post(endpoints.predict_rates, {
          recipients_summary,
          campaign_info,
        });

        if (res && res.data && (res.data.open_rate || res.data.click_rate)) {
          setAiPrediction(res.data);
        }
      } catch (err) {
        // console.error("AI prediction failed", err);
      } finally {
        setAiLoading(false);
      }
    };

    fetchAiPrediction();
  }, [currentStep, recipientCount, selectedDatasets, selectedCustomDatasets, campaignType, subject, selectedTemplate]);

  // When entering Step 8, calculate engagement score
  useEffect(() => {
    if (currentStep === 8 && engagementScore === null) {
      getEngagementScorePrediction();
    }
  }, [currentStep, engagementScore, getEngagementScorePrediction]);

  const calculateBestSendTimes = useMemo(() => {
    interface TimeRecommendation {
      id: number;
      dayName: string;
      dayNumber: number;
      hour: number;
      formattedTime: string;
      reason: string;
      confidence: number; // 0-100 score
      category: string;
      factors: string[];
    }

    // Scoring factors
    let recommendations: TimeRecommendation[] = [];
    const factors: string[] = [];

    // =========================================================================
    // ANALYZE PROPERTY DATA
    // =========================================================================
    if (campaignType === "property") {
      // Extract all property details
      const price = selectedProperty?.price || propertyData.price;
      const numericPrice =
        typeof price === "number"
          ? price
          : parseInt(String(price || "0").replace(/[^0-9]/g, ""));

      const propertyType = (
        selectedProperty?.property_type ||
        propertyData.propertyType ||
        ""
      ).toLowerCase();

      const isOpenHouse = Boolean(
        selectedProperty?.is_open_house || propertyData.is_open_house
      );

      const bedrooms = Number(
        selectedProperty?.bedrooms || propertyData.bedrooms || 0
      );

      const bathrooms = Number(
        selectedProperty?.bathrooms || propertyData.bathrooms || 0
      );

      const area = Number(selectedProperty?.area || propertyData.area || 0);

      const address = (
        selectedProperty?.address ||
        propertyData.address ||
        ""
      ).toLowerCase();

      const description = (
        selectedProperty?.description ||
        propertyData.description ||
        ""
      ).toLowerCase();

      const headline = (
        selectedProperty?.title ||
        propertyData.headline ||
        ""
      ).toLowerCase();

      // =========================================================================
      // DETERMINE PROPERTY CATEGORY & TARGET AUDIENCE
      // =========================================================================

      // Price-based categorization
      let priceCategory = "standard";
      let targetAudience = "general";

      if (numericPrice >= 2000000) {
        priceCategory = "ultra-luxury";
        targetAudience = "high-net-worth";
        factors.push(
          `Ultra-luxury property ($${(numericPrice / 1000000).toFixed(1)}M+)`
        );
      } else if (numericPrice >= 1000000) {
        priceCategory = "luxury";
        targetAudience = "affluent-professionals";
        factors.push(
          `Luxury property ($${(numericPrice / 1000000).toFixed(1)}M)`
        );
      } else if (numericPrice >= 500000) {
        priceCategory = "upper-mid";
        targetAudience = "professionals";
        factors.push(`Upper-mid range ($${(numericPrice / 1000).toFixed(0)}K)`);
      } else if (numericPrice >= 300000) {
        priceCategory = "mid-range";
        targetAudience = "families";
        factors.push(
          `Mid-range property ($${(numericPrice / 1000).toFixed(0)}K)`
        );
      } else if (numericPrice > 0) {
        priceCategory = "starter";
        targetAudience = "first-time-buyers";
        factors.push(
          `Starter/Affordable ($${(numericPrice / 1000).toFixed(0)}K)`
        );
      }

      // Property type analysis
      let propertyCategory = "residential";
      if (
        propertyType.includes("commercial") ||
        propertyType.includes("office") ||
        propertyType.includes("retail")
      ) {
        propertyCategory = "commercial";
        targetAudience = "investors";
        factors.push("Commercial property");
      } else if (
        propertyType.includes("condo") ||
        propertyType.includes("apartment")
      ) {
        propertyCategory = "condo";
        factors.push("Condo/Apartment");
      } else if (
        propertyType.includes("land") ||
        propertyType.includes("lot")
      ) {
        propertyCategory = "land";
        targetAudience = "developers";
        factors.push("Land/Lot");
      } else if (
        propertyType.includes("multi") ||
        propertyType.includes("duplex") ||
        propertyType.includes("triplex")
      ) {
        propertyCategory = "multi-family";
        targetAudience = "investors";
        factors.push("Multi-family property");
      }

      // Size-based analysis
      let sizeCategory = "standard";
      if (bedrooms >= 5 || area >= 4000) {
        sizeCategory = "large";
        factors.push(
          `Large property (${bedrooms} bed, ${area.toLocaleString()} sqft)`
        );
      } else if (bedrooms <= 2 && area < 1200) {
        sizeCategory = "compact";
        factors.push(
          `Compact property (${bedrooms} bed, ${area.toLocaleString()} sqft)`
        );
      } else if (bedrooms >= 3) {
        factors.push(`Family-sized (${bedrooms} bed, ${bathrooms} bath)`);
      }

      // Open House detection
      if (isOpenHouse) {
        factors.push("Open House scheduled");
      }

      // Keyword analysis from description/headline
      const keywords = {
        investment: [
          "investment",
          "roi",
          "rental",
          "income",
          "cash flow",
          "tenant",
        ],
        luxury: [
          "luxury",
          "premium",
          "exclusive",
          "estate",
          "mansion",
          "prestigious",
        ],
        family: [
          "family",
          "school",
          "backyard",
          "neighborhood",
          "kids",
          "playground",
        ],
        modern: [
          "modern",
          "new construction",
          "smart home",
          "contemporary",
          "renovated",
        ],
        waterfront: [
          "waterfront",
          "ocean",
          "lake",
          "beach",
          "water view",
          "bay",
        ],
        downtown: ["downtown", "urban", "city center", "walkable", "metro"],
        suburban: ["suburban", "quiet", "cul-de-sac", "peaceful", "private"],
        retirement: ["retirement", "senior", "55+", "active adult", "golf"],
      };

      const combinedText = `${headline} ${description} ${address}`;
      const detectedKeywords: string[] = [];

      Object.entries(keywords).forEach(([category, words]) => {
        if (words.some((word) => combinedText.includes(word))) {
          detectedKeywords.push(category);
        }
      });

      if (detectedKeywords.length > 0) {
        factors.push(`Keywords: ${detectedKeywords.join(", ")}`);
      }

      // Location analysis
      const locationKeywords = {
        urban: ["downtown", "city", "metro", "urban"],
        suburban: ["suburb", "residential", "neighborhood"],
        rural: ["rural", "country", "farm", "acres"],
        coastal: ["beach", "ocean", "coastal", "bay", "waterfront"],
      };

      let locationType = "suburban"; // default
      Object.entries(locationKeywords).forEach(([type, words]) => {
        if (
          words.some(
            (word) => address.includes(word) || description.includes(word)
          )
        ) {
          locationType = type;
        }
      });

      // =========================================================================
      // GENERATE DYNAMIC RECOMMENDATIONS
      // =========================================================================

      // Base time slots with scoring
      const timeSlots = [
        // Morning slots
        { day: 1, hour: 8, name: "Monday", period: "Early Morning" },
        { day: 1, hour: 10, name: "Monday", period: "Mid-Morning" },
        { day: 1, hour: 11, name: "Monday", period: "Late Morning" },
        { day: 2, hour: 8, name: "Tuesday", period: "Early Morning" },
        { day: 2, hour: 9, name: "Tuesday", period: "Mid-Morning" },
        { day: 2, hour: 10, name: "Tuesday", period: "Mid-Morning" },
        { day: 2, hour: 11, name: "Tuesday", period: "Late Morning" },
        { day: 2, hour: 14, name: "Tuesday", period: "Afternoon" },
        { day: 3, hour: 8, name: "Wednesday", period: "Early Morning" },
        { day: 3, hour: 9, name: "Wednesday", period: "Mid-Morning" },
        { day: 3, hour: 10, name: "Wednesday", period: "Mid-Morning" },
        { day: 3, hour: 11, name: "Wednesday", period: "Late Morning" },
        { day: 3, hour: 14, name: "Wednesday", period: "Afternoon" },
        { day: 3, hour: 15, name: "Wednesday", period: "Afternoon" },
        { day: 4, hour: 8, name: "Thursday", period: "Early Morning" },
        { day: 4, hour: 9, name: "Thursday", period: "Mid-Morning" },
        { day: 4, hour: 10, name: "Thursday", period: "Mid-Morning" },
        { day: 4, hour: 11, name: "Thursday", period: "Late Morning" },
        { day: 4, hour: 12, name: "Thursday", period: "Lunch" },
        { day: 4, hour: 14, name: "Thursday", period: "Afternoon" },
        { day: 5, hour: 9, name: "Friday", period: "Morning" },
        { day: 5, hour: 10, name: "Friday", period: "Morning" },
        { day: 6, hour: 10, name: "Saturday", period: "Morning" },
        { day: 0, hour: 11, name: "Sunday", period: "Morning" },
        { day: 0, hour: 18, name: "Sunday", period: "Evening" },
      ];

      // Score each time slot
      const scoredSlots = timeSlots.map((slot) => {
        let score = 50; // Base score
        const reasons: string[] = [];

        // ========== PRICE-BASED SCORING ==========
        if (priceCategory === "ultra-luxury" || priceCategory === "luxury") {
          // Luxury: Tuesday-Wednesday, 10-11 AM (executives after meetings)
          if (slot.day === 2 && slot.hour === 10) {
            score += 25;
            reasons.push("Optimal for luxury buyers");
          }
          if (slot.day === 2 && slot.hour === 11) {
            score += 20;
            reasons.push("High-net-worth engagement peak");
          }
          if (slot.day === 3 && slot.hour === 10) {
            score += 18;
            reasons.push("Strong luxury market response");
          }
          if (slot.day === 3 && slot.hour === 11) {
            score += 15;
            reasons.push("Professional buyers available");
          }
          if (slot.day === 4 && slot.hour === 9) {
            score += 12;
            reasons.push("Pre-weekend luxury viewing planning");
          }
          // Penalize weekends and early hours
          if (slot.day === 0 || slot.day === 6) {
            score -= 15;
          }
          if (slot.hour < 9) {
            score -= 10;
          }
          if (slot.hour >= 17) {
            score -= 10;
          }
        } else if (priceCategory === "upper-mid") {
          // Upper-mid: Wednesday-Thursday, 10-11 AM
          if (slot.day === 3 && slot.hour === 11) {
            score += 22;
            reasons.push("Peak for professional buyers");
          }
          if (slot.day === 3 && slot.hour === 10) {
            score += 20;
            reasons.push("High engagement for upper-mid segment");
          }
          if (slot.day === 2 && slot.hour === 10) {
            score += 18;
            reasons.push("Strong response from career professionals");
          }
          if (slot.day === 4 && slot.hour === 10) {
            score += 15;
            reasons.push("Thursday planning for weekend viewings");
          }
          if (slot.day === 4 && slot.hour === 12) {
            score += 10;
            reasons.push("Lunch-hour browsing");
          }
        } else if (priceCategory === "mid-range") {
          // Mid-range: Wednesday, family-friendly times
          if (slot.day === 3 && slot.hour === 10) {
            score += 22;
            reasons.push("Optimal for family home buyers");
          }
          if (slot.day === 2 && slot.hour === 11) {
            score += 18;
            reasons.push("Strong family engagement");
          }
          if (slot.day === 4 && slot.hour === 10) {
            score += 16;
            reasons.push("Pre-weekend family planning");
          }
          if (slot.day === 3 && slot.hour === 14) {
            score += 12;
            reasons.push("Afternoon family browsing");
          }
          // Slight boost for weekend
          if (slot.day === 6 && slot.hour === 10) {
            score += 8;
            reasons.push("Weekend family house hunting");
          }
        } else if (priceCategory === "starter") {
          // Starter homes: Thursday lunch, evenings, weekends
          if (slot.day === 4 && slot.hour === 12) {
            score += 25;
            reasons.push("First-time buyers browse during lunch");
          }
          if (slot.day === 3 && slot.hour === 19) {
            score += 20;
            reasons.push("After-work browsing for young buyers");
          }
          if (slot.day === 6 && slot.hour === 10) {
            score += 18;
            reasons.push("Weekend house hunting time");
          }
          if (slot.day === 0 && slot.hour === 11) {
            score += 15;
            reasons.push("Sunday morning property browsing");
          }
          if (slot.day === 2 && slot.hour === 18) {
            score += 12;
            reasons.push("Evening research time");
          }
          // Young buyers are more active in evenings/weekends
          if (slot.hour >= 18 && slot.hour <= 20) {
            score += 8;
          }
        }

        // ========== PROPERTY TYPE SCORING ==========
        if (propertyCategory === "commercial") {
          // Commercial: Early mornings, Tue-Thu
          if (slot.day === 2 && slot.hour === 9) {
            score += 20;
            reasons.push("Business decision-makers review early");
          }
          if (slot.day === 3 && slot.hour === 10) {
            score += 18;
            reasons.push("Mid-week investment planning");
          }
          if (slot.day === 2 && slot.hour === 8) {
            score += 15;
            reasons.push("Early reach to business professionals");
          }
          if (slot.day === 4 && slot.hour === 8) {
            score += 12;
            reasons.push("Thursday morning investment reviews");
          }
          // Penalize weekends heavily
          if (slot.day === 0 || slot.day === 6) {
            score -= 25;
          }
          if (slot.hour >= 17) {
            score -= 15;
          }
        } else if (propertyCategory === "multi-family") {
          // Multi-family/Investment: Tuesday-Wednesday mornings
          if (slot.day === 2 && slot.hour === 9) {
            score += 22;
            reasons.push("Investors analyze deals early week");
          }
          if (slot.day === 3 && slot.hour === 10) {
            score += 18;
            reasons.push("Mid-week investment opportunity review");
          }
          if (slot.day === 2 && slot.hour === 10) {
            score += 15;
            reasons.push("Strong investor engagement");
          }
          if (slot.day === 4 && slot.hour === 9) {
            score += 12;
            reasons.push("Pre-weekend deal analysis");
          }
        } else if (propertyCategory === "condo") {
          // Condos: Often younger buyers, more flexible times
          if (slot.day === 3 && slot.hour === 11) {
            score += 20;
            reasons.push("Peak condo buyer engagement");
          }
          if (slot.day === 2 && slot.hour === 10) {
            score += 18;
            reasons.push("Strong urban buyer response");
          }
          if (slot.day === 4 && slot.hour === 12) {
            score += 15;
            reasons.push("Lunch-hour condo browsing");
          }
          if (slot.day === 0 && slot.hour === 11) {
            score += 10;
            reasons.push("Weekend condo shopping");
          }
        } else if (propertyCategory === "land") {
          // Land: Developers, early mornings
          if (slot.day === 2 && slot.hour === 8) {
            score += 22;
            reasons.push("Developers review opportunities early");
          }
          if (slot.day === 3 && slot.hour === 9) {
            score += 18;
            reasons.push("Mid-week land investment analysis");
          }
          if (slot.day === 1 && slot.hour === 9) {
            score += 15;
            reasons.push("Week-start project planning");
          }
        }

        // ========== OPEN HOUSE SCORING ==========
        if (isOpenHouse) {
          // Best sent Wed-Thu to allow weekend planning
          if (slot.day === 3 && slot.hour === 11) {
            score += 20;
            reasons.push("Optimal for weekend open house awareness");
          }
          if (slot.day === 4 && slot.hour === 10) {
            score += 18;
            reasons.push("Last chance to plan weekend visit");
          }
          if (slot.day === 3 && slot.hour === 10) {
            score += 15;
            reasons.push("Mid-week open house promotion");
          }
          if (slot.day === 5 && slot.hour === 9) {
            score += 10;
            reasons.push("Friday reminder for weekend open house");
          }
          // Penalize early week and weekends
          if (slot.day === 1) {
            score -= 5;
          }
          if (slot.day === 0 || slot.day === 6) {
            score -= 10;
          }
        }

        // ========== SIZE-BASED SCORING ==========
        if (sizeCategory === "large") {
          // Large homes: Families, slightly later morning
          if (slot.hour === 10 || slot.hour === 11) {
            score += 5;
            reasons.push("Family-friendly timing");
          }
          if (slot.day === 6) {
            score += 5;
            reasons.push("Weekend family viewing opportunity");
          }
        } else if (sizeCategory === "compact") {
          // Compact: Young professionals, flexible
          if (slot.hour >= 18 && slot.hour <= 20) {
            score += 8;
            reasons.push("After-work browsing for young professionals");
          }
          if (slot.day === 4 && slot.hour === 12) {
            score += 5;
            reasons.push("Lunch-break property search");
          }
        }

        // ========== KEYWORD-BASED SCORING ==========
        if (detectedKeywords.includes("investment")) {
          if (slot.day === 2 && slot.hour <= 10) {
            score += 10;
            reasons.push("Investor-focused timing");
          }
          if (slot.hour < 9) {
            score += 5;
          }
        }
        if (detectedKeywords.includes("family")) {
          if (slot.hour >= 10 && slot.hour <= 14) {
            score += 5;
            reasons.push("Family-friendly hours");
          }
          if (slot.day === 6 || slot.day === 0) {
            score += 5;
            reasons.push("Weekend family time");
          }
        }
        if (detectedKeywords.includes("luxury")) {
          if (slot.day === 2 && slot.hour === 10) {
            score += 8;
            reasons.push("Premium buyer engagement");
          }
          if (slot.day === 3 && slot.hour === 11) {
            score += 6;
          }
        }
        if (detectedKeywords.includes("retirement")) {
          // Seniors check email mid-morning
          if (slot.hour >= 9 && slot.hour <= 11) {
            score += 10;
            reasons.push("Senior-friendly timing");
          }
          if (slot.day >= 1 && slot.day <= 4) {
            score += 5;
          }
        }
        if (
          detectedKeywords.includes("downtown") ||
          detectedKeywords.includes("urban")
        ) {
          // Urban buyers: More flexible, lunch hours good
          if (slot.hour === 12) {
            score += 8;
            reasons.push("Urban professional lunch browsing");
          }
          if (slot.hour >= 17 && slot.hour <= 19) {
            score += 5;
            reasons.push("After-work city browsing");
          }
        }

        // ========== RECIPIENT COUNT ADJUSTMENT ==========
        if (recipientCount > 10000) {
          // Large campaigns: Earlier is better to avoid server queues
          if (slot.hour === 8 || slot.hour === 9) {
            score += 5;
            reasons.push("Early send for large campaign");
          }
        } else if (recipientCount > 5000) {
          if (slot.hour <= 10) {
            score += 3;
          }
        }

        // ========== DAY-OF-WEEK BASE ADJUSTMENTS ==========
        // Tuesday and Wednesday are generally best for email
        if (slot.day === 2) {
          score += 5;
        }
        if (slot.day === 3) {
          score += 5;
        }
        // Monday has lower engagement (catching up)
        if (slot.day === 1 && slot.hour < 10) {
          score -= 5;
        }
        // Friday afternoon is poor
        if (slot.day === 5 && slot.hour >= 14) {
          score -= 10;
        }

        return {
          ...slot,
          score: Math.min(100, Math.max(0, score)),
          reasons: reasons.slice(0, 2), // Top 2 reasons
        };
      });

      // Sort by score and take top 5
      const topSlots = scoredSlots
        .sort((a, b) => b.score - a.score)
        .slice(0, 5);

      // Convert to recommendations with timezone conversion
      recommendations = topSlots.map((slot, index) => {
        // Create a UTC date for this slot (next occurrence)
        const now = new Date();
        const daysUntilSlot = (slot.day - now.getUTCDay() + 7) % 7 || 7;
        const recommendedDate = new Date(now.getTime() + daysUntilSlot * 24 * 60 * 60 * 1000);
        recommendedDate.setUTCHours(slot.hour, 0, 0, 0);

        // Format in user's timezone
        const userTzTime = convertUtcToUserTimezone(recommendedDate.toISOString());

        // Parse formatted time to extract just the time part
        const timeMatch = userTzTime.time.match(/(\d{1,2}):(\d{2})\s(AM|PM)/);
        const displayTime = timeMatch ? `${timeMatch[1]}:${timeMatch[2]} ${timeMatch[3]}` : `${slot.hour > 12 ? slot.hour - 12 : slot.hour === 0 ? 12 : slot.hour}:00 ${slot.hour >= 12 ? "PM" : "AM"}`;

        const localInputValue = toDateInputValue(recommendedDate.toISOString());
        const formattedLocalDate = new Intl.DateTimeFormat("en-US", {
          timeZone: effectiveTimezone,
          weekday: "short",
          month: "short",
          day: "numeric",
          year: "numeric",
        }).format(recommendedDate);

        return {
          id: index + 1,
          dayName: slot.name,
          dayNumber: slot.day,
          hour: slot.hour,
          formattedTime: displayTime,
          userTimezone: userTzTime.timezone,
          utcTime: `${slot.hour > 12 ? slot.hour - 12 : slot.hour === 0 ? 12 : slot.hour}:00 ${slot.hour >= 12 ? "PM" : "AM"} UTC`,
          // `datetime-local` value in the user's selected timezone.
          // This prevents double-conversion bugs when saving (we convert to UTC only once on submit).
          inputValue:
            localInputValue ||
            recommendedDate.toISOString().slice(0, 16).replace("T", "T"),
          formattedDate: formattedLocalDate,
          reason:
            slot.reasons.length > 0
              ? slot.reasons.join(". ")
              : `${slot.period} on ${slot.name} shows strong engagement for this property type`,
          confidence: slot.score,
          category:
            index === 0
              ? "Best Overall"
              : index === 1
                ? "Second Best"
                : slot.period,
          factors: factors,
        };
      });
    }

    // =========================================================================
    // ANALYZE SERVICE DATA
    // =========================================================================
    else if (campaignType === "service") {
      const serviceType = (
        serviceData.serviceType ||
        serviceData.service_type ||
        ""
      ).toLowerCase();

      const serviceTitle = (serviceData.title || "").toLowerCase();
      const serviceDescription = (serviceData.description || "").toLowerCase();
      const serviceFeatures = (serviceData.features || [])
        .join(" ")
        .toLowerCase();

      const combinedServiceText = `${serviceType} ${serviceTitle} ${serviceDescription} ${serviceFeatures}`;

      // Categorize service
      let serviceCategory = "general";

      if (
        serviceType.includes("mortgage") ||
        serviceType.includes("loan") ||
        serviceType.includes("finance") ||
        serviceType.includes("broker")
      ) {
        serviceCategory = "financial";
        factors.push("Financial/Mortgage service");
      } else if (
        serviceType.includes("contractor") ||
        serviceType.includes("renovation") ||
        serviceType.includes("construction") ||
        serviceType.includes("remodel")
      ) {
        serviceCategory = "contractor";
        factors.push("Contractor/Renovation service");
      } else if (
        serviceType.includes("photo") ||
        serviceType.includes("staging") ||
        serviceType.includes("virtual") ||
        serviceType.includes("media")
      ) {
        serviceCategory = "media";
        factors.push("Photography/Staging service");
      } else if (
        serviceType.includes("clean") ||
        serviceType.includes("maid") ||
        serviceType.includes("janitorial")
      ) {
        serviceCategory = "cleaning";
        factors.push("Cleaning service");
      } else if (
        serviceType.includes("landscape") ||
        serviceType.includes("lawn") ||
        serviceType.includes("garden") ||
        serviceType.includes("yard")
      ) {
        serviceCategory = "landscaping";
        factors.push("Landscaping service");
      } else if (
        serviceType.includes("inspect") ||
        serviceType.includes("apprais")
      ) {
        serviceCategory = "inspection";
        factors.push("Inspection/Appraisal service");
      } else if (
        serviceType.includes("moving") ||
        serviceType.includes("relocation") ||
        serviceType.includes("storage")
      ) {
        serviceCategory = "moving";
        factors.push("Moving/Relocation service");
      } else if (
        serviceType.includes("plumb") ||
        serviceType.includes("electric") ||
        serviceType.includes("hvac") ||
        serviceType.includes("repair")
      ) {
        serviceCategory = "trades";
        factors.push("Trade/Repair service");
      } else if (
        serviceType.includes("legal") ||
        serviceType.includes("attorney") ||
        serviceType.includes("title")
      ) {
        serviceCategory = "legal";
        factors.push("Legal/Title service");
      } else if (serviceType.includes("insurance")) {
        serviceCategory = "insurance";
        factors.push("Insurance service");
      }

      // Additional keyword detection
      if (
        combinedServiceText.includes("urgent") ||
        combinedServiceText.includes("emergency") ||
        combinedServiceText.includes("fast")
      ) {
        factors.push("Urgency messaging detected");
      }
      if (
        combinedServiceText.includes("discount") ||
        combinedServiceText.includes("special") ||
        combinedServiceText.includes("offer")
      ) {
        factors.push("Promotional content detected");
      }

      // Time slots for services
      const serviceTimeSlots = [
        { day: 1, hour: 9, name: "Monday", period: "Morning" },
        { day: 1, hour: 10, name: "Monday", period: "Mid-Morning" },
        { day: 1, hour: 11, name: "Monday", period: "Late Morning" },
        { day: 2, hour: 8, name: "Tuesday", period: "Early Morning" },
        { day: 2, hour: 9, name: "Tuesday", period: "Morning" },
        { day: 2, hour: 10, name: "Tuesday", period: "Mid-Morning" },
        { day: 2, hour: 11, name: "Tuesday", period: "Late Morning" },
        { day: 2, hour: 14, name: "Tuesday", period: "Afternoon" },
        { day: 3, hour: 8, name: "Wednesday", period: "Early Morning" },
        { day: 3, hour: 9, name: "Wednesday", period: "Morning" },
        { day: 3, hour: 10, name: "Wednesday", period: "Mid-Morning" },
        { day: 3, hour: 11, name: "Wednesday", period: "Late Morning" },
        { day: 3, hour: 14, name: "Wednesday", period: "Afternoon" },
        { day: 4, hour: 8, name: "Thursday", period: "Early Morning" },
        { day: 4, hour: 9, name: "Thursday", period: "Morning" },
        { day: 4, hour: 10, name: "Thursday", period: "Mid-Morning" },
        { day: 4, hour: 11, name: "Thursday", period: "Late Morning" },
        { day: 4, hour: 14, name: "Thursday", period: "Afternoon" },
        { day: 5, hour: 8, name: "Friday", period: "Early Morning" },
        { day: 5, hour: 9, name: "Friday", period: "Morning" },
        { day: 5, hour: 10, name: "Friday", period: "Morning" },
      ];

      // Score service time slots
      const scoredServiceSlots = serviceTimeSlots.map((slot) => {
        let score = 50;
        const reasons: string[] = [];

        // ========== SERVICE CATEGORY SCORING ==========
        if (serviceCategory === "financial") {
          if (slot.day === 2 && slot.hour === 9) {
            score += 25;
            reasons.push("Peak time for financing discussions");
          }
          if (slot.day === 2 && slot.hour === 10) {
            score += 22;
            reasons.push("Agents review lender options");
          }
          if (slot.day === 3 && slot.hour === 10) {
            score += 18;
            reasons.push("Mid-week financial planning");
          }
          if (slot.day === 1 && slot.hour === 10) {
            score += 15;
            reasons.push("Week-start financing reviews");
          }
          if (slot.day === 4 && slot.hour === 9) {
            score += 12;
            reasons.push("Thursday rate discussions");
          }
          if (slot.day === 5) {
            score -= 10;
          } // Financial decisions less on Friday
        } else if (serviceCategory === "contractor") {
          if (slot.day === 3 && slot.hour === 10) {
            score += 25;
            reasons.push("Mid-week renovation planning peak");
          }
          if (slot.day === 2 && slot.hour === 9) {
            score += 20;
            reasons.push("Agents sourcing contractors for listings");
          }
          if (slot.day === 4 && slot.hour === 10) {
            score += 18;
            reasons.push("Pre-weekend project scheduling");
          }
          if (slot.day === 1 && slot.hour === 9) {
            score += 15;
            reasons.push("Week-start project planning");
          }
          if (slot.day === 3 && slot.hour === 14) {
            score += 10;
            reasons.push("Afternoon contractor research");
          }
        } else if (serviceCategory === "media") {
          if (slot.day === 2 && slot.hour === 11) {
            score += 25;
            reasons.push("Optimal for new listing photo booking");
          }
          if (slot.day === 1 && slot.hour === 10) {
            score += 22;
            reasons.push("Week-start media planning");
          }
          if (slot.day === 3 && slot.hour === 10) {
            score += 18;
            reasons.push("Mid-week staging consultations");
          }
          if (slot.day === 4 && slot.hour === 11) {
            score += 15;
            reasons.push("Pre-weekend photo scheduling");
          }
          if (slot.day === 2 && slot.hour === 14) {
            score += 10;
            reasons.push("Afternoon media bookings");
          }
        } else if (serviceCategory === "cleaning") {
          if (slot.day === 4 && slot.hour === 10) {
            score += 25;
            reasons.push("Peak pre-weekend cleaning bookings");
          }
          if (slot.day === 3 && slot.hour === 11) {
            score += 22;
            reasons.push("Mid-week cleaning preparation");
          }
          if (slot.day === 5 && slot.hour === 8) {
            score += 18;
            reasons.push("Last-minute weekend prep");
          }
          if (slot.day === 2 && slot.hour === 10) {
            score += 15;
            reasons.push("Early week cleaning scheduling");
          }
          if (slot.day === 4 && slot.hour === 14) {
            score += 12;
            reasons.push("Afternoon cleaning coordination");
          }
        } else if (serviceCategory === "landscaping") {
          if (slot.day === 3 && slot.hour === 9) {
            score += 25;
            reasons.push("Mid-week curb appeal planning");
          }
          if (slot.day === 2 && slot.hour === 10) {
            score += 22;
            reasons.push("Early week landscaping quotes");
          }
          if (slot.day === 4 && slot.hour === 9) {
            score += 18;
            reasons.push("Pre-weekend yard preparation");
          }
          if (slot.day === 1 && slot.hour === 10) {
            score += 15;
            reasons.push("Week-start outdoor planning");
          }
          if (slot.day === 3 && slot.hour === 14) {
            score += 10;
            reasons.push("Afternoon landscaping consultations");
          }
        } else if (serviceCategory === "inspection") {
          if (slot.day === 2 && slot.hour === 8) {
            score += 25;
            reasons.push("Early reach for pending transactions");
          }
          if (slot.day === 3 && slot.hour === 9) {
            score += 22;
            reasons.push("Mid-week inspection scheduling");
          }
          if (slot.day === 1 && slot.hour === 9) {
            score += 18;
            reasons.push("Week-start inspection coordination");
          }
          if (slot.day === 4 && slot.hour === 8) {
            score += 15;
            reasons.push("Thursday inspection bookings");
          }
          if (slot.day === 2 && slot.hour === 10) {
            score += 12;
            reasons.push("Morning inspection discussions");
          }
        } else if (serviceCategory === "moving") {
          if (slot.day === 3 && slot.hour === 10) {
            score += 25;
            reasons.push("Mid-week moving coordination");
          }
          if (slot.day === 4 && slot.hour === 11) {
            score += 22;
            reasons.push("Pre-weekend move scheduling");
          }
          if (slot.day === 2 && slot.hour === 10) {
            score += 18;
            reasons.push("Moving quote requests peak");
          }
          if (slot.day === 1 && slot.hour === 11) {
            score += 15;
            reasons.push("Week-start relocation planning");
          }
          if (slot.day === 5 && slot.hour === 9) {
            score += 10;
            reasons.push("Friday moving confirmations");
          }
        } else if (serviceCategory === "trades") {
          if (slot.day === 2 && slot.hour === 9) {
            score += 25;
            reasons.push("Urgent repair requests peak");
          }
          if (slot.day === 1 && slot.hour === 8) {
            score += 22;
            reasons.push("Week-start emergency repairs");
          }
          if (slot.day === 3 && slot.hour === 10) {
            score += 18;
            reasons.push("Scheduled maintenance planning");
          }
          if (slot.day === 4 && slot.hour === 9) {
            score += 15;
            reasons.push("Pre-weekend repairs");
          }
          if (slot.day === 5 && slot.hour === 8) {
            score += 12;
            reasons.push("Friday quick fixes");
          }
        } else if (serviceCategory === "legal") {
          if (slot.day === 2 && slot.hour === 10) {
            score += 25;
            reasons.push("Legal review timing optimal");
          }
          if (slot.day === 3 && slot.hour === 11) {
            score += 22;
            reasons.push("Mid-week closing preparation");
          }
          if (slot.day === 1 && slot.hour === 10) {
            score += 18;
            reasons.push("Week-start legal consultations");
          }
          if (slot.day === 4 && slot.hour === 10) {
            score += 15;
            reasons.push("Pre-closing legal reviews");
          }
          if (slot.day === 5) {
            score -= 10;
          } // Legal less responsive Friday
        } else if (serviceCategory === "insurance") {
          if (slot.day === 2 && slot.hour === 10) {
            score += 25;
            reasons.push("Insurance quote timing optimal");
          }
          if (slot.day === 3 && slot.hour === 11) {
            score += 22;
            reasons.push("Mid-week policy discussions");
          }
          if (slot.day === 1 && slot.hour === 11) {
            score += 18;
            reasons.push("Week-start coverage reviews");
          }
          if (slot.day === 4 && slot.hour === 10) {
            score += 15;
            reasons.push("Pre-closing insurance needs");
          }
        } else {
          // General service
          if (slot.day === 2 && slot.hour === 10) {
            score += 20;
            reasons.push("Peak service inquiry time");
          }
          if (slot.day === 3 && slot.hour === 11) {
            score += 18;
            reasons.push("Strong mid-week engagement");
          }
          if (slot.day === 4 && slot.hour === 10) {
            score += 15;
            reasons.push("Pre-weekend service booking");
          }
          if (slot.day === 2 && slot.hour === 14) {
            score += 10;
            reasons.push("Afternoon service research");
          }
        }

        // ========== GENERAL ADJUSTMENTS ==========
        // Tuesday/Wednesday bonus
        if (slot.day === 2 || slot.day === 3) {
          score += 5;
        }
        // Early Friday penalty
        if (slot.day === 5 && slot.hour >= 12) {
          score -= 10;
        }
        // Monday morning penalty (catching up)
        if (slot.day === 1 && slot.hour < 9) {
          score -= 5;
        }

        // Recipient count
        if (recipientCount > 5000 && slot.hour <= 9) {
          score += 3;
        }

        return {
          ...slot,
          score: Math.min(100, Math.max(0, score)),
          reasons: reasons.slice(0, 2),
        };
      });

      // Sort and take top 5
      const topServiceSlots = scoredServiceSlots
        .sort((a, b) => b.score - a.score)
        .slice(0, 5);

      recommendations = topServiceSlots.map((slot, index) => ({
        id: index + 1,
        dayName: slot.name,
        dayNumber: slot.day,
        hour: slot.hour,
        formattedTime: `${slot.hour > 12 ? slot.hour - 12 : slot.hour === 0 ? 12 : slot.hour
          }:00 ${slot.hour >= 12 ? "PM" : "AM"}`,
        reason:
          slot.reasons.length > 0
            ? slot.reasons.join(". ")
            : `${slot.period} on ${slot.name} optimal for ${serviceCategory} services`,
        confidence: slot.score,
        category:
          index === 0
            ? "Best Overall"
            : index === 1
              ? "Second Best"
              : slot.period,
        factors: factors,
      }));
    }

    // =========================================================================
    // DEFAULT FALLBACK
    // =========================================================================
    if (recommendations.length === 0) {
      recommendations = [
        {
          id: 1,
          dayName: "Tuesday",
          dayNumber: 2,
          hour: 10,
          formattedTime: "10:00 AM",
          reason: "Industry standard peak time",
          confidence: 75,
          category: "Best Overall",
          factors: ["Default recommendation"],
        },
        {
          id: 2,
          dayName: "Wednesday",
          dayNumber: 3,
          hour: 11,
          formattedTime: "11:00 AM",
          reason: "Strong mid-week engagement",
          confidence: 70,
          category: "Second Best",
          factors: ["Default recommendation"],
        },
        {
          id: 3,
          dayName: "Thursday",
          dayNumber: 4,
          hour: 10,
          formattedTime: "10:00 AM",
          reason: "Pre-weekend planning time",
          confidence: 65,
          category: "Alternative",
          factors: ["Default recommendation"],
        },
        {
          id: 4,
          dayName: "Tuesday",
          dayNumber: 2,
          hour: 14,
          formattedTime: "2:00 PM",
          reason: "Afternoon engagement spike",
          confidence: 60,
          category: "Afternoon",
          factors: ["Default recommendation"],
        },
        {
          id: 5,
          dayName: "Wednesday",
          dayNumber: 3,
          hour: 9,
          formattedTime: "9:00 AM",
          reason: "Early morning reach",
          confidence: 55,
          category: "Early Bird",
          factors: ["Default recommendation"],
        },
      ];
    }

    // =========================================================================
    // CALCULATE ACTUAL DATES
    // =========================================================================
    const now = new Date();
    const weekdayMap: Record<string, number> = {
      Sun: 0,
      Mon: 1,
      Tue: 2,
      Wed: 3,
      Thu: 4,
      Fri: 5,
      Sat: 6,
    };

    const getNextOccurrenceUtcIso = (weekday: number, hour: number): string => {
      for (let i = 0; i < 14; i++) {
        const probe = new Date(now.getTime() + i * 24 * 60 * 60 * 1000);
        const localDate =
          new Intl.DateTimeFormat("sv-SE", {
            timeZone: effectiveTimezone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }).format(probe) || "";

        if (!localDate) continue;

        // Determine the weekday of this local date in the selected timezone.
        const localNoonUtcIso = localToUtcIso(`${localDate}T12:00`);
        if (!localNoonUtcIso) continue;
        const weekdayShort =
          new Intl.DateTimeFormat("en-US", {
            timeZone: effectiveTimezone,
            weekday: "short",
          }).format(new Date(localNoonUtcIso)) || "";

        if ((weekdayMap[weekdayShort] ?? -1) !== weekday) continue;

        const scheduledLocal = `${localDate}T${String(hour).padStart(2, "0")}:00`;
        const scheduledUtcIso = localToUtcIso(scheduledLocal);
        if (!scheduledUtcIso) continue;
        if (new Date(scheduledUtcIso) <= now) continue;

        return scheduledUtcIso;
      }

      // Fallback: 7 days from now at this hour (UTC) if anything goes wrong.
      const fallback = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
      fallback.setUTCHours(hour, 0, 0, 0);
      return fallback.toISOString();
    };

    const recommendationsWithDates = recommendations.map((rec) => {
      const utcIso = getNextOccurrenceUtcIso(rec.dayNumber, rec.hour);
      const targetDate = new Date(utcIso);
      const inputValue = toDateInputValue(utcIso) || rec.inputValue;

      // Determine confidence label
      let confidenceLabel: "high" | "medium" | "low" = "medium";
      if (rec.confidence >= 75) confidenceLabel = "high";
      else if (rec.confidence >= 50) confidenceLabel = "medium";
      else confidenceLabel = "low";

      return {
        ...rec,
        date: targetDate,
        formattedDate: formatDateTime(utcIso, {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric",
        }),
        inputValue,
        confidenceLabel,
        confidencePercent: rec.confidence,
      };
    });

    return {
      recommendations: recommendationsWithDates,
      factors: factors,
      analysisType: campaignType,
    };
  }, [
    campaignType,
    selectedProperty,
    propertyData,
    serviceData,
    recipientCount,
    effectiveTimezone,
    toDateInputValue,
  ]);

  const calculateEngagementPredictions = useMemo(() => {

    interface EngagementPrediction {
      openRate: number;
      clickRate: number;
      estimatedOpens: number;
      estimatedClicks: number;
      estimatedLeads: number;
      estimatedResponses: number;
      engagementScore: number;
      qualityScore: "excellent" | "good" | "average" | "low";
      conversionRate: number;
      reachRate: number;
      insights: string[];
      recommendations: string[];
      factors: {
        name: string;
        impact: "positive" | "neutral" | "negative";
        value: string;
        score: number;
      }[];
      breakdown: {
        label: string;
        value: number;
        percentage: number;
        color: string;
      }[];
    }

    const totalContacts = recipientCount;


    const insights: string[] = [];
    const recommendations: string[] = [];
    const factors: {
      name: string;
      impact: "positive" | "neutral" | "negative";
      value: string;
      score: number;
    }[] = [];

    if (totalContacts === 0) {

      return {
        openRate: 0,
        clickRate: 0,
        estimatedOpens: 0,
        estimatedClicks: 0,
        estimatedLeads: 0,
        estimatedResponses: 0,
        engagementScore: 0,
        qualityScore: "low" as const,
        conversionRate: 0,
        reachRate: 0,
        insights: ["Select recipients to see engagement predictions"],
        recommendations: [
          "Choose at least one association or contact list to continue",
        ],
        factors: [],
        breakdown: [],
      };
    }

    // =========================================================================
    // REALISTIC DYNAMIC BASE CALCULATION BASED ON CONTACT COUNT
    // =========================================================================
    // Industry benchmarks: Real estate email open rates average 19-25%
    // We'll show slightly optimized rates (25-35% for good campaigns)
    // but scale DOWN as list size increases (more realistic)

    let dynamicOpenRate: number;
    let dynamicClickRate: number;
    let baseQualityMultiplier = 1.0; // Will be adjusted based on campaign quality

    // Base rates scale DOWN as audience grows (more realistic)
    if (totalContacts <= 100) {
      // Very targeted - highest engagement
      dynamicOpenRate = 32 + Math.random() * 6; // 32-38%
      dynamicClickRate = 6 + Math.random() * 2; // 6-8%
      baseQualityMultiplier = 1.15; // Small list bonus
      factors.push({
        name: "Highly Targeted Audience",
        impact: "positive",
        value: "Small, focused list",
        score: 8,
      });
    } else if (totalContacts <= 500) {
      // Small targeted list
      dynamicOpenRate = 28 + Math.random() * 5; // 28-33%
      dynamicClickRate = 5 + Math.random() * 1.8; // 5-6.8%
      baseQualityMultiplier = 1.1;
      factors.push({
        name: "Well-Targeted List",
        impact: "positive",
        value: "Good audience size",
        score: 6,
      });
    } else if (totalContacts <= 1000) {
      // Medium list - realistic average
      dynamicOpenRate = 24 + Math.random() * 4; // 24-28%
      dynamicClickRate = 4.5 + Math.random() * 1.5; // 4.5-6%
      baseQualityMultiplier = 1.05;
      factors.push({
        name: "Medium Audience",
        impact: "positive",
        value: "Balanced reach",
        score: 5,
      });
    } else if (totalContacts <= 2500) {
      // Larger list - lower engagement
      dynamicOpenRate = 21 + Math.random() * 3.5; // 21-24.5%
      dynamicClickRate = 4 + Math.random() * 1.3; // 4-5.3%
      baseQualityMultiplier = 1.0;
      factors.push({
        name: "Large Audience",
        impact: "neutral",
        value: "Broad reach",
        score: 4,
      });
    } else if (totalContacts <= 5000) {
      // Large list
      dynamicOpenRate = 19 + Math.random() * 3; // 19-22%
      dynamicClickRate = 3.5 + Math.random() * 1.2; // 3.5-4.7%
      baseQualityMultiplier = 0.95;
      factors.push({
        name: "Very Large Audience",
        impact: "neutral",
        value: "Maximum exposure",
        score: 3,
      });
    } else if (totalContacts <= 10000) {
      // Very large list - industry average
      dynamicOpenRate = 17 + Math.random() * 2.5; // 17-19.5%
      dynamicClickRate = 3 + Math.random() * 1; // 3-4%
      baseQualityMultiplier = 0.9;
      factors.push({
        name: "Mass Distribution",
        impact: "neutral",
        value: "Wide market coverage",
        score: 2,
      });
    } else {
      // Massive list (10k+) - expect lower engagement
      dynamicOpenRate = 15 + Math.random() * 2; // 15-17%
      dynamicClickRate = 2.5 + Math.random() * 0.8; // 2.5-3.3%
      baseQualityMultiplier = 0.85;
      factors.push({
        name: "Massive Campaign",
        impact: "negative",
        value: "Very broad distribution",
        score: 1,
      });
      insights.push(
        "Large lists typically have lower engagement. Consider segmenting for better results."
      );
    }

    // Add contact tier info
    const contactTier =
      totalContacts <= 500
        ? "Highly Targeted"
        : totalContacts <= 2000
          ? "Well Targeted"
          : totalContacts <= 5000
            ? "Broad Reach"
            : "Maximum Exposure";

    factors.push({
      name: `${totalContacts.toLocaleString()} Contacts (${contactTier})`,
      impact: totalContacts <= 2000 ? "positive" : "neutral",
      value: `Base: ${dynamicOpenRate.toFixed(1)}% open rate`,
      score: totalContacts <= 1000 ? 10 : totalContacts <= 5000 ? 7 : 5,
    });

    // =========================================================================
    // CAMPAIGN TYPE BOOST
    // =========================================================================
    if (campaignType === "property") {
      const boost = (1.5 + Math.random() * 1) * baseQualityMultiplier;
      dynamicOpenRate += boost;
      dynamicClickRate += boost * 0.3;

      factors.push({
        name: "Property Campaign",
        impact: "positive",
        value: `+${boost.toFixed(1)}% engagement`,
        score: 6,
      });

      // Price-based dynamic boost (More Realistic)
      const price = selectedProperty?.price || propertyData.price;
      const numericPrice =
        typeof price === "number"
          ? price
          : parseInt(String(price || "0").replace(/[^0-9]/g, ""));

      if (numericPrice > 0) {
        let priceBoost = 0;
        let priceLabel = "";

        if (numericPrice >= 2000000) {
          priceBoost = (2.5 + Math.random() * 1) * baseQualityMultiplier;
          priceLabel = `Ultra-Luxury ($${(numericPrice / 1000000).toFixed(
            1
          )}M)`;
          insights.push(
            `Ultra-luxury properties generate ${Math.round(
              18 + Math.random() * 7
            )}% more interest than average`
          );
        } else if (numericPrice >= 1000000) {
          priceBoost = (2 + Math.random() * 0.8) * baseQualityMultiplier;
          priceLabel = `Luxury ($${(numericPrice / 1000000).toFixed(1)}M)`;
          insights.push(
            `Luxury listings see ${Math.round(
              15 + Math.random() * 5
            )}% higher engagement`
          );
        } else if (numericPrice >= 500000) {
          priceBoost = (1.5 + Math.random() * 0.6) * baseQualityMultiplier;
          priceLabel = `Premium ($${(numericPrice / 1000).toFixed(0)}K)`;
        } else if (numericPrice >= 300000) {
          priceBoost = (1.2 + Math.random() * 0.5) * baseQualityMultiplier;
          priceLabel = `Mid-Market ($${(numericPrice / 1000).toFixed(0)}K)`;
        } else {
          priceBoost = (1.8 + Math.random() * 0.7) * baseQualityMultiplier;
          priceLabel = `Starter Home ($${(numericPrice / 1000).toFixed(0)}K)`;
          insights.push(
            "First-time buyer properties show strong demand in current market"
          );
        }

        dynamicOpenRate += priceBoost;
        dynamicClickRate += priceBoost * 0.2;

        factors.push({
          name: priceLabel,
          impact: "positive",
          value: `+${priceBoost.toFixed(1)}% boost`,
          score: Math.round(priceBoost * 1.5),
        });
      }

      // Property details boost
      const bedrooms = Number(
        selectedProperty?.bedrooms || propertyData.bedrooms || 0
      );
      const bathrooms = Number(
        selectedProperty?.bathrooms || propertyData.bathrooms || 0
      );
      const area = Number(selectedProperty?.area || propertyData.area || 0);

      if (bedrooms >= 4 && bathrooms >= 3) {
        const familyBoost = 2.5 + Math.random() * 1;
        dynamicOpenRate += familyBoost;
        factors.push({
          name: `Family Home (${bedrooms}BR/${bathrooms}BA)`,
          impact: "positive",
          value: `+${familyBoost.toFixed(1)}%`,
          score: 6,
        });
      }

      if (area >= 3000) {
        const sizeBoost = 2 + Math.random() * 0.8;
        dynamicOpenRate += sizeBoost;
        factors.push({
          name: `Spacious (${area.toLocaleString()} sqft)`,
          impact: "positive",
          value: `+${sizeBoost.toFixed(1)}%`,
          score: 5,
        });
      }

      // Open House boost
      const isOpenHouse =
        selectedProperty?.is_open_house || propertyData.is_open_house;
      if (isOpenHouse) {
        const ohBoost = 5 + Math.random() * 2;
        dynamicOpenRate += ohBoost;
        dynamicClickRate += ohBoost * 0.4;

        factors.push({
          name: "Open House Event",
          impact: "positive",
          value: `+${ohBoost.toFixed(1)}% engagement`,
          score: 12,
        });
        insights.push(
          `Open house emails generate ${Math.round(
            40 + Math.random() * 15
          )}% more clicks`
        );
      }

      // Property type boost
      const propertyType = (
        selectedProperty?.property_type ||
        propertyData.propertyType ||
        ""
      ).toLowerCase();
      if (propertyType) {
        let typeBoost = 2 + Math.random() * 1;
        let typeLabel =
          propertyType.charAt(0).toUpperCase() + propertyType.slice(1);

        if (propertyType.includes("commercial")) {
          typeBoost = 3 + Math.random() * 1.5;
          typeLabel = "Commercial Property";
        } else if (propertyType.includes("condo")) {
          typeBoost = 2.5 + Math.random() * 1;
          typeLabel = "Condominium";
        } else if (propertyType.includes("land")) {
          typeBoost = 2.8 + Math.random() * 1.2;
          typeLabel = "Land/Development";
        }

        dynamicOpenRate += typeBoost;
        factors.push({
          name: typeLabel,
          impact: "positive",
          value: `+${typeBoost.toFixed(1)}%`,
          score: 5,
        });
      }

      // Images boost
      const hasImages = propertyData.heroImage || selectedProperty?.image;
      const photoCount = (propertyData.photos || []).length;

      if (hasImages || photoCount > 0) {
        const imgBoost = 2 + photoCount * 0.5 + Math.random() * 1;
        dynamicOpenRate += imgBoost;
        dynamicClickRate += imgBoost * 0.3;

        factors.push({
          name: `${photoCount > 0 ? photoCount + " Photos" : "Property Images"
            }`,
          impact: "positive",
          value: `+${imgBoost.toFixed(1)}%`,
          score: 7,
        });
      }

      // Description quality
      const description =
        propertyData.description || selectedProperty?.description || "";
      if (description.length > 100) {
        const descBoost =
          1.5 + Math.min(description.length, 500) / 250 + Math.random() * 0.5;
        dynamicOpenRate += descBoost;

        factors.push({
          name: "Detailed Description",
          impact: "positive",
          value: `+${descBoost.toFixed(1)}%`,
          score: 4,
        });
      }
    } else if (campaignType === "service") {
      const serviceType = (
        serviceData.serviceType ||
        serviceData.service_type ||
        ""
      ).toLowerCase();

      let serviceBoost = 3 + Math.random() * 2;
      let serviceName = "Service Campaign";

      if (
        serviceType.includes("mortgage") ||
        serviceType.includes("loan") ||
        serviceType.includes("finance")
      ) {
        serviceBoost = 5 + Math.random() * 2;
        serviceName = "Mortgage/Finance Service";
        insights.push("Financial services are in peak demand with agents");
      } else if (
        serviceType.includes("photo") ||
        serviceType.includes("staging")
      ) {
        serviceBoost = 4.5 + Math.random() * 1.8;
        serviceName = "Photography/Staging";
        insights.push("Visual services have highest booking rates");
      } else if (
        serviceType.includes("contractor") ||
        serviceType.includes("renovation")
      ) {
        serviceBoost = 4 + Math.random() * 1.5;
        serviceName = "Contractor/Renovation";
      } else if (serviceType.includes("inspect")) {
        serviceBoost = 4.2 + Math.random() * 1.6;
        serviceName = "Inspection Service";
      } else if (serviceType.includes("clean")) {
        serviceBoost = 3.5 + Math.random() * 1.2;
        serviceName = "Cleaning Service";
      } else if (serviceType.includes("landscape")) {
        serviceBoost = 3.8 + Math.random() * 1.4;
        serviceName = "Landscaping Service";
      }

      dynamicOpenRate += serviceBoost;
      dynamicClickRate += serviceBoost * 0.25;

      factors.push({
        name: serviceName,
        impact: "positive",
        value: `+${serviceBoost.toFixed(1)}% engagement`,
        score: Math.round(serviceBoost * 1.8),
      });

      // Features boost
      const featuresCount = (serviceData.features || []).filter(
        (f) => f && f.trim()
      ).length;
      if (featuresCount > 0) {
        const featBoost = 1.5 + featuresCount * 0.4 + Math.random() * 0.5;
        dynamicOpenRate += featBoost;

        factors.push({
          name: `${featuresCount} Service Features`,
          impact: "positive",
          value: `+${featBoost.toFixed(1)}%`,
          score: Math.min(featuresCount * 2, 8),
        });
      }

      // Service description
      const serviceDesc = serviceData.description || "";
      if (serviceDesc.length > 50) {
        const descBoost =
          1 + Math.min(serviceDesc.length, 300) / 200 + Math.random() * 0.5;
        dynamicOpenRate += descBoost;

        factors.push({
          name: "Service Description",
          impact: "positive",
          value: `+${descBoost.toFixed(1)}%`,
          score: 4,
        });
      }
    }

    // =========================================================================
    // RECIPIENT QUALITY BOOST
    // =========================================================================
    // Database (Associations) boost (More Realistic)
    if (sendTo.database && selectedDatasets.length > 0) {
      const associationCount = selectedDatasets.length;

      if (associationCount > 0) {
        // Scale boost based on list size (more associations = slightly better targeting)
        const assocBoost =
          (1 + associationCount * 0.3 + Math.random() * 0.5) *
          baseQualityMultiplier;
        dynamicOpenRate += assocBoost;

        factors.push({
          name: `${associationCount} Association${associationCount > 1 ? "s" : ""
            } Selected (${totalContacts.toLocaleString()} total contacts)`,
          impact: "positive",
          value: `+${assocBoost.toFixed(1)}% reach`,
          score: Math.min(associationCount * 2, 8),
        });

        if (associationCount >= 3) {
          insights.push(
            `Targeting ${associationCount} associations provides good market coverage`
          );
        }
      }

      // State selection boost (minor)
      if (selectedState) {
        const stateBoost = (0.8 + Math.random() * 0.4) * baseQualityMultiplier;
        dynamicOpenRate += stateBoost;

        factors.push({
          name: "Geographic Targeting",
          impact: "positive",
          value: `+${stateBoost.toFixed(1)}%`,
          score: 3,
        });
      }
    }

    // Custom Hubs boost (More Realistic)
    if (sendTo.mycontacts && selectedCustomDatasets.length > 0) {
      // Personal contacts have higher engagement but still realistic
      const personalBoost = (3 + Math.random() * 1.5) * baseQualityMultiplier;
      dynamicOpenRate += personalBoost;
      dynamicClickRate += personalBoost * 0.4;

      factors.push({
        name: "Personal Contacts (Hub)",
        impact: "positive",
        value: `+${personalBoost.toFixed(1)}% engagement`,
        score: 10,
      });

      insights.push(
        "Personal contacts typically have 1.5-2x higher engagement rates"
      );

      const customListCount = selectedCustomDatasets.length;
      if (customListCount > 0) {
        const listBoost =
          (0.5 + customListCount * 0.25 + Math.random() * 0.3) *
          baseQualityMultiplier;
        dynamicOpenRate += listBoost;

        factors.push({
          name: `${customListCount} Custom List${customListCount > 1 ? "s" : ""
            }`,
          impact: "positive",
          value: `+${listBoost.toFixed(1)}%`,
          score: customListCount * 1.5,
        });
      }
    }

    // =========================================================================
    // SUBJECT LINE ANALYSIS
    // =========================================================================
    if (subject && subject.trim().length > 0) {
      const subjectLength = subject.trim().length;
      const subjectLower = subject.toLowerCase();

      // Length optimization
      let lengthBoost = 0;
      if (subjectLength >= 25 && subjectLength <= 55) {
        lengthBoost = 2.5 + Math.random() * 1;
        factors.push({
          name: "Optimal Subject Length",
          impact: "positive",
          value: `+${lengthBoost.toFixed(1)}%`,
          score: 6,
        });
      } else if (subjectLength >= 15 && subjectLength < 25) {
        lengthBoost = 1.5 + Math.random() * 0.5;
        factors.push({
          name: "Good Subject Length",
          impact: "positive",
          value: `+${lengthBoost.toFixed(1)}%`,
          score: 4,
        });
      } else if (subjectLength > 55) {
        lengthBoost = 1 + Math.random() * 0.5;
        factors.push({
          name: "Subject Line",
          impact: "neutral",
          value: `+${lengthBoost.toFixed(1)}%`,
          score: 2,
        });
        recommendations.push(
          "Consider shortening subject (35-50 chars optimal)"
        );
      }
      dynamicOpenRate += lengthBoost;

      // Power words detection
      const powerWords = [
        "exclusive",
        "new",
        "just listed",
        "price reduced",
        "open house",
        "luxury",
        "dream",
        "stunning",
        "amazing",
        "beautiful",
        "gorgeous",
        "must see",
        "hot",
        "rare",
        "unique",
        "perfect",
        "ideal",
        "opportunity",
        "deal",
        "special",
        "limited",
        "urgent",
      ];

      const foundPowerWords = powerWords.filter((word) =>
        subjectLower.includes(word)
      );
      if (foundPowerWords.length > 0) {
        const powerBoost = 2 + foundPowerWords.length * 0.8 + Math.random() * 1;
        dynamicOpenRate += powerBoost;
        dynamicClickRate += powerBoost * 0.2;

        factors.push({
          name: `Power Keywords (${foundPowerWords.length})`,
          impact: "positive",
          value: `+${powerBoost.toFixed(1)}%`,
          score: Math.min(foundPowerWords.length * 3, 10),
        });
      }

      // Emoji detection
      const emojiRegex =
        /[\u{1F300}-\u{1F9FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/gu;
      const emojis = subject.match(emojiRegex);
      if (emojis && emojis.length > 0) {
        const emojiBoost = 1.5 + Math.random() * 0.8;
        dynamicOpenRate += emojiBoost;

        factors.push({
          name: "Subject with Emoji",
          impact: "positive",
          value: `+${emojiBoost.toFixed(1)}%`,
          score: 4,
        });
      }

      // Numbers in subject
      if (/\d/.test(subject)) {
        const numBoost = 1 + Math.random() * 0.5;
        dynamicOpenRate += numBoost;

        factors.push({
          name: "Specific Numbers",
          impact: "positive",
          value: `+${numBoost.toFixed(1)}%`,
          score: 3,
        });
      }
    }

    // =========================================================================
    // TEMPLATE & TIMING BOOST
    // =========================================================================
    if (selectedTemplate || selectedServiceTemplate) {
      const templateBoost = 2 + Math.random() * 1;
      dynamicOpenRate += templateBoost;
      dynamicClickRate += templateBoost * 0.25;

      const templateName =
        selectedTemplate?.name ||
        selectedServiceTemplate?.name ||
        "Professional";
      factors.push({
        name: `${templateName} Template`,
        impact: "positive",
        value: `+${templateBoost.toFixed(1)}%`,
        score: 6,
      });
    }

    // Schedule timing analysis
    if (scheduleOption === "later" && selectedDateTime) {
      const scheduledUtcIso = localToUtcIso(selectedDateTime);
      const scheduledInstant = new Date(scheduledUtcIso || selectedDateTime);

      const weekdayShort =
        new Intl.DateTimeFormat("en-US", {
          timeZone: effectiveTimezone,
          weekday: "short",
        }).format(scheduledInstant) || "";
      const hourStr =
        new Intl.DateTimeFormat("en-US", {
          timeZone: effectiveTimezone,
          hour: "2-digit",
          hour12: false,
        }).format(scheduledInstant) || "";

      const weekdayMap: Record<string, number> = {
        Sun: 0,
        Mon: 1,
        Tue: 2,
        Wed: 3,
        Thu: 4,
        Fri: 5,
        Sat: 6,
      };
      const dayOfWeek = weekdayMap[weekdayShort] ?? scheduledInstant.getUTCDay();
      const hour = Number(hourStr);
      const dayNames = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      let timeBoost = 0;
      let timeLabel = "";

      // Optimal days (Tuesday, Wednesday, Thursday)
      if (dayOfWeek >= 2 && dayOfWeek <= 4) {
        timeBoost += 2.5 + Math.random() * 1;
        timeLabel = `${dayNames[dayOfWeek]} (Optimal Day)`;
      } else if (dayOfWeek === 1 || dayOfWeek === 5) {
        timeBoost += 1.5 + Math.random() * 0.5;
        timeLabel = `${dayNames[dayOfWeek]}`;
      } else {
        timeBoost += 1 + Math.random() * 0.3;
        timeLabel = `${dayNames[dayOfWeek]}`;
      }

      // Optimal hours
      if ((hour >= 9 && hour <= 11) || (hour >= 14 && hour <= 16)) {
        timeBoost += 2 + Math.random() * 0.8;
        timeLabel += ` at ${hour > 12 ? hour - 12 : hour}${hour >= 12 ? "PM" : "AM"
          } (Peak Time)`;
      } else if (hour >= 7 && hour <= 18) {
        timeBoost += 1 + Math.random() * 0.5;
        timeLabel += ` at ${hour > 12 ? hour - 12 : hour}${hour >= 12 ? "PM" : "AM"
          }`;
      }

      dynamicOpenRate += timeBoost;

      factors.push({
        name: timeLabel,
        impact: "positive",
        value: `+${timeBoost.toFixed(1)}% timing`,
        score: Math.round(timeBoost * 2),
      });
    } else if (scheduleOption === "now") {
      const nowBoost = 1.5 + Math.random() * 0.5;
      dynamicOpenRate += nowBoost;

      factors.push({
        name: "Immediate Send",
        impact: "positive",
        value: `+${nowBoost.toFixed(1)}%`,
        score: 4,
      });
    }

    // =========================================================================
    // ENSURE HIGH ENGAGEMENT SCORE (80%+) AND CALCULATE FINAL RATES
    // =========================================================================

    // Calculate current score
    let currentScore = factors.reduce((sum, f) => sum + f.score, 0);

    // High score range: 80-98% (excellent range for display)
    const minScore = 60;
    const maxScore = 95;

    // Add AI optimization only if score is very low (local fallback)
    if (currentScore < 30) {
      const boostNeeded = 15 + Math.random() * 8;
      factors.push({
        name: "AI Optimization Applied",
        impact: "positive",
        value: `+${boostNeeded.toFixed(0)} points`,
        score: boostNeeded,
      });
      currentScore += boostNeeded;
    }

    // Local normalized score (baseline)
    const localNormalizedScore = Math.min(
      maxScore,
      Math.max(
        minScore,
        minScore + (currentScore / 60) * (maxScore - minScore) + Math.random() * 5
      )
    );

    // If the component state `engagementScore` (AI-derived from backend/OpenAI)
    // exists and we're analyzing a property campaign, blend it with the local
    // score to produce the final engagement score. Use a safe 60/40 weighting
    // (local/AI) so UI numbers remain realistic even if AI is not yet ideal.
    const aiScoreFromState = typeof engagementScore === "number" ? engagementScore : null;

    let blendedScore = Math.round(localNormalizedScore);
    if (campaignType === "property" && aiScoreFromState !== null) {
      blendedScore = Math.round(localNormalizedScore * 0.6 + aiScoreFromState * 0.4 + Math.random() * 2);
      factors.push({
        name: "OpenAI Property Insight",
        impact: "positive",
        value: `AI adjusted: ${aiScoreFromState}%`,
        score: Math.max(6, Math.round((aiScoreFromState - 70) / 3)),
      });
    }

    // Ensure final score is bounded
    const finalEngagementScore = Math.round(Math.max(minScore, Math.min(maxScore, blendedScore)));

    // =========================================================================
    // CALCULATE FINAL RATES - HIGH ENGAGEMENT (70%+ for both)
    // =========================================================================

    // Open rate: 75-95% range based on engagement score
    const openRateBase = 75 + (engagementScore / 100) * 15;
    const openRateVariation = Math.random() * 5;
    let finalOpenRate = Math.min(
      95,
      Math.max(75, openRateBase + openRateVariation)
    );

    // Click rate: 70-88% range, always less than open rate
    const clickRateBase = 70 + (engagementScore / 100) * 12;
    const clickRateVariation = Math.random() * 4;
    let finalClickRate = Math.min(
      88,
      Math.max(70, clickRateBase + clickRateVariation)
    );

    // Ensure click rate is ALWAYS at least 3-8% less than open rate
    const minDifference = 3 + Math.random() * 5; // 3-8% difference
    if (finalClickRate >= finalOpenRate - minDifference) {
      finalClickRate = finalOpenRate - minDifference;
    }

    // Final safety bounds with one decimal place
    finalOpenRate =
      Math.round(Math.min(95, Math.max(75, finalOpenRate)) * 10) / 10;
    finalClickRate =
      Math.round(
        Math.min(finalOpenRate - 3, Math.max(70, finalClickRate)) * 10
      ) / 10;

    // =========================================================================
    // CALCULATE ESTIMATES BASED ON CONTACTS
    // =========================================================================
    const estimatedOpens = Math.round(totalContacts * (finalOpenRate / 100));
    const estimatedClicks = Math.round(totalContacts * (finalClickRate / 100));

    // Additional metrics with higher conversion rates
    const conversionRate = 25 + Math.random() * 15; // 25-40% of clicks become leads
    const estimatedLeads = Math.round(estimatedClicks * (conversionRate / 100));
    const responseRate = 15 + Math.random() * 10; // 15-25% response rate
    const estimatedResponses = Math.round(
      estimatedOpens * (responseRate / 100)
    );
    const reachRate = 95 + Math.random() * 4; // 95-99% deliverability

    // Quality score is always excellent for 80%+ engagement
    const qualityScore: "excellent" | "good" | "average" | "low" = "excellent";

    // =========================================================================
    // GENERATE DYNAMIC INSIGHTS
    // =========================================================================

    // Contact-based insights
    if (totalContacts <= 500) {
      insights.push(
        `Highly targeted campaign to ${totalContacts} contacts = premium engagement`
      );
    } else if (totalContacts <= 2000) {
      insights.push(
        `Well-sized audience of ${totalContacts.toLocaleString()} contacts for optimal reach`
      );
    } else {
      insights.push(
        `Broad reach to ${totalContacts.toLocaleString()} contacts maximizes exposure`
      );
    }

    // Performance insights
    insights.push(
      `Expected ${finalOpenRate.toFixed(
        1
      )}% open rate - exceptional performance predicted`
    );

    if (estimatedLeads >= 10) {
      insights.push(
        `Projected ${estimatedLeads} qualified leads from this campaign`
      );
    }

    if (estimatedClicks >= 50) {
      insights.push(
        `~${estimatedClicks} clicks indicate strong interest potential`
      );
    }

    // Add positive recommendations
    if (recommendations.length === 0) {
      recommendations.push("Your launch is optimized for maximum engagement");
    }
    recommendations.push(
      `Best performance expected: ${Math.round(
        engagementScore
      )}% engagement score`
    );

    // =========================================================================
    // BREAKDOWN FOR VISUALIZATION
    // =========================================================================
    const breakdown = [
      {
        label: "Delivered",
        value: Math.round(totalContacts * (reachRate / 100)),
        percentage: reachRate,
        color: "bg-blue-500",
      },
      {
        label: "Opened",
        value: estimatedOpens,
        percentage: finalOpenRate,
        color: "bg-green-500",
      },
      {
        label: "Clicked",
        value: estimatedClicks,
        percentage: finalClickRate,
        color: "bg-purple-500",
      },
      {
        label: "Leads",
        value: estimatedLeads,
        percentage: (estimatedLeads / totalContacts) * 100,
        color: "bg-amber-500",
      },
    ];

    return {
      openRate: finalOpenRate,
      clickRate: finalClickRate,
      estimatedOpens,
      estimatedClicks,
      estimatedLeads,
      estimatedResponses,
      engagementScore: engagementScore !== null ? engagementScore : finalEngagementScore,
      qualityScore,
      conversionRate,
      reachRate,
      insights,
      recommendations,
      factors: factors.sort((a, b) => b.score - a.score), // Sort by impact
      breakdown,
    };
  }, [
    recipientCount,
    campaignType,
    selectedProperty,
    propertyData,
    serviceData,
    sendTo.database,
    sendTo.mycontacts,
    selectedDatasets,
    selectedCustomDatasets,
    agentLists,
    customAgentLists,
    selectedState,
    subject,
    selectedTemplate,
    selectedServiceTemplate,
    scheduleOption,
    selectedDateTime,
    engagementScore,
  ]);
  const handleFocus = () => {
    if (selectRef.current) {
      selectRef.current.size = 6;
    }
  };

  const handleBlur = () => {
    if (selectRef.current) {
      selectRef.current.size = 1;
    }
  };
  const handleChange = (e) => {
    setSelectedState(e.target.value);
    if (selectRef.current) {
      selectRef.current.size = 0;
      selectRef.current.blur(); // close dropdown
    }
  };
  // Use backend-provided states only (no static fallback)
  const stateOptions = statesList.map((s) => ({
    value: String(s.id),
    label: s.state_name,
  }));

  const filteredStates = stateOptions.filter((state) =>
    state.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchQuery("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    if (isOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen]);

  const handleSelect = (state) => {
    setSelectedState(state.value);
    setIsOpen(false);
    setSearchQuery("");
  };

  const selectedStateLabel =
    stateOptions.find((s) => s.value === String(selectedState))?.label ||
    "Select a state";

  // Load states from backend on mount
  useEffect(() => {
    const fetchStates = async () => {
      setStatesLoading(true);
      try {
        const res = await axiosInstance.get(endpoints.db_states);

        const data = Array.isArray(res.data)
          ? res.data
          : res.data.results || [];
        setStatesList(
          data.map((s: any) => ({
            id: s.id,
            state_name: s.state_name || s.name || s.state,
          }))
        );
      } catch (e) {
        console.warn(
          "[CampaignBuilder] axios get states failed, attempting fetch fallback",
          e?.message || e
        );
        // Try a plain fetch as a fallback (useful when axiosInstance has auth/cors issues)
        try {
          const resp = await fetch(endpoints.db_states, {
            method: "GET",
            mode: "cors",
          });
          const json = await resp.json();

          const data = Array.isArray(json) ? json : json.results || [];
          setStatesList(
            data.map((s: any) => ({
              id: s.id,
              state_name: s.state_name || s.name || s.state,
            }))
          );
        } catch (ferr) {
          console.error(
            "[CampaignBuilder] failed to load states via fetch fallback",
            ferr
          );
          const status = e?.response?.status;
          const msg =
            e?.response?.data?.detail ||
            e?.message ||
            ferr?.message ||
            "Failed to load states list";
          toast({
            title: `Failed to load states${status ? ` (${status})` : ""}`,
            description: String(msg),
            variant: "destructive",
          });
          setStatesList([]);
        }
      } finally {
        setStatesLoading(false);
      }
    };
    fetchStates();
  }, []);

  // Helper: Merge duplicate city names and sum their agent counts
  const mergeDuplicateCities = (items: AgentList[]): AgentList[] => {
    const cityMap = new Map<string, { count: number; id: string }>();

    items.forEach((item) => {
      const normalizedName = item.name.toLowerCase().trim();

      if (cityMap.has(normalizedName)) {
        // Merge: add agent counts
        const existing = cityMap.get(normalizedName)!;
        existing.count += item.agent_count;
      } else {
        // First occurrence: store it
        cityMap.set(normalizedName, {
          count: item.agent_count,
          id: item.id,
        });
      }
    });

    // Convert back to array, preserving original case from first occurrence
    const result: AgentList[] = [];
    const seenNormalized = new Set<string>();

    items.forEach((item) => {
      const normalizedName = item.name.toLowerCase().trim();
      if (!seenNormalized.has(normalizedName)) {
        seenNormalized.add(normalizedName);
        const merged = cityMap.get(normalizedName)!;
        result.push({
          id: merged.id,
          name: item.name, // Keep original case from first occurrence
          count: merged.count,
          agent_count: merged.count,
        });
      }
    });

    return result;
  };

  // When a state is selected, fetch its associations and populate agentLists
  useEffect(() => {
    if (!selectedState) {
      setAgentLists([]);
      setLoadingStateAssociations(false);
      return;
    }

    setLoadingStateAssociations(true);
    const fetchAssociations = async () => {
      const stateId = selectedState;
      const tryUrls = [
        // Fetch counties for the selected state (returns {id, name, agent_count})
        endpoints.db_counties_by_state(stateId),
        // Fallback to cities if counties endpoint isn't available yet
        `${endpoints.db_cities}?state=${stateId}`,
      ];

      for (const url of tryUrls) {
        try {
          const res = await axiosInstance.get(url);

          const items = Array.isArray(res.data)
            ? res.data
            : res.data.results || [];
          const mapped = items.map((a: any) => ({
            id: a.id ?? a.pk ?? String(Math.random()),
            // city endpoint returns `city`, association endpoint returns `name`
            name:
              a.city ||
              a.name ||
              a.association_name ||
              a.title ||
              a.display_name ||
              a.state_name ||
              "Association",
            agent_count: a.agent_count ?? a.count ?? a.agents?.length ?? 0,
          }));

          // Merge duplicate cities and sum agent counts
          const merged = mergeDuplicateCities(mapped);
          setAgentLists(merged);
          return; // success
        } catch (e) {
          console.warn(
            `[CampaignBuilder] axios GET failed for ${url}:`,
            e?.message || e
          );
          // try fetch fallback for this url
          try {
            const resp = await fetch(url, { method: "GET", mode: "cors" });
            const json = await resp.json();
            console.debug(
              "[CampaignBuilder] associations response (fetch):",
              url,
              resp.status,
              json
            );
            const items = Array.isArray(json) ? json : json.results || [];
            const mapped = items.map((a: any) => ({
              id: a.id ?? a.pk ?? String(Math.random()),
              name:
                a.city ||
                a.name ||
                a.association_name ||
                a.title ||
                a.display_name ||
                a.state_name ||
                "Association",
              agent_count: a.agent_count ?? a.count ?? a.agents?.length ?? 0,
            }));

            // Merge duplicate cities and sum agent counts
            const merged = mergeDuplicateCities(mapped);
            setAgentLists(merged);
            return; // success
          } catch (ferr) {
            console.warn(
              `[CampaignBuilder] fetch fallback failed for ${url}:`,
              ferr?.message || ferr
            );
            // continue to next url
          }
        }
      }

      console.error(
        "[CampaignBuilder] all attempts to load associations failed for state",
        stateId
      );
      setAgentLists([]);
      setLoadingStateAssociations(false);
      toast({
        title: "Error",
        description: "Failed to load associations for selected state",
        variant: "destructive",
        duration: 1000
      });
    };

    fetchAssociations().finally(() => {
      setLoadingStateAssociations(false);
    });
  }, [selectedState, toast]);

  // Fetch top 3 nearby county suggestions based on property location using OpenAI
  useEffect(() => {
    if (!selectedState || !selectedProperty?.address || !agentLists.length) {
      setCountySuggestions([]);
      return;
    }

    const suggestCounties = async () => {
      setSuggestingCounties(true);
      try {
        const countyNames = agentLists.map((county) => county.name);

        const response = await axiosInstance.post(
          endpoints.suggest_nearest_counties,
          {
            address: selectedProperty.address,
            state_id: selectedState,
            available_counties: countyNames,
          }
        );

        const suggestions = response.data?.suggestions || [];
        // Only keep top 3 suggestions
        setCountySuggestions(suggestions.slice(0, 3));
      } catch (err) {
        console.error("[CountySuggestions] Error:", err?.message);
        // Fallback: Show top 3 counties by agent count
        const topCounties = agentLists
          .sort((a, b) => b.agent_count - a.agent_count)
          .slice(0, 3)
          .map((county) => county.name);

        setCountySuggestions(topCounties);
      } finally {
        setSuggestingCounties(false);
      }
    };

    // Delay slightly to let agentLists settle
    const timer = setTimeout(suggestCounties, 500);
    return () => clearTimeout(timer);
  }, [selectedState, selectedProperty?.address, agentLists]);


  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { data } = await axiosInstance.get(endpoints.me);
        setUser(data);
        // Recalculate limits based on fresh data if needed
      } catch (e) {
        console.error("Error fetching user", e);
      }
    };
    fetchUser();
  }, []);

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        // Fetch agent users
        const res = await axiosInstance.get(endpoints.agent_user);
        const data = Array.isArray(res.data)
          ? res.data
          : res.data.results || [];
        setContacts(data);

        // Try to fetch server-side contact groups so we can map agents into groups
        let groupsMapById: Record<string | number, string> = {};
        try {
          const grpRes = await axiosInstance.get(endpoints.contact_groups);
          const grpData = Array.isArray(grpRes.data)
            ? grpRes.data
            : grpRes.data.results || [];
          grpData.forEach((g: any) => {
            if (g?.id != null) groupsMapById[g.id] = g.name || String(g.id);
            else if (g?.name) groupsMapById[g.name] = g.name;
          });
        } catch (e) {
          // ignore — we'll fall back to company field grouping
        }

        // Group agents by their actual group ID (not name, to prevent cross-user data mixing)
        const groupedById: Record<string | number, { agents: any[]; groupName: string }> = {};
        data.forEach((agent: any) => {
          // Get the actual group ID from the agent
          const possibleGroupIds = [
            agent.group,
            agent.group_id,
            agent.contact_group,
            agent.groupId,
          ];
          const groupId = possibleGroupIds.find(
            (v) => v !== undefined && v !== null && v !== ""
          );

          if (groupId !== undefined && groupId !== null) {
            // Use group ID as the key, get group name for display
            const groupName = groupsMapById[groupId] || `Group ${groupId}`;
            if (!groupedById[groupId]) {
              groupedById[groupId] = { agents: [], groupName };
            }
            groupedById[groupId].agents.push(agent);
          }
        });

        // Convert to list format with group IDs (not names)
        const lists = Object.entries(groupedById).map(([groupId, { agents, groupName }]) => ({
          id: String(groupId), // Store actual group ID
          name: groupName,
          count: agents.length,
        }));
        setCustomAgentLists(lists);
      } catch (err) {
        console.error("Failed to fetch agent users", err);
      }
    };
    fetchAgents();
  }, []);
  const handlePropertyListCreated = useCallback(
    (newList: { id: number; list_name: string }) => {
      // Update propertyLists state
      setPropertyLists((prev) => {
        const exists = prev.some((l) => l.id === newList.id);
        if (exists) return prev;
        return [...prev, newList];
      });

      // ✅ ADD: Also update the selectedPropertyList immediately
      setSelectedPropertyList(newList.list_name);

      // ✅ ADD: Update the selectedProperty to reflect the new list
      setSelectedProperty((prev) =>
        prev
          ? {
            ...prev,
            propertyListType: {
              id: newList.id,
              list_name: newList.list_name,
            },
          }
          : prev
      );
    },
    []
  );

  useNavigationWarning({
    hasUnsavedChanges: currentStep === 9 ? false : hasUnsavedChanges,
    message:
      isEditingTemplate && isDirty
        ? leaveTemplateEditMessage
        : "You have unsaved changes in the Launch Wizard. All your data will be cleared if you leave this page.",
  });
  // 1. Improve hasUnsavedChanges detection
  // 1. Improve hasUnsavedChanges detection (exclude Step 9 - campaign complete)
  useEffect(() => {
    // If user is on Step 9 (success page), don't block navigation
    if (currentStep === 9) {
      setHasUnsavedChanges(false);
      return;
    }

    const hasData =
      currentStep > 1 ||
      campaignType !== null ||
      selectedProperty !== null ||
      selectedTemplate !== null ||
      selectedServiceTemplate !== null ||
      propertyData.address !== "" ||
      propertyData.headline !== "" ||
      serviceData.title !== "" ||
      subject !== "" ||
      selectedDatasets.length > 0 ||
      selectedCustomDatasets.length > 0 ||
      isDirty ||
      proofSentCount > 0 ||
      acceptedTerms;

    setHasUnsavedChanges(hasData);
  }, [
    currentStep,
    campaignType,
    selectedProperty,
    selectedTemplate,
    selectedServiceTemplate,
    propertyData,
    serviceData,
    subject,
    selectedDatasets,
    selectedCustomDatasets,
    isDirty,
    proofSentCount,
    acceptedTerms,
  ]);
  const safeNavigate = (path: string) => {
    // If on Step 9 (success page), allow navigation without warning
    if (currentStep === 9) {
      navigate(path);
      return;
    }

    if (isEditingTemplate && isDirty) {
      setTemplateEditLeaveAction(() => {
        (window as any).__bypassNav = true;
        navigate(path);
        setTimeout(() => {
          (window as any).__bypassNav = false;
        }, 100);
      });
      setShowTemplateEditLeaveModal(true);
      return;
    }

    if (hasUnsavedChanges) {
      setPendingNavigation(path);
      setShowLeaveDialog(true);
    } else {
      navigate(path);
    }
  };

  // Handle internal navigation (sidebar links, etc.)
  // const handleNavigationAttempt = useCallback(
  //   (targetPath: string, options?: { skipRouterNavigation?: boolean }): boolean => {
  //     const skipRouterNavigation = options?.skipRouterNavigation === true;
  //     if ((window as any).__internalStepNav) return true;
  //     if ((window as any).__bypassNav) return true;
  //     if (skipRouterNavigation) {
  //       console.log('[handleNavigationAttempt] skipRouterNavigation=true, allowing internal navigation to', targetPath);
  //       return true;
  //     }
  //     console.log('[handleNavigationAttempt] attempt to navigate to:', targetPath, 'currentStep=', currentStep, 'skipRouterNavigation=', skipRouterNavigation);

  //     // If template is being edited and has unsaved changes, intercept
  //     if (isEditingTemplate && isDirty) {
  //       setTemplateEditLeaveAction(() => {
  //         (window as any).__bypassNav = true;
  //         navigate(targetPath);
  //         setTimeout(() => {
  //           (window as any).__bypassNav = false;
  //         }, 100);
  //       });
  //       setShowTemplateEditLeaveModal(true);
  //       return false;
  //     }

  //     // If on Step 9 (success page), allow navigation without warning
  //     if (currentStep === 9) {
  //       console.log('[handleNavigationAttempt] on Step 9 — allow navigation to', targetPath);
  //       navigate(targetPath);
  //       return true;
  //     }

  //     // Step 8 is the final pre-launch step. If the user leaves here before
  //     // clicking "Launch", warn them that the launch is still incomplete.
  //     if (currentStep === 8) {
  //       setPendingNavigation(targetPath);
  //       setShowCompleteLaunchDialog(true);
  //       return false;
  //     }

  //     // Step 9+ (after payment/launch) - just navigate normally or show leave warning
  //     if (currentStep >= 9) {
  //       if (hasUnsavedChanges) {
  //         setPendingNavigation(targetPath);
  //         setShowLeaveDialog(true);
  //         return false;
  //       }
  //       navigate(targetPath);
  //       return true;
  //     }

  //     // ✅ Show draft dialog on Step 4, 5, 6, or 7 (payment step) when user tries to leave
  //     if (currentStep >= 4 && currentStep <= 7) {
  //       const hasData =
  //         campaignType !== null ||
  //         selectedProperty !== null ||
  //         selectedService !== null ||
  //         selectedTemplate !== null ||
  //         selectedServiceTemplate !== null ||
  //         (subject && subject.trim() !== "") ||
  //         selectedDatasets.length > 0 ||
  //         selectedCustomDatasets.length > 0;

  //       if (hasData || hasUnsavedChanges) {
  //         // ✅ Capture the step when dialog opens (allow up to Step 7)
  //         console.log('[handleNavigationAttempt] will show Save Draft dialog, pendingNavigation=', targetPath, 'draftStep=', Math.min(currentStep, 7));
  //         setDraftStepToSave(Math.min(currentStep, 7));
  //         setPendingNavigation(targetPath);
  //         setShowLeaveDraftDialog(true);
  //         return false;
  //       }
  //     }

  //     // For Step 1-4 or no data, just navigate normally
  //     console.log('[handleNavigationAttempt] navigating normally to', targetPath);
  //     navigate(targetPath);
  //     return true;
  //   },
  //   [
  //     hasUnsavedChanges,
  //     navigate,
  //     currentStep,
  //     campaignType,
  //     selectedProperty,
  //     selectedService,
  //     selectedTemplate,
  //     selectedServiceTemplate,
  //     subject,
  //     selectedDatasets,
  //     selectedCustomDatasets,
  //     isEditingTemplate,
  //     isDirty
  //   ]
  // );

  const handleNavigationAttempt = useCallback(
  (targetPath: string, options?: { skipRouterNavigation?: boolean }): boolean => {
    const skipRouterNavigation = options?.skipRouterNavigation === true;
    if ((window as any).__internalStepNav) return true;
    if ((window as any).__bypassNav) return true;

    // When this call originated from the patched pushState/replaceState
    // (i.e. a navigation is already in flight), don't call navigate() again —
    // just return allowed/blocked and let the wrapper perform the real push.
    const doNavigate = (path: string) => {
      if (!skipRouterNavigation) {
        navigate(path);
      }
    };

    console.log('[handleNavigationAttempt] attempt to navigate to:', targetPath, 'currentStep=', currentStep, 'skipRouterNavigation=', skipRouterNavigation);

    if (isEditingTemplate && isDirty) {
      setTemplateEditLeaveAction(() => {
        (window as any).__bypassNav = true;
        navigate(targetPath);
        setTimeout(() => {
          (window as any).__bypassNav = false;
        }, 100);
      });
      setShowTemplateEditLeaveModal(true);
      return false;
    }

    if (currentStep === 9) {
      console.log('[handleNavigationAttempt] on Step 9 — allow navigation to', targetPath);
      doNavigate(targetPath);
      return true;
    }

    if (currentStep === 8) {
      setPendingNavigation(targetPath);
      setShowCompleteLaunchDialog(true);
      return false;
    }

    if (currentStep >= 9) {
      if (hasUnsavedChanges) {
        setPendingNavigation(targetPath);
        setShowLeaveDialog(true);
        return false;
      }
      doNavigate(targetPath);
      return true;
    }

    if (currentStep >= 4 && currentStep <= 7) {
      const hasData =
        campaignType !== null ||
        selectedProperty !== null ||
        selectedService !== null ||
        selectedTemplate !== null ||
        selectedServiceTemplate !== null ||
        (subject && subject.trim() !== "") ||
        selectedDatasets.length > 0 ||
        selectedCustomDatasets.length > 0;

      if (hasData || hasUnsavedChanges) {
        console.log('[handleNavigationAttempt] will show Save Draft dialog, pendingNavigation=', targetPath, 'draftStep=', Math.min(currentStep, 7));
        setDraftStepToSave(Math.min(currentStep, 7));
        setPendingNavigation(targetPath);
        setShowLeaveDraftDialog(true);
        return false;
      }
    }

    console.log('[handleNavigationAttempt] navigating normally to', targetPath);
    doNavigate(targetPath);
    return true;
  },
  [
    hasUnsavedChanges,
    navigate,
    currentStep,
    campaignType,
    selectedProperty,
    selectedService,
    selectedTemplate,
    selectedServiceTemplate,
    subject,
    selectedDatasets,
    selectedCustomDatasets,
    isEditingTemplate,
    isDirty
  ]
);

  // useEffect(() => {
  //   const origPush = window.history.pushState;
  //   const origReplace = window.history.replaceState;

  //   const patched = function (this: History, data: any, title: string, url?: string | null) {
  //     try {
  //       // If draft dialog is open, don't intercept anything
  //       if ((window as any).__bypassNav) {
  //         return origPush.apply(this, [data, title, url]);
  //       }

  //       if (!url) {
  //         return origPush.apply(this, [data, title, url]);
  //       }

  //       const full = new URL(String(url), window.location.href);
  //       const path = full.pathname + (full.search || '');

  //       // Skip same-pathname updates (React Router internal)
  //       if (full.pathname === window.location.pathname) {
  //         return origPush.apply(this, [data, title, url]);
  //       }

  //       const allowed = handleNavigationAttempt(path);
  //       if (allowed) return origPush.apply(this, [data, title, url]);
  //       return undefined as any;
  //     } catch (err) {
  //       return origPush.apply(this, [data, title, url]);
  //     }
  //   } as any;

  //   const patchedReplace = function (this: History, data: any, title: string, url?: string | null) {
  //     try {
  //       if (!url) {
  //         return origReplace.apply(this, [data, title, url]);
  //       }
  //       const full = new URL(String(url), window.location.href);
  //       const path = full.pathname + (full.search || '');
  //       const allowed = handleNavigationAttempt(path);
  //       if (allowed) {
  //         return origReplace.apply(this, [data, title, url]);
  //       }
  //       return undefined as any;
  //     } catch (err) {
  //       return origReplace.apply(this, [data, title, url]);
  //     }
  //   } as any;

  //   // Patch
  //   // @ts-ignore
  //   window.history.pushState = patched;
  //   // @ts-ignore
  //   window.history.replaceState = patchedReplace;

  //   return () => {
  //     // restore
  //     // @ts-ignore
  //     window.history.pushState = origPush;
  //     // @ts-ignore
  //     window.history.replaceState = origReplace;
  //   };
  // }, [handleNavigationAttempt]);


  useEffect(() => {
  const origPush = window.history.pushState;
  const origReplace = window.history.replaceState;
  let isProcessingNav = false; // belt-and-suspenders only; skipRouterNavigation
                                // above is what actually prevents the recursion

  const patched = function (this: History, data: any, title: string, url?: string | null) {
    try {
      if ((window as any).__bypassNav || isProcessingNav) {
        return origPush.apply(this, [data, title, url]);
      }
      if (!url) {
        return origPush.apply(this, [data, title, url]);
      }
      const full = new URL(String(url), window.location.href);
      const path = full.pathname + (full.search || '');
      if (full.pathname === window.location.pathname) {
        return origPush.apply(this, [data, title, url]);
      }
      isProcessingNav = true;
      let allowed: boolean;
      try {
        allowed = handleNavigationAttempt(path, { skipRouterNavigation: true });
      } finally {
        isProcessingNav = false;
      }
      if (allowed) return origPush.apply(this, [data, title, url]);
      return undefined as any;
    } catch (err) {
      return origPush.apply(this, [data, title, url]);
    }
  } as any;

  const patchedReplace = function (this: History, data: any, title: string, url?: string | null) {
    try {
      if ((window as any).__bypassNav || isProcessingNav) {
        return origReplace.apply(this, [data, title, url]);
      }
      if (!url) {
        return origReplace.apply(this, [data, title, url]);
      }
      const full = new URL(String(url), window.location.href);
      const path = full.pathname + (full.search || '');
      isProcessingNav = true;
      let allowed: boolean;
      try {
        allowed = handleNavigationAttempt(path, { skipRouterNavigation: true });
      } finally {
        isProcessingNav = false;
      }
      if (allowed) {
        return origReplace.apply(this, [data, title, url]);
      }
      return undefined as any;
    } catch (err) {
      return origReplace.apply(this, [data, title, url]);
    }
  } as any;

  // @ts-ignore
  window.history.pushState = patched;
  // @ts-ignore
  window.history.replaceState = patchedReplace;

  return () => {
    // @ts-ignore
    window.history.pushState = origPush;
    // @ts-ignore
    window.history.replaceState = origReplace;
  };
}, [handleNavigationAttempt]);

  // Intercept native link clicks while this page is mounted so internal
  // navigation always goes through `handleNavigationAttempt` and the
  // draft dialog can be shown consistently for any link (header, sidebar,
  // footer, etc.). Uses capture phase to run before React Router handles
  // the navigation.
  useEffect(() => {
    const clickHandler = (e: MouseEvent) => {
      // Only handle primary button clicks without modifier keys
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;

      const target = e.target as HTMLElement | null;
      if (!target) return;

      const anchor = target.closest && (target.closest('a') as HTMLAnchorElement | null);
      if (!anchor) return;

      const href = anchor.getAttribute('href');
      if (!href) return;

      // Ignore external links and anchors
      try {
        const url = new URL(href, window.location.href);
        const sameOrigin = url.origin === window.location.origin;
        if (!sameOrigin) return; // external link - let it proceed

        // Only intercept internal app routes (start with '/'), ignore hashes and file anchors
        if (url.pathname === window.location.pathname && url.hash) return;

        // Prevent the default navigation and route via handler
        e.preventDefault();
        handleNavigationAttempt(url.pathname + (url.search || ''));
      } catch (err) {
        // If URL parsing fails, do nothing
        return;
      }
    };

    window.addEventListener('click', clickHandler, true);
    return () => window.removeEventListener('click', clickHandler, true);
  }, [handleNavigationAttempt]);

  // const handleSaveDraftOnLeave = async () => {
  //   setIsDraftSaving(true);

  //   // ✅ Use draftStepToSave which was captured when dialog opened
  //   // ✅ CAP at Step 6 - Don't save Step 7+ (Payment step)
  //   let stepToSave = draftStepToSave || currentStep;
  //   if (stepToSave > 6) {
  //     stepToSave = 6;
  //   }

  //   try {
  //     // 🔥 EXPLICIT TYPE SETTING: Use campaignType from state if available
  //     // If not, intelligently detect based on which data is populated
  //     let finalCampaignType = campaignType;

  //     if (!finalCampaignType) {
  //       // Smart detection only if campaignType wasn't explicitly set
  //       const hasServiceTitle = serviceData?.title?.trim();
  //       const hasServiceId = selectedService?.id || serviceCampaignId;
  //       const hasPropertyTitle = propertyData?.headline?.trim() || selectedProperty?.title?.trim();
  //       const hasPropertyId = selectedProperty?.id;

  //       console.log('[handleSaveDraftOnLeave] Detection:', {
  //         hasServiceTitle,
  //         hasServiceId,
  //         hasPropertyTitle,
  //         hasPropertyId,
  //         campaignType
  //       });

  //       // Prioritize service if service-specific data exists
  //       if ((hasServiceTitle || hasServiceId) && !hasPropertyId) {
  //         finalCampaignType = 'service';
  //         console.log('[handleSaveDraftOnLeave] ✅ Auto-detected: SERVICE');
  //       } else {
  //         // Default to property
  //         finalCampaignType = 'property';
  //         console.log('[handleSaveDraftOnLeave] ✅ Auto-detected: PROPERTY (or default)');
  //       }
  //     } else {
  //       console.log('[handleSaveDraftOnLeave] ✅ Using explicit campaignType:', finalCampaignType);
  //     }

  //     const draftData: any = {
  //       current_step: stepToSave,  // ✅ Capped at Step 6
  //       campaign_type: finalCampaignType,  // 🔥 ALWAYS SET
  //       status: 'draft',
  //     };

  //     console.log('[handleSaveDraftOnLeave] Saving draft with campaign_type:', draftData.campaign_type);
  //     console.log('[handleSaveDraftOnLeave] Draft data before save:', {
  //       title: draftData.title,
  //       image_url: draftData.image_url,
  //       photos: draftData.photos,
  //       hero_image: draftData.hero_image,
  //       selectedImageFile: selectedImageFile ? 'YES' : 'NO',
  //       photoFiles_count: photoFiles?.length || 0,
  //     });

  //     // ========== STEP 2+ DATA - Property/Service details ==========
  //     if (stepToSave >= 2) {
  //       if (finalCampaignType === 'property') {
  //         draftData.title = propertyData?.headline || selectedProperty?.title || "";
  //         draftData.headline = propertyData?.headline || selectedProperty?.headline || "";
  //         draftData.address = propertyData?.address || selectedProperty?.address || "";
  //         draftData.postal_code = propertyData?.postalCode || selectedProperty?.postal_code || "";
  //         draftData.city = propertyData?.city || selectedProperty?.city || "";
  //         draftData.state = propertyData?.state || selectedProperty?.state || "";
  //         draftData.price = propertyData?.price || selectedProperty?.price || null;
  //         draftData.bedrooms = propertyData?.bedrooms || selectedProperty?.bedrooms || null;
  //         draftData.bathrooms = propertyData?.bathrooms || selectedProperty?.bathrooms || null;
  //         draftData.area = propertyData?.area || selectedProperty?.area || null;
  //         draftData.property_type = propertyData?.propertyType || selectedProperty?.property_type || "";
  //         draftData.description = propertyData?.description || selectedProperty?.description || "";
  //         draftData.text_section = propertyData?.text_section || selectedProperty?.text_section || "";
  //         draftData.is_open_house = selectedProperty?.is_open_house || false;

  //         // 🆕 Only include old image URLs if NO new files are being uploaded
  //         if (!selectedImageFile) {
  //           const heroImage = propertyData?.heroImage || selectedProperty?.image || "";
  //           if (heroImage && typeof heroImage === 'string' && !heroImage.startsWith('blob:')) {
  //             draftData.image_url = heroImage;
  //           }
  //         }

  //         // 🆕 Only include old photos if NO new files are being uploaded
  //         if (photoFiles.length === 0) {
  //           const photos: string[] = [];
  //           const allPhotos = [
  //             ...(propertyData?.photos || []),
  //             ...(selectedProperty?.photos || [])
  //           ];
  //           allPhotos.forEach((photo: string) => {
  //             if (photo && typeof photo === 'string' && !photo.startsWith('blob:') && !photos.includes(photo)) {
  //               photos.push(photo);
  //             }
  //           });
  //           if (photos.length > 0) {
  //             draftData.photos = photos;
  //           }
  //         }

  //         // Property list
  //         if (selectedPropertyList) {
  //           const listObj = propertyLists.find(l => l.list_name === selectedPropertyList);
  //           if (listObj) {
  //             draftData.propertyListType = listObj.id;
  //             draftData.property_list_name = listObj.list_name;
  //           }
  //         }

  //         // Property ID
  //         if (selectedProperty?.id) {
  //           draftData.property_id = selectedProperty.id;
  //         }

  //       } else if (finalCampaignType === 'service') {
  //         draftData.title = serviceData?.title || selectedService?.title || "";
  //         draftData.headline = serviceData?.headline || serviceData?.title || "";
  //         draftData.service_type = serviceData?.serviceType || serviceData?.service_type || "";
  //         draftData.description = serviceData?.description || "";
  //         draftData.phone = serviceData?.phone || "";
  //         draftData.email = serviceData?.email || "";
  //         draftData.website = serviceData?.website || "";
  //         draftData.address = serviceData?.address || "";

  //         // 🆕 Features - store both as 'features' and 'service_features'
  //         const features = (serviceData?.features || []).filter((f: any) => f && f.toString().trim() !== "");
  //         if (features.length > 0) {
  //           draftData.features = features;
  //           draftData.service_features = features;  // 🆕 Also store in service_features field
  //         }

  //         // 🆕 Only include old hero image if NO new files are being uploaded
  //         if (!selectedImageFile) {
  //           const heroImage = serviceData?.heroImage || "";
  //           if (heroImage && !heroImage.startsWith('blob:')) {
  //             draftData.hero_image = heroImage;
  //           }
  //         }

  //         // 🆕 Only include old photos if NO new files are being uploaded
  //         if (photoFiles.length === 0) {
  //           const photos: string[] = [];
  //           const allPhotos = serviceData?.photos || [];
  //           allPhotos.forEach((photo: string) => {
  //             if (photo && typeof photo === 'string' && !photo.startsWith('blob:') && !photos.includes(photo)) {
  //               photos.push(photo);
  //             }
  //           });
  //           if (photos.length > 0) {
  //             draftData.photos = photos;
  //             draftData.service_photos = photos;  // 🆕 Also store in service_photos field
  //           }
  //         }

  //         // Service IDs
  //         if (selectedService?.id) {
  //           draftData.service_id = selectedService.id;
  //         }
  //         if (serviceCampaignId) {
  //           draftData.service_campaign_id = serviceCampaignId;
  //         }
  //       }
  //     }

  //     // ========== STEP 3+ DATA - Template ==========
  //     if (stepToSave >= 3) {
  //       if (finalCampaignType === 'property' && selectedTemplate) {
  //         draftData.selected_template_id = String(selectedTemplate.id);
  //         draftData.template_name = selectedTemplate.name;

  //         // Save template HTML if available
  //         try {
  //           const templateHtml = sessionStorage.getItem("campaign_template_html");
  //           if (templateHtml) {
  //             draftData.template_html = templateHtml;
  //           }
  //         } catch (e) { }

  //       } else if (finalCampaignType === 'service' && selectedServiceTemplate) {
  //         draftData.selected_template_id = String(selectedServiceTemplate.id);
  //         draftData.template_name = selectedServiceTemplate.name;
  //       }
  //     }

  //     // ========== STEP 4+ DATA - Subject and Features ==========
  //     if (stepToSave >= 4) {
  //       if (subject && subject.trim() !== "") {
  //         draftData.subject = subject;
  //       }

  //       // Key features for property
  //       if (finalCampaignType === 'property' && keyFeatures && keyFeatures.length > 0) {
  //         draftData.key_features = keyFeatures.map(f => ({
  //           id: f.id,
  //           feature_name: f.feature_name
  //         }));
  //       }
  //     }

  //     // ========== STEP 5+ DATA - Recipients ==========
  //     if (stepToSave >= 5) {
  //       draftData.send_to = sendTo;

  //       if (selectedDatasets.length > 0) {
  //         draftData.selected_datasets = selectedDatasets;
  //       }
  //       if (selectedCustomDatasets.length > 0) {
  //         draftData.selected_custom_datasets = selectedCustomDatasets;
  //       }
  //       if (selectedState) {
  //         draftData.selected_state = selectedState;
  //       }
  //     }

  //     // ========== STEP 6 DATA - Schedule (MAX STEP TO SAVE) ==========
  //     if (stepToSave >= 6) {
  //       draftData.schedule_option = scheduleOption || 'now';

  //       if (selectedDateTime) {
  //         draftData.selected_date_time = selectedDateTime;
  //       }

  //       draftData.is_recurring = isRecurringCampaign || false;

  //       if (isRecurringCampaign) {
  //         draftData.recurrence_type = recurrenceType;
  //         if (recurringEndDate) {
  //           draftData.recurring_end_date = recurringEndDate;
  //         }
  //         if (customRecurringDates && customRecurringDates.length > 0) {
  //           draftData.custom_recurring_dates = customRecurringDates;
  //         }
  //       }

  //       draftData.accepted_terms = acceptedTerms || false;
  //     }

  //     // ✅ Save to backend using draftService (with proper file/image handling)
  //     // 🆕 Include image files for proper upload
  //     const response = await draftService.saveDraft(draftData, {
  //       mainImageFile: selectedImageFile,  // 🆕 Main image file
  //       additionalPhotoFiles: photoFiles,   // 🆕 Additional photo files
  //     });

  //     if (response.data) {
  //       toast({
  //         title: "✓ Draft Saved",
  //         description: `Progress saved at Step ${stepToSave}: ${launchSteps[stepToSave - 1]?.title || 'Unknown'}`,
  //         variant: "default",
  //       });

  //       // Update local draft state
  //       setHasDraft(true);
  //       setDraft(response.data.data || draftData);
  //     }

  //     // Clear session storage
  //     try {
  //       sessionStorage.removeItem("campaign_template_html");
  //       sessionStorage.removeItem("service_custom_template_html");
  //       sessionStorage.removeItem("campaignSubject");
  //       sessionStorage.removeItem("selectedTemplateId");
  //       sessionStorage.removeItem("selectedPropertyId");
  //     } catch (e) { }

  //     setHasUnsavedChanges(false);

  //     // Close dialog first, then navigate. Capture pendingNavigation locally
  //     const target = pendingNavigation;
  //     setShowLeaveDraftDialog(false);

  //     if (target) {
  //       console.log('[handleSaveDraftOnLeave] navigating to pendingNavigation (captured):', target);
  //       // Temporarily suppress beforeunload confirmation and navigation interception
  //       // while we perform navigation
  //       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //       // @ts-ignore
  //       (window as any).__ignoreBeforeUnload = true;
  //       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //       // @ts-ignore
  //       (window as any).__bypassNav = true;

  //       // Small delay to allow modal to close and state to settle
  //       setTimeout(() => {
  //         try {
  //           navigate(target);
  //           // If SPA navigation didn't change location after a short delay, fallback to full reload
  //           setTimeout(() => {
  //             if (window.location.pathname !== target) {
  //               console.warn('[handleSaveDraftOnLeave] navigate did not change path, falling back to window.location.href');
  //               window.location.href = target;
  //             }
  //           }, 250);
  //         } catch (err) {
  //           console.warn('[handleSaveDraftOnLeave] navigate threw, falling back to location.href', err);
  //           window.location.href = target;
  //         } finally {
  //           // Clear the flags after a short grace period in case navigation is SPA-based
  //           setTimeout(() => {
  //             try {
  //               // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //               // @ts-ignore
  //               delete (window as any).__ignoreBeforeUnload;
  //               // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //               // @ts-ignore
  //               delete (window as any).__bypassNav;
  //             } catch (e) { }
  //           }, 1000);
  //         }
  //       }, 80);

  //       setPendingNavigation(null);
  //     } else {
  //       console.log('[handleSaveDraftOnLeave] no pendingNavigation to navigate to');
  //     }

  //   } catch (error: any) {
  //     console.error('[handleSaveDraftOnLeave] Error:', error);
  //     console.error('[handleSaveDraftOnLeave] Error response:', error.response?.data);

  //     toast({
  //       title: "Error Saving Draft",
  //       description: error.response?.data?.detail || error.response?.data?.error || "Failed to save draft. Please try again.",
  //       variant: "destructive",
  //     });
  //   } finally {
  //     setIsDraftSaving(false);
  //   }
  // };

  const handleLeaveWithoutSaving = () => {
    try {
      console.log('[handleLeaveWithoutSaving] Starting discard process...');

      // Close dialog first
      setShowLeaveDraftDialog(false);
      setHasUnsavedChanges(false);

      // Clear session storage
      sessionStorage.removeItem("campaign_template_html");
      sessionStorage.removeItem("service_custom_template_html");
      sessionStorage.removeItem("campaignSubject");
      sessionStorage.removeItem("selectedTemplateId");
      sessionStorage.removeItem("selectedPropertyId");

      console.log('[handleLeaveWithoutSaving] pendingNavigation:', pendingNavigation);

      // Capture pending navigation before clearing it
      const targetPath = pendingNavigation || "/dashboard";
      setPendingNavigation(null);

      console.log('[handleLeaveWithoutSaving] Navigating to:', targetPath);

      // Set bypass flag to prevent handleNavigationAttempt from re-showing draft dialog
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      (window as any).__bypassNav = true;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      (window as any).__ignoreBeforeUnload = true;

      // Use window.location.href for hard navigation to bypass React Router interception
      // This is appropriate for discarding since we're not preserving any state
      setTimeout(() => {
        window.location.href = targetPath;
      }, 50);
    } catch (error) {
      console.error('[handleLeaveWithoutSaving] Error:', error);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      (window as any).__bypassNav = false;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      (window as any).__ignoreBeforeUnload = false;
    }
  };

  const handleCancelLeaveDraft = () => {
    resetLeaveDraftDialogState();
  };

  // Handle browser refresh/tab close
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      // Allow code to temporarily suppress beforeunload when performing
      // a programmatic Save & Leave navigation.
      // Use a window flag so the handler can be referenced from other scopes.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if ((window as any).__ignoreBeforeUnload) return;
      // Skip warning on success page
      if (currentStep === 9) return;

      // Check if user has any data worth saving
      const hasData =
        campaignType !== null ||
        selectedProperty !== null ||
        selectedService !== null ||
        selectedTemplate !== null ||
        selectedServiceTemplate !== null ||
        subject.trim() !== "" ||
        selectedDatasets.length > 0 ||
        selectedCustomDatasets.length > 0 ||
        propertyData.headline !== "" ||
        propertyData.address !== "" ||
        serviceData.title !== "" ||
        currentStep > 1;

      if (hasData || hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
        return e.returnValue;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [
    currentStep,
    hasUnsavedChanges,
    campaignType,
    selectedProperty,
    selectedService,
    selectedTemplate,
    selectedServiceTemplate,
    subject,
    selectedDatasets,
    selectedCustomDatasets,
    propertyData.headline,
    propertyData.address,
    serviceData.title
  ]);
  // Confirm leave and navigate
  const confirmLeave = () => {
    setHasUnsavedChanges(false); // Reset to prevent beforeunload
    if (pendingNavigation) {
      navigate(pendingNavigation);
    }
    setShowLeaveDialog(false);
    setPendingNavigation(null);
  };

  // Cancel leave
  const cancelLeave = () => {
    setShowLeaveDialog(false);
    setPendingNavigation(null);
  };

  const confirmCompleteLaunchLeave = () => {
    const target = pendingNavigation;
    setShowCompleteLaunchDialog(false);
    setPendingNavigation(null);
    if (target) {
      navigate(target);
    }
  };

  const cancelCompleteLaunchLeave = () => {
    setShowCompleteLaunchDialog(false);
    setPendingNavigation(null);
  };

  // Handler to update full list immediately (for sync across templates)
  const handlePropertyListsUpdate = useCallback(
    (updatedLists: { id: number; list_name: string }[]) => {
      setPropertyLists((prev) => {
        // Merge updated lists with existing ones to preserve any local additions
        const merged = [...updatedLists];
        prev.forEach((existingList) => {
          if (!merged.some((l) => l.id === existingList.id)) {
            merged.push(existingList);
          }
        });
        return merged;
      });
    },
    []
  );
  const handleAddCustomDataset = (id: string) =>
    setSelectedCustomDatasets((prev) => [...new Set([...prev, id])]);
  const handleRemoveCustomDataset = (id: string) =>
    setSelectedCustomDatasets((prev) => prev.filter((x) => x !== id));
  const handleRegenerateDescription = async () => {
    if (isGeneratingDesc || generationCount >= 3) return;
    if (!serviceData.serviceType) {
      toast({
        title: "No Service Type",
        description: "Please select a service type first.",
        variant: "destructive",
        duration: 1000
      });
      return;
    }
    setIsGeneratingDesc(true);
    const userText = serviceData.description?.trim() || "a real estate service";
    const serviceType = serviceData.serviceType;
    const prompt = `
    You are a professional real estate copywriter.
    Write a compelling 2–3 sentence service description (max 120 words) for a marketing flyer.
    Service Type: ${serviceType}
    User Input: "${userText}"
    Focus on benefits, urgency, and emotional appeal. Make it vivid and client-focused.
  `.trim();
    try {
      const resp = await axiosInstance.post(endpoints.generate_description, {
        mode: "service",
        service_type: serviceType,
        description: userText,
      });

      const enhancedDesc = resp.data?.description?.trim();
      if (enhancedDesc) {
        setServiceData((prev) => ({ ...prev, description: enhancedDesc }));
        toast({
          title: "Description Enhanced",
          description: "AI improved your service description!",
          variant: "default",
          duration: 1000
        });
        setGenerationCount((prev) => prev + 1);
      }
    } catch (err: any) {
      console.error(err);
      toast({
        title: "Failed",
        description: "Could not enhance description",
        variant: "destructive",
      });
    } finally {
      setIsGeneratingDesc(false);
    }
  };

  const handleImproveText = async () => {
    if (isImprovingText) return;
    if (!serviceData.description?.trim()) {
      toast({
        title: "No Text",
        description: "Please enter some text to improve.",
        variant: "destructive",
        duration: 1000

      });
      return;
    }

    setIsImprovingText(true);
    try {
      const resp = await axiosInstance.post(endpoints.improve_text, {
        text: serviceData.description.trim(),
      });

      const improvedText = resp.data?.improved_text?.trim();
      if (improvedText) {
        setServiceData((prev) => ({ ...prev, description: improvedText }));
        toast({
          title: "Text Improved",
          description: "Your text has been enhanced!",
          variant: "default",
          duration: 1000

        });
      }
    } catch (err: any) {
      console.error(err);
      toast({
        title: "Failed",
        description: "Could not improve text",
        variant: "destructive",
      });
    } finally {
      setIsImprovingText(false);
    }
  };

  // 🔹 ADD THIS FUNCTION IN THE PARENT COMPONENT
  // const handleEditProperty = (property) => {
  //   setSelectedProperty(property);

  //   setPropertyData({
  //     headline: property.title,
  //     price: property.price,
  //     address: property.address,
  //     city: property.city,
  //     state: property.state,
  //     bedrooms: property.bedrooms,
  //     bathrooms: property.bathrooms,
  //     area: property.area,
  //     description: property.description,
  //     text_section: property.text_section,
  //     heroImage: property.image,
  //     photos: property.photos || [],
  //     agentName: property.agentName,
  //     agentPhone: property.agentPhone,
  //     agentEmail: property.agentEmail,
  //   });

  //   setIsEditingTemplate(true);
  //   setCurrentStep(4); // PropertyStep
  // };

  const handleEditProperty = (property) => {
    setSelectedProperty(property);
    const initialPropertyData = {
      headline: property.title,
      price: property.price,
      address: property.address,
      city: property.city,
      state: property.state,
      bedrooms: property.bedrooms,
      bathrooms: property.bathrooms,
      area: property.area,
      description: property.description,
      text_section: property.text_section,
      heroImage: property.image,
      photos: property.photos || [],
      agentName: property.agentName,
      agentPhone: property.agentPhone,
      agentEmail: property.agentEmail,
    };
    setPropertyData(initialPropertyData);
    setPropertyEditSnapshot({
      ...initialPropertyData,
      features: Array.isArray(keyFeatures) ? [...keyFeatures] : [],
    });
    setPropertyKeyFeaturesSnapshot(Array.isArray(keyFeatures) ? [...keyFeatures] : []);
    setIsEditingTemplate(true);
    setCurrentStep(4);
  };


  const handleCorrectGrammar = async () => {
    if (isCorrectingGrammar) return;
    if (!serviceData.description?.trim()) {
      toast({
        title: "No Text",
        description: "Please enter some text to correct.",
        variant: "destructive",
        duration: 1000
      });
      return;
    }

    setIsCorrectingGrammar(true);
    try {
      const resp = await axiosInstance.post(endpoints.correct_grammar, {
        text: serviceData.description.trim(),
      });

      const correctedText = resp.data?.corrected_text?.trim();
      if (correctedText) {
        setServiceData((prev) => ({ ...prev, description: correctedText }));
        toast({
          title: "Grammar Corrected",
          description: "Your text has been corrected!",
          variant: "default",
          duration: 1000
        });
      }
    } catch (err: any) {
      console.error(err);
      toast({
        title: "Failed",
        description: "Could not correct grammar",
        variant: "destructive",
      });
    } finally {
      setIsCorrectingGrammar(false);
    }
  };

  const handleEnhanceImage = async () => {
    if (isEnhancingImage) return;
    // This will be handled by file input change handler
    // For now, just set loading state
    setIsEnhancingImage(true);
    try {
      // Image enhancement would be applied when user uploads an image
      // The endpoint will be called during the image upload process
      toast({
        title: "Image Processing",
        description: "Preparing to enhance your image...",
        variant: "default",
        duration: 1000
      });
    } finally {
      setIsEnhancingImage(false);
    }
  };

  const handleSaveServiceTemplate = async (action: "save" | "continue") => {
    setSavingTemplate(true);
    const editor = editorRef.current?.editor;

    if (!editor || !EmailEditor) {
      toast({ title: "Editor not ready", variant: "destructive", duration: 1000 });
      setSavingTemplate(false);
      return;
    }
    try {
      editor.exportHtml(
        async ({ html, design }: { html: string; design: any }) => {
          try {
            const payload = {
              name: serviceTemplateName,
              html,
              unlayerDesign: design,
              campaign_type: "service",
            };

            const response = await axiosInstance.post(
              endpoints.custom_templates,
              payload
            );
            const savedTemplateId = response.data?.id;

            toast({
              title: "Success",
              description: "Template saved successfully!",
              variant: "default",
              duration: 1000
            });

            // Save to sessionStorage for use in next step
            sessionStorage.setItem("service_custom_template_html", html);
            sessionStorage.setItem(
              "service_custom_template_design",
              JSON.stringify(design)
            );
            sessionStorage.setItem(
              "service_custom_template_name",
              serviceTemplateName
            );
            if (savedTemplateId) {
              sessionStorage.setItem(
                "service_custom_template_id",
                String(savedTemplateId)
              );
              setSavedServiceTemplateId(savedTemplateId);
            }

            if (action === "continue") {
              setCurrentStep(4);
            }
          } catch (error: any) {
            console.error("Error saving template:", error);
            toast({
              title: "Error",
              description:
                error?.response?.data?.message || "Failed to save template",
              variant: "destructive",
            });
          } finally {
            setSavingTemplate(false);
          }
        }
      );
    } catch (error: any) {
      console.error("Error exporting template:", error);
      toast({
        title: "Error",
        description: "Failed to export template",
        variant: "destructive",
      });
      setSavingTemplate(false);
    }
  };
  useEffect(() => {
    const restore = (location.state as any)?.restoreStep;
    const campaignType = (location.state as any)?.campaignType;
    if (restore != null && campaignType === "property") {
      setCampaignType("property");
      setCurrentStep(restore);
      setIsServiceFlow(false);
    }
  }, [location.state]);
  const getGenerateButtonText = () => {
    if (generationCount === 0) return "Generate";
    if (generationCount > 0 && generationCount < 3) return "Regenerate";
    return "Limit Reached";
  };
  const addServiceComponent = (type: string) => {
    const editor = editorRef.current?.editor;
    if (!editor || !EmailEditor) {
      toast({ title: "Editor not ready", variant: "destructive", duration: 1000 });
      return;
    }
    let content = "";
    switch (type) {
      case "text":
        content = "New service text block...";
        break;
      case "address":
        content =
          serviceData.description.trim() ||
          "Add your service description here...";
        break;
      case "price":
        content = "$99/month";
        break;
      case "agent":
        content = "Your Name\nyour@email.com";
        break;
      default:
        content = "New content";
    }
    editor.exportHtml(({ design }: any) => {
      const rows = design?.body?.rows || [];
      let newBlock: any = {};
      switch (type) {
        case "address":
          newBlock = {
            type: "text",
            values: {
              text: `<p style="font-size:16px; line-height:1.5; color:#374151; margin:0;">${content}</p>`,
            },
          };
          break;
        case "price":
          newBlock = {
            type: "text",
            values: {
              text: `<p style="font-size:28px;font-weight:700;color:#dc2626;margin:0;">${content}</p>`,
            },
          };
          break;
        case "agent":
          newBlock = {
            type: "text",
            values: {
              text: `<p style="margin:0;"><strong>${content.split("\n")[0]
                }</strong><br/>${content.split("\n")[1]}</p>`,
            },
          };
          break;
        case "text":
        default:
          newBlock = {
            type: "text",
            values: { text: `<p style="margin:0;">${content}</p>` },
          };
          break;
      }
      const newRow = {
        cells: [1],
        columns: [{ contents: [newBlock], values: { padding: "10px 0px" } }],
      };
      editor.loadDesign({
        ...design,
        body: { ...design.body, rows: [...rows, newRow] },
      });
      setServiceElements((prev) => [
        ...prev,
        { id: Date.now(), type, content },
      ]);
    });
  };
  useEffect(() => {
    import("react-email-editor").then((mod) =>
      setEmailEditor(() => mod.default)
    );
  }, []);
  useEffect(() => {
    if (showRecurringModal) {
      // Re-sync tempSelectedDates from customRecurringDates when modal opens
      if (recurrenceType === "custom" && customRecurringDates.length > 0) {
        setTempSelectedDates(new Set(customRecurringDates));
      }
    }
  }, [showRecurringModal]);
  const buildInitialDesign = useCallback((): any => {
    return {
      body: {
        rows: serviceElements.map((el) => {
          switch (el.type) {
            case "image":
              return {
                cells: [1],
                columns: [{ contents: [], values: { padding: "10px 0px" } }],
              };
            case "address":
              return {
                cells: [1],
                columns: [
                  {
                    contents: [
                      {
                        type: "text",
                        values: {
                          text: `<p style="font-size:18px;font-weight:600;color:#2563eb;margin:0;"><span style="margin-right:8px;">Location</span>${el.content}</p>`,
                        },
                      },
                    ],
                  },
                ],
              };
            case "price":
              return {
                cells: [1],
                columns: [
                  {
                    contents: [
                      {
                        type: "text",
                        values: {
                          text: `<p style="font-size:28px;font-weight:700;color:#dc2626;margin:0;">${el.content}</p>`,
                        },
                      },
                    ],
                  },
                ],
              };
            case "agent":
              return {
                cells: [1],
                columns: [
                  {
                    contents: [
                      {
                        type: "text",
                        values: {
                          text: `<p style="margin:0;"><strong>${el.content.split("\n")[0]
                            }</strong><br/>${el.content.split("\n")[1]}</p>`,
                        },
                      },
                    ],
                  },
                ],
              };
            case "text":
            default:
              return {
                cells: [1],
                columns: [
                  {
                    contents: [
                      {
                        type: "text",
                        values: {
                          text: `<p style="margin:0;">${el.content}</p>`,
                        },
                      },
                    ],
                  },
                ],
              };
          }
        }),
      },
    };
  }, [serviceElements]);
  const handleEditorReady = useCallback(() => {
    const editor = editorRef.current?.editor;
    if (editor && EmailEditor) {
      try {
        editor.loadDesign(buildInitialDesign());
      } catch (err) {
        console.error("Failed to load initial design:", err);
      }
    }
  }, [EmailEditor, buildInitialDesign]);
  useEffect(() => {
    const editor = editorRef.current?.editor;
    if (!editor) return;
    const syncFromEditor = () => {
      editor.exportHtml(({ design }: any) => {
        const rows = design?.body?.rows ?? [];
        const newElements: Element[] = rows.map((row: any, idx: number) => {
          const col = row.columns?.[0];
          const block = col?.contents?.[0];
          let type = "text";
          let content = "";
          if (block?.type === "text") {
            const html = block.values.text ?? "";
            const text = html.replace(/<[^>]*>/g, "").trim();
            if (html.includes("Location")) type = "address";
            else if (html.includes("font-size:28px")) type = "price";
            else if (html.includes("<strong>")) type = "agent";
            else type = "text";
            content = text;
          }
          return { id: Date.now() + idx, type, content };
        });
        setServiceElements(newElements);
      });
    };
    editor.addEventListener("design:updated", syncFromEditor);
    return () => editor.removeEventListener("design:updated", syncFromEditor);
  }, [buildInitialDesign]);
  useEffect(() => {
    const fetchPlanLimits = async () => {
      try {
        const { data } = await axiosInstance.get(endpoints.plans);
        const limits: Record<string, number> = {};
        data.forEach((p: any) => {
          limits[p.name] = p.Campaigns ?? 0;
        });
        setPlanLimits(limits);
      } catch (err) {
        console.error("Failed to load plan limits", err);
      }
    };
    fetchPlanLimits();
  }, []);
  useEffect(() => {
    const fetchPropertyLists = async () => {
      try {
        setLoadingLists(true);
        const response = await axiosInstance.get(endpoints.propertylisttype);
        const lists = Array.isArray(response.data) ? response.data : [];
        const normalized = lists.map((item) => ({
          id: item.id,
          list_name: item.list_name || item.name || "Unknown List",
          custom_template_data: item.custom_template_data || {},
        }));

        // Ensure "Open House" is present
        const hasOpenHouse = normalized.some(
          (l) => l.list_name === "Open House"
        );
        if (!hasOpenHouse) {
          try {
            const createResp = await axiosInstance.post(
              endpoints.propertylisttype,
              { list_name: "Open House" }
            );
            const created = createResp.data;
            normalized.push({
              id: created.id,
              list_name: created.list_name || "Open House",
              custom_template_data: created.custom_template_data || {},
            });
          } catch (createErr) {
            normalized.push({
              id: null,
              list_name: "Open House",
              custom_template_data: {},
            });
          }
        }

        // MERGE with existing local lists instead of replacing
        setPropertyLists((prev) => {
          const merged = [...normalized];
          prev.forEach((existingList) => {
            if (!merged.some((l) => l.id === existingList.id)) {
              merged.push(existingList);
            }
          });
          return merged;
        });
      } catch (err: any) {
        console.error("Failed to load property lists:", err.response || err);
        toast({
          title: "Warning",
          description: "Using fallback lists",
          variant: "default",
        });
        setPropertyLists([
          { id: 1, list_name: "" },
          { id: 2, list_name: "" },
          { id: 3, list_name: "" },
          { id: 4, list_name: "" },
        ]);
      } finally {
        setLoadingLists(false);
      }
    };
    fetchPropertyLists();
  }, [toast]);
  const maxAllowed = useMemo(() => {
    if (!userPlan) return 0;
    return planLimits[userPlan] ?? 0;
  }, [userPlan, planLimits]);
  const [dirtyFields, setDirtyFields] = useState<Set<string>>(new Set());

  useEffect(() => {
    if (!templateId) return;
    const id = Number(templateId);
    const tmpl = templates.find((t) => t.id === id);
    if (!tmpl) {
      toast({
        title: "Error",
        description: "Template not found",
        variant: "destructive",
      });
      navigate("/launches");
      return;
    }
    setSelectedTemplate(tmpl);
    setCampaignType("property");
    setCurrentStep(4);
    if (propertyIdFromUrl) {
      const fetchProperty = async () => {
        try {
          const res = await axiosInstance.get(
            `${endpoints.properties}${propertyIdFromUrl}/`
          );
          // console.log("Property response:", res.data);
          setSelectedProperty(res.data);
          // If backend has a saved subject for this property, preload it
          if (res.data.subject) {
            setSubject(res.data.subject);
          }
          if (res.data.propertyListType?.list_name) {
            setSelectedPropertyList(res.data.propertyListType.list_name);
          }
          setPropertyData({
            address: res.data.address || "",
            mlsImport: false,
            description: res.data.description || "",
            agentInfo: "",
            price: res.data.price ? String(res.data.price) : "",
            campaignType: "property",
            headline: res.data.title || "",
            bedrooms: res.data.bedrooms ?? 0,
            bathrooms: res.data.bathrooms ?? 0,
            area: res.data.area ?? 0,
            agentPhone: res.data.agentPhone || res.data.agent?.phone || "",
            agentEmail: res.data.agentEmail || res.data.agent?.email || "",
            text_section: res.data.text_section || "",
          });
        } catch (err) {
          console.error("Error fetching property:", err);
          toast({
            title: "Error",
            description: "Property not found",
            variant: "destructive",
          });
        }
      };
      const fetchAgent = async () => {
        try {
          const res = await axiosInstance.get(endpoints.me);
          // console.log("Agent response:", res.data);
          const { first_name, last_name, phone_number, email } = res.data;
          const fullName = `${first_name ?? ""} ${last_name ?? ""}`.trim();
          setPropertyData((prev) => ({
            ...prev,
            agentInfo: prev.agentInfo || fullName || "No agent assigned",
            agentPhone: prev.agentPhone || phone_number || "N/A",
            agentEmail: prev.agentEmail || email || "N/A",
          }));
        } catch (err) {
          console.error("Error fetching agent:", err);
          toast({
            title: "Warning",
            description: "Agent info not found",
            variant: "default",
          });
        }
      };
      fetchProperty();
      fetchAgent();
    }
  }, [templateId, propertyIdFromUrl, navigate, toast]);
  // Fetch properties (reusable so we can call on mount and when entering step 2)
  const fetchProperties = useCallback(async () => {
    try {
      setLoadingProperties(true);
      const res = await axiosInstance.get(endpoints.properties);

      // Only include manually-created properties (exclude MLS-imported ones).
      // MLS-imported properties have an `mls` foreign key set on the backend.
      const manualOnly = Array.isArray(res.data)
        ? res.data.filter((p: any) => !p.mls)
        : [];

      const sorted = [...manualOnly]
        .sort((a: any, b: any) => {
          const dateA = new Date(a.created_at || a.id).getTime();
          const dateB = new Date(b.created_at || b.id).getTime();
          return dateB - dateA;
        })
        .filter((item, index, arr) =>
          index === arr.findIndex((other) => String(other.id) === String(item.id))
        );

      setProperties(sorted);
    } catch (error) {
      console.error("Error fetching properties:", error);
    } finally {
      setLoadingProperties(false);
    }
  }, []);

  // Call once on mount to ensure properties are available when user first opens step 2
  useEffect(() => {
    fetchProperties();
  }, [fetchProperties]);

  // Also refresh when user navigates into the property flow (step 2)
  useEffect(() => {
    if (campaignType === "property" && currentStep === 2) {
      fetchProperties();
    }
  }, [campaignType, currentStep, fetchProperties]);

  useEffect(() => {
    if (!selectedProperty?.id) {
      setKeyFeatures([]);
      setOriginalKeyFeatures([]);
      return;
    }
    const fetchKeyFeatures = async () => {
      try {
        setLoadingFeatures(true);
        const res = await axiosInstance.get(endpoints.keyfeatures);
        const filtered = res.data.filter(
          (f: any) => Number(f.propetyId) === Number(selectedProperty.id)
        );
        setKeyFeatures(filtered);
        setOriginalKeyFeatures([...filtered]);
      } catch (err: any) {
        console.error("Failed to load features:", err);
        toast({
          title: "Error",
          description: "Could not load property features",
          variant: "destructive",
        });
      } finally {
        setLoadingFeatures(false);
      }
    };
    fetchKeyFeatures();
  }, [selectedProperty?.id, toast]);

  // Fetch logged-in user's contact information and populate serviceData
  useEffect(() => {
    const fetchUserContactInfo = async () => {
      try {
        const res = await axiosInstance.get(endpoints.me);
        const { first_name, last_name, phone_number, email, company } =
          res.data;

        setServiceData((prev) => ({
          ...prev,
          phone: phone_number || prev.phone || "",
          email: email || prev.email || "",
          address: prev.address || "", // Address not in User model, keep empty for now
          website: prev.website || "", // Website not in User model, keep empty for now
        }));
      } catch (err) {
        console.error("Error fetching user contact info:", err);
      }
    };

    fetchUserContactInfo();
  }, []);

  // Fetch saved custom templates
  useEffect(() => {
    const fetchCustomTemplates = async () => {
      try {
        const res = await axiosInstance.get(endpoints.custom_templates);
        setCustomTemplates(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Failed to load custom templates", err);
      }
    };
    fetchCustomTemplates();
  }, []);

  // Fetch association list for agent lists
  // useEffect(() => {
  //   const fetchAgentLists = async () => {
  //     try {
  //       const res = await axiosInstance.get(endpoints.associations);

  //       const data = (
  //         Array.isArray(res.data) ? res.data : res.data.results || []
  //       ).map((assoc: any) => ({
  //         id: String(assoc.id || assoc.pk || Math.random()),
  //         name: assoc.name || "Unknown",
  //         count: assoc.agent_count || assoc.agents?.length || 0,
  //       }));

  //       // populate state so UI can render associations
  //       setAgentLists(data);
  //     } catch (error) {
  //       console.error("Failed to load association lists", error);
  //       // toast({
  //       //   title: "Error",
  //       //   description: "Failed to load association lists",
  //       //   variant: "destructive",
  //       // });
  //     }
  //   };

  //   fetchAgentLists();
  // }, []);

  const filteredTemplates = MANUAL_PROPERTY_TEMPLATES.filter(
    (t) =>
      (t.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        t.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
        t.style.toLowerCase().includes(searchQuery.toLowerCase()) ||
        t.tag.toLowerCase().includes(searchQuery.toLowerCase())) &&
      (activeFilter === "All Templates" ||
        t.category.toLowerCase().includes(activeFilter.toLowerCase()))
  );
  const filteredServiceTemplates = serviceTemplates.filter((t) =>
    t.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleCampaignTypeSelect = (type: "property" | "service") => {
    setCampaignType(type);
    setIsServiceFlow(type === "service");
    setPaymentCompleted(false);
    setShowPaymentForm(false);
    setPaymentIntentId(null);

    // ✅ ADD THESE:
    setIsAutoAIMode(false);
    setAutoAITemplateId(null);
    setSelectedTemplate(null);
    setSelectedServiceTemplate(null);

    setCurrentStep(2);
  };
  const handleContinue = () => {
    if (!campaignType) return;
    setCurrentStep(2);
  };

  // const requestStepNavigation = useCallback(


  //   (
  //     targetStep: number,
  //     afterNavigate?: () => void,
  //     confirmOnBackward: boolean = false
  //   ) => {
  //     if (targetStep === currentStep) return;

  //     if (targetStep > currentStep) {
  //       afterNavigate?.();
  //       setCurrentStep(targetStep);
  //       return;
  //     }

  //     // Disable back button on step 7 (payment) after payment is completed
  //     if (currentStep === 7 && paymentCompleted) {
  //       toast({
  //         title: "Cannot Go Back",
  //         description:
  //           "You cannot go back after completing the payment. Please proceed to launch your campaign.",
  //         variant: "destructive",
  //         duration: 1000,
  //       });
  //       return;
  //     }

  //     if (confirmOnBackward && currentStep === 8 && targetStep < currentStep) {
  //       setPendingStepNavigationAction(null);
  //       setStepClickTarget(null);
  //       setPendingNavigation(null);
  //       setShowCompleteLaunchDialog(true);
  //       return;
  //     }

  //     if (!confirmOnBackward) {
  //       afterNavigate?.();
  //       setCurrentStep(targetStep);
  //       return;
  //     }

  //     setPendingStepNavigationAction(() => afterNavigate ?? null);
  //     setStepClickTarget(targetStep);
  //   },
  //   [currentStep, paymentCompleted, toast]
  // );

  const requestStepNavigation = useCallback(
    (
      targetStep: number,
      afterNavigate?: () => void,
      confirmOnBackward: boolean = false
    ) => {
      if (targetStep === currentStep) return;

      const proceed = () => {
        if (targetStep > currentStep) {
          afterNavigate?.();
          setCurrentStep(targetStep);
          return;
        }

        if (currentStep === 7 && paymentCompleted) {
          toast({
            title: "Cannot Go Back",
            description:
              "You cannot go back after completing the payment. Please proceed to launch your campaign.",
            variant: "destructive",
            duration: 1000,
          });
          return;
        }

        if (confirmOnBackward && currentStep === 8 && targetStep < currentStep) {
          setPendingStepNavigationAction(null);
          setStepClickTarget(null);
          setPendingNavigation(null);
          setShowCompleteLaunchDialog(true);
          return;
        }

        if (!confirmOnBackward) {
          afterNavigate?.();
          setCurrentStep(targetStep);
          return;
        }

        setPendingStepNavigationAction(() => afterNavigate ?? null);
        setStepClickTarget(targetStep);
      };

      if (isEditingTemplate && isDirty) {
        setTemplateEditLeaveAction(() => proceed);
        setShowTemplateEditLeaveModal(true);
        return;
      }

      proceed();
    },
    [currentStep, paymentCompleted, toast, isEditingTemplate, isDirty]
  );

  const handleBack = () => {
    requestStepNavigation(Math.max(1, currentStep - 1));
  };

  const handleNext = () => {
    setCurrentStep((prev) => prev + 1);
  };
  // Validate step 6 before advancing: ensure schedule (if 'later') isn't in the past (UTC)

  const resetRecurring = () => {
    setIsRecurringCampaign(false);
    setRecurringStartDateTime("");
    setRecurringEndDate("");
    setCustomRecurringDates([]);
    setCheckoutData(null);
    setRecurringReviewAmount(0);
    setRecurringReviewConfirmed(false);
    setShowCheckoutModal(false);
    setShowRecurringModal(false);
  };

  const closeRecurringModal = () => {
    // if (!isRecurringCampaign) {
    //   setCheckoutData(null);
    // }
    setShowRecurringModal(false);
  };

  const trialActivationEligible =
    user?.is_in_active_trial === true &&
    Boolean(user?.stripe_subscription_id);

  const getRealPlanCreditsFromUser = (profile: any = user) => {
    const rawCredits =
      profile?.plan_period_remaining ??
      profile?.get_current_period_remaining ??
      (Number(profile?.plan_period_total ?? 0) - Number(profile?.campaigns_sent_this_month ?? 0));
    return Math.max(0, Number(rawCredits) || 0);
  };

  const getRealPlanCreditsDuringTrial = () => getRealPlanCreditsFromUser(user);

  const trialActivationNeedsPrompt = (totalSends: number) => {
    const remainingTrialCampaigns = Number(user?.remaining_trial_campaigns ?? 0);
    return trialActivationEligible && totalSends > remainingTrialCampaigns;
  };

  const handleTrialActivationIfNeeded = (
    _paymentAmount: number,
    totalSends: number,
    totalSelected = sendTo.database ? selectedDatasets.length : 0
  ) => {
    if (trialActivationNeedsPrompt(totalSends)) {
      const remainingTrialCampaigns = Number(user?.remaining_trial_campaigns ?? 0);
      const realPlanCredits = getRealPlanCreditsDuringTrial();
      setPendingTrialActivation({
        totalSends,
        trialCredits: Math.max(0, remainingTrialCampaigns),
        planCredits: realPlanCredits,
        totalSelected,
      });
      toast({
        title: "Free trial limit reached",
        description:
          "Your free trial sends have been used up. Activate your subscription to unlock your paid plan credits and continue this launch.",
        variant: "destructive",
        duration: 3000,
      });

      setShowTrialPaymentModal(true);
      setPlanLoading(false);
      return true;
    }
    return false;
  };

  const handleStep6Continue = async () => {
    // ✅ DEBUG: Log current state
    console.log("🔍 handleStep6Continue() called with state:", {
      isRecurringCampaign,
      checkoutData,
      paymentAmount,
      recurringReviewAmount,
      recurringReviewConfirmed,
      acceptedTerms,
      scheduleOption,
    });

    if (!acceptedTerms) {
      toast({
        title: "Terms Required",
        description: "Please accept the terms before continuing.",
        variant: "destructive",
        duration: 1000
      });
      return;
    }

    if (
      !(
        (sendTo.database && selectedDatasets.length > 0) ||
        (sendTo.mycontacts && selectedCustomDatasets.length > 0)
      )
    ) {
      toast({
        title: "No Recipients",
        description: "Select at least one recipient list.",
        variant: "destructive",
        duration: 1000
      });
      return;
    }

    if (scheduleOption === "later") {
      console.log("📅 Validating 'Schedule Later' option...");

      const hasRecurringDates =
        recurrenceType === "custom"
          ? customRecurringDates.length > 0
          : Boolean(recurringEndDate);

      console.log("   → hasRecurringDates:", hasRecurringDates);
      console.log("   → isRecurringCampaign:", isRecurringCampaign);

      if (isRecurringCampaign && !hasRecurringDates) {
        console.log("❌ Schedule Later validation failed - returning early");
        toast({
          title: "Recurring Dates Required",
          description:
            "Please set recurring dates before continuing with Schedule Later.",
          variant: "destructive",
          duration: 1000,
        });
        return;
      }

      if (!isRecurringCampaign && !selectedDateTime) {
        console.log("❌ No selectedDateTime - returning early");
        toast({
          title: "Missing Schedule",
          description: "Please select date and time.",
          variant: "destructive",
          duration: 1000
        });
        return;
      }

      const utcIso = localToUtcIso(selectedDateTime) || selectedDateTime;
      if (!isRecurringCampaign && (!utcIso || new Date(utcIso) < new Date(Date.now() - 30 * 1000))) {
        console.log("❌ Invalid date - returning early");
        toast({
          title: "Invalid Date",
          description: "You cannot schedule a launch in the past.",
          variant: "destructive",
          duration: 1000
        });
        return;
      }

      console.log("✅ Schedule Later validation passed, continuing...");
    }

    // ✅ FOR SEND NOW / RECURRING: If the broadcast requires more sends than the trial still allows,
    // prompt the user to activate their original paid plan rather than taking them to payment.
    if (checkoutData?.recurrenceType) {
      console.log("✅ Recurring campaign detected, recurrenceType:", checkoutData.recurrenceType);

      const totalSelected = sendTo.database ? selectedDatasets.length : 0;
      const totalSends = Number(checkoutData.recurringCount) || 1;

      // Recalculate billing with the current live selections to avoid stale values
      // (user may have returned to Step 5 and changed selected datasets).
      try {
        const billingNow = calculateBillingDetails({
          totalSelected,
          totalSends,
          remainingCamps: remainingCampaigns ?? 0,
          extraHubsCredit: extraHubsCredit ?? 0,
          extraLaunchCredits: extraLaunchCredits ?? 0,
          isOneTimePlan: checkoutData.selectedOneTimePlan || selectedOneTimePlan,
          oneTimePlanPrice: checkoutData.oneTimePlanPrice || selectedOneTimePrice,
        });

        // Update checkoutData with recalculated review totals so the modal shows
        // accurate values even if selection changed after the modal was first created.
        setCheckoutData((prev: any) => ({
          ...(prev || checkoutData),
          selectedAssociations: totalSelected,
          extraAssociationsCount: billingNow.totalExtraHubs,
          paidLaunchesCount: billingNow.paidLaunches ?? (prev?.paidLaunchesCount ?? 0),
          freeLaunchesCount: billingNow.freeLaunches ?? (prev?.freeLaunchesCount ?? 0),
          reviewTotalCharge: billingNow.totalCharge,
        }));
      } catch (err) {
        console.error("Failed to recalc billing for recurring review:", err);
      }

      if (handleTrialActivationIfNeeded(0, totalSends, totalSelected)) {
        return;
      }

      let reviewConfirmed = recurringReviewConfirmed;
      if (!reviewConfirmed) {
        const skippedReview = autoConfirmFreeRecurringReview(
          checkoutData,
          totalSends,
          totalSelected
        );
        if (skippedReview) {
          reviewConfirmed = true;
        } else {
          console.log("❌ recurringReviewConfirmed is false - showing modal");
          setShowCheckoutModal(true);
          // toast({
          //   title: "Review recurring payment",
          //   description:
          //     "Please click Save & Continue on the recurring review before continuing.",
          //   variant: "destructive",
          //   duration: 1500,
          // });
          return;
        }
      }

      let reviewedAmount = Number(
        checkoutData.reviewTotalCharge ?? recurringReviewAmount ?? paymentAmount ?? 0
      );
      if (reviewConfirmed && !recurringReviewConfirmed) {
        reviewedAmount = 0;
      }

      console.log("📊 Recurring review data:", {
        checkoutData_reviewTotalCharge: checkoutData.reviewTotalCharge,
        recurringReviewAmount,
        paymentAmount,
        calculatedReviewedAmount: reviewedAmount,
        recurringReviewConfirmed: reviewConfirmed,
      });

      setIsRecurringCampaign(true);
      setPaymentAmount(reviewedAmount);
      setNeedsPayment(reviewedAmount > 0);

      if (reviewedAmount > 0) {
        console.log("✅ reviewedAmount > 0, going to step 7 (payment page)");
        // Validate schedule before opening payment
        const ok = validateScheduleBeforePayment(checkoutData);
        if (!ok) return;
        setShowPaymentForm(true);
        setCurrentStep(7);
        return;
      }

      console.log("❌ reviewedAmount is 0, going to step 8 (no payment needed)");
      setShowPaymentForm(false);
      setCurrentStep(8);
      return;
    }

    if (scheduleOption === "now") {
      console.log("📤 'Send Now' option selected - calculating billing");

      const hasRecurringSchedule =
        Boolean(checkoutData?.recurrenceType) || isRecurringCampaign;

      // Only LaunchIQ Database hubs are billable. User datasets remain free.
      const totalSelected = sendTo.database ? selectedDatasets.length : 0;

      let activeCheckout = checkoutData;
      if (hasRecurringSchedule && !activeCheckout?.recurrenceType) {
        const built = buildRecurringCheckoutData();
        if (!built.data) {
          toast({
            title: "Recurring schedule required",
            description:
              built.error ||
              "Please open Set Recurring Schedule, add your dates, and click Apply Recurring Schedule.",
            variant: "destructive",
            duration: 2500,
          });
          setShowRecurringModal(true);
          return;
        }
        setCheckoutData(built.data);
        activeCheckout = built.data;
      }

      if (hasRecurringSchedule && activeCheckout?.recurrenceType) {
        const totalSends = Number(activeCheckout.recurringCount) || 1;
        if (handleTrialActivationIfNeeded(0, totalSends, totalSelected)) {
          return;
        }

        const billing = calculateBillingDetails({
          totalSelected,
          totalSends,
          remainingCamps: remainingCampaigns ?? 0,
          extraHubsCredit: extraHubsCredit ?? 0,
          extraLaunchCredits: (planDetails?.extra_launch_credits ?? user?.extra_launch_credits ?? 0),  // ADD
          isOneTimePlan: selectedOneTimePlan,
          oneTimePlanPrice: selectedOneTimePrice,
        });

        // setCheckoutData({
        //   ...activeCheckout,
        //   extraAssociationsCount: billing.totalExtraHubs ?? activeCheckout.extraAssociationsCount,
        //   campaignNeedsPayment: billing.paidLaunches > 0,
        // });

        setCheckoutData({
          ...activeCheckout,
          selectedAssociations: totalSelected,
          extraAssociationsCount: billing.totalExtraHubs ?? activeCheckout.extraAssociationsCount,
          campaignNeedsPayment: billing.paidLaunches > 0,
          paidLaunchesCount: billing.paidLaunches ?? activeCheckout.paidLaunchesCount,
          freeLaunchesCount: billing.freeLaunches ?? activeCheckout.freeLaunchesCount,
        });

        if (!recurringReviewConfirmed && billing.totalCharge > 0) {
          setShowCheckoutModal(true);
          toast({
            title: "Review recurring payment",
            description:
              "Please review your recurring launch charges and click Save & Continue.",
            variant: "destructive",
            duration: 2000,
          });
          return;
        }

        if (billing.totalCharge <= 0) {
          autoConfirmFreeRecurringReview(activeCheckout, totalSends, totalSelected);
        }

        if (handleTrialActivationIfNeeded(billing.totalCharge, totalSends, totalSelected)) {
          return;
        }

        if (billing.totalCharge > 0) {
          setPaymentAmount(billing.totalCharge);
          // Validate schedule before opening payment
          if (!validateScheduleBeforePayment({ ...activeCheckout, firstDate: activeCheckout.firstDate })) return;
          setShowPaymentForm(true);
          setCurrentStep(7);
          return;
        }

        setCurrentStep(8);
        return;
      }

      const totalSends = 1;
      const billing = calculateBillingDetails({
        totalSelected,
        totalSends,
        remainingCamps: remainingCampaigns ?? 0,
        extraHubsCredit: extraHubsCredit ?? 0,
        extraLaunchCredits: extraLaunchCredits ?? 0,
        isOneTimePlan: selectedOneTimePlan,
        oneTimePlanPrice: selectedOneTimePrice,
      });

      const newCheckoutData = {
        extraAssociationsCount: billing.totalExtraHubs,
        selectedAssociations: totalSelected,
        campaignNeedsPayment: billing.totalCharge > 0,
        firstDate: new Date().toISOString(),
        recurrenceType: null,
        recurringCount: 1,
        customRecurringDates: [],
        selectedOneTimePlan: Boolean(selectedOneTimePlan),
        oneTimePlanId: selectedOneTimePlan?.id || null,
        oneTimePlanPrice: selectedOneTimePrice,
      };

      setCheckoutData(newCheckoutData);

      const totalPaymentAmount = billing.totalCharge;

      if (handleTrialActivationIfNeeded(totalPaymentAmount, totalSends, totalSelected)) {
        return;
      }

      if (totalPaymentAmount > 0) {
        setPaymentAmount(totalPaymentAmount);
        // Validate schedule before opening payment
        if (!validateScheduleBeforePayment(newCheckoutData)) return;
        setShowPaymentForm(true);
        setCurrentStep(7);
        return;
      }

      setCurrentStep(8);
      return;
    }

    // ✅ USE CHECKOUT DATA IF AVAILABLE (from modal review for "Schedule Later")
    // If user came from Review modal, use the already-calculated values
    if (checkoutData) {
      console.log("📋 Using existing checkoutData:", {
        checkoutData,
        paymentAmount,
        showPaymentForm,
      });

      // const totalSelected = Number(checkoutData.selectedAssociations ?? 0);
      const totalSelected = sendTo.database ? selectedDatasets.length : Number(checkoutData.selectedAssociations ?? 0);
      const totalSends =
        (Boolean(checkoutData.recurrenceType) || isRecurringCampaign) && checkoutData.recurringCount
          ? Number(checkoutData.recurringCount) || 1
          : 1;

      const billing = calculateBillingDetails({
        totalSelected,
        totalSends,
        remainingCamps: remainingCampaigns ?? 0,
        extraHubsCredit: extraHubsCredit ?? 0,
        extraLaunchCredits: extraLaunchCredits ?? 0,
        isOneTimePlan: checkoutData.selectedOneTimePlan || selectedOneTimePlan,
        oneTimePlanPrice: checkoutData.oneTimePlanPrice || selectedOneTimePrice,
      });


      const updatedCheckoutData = {
        ...checkoutData,
        selectedAssociations: totalSelected,
        extraAssociationsCount: billing.totalExtraHubs,
        campaignNeedsPayment: billing.totalCharge > 0,
        paidLaunchesCount: billing.paidLaunches ?? checkoutData.paidLaunchesCount,
        freeLaunchesCount: billing.freeLaunches ?? checkoutData.freeLaunchesCount,
        reviewTotalCharge: billing.totalCharge,
      };

      setCheckoutData(updatedCheckoutData);
      const totalPaymentAmount = billing.totalCharge;
      setPaymentAmount(totalPaymentAmount);

      if (totalPaymentAmount > 0) {
        if (handleTrialActivationIfNeeded(totalPaymentAmount, totalSends, totalSelected)) {
          return;
        }

        console.log("✅ recalculated checkout total > 0, going to step 7");
        // Validate schedule before opening payment
        if (!validateScheduleBeforePayment(updatedCheckoutData)) return;
        setShowPaymentForm(true);
        setNeedsPayment(true);
        setCurrentStep(7);
        return;
      }

      if (handleTrialActivationIfNeeded(totalPaymentAmount, totalSends, totalSelected)) {
        return;
      }

      setShowPaymentForm(false);
      setNeedsPayment(false);
      setCurrentStep(8);
      return;
    }

    // ✅ FALLBACK: If no checkoutData, calculate from scratch (for "Schedule Later" without modal)
    console.log("⚠️ No matching conditions, using fallback logic");

    const remainingCamps = remainingCampaigns ?? 0;

    // Only LaunchIQ Database hubs are billable. User datasets remain free.
    const totalAssociationsSelected = sendTo.database ? selectedDatasets.length : 0;

    // ✅ CORRECT LOGIC: 
    // If BOTH remaining_campaigns = 0 AND remaining_associations = 0, charge for EVERYTHING
    // Otherwise, apply free allocations:
    // - 1 launch is free while remaining_campaigns > 0
    // - 1 hub/association is included free with that launch while remaining_campaigns > 0

    const campaignUnitPrice = campaignAddOnPrice;
    const associationUnitPrice = associationAddOnPrice;

    // Campaign charge: Pay if no free campaigns left
    let campaignChargePerDay = 0;
    if (remainingCamps === 0) {
      campaignChargePerDay = campaignUnitPrice;
    }

    const freeAssociationsPerCampaign = totalAssociationsSelected > 0 ? 1 : 0;
    const extraAssociations = Math.max(0, totalAssociationsSelected - freeAssociationsPerCampaign);
    const associationChargePerDay = extraAssociations * associationUnitPrice;

    const totalDay1Charge = campaignChargePerDay + associationChargePerDay;
    const paymentNeeded = totalDay1Charge > 0;

    if (paymentNeeded) {
      let totalPaymentAmount = totalDay1Charge;

      const totalSends = 1;
      const freeLaunches = Math.min(Math.max(remainingCamps, 0), totalSends);
      const paidLaunches = Math.max(0, totalSends - freeLaunches);

      const includedHubsPerSend = totalAssociationsSelected > 0 ? 1 : 0;
      const extraHubsPerSend = Math.max(0, totalAssociationsSelected - includedHubsPerSend);

      const newCheckoutData = {
        extraAssociationsCount: extraHubsPerSend,
        selectedAssociations: totalAssociationsSelected,
        campaignNeedsPayment: paidLaunches > 0,
        paidLaunchesCount: paidLaunches,
        freeLaunchesCount: freeLaunches,
        firstDate: selectedDateTime || new Date().toISOString(),
        recurrenceType: null,
        recurringCount: totalSends,
        customRecurringDates: [],
        endDate: null,
        selectedOneTimePlan: Boolean(selectedOneTimePlan),
        oneTimePlanId: selectedOneTimePlan?.id || null,
        oneTimePlanPrice: selectedOneTimePrice,
      };

      setCheckoutData(newCheckoutData);

      if (scheduleOption === "later" && isRecurringCampaign && checkoutData?.recurringCount) {
        const recurringDays = checkoutData.recurringCount - 1;
        const campaignUnitPrice = campaignAddOnPrice;
        const associationUnitPrice = associationAddOnPrice;

        const remainingDaysCharge = recurringDays * (campaignUnitPrice + totalAssociationsSelected * associationUnitPrice);
        totalPaymentAmount += remainingDaysCharge;
      }

      if (handleTrialActivationIfNeeded(totalPaymentAmount, totalSends, totalAssociationsSelected)) {
        return;
      }
      setPaymentAmount(totalPaymentAmount);
      // Validate schedule before opening payment
      if (!validateScheduleBeforePayment(newCheckoutData)) return;
      setShowPaymentForm(true);
      setCurrentStep(7);
      return;
    }

    if (handleTrialActivationIfNeeded(0, 1, totalAssociationsSelected)) {
      return;
    }

    // For campaigns using free resources, go directly to preview
    setCurrentStep(8);
  };

  // Validate schedule before opening payment. Returns true if ok, false if should stop.
  const validateScheduleBeforePayment = (checkout?: any): boolean => {
    // If schedule option is 'later', ensure first scheduled date exists and is in the future
    const firstDate = checkout?.firstDate || selectedDateTime || recurringStartDateTime || null;
    if (!firstDate) {
      toast({ title: "Missing Schedule", description: "Please select date and time.", variant: "destructive", duration: 1500 });
      setCurrentStep(6);
      return false;
    }

    const utc = localToUtcIso(firstDate) || firstDate;
    if (!utc || new Date(utc) < new Date(Date.now() - 30 * 1000)) {
      toast({ title: "Invalid Date", description: "You cannot schedule a launch in the past.", variant: "destructive", duration: 2000 });
      // Send user back to Schedule step so they can fix it
      setCurrentStep(6);
      // If recurring, open recurring modal for easier fixes
      if (checkout?.recurrenceType || isRecurringCampaign) {
        setShowRecurringModal(true);
      }
      return false;
    }

    // For recurring campaigns, ensure at least one recurring date exists and is valid
    if ((checkout?.recurrenceType || isRecurringCampaign)) {
      const hasRecurringDates = recurrenceType === "custom" ? customRecurringDates.length > 0 : Boolean(recurringEndDate) || Boolean(checkout?.customRecurringDates && checkout.customRecurringDates.length > 0);
      if (!hasRecurringDates && !checkout?.recurrenceType) {
        toast({ title: "Recurring Dates Required", description: "Please set recurring dates before continuing.", variant: "destructive", duration: 2000 });
        setCurrentStep(6);
        setShowRecurringModal(true);
        return false;
      }
    }

    return true;
  };


  const handleSendCampaign = async (scheduledOverride?: string) => {
    // ✅ Declare payload BEFORE try block so it's accessible in catch for error logging
    let payload: any = null;

    try {
      // ============ CHECK PAYMENT REQUIREMENTS ============
      // SKIP payment check if we're at Step 8 (payment already handled)
      // Only check payment if coming from earlier steps
      const shouldCheckPayment = currentStep < 8;
      const paymentNeeded = shouldCheckPayment ? checkPaymentRequired() : false;
      if (paymentNeeded && !paymentCompleted) {
        // Build checkoutData and show the complete payment (Step 7) with breakdown
        // Only LaunchIQ Database hubs are billable. User datasets remain free.
        const totalSelected = sendTo.database ? selectedDatasets.length : 0;

        const totalSends =
          (Boolean(checkoutData?.recurrenceType) || isRecurringCampaign) && checkoutData?.recurringCount
            ? Number(checkoutData.recurringCount) || 1
            : 1;

        const billing = calculateBillingDetails({
          totalSelected,
          totalSends,
          remainingCamps: remainingCampaigns ?? 0,
          extraLaunchCredits: extraLaunchCredits ?? 0,
          isOneTimePlan: checkoutData?.selectedOneTimePlan || selectedOneTimePlan,
          oneTimePlanPrice: checkoutData?.oneTimePlanPrice || selectedOneTimePrice,
        });

        const newCheckoutData = {
          extraAssociationsCount: billing.totalExtraHubs,
          selectedAssociations: totalSelected,
          campaignNeedsPayment: billing.totalCharge > 0,
          paidLaunchesCount: billing.paidLaunches ?? 0,
          freeLaunchesCount: billing.freeLaunches ?? 0,
          firstDate: checkoutData?.firstDate || new Date().toISOString(),
          recurrenceType: checkoutData?.recurrenceType || null,
          recurringCount: totalSends,
          customRecurringDates: checkoutData?.customRecurringDates || [],
          endDate: checkoutData?.endDate,
          selectedOneTimePlan: Boolean(checkoutData?.selectedOneTimePlan || selectedOneTimePlan),
          oneTimePlanId: checkoutData?.oneTimePlanId || selectedOneTimePlan?.id || null,
          oneTimePlanPrice: checkoutData?.oneTimePlanPrice || selectedOneTimePrice,
        };

        setCheckoutData(newCheckoutData);

        const totalPaymentAmount = billing.totalCharge;

        if (totalPaymentAmount > 0) {
          setPaymentAmount(totalPaymentAmount);
          // Validate schedule before opening payment
          if (!validateScheduleBeforePayment(newCheckoutData)) return;
          setShowPaymentForm(true);
          setCurrentStep(7);
          return;
        } else {
          setCurrentStep(8);
          return;
        }
      }

      // if (!subject.trim()) {
      //   setError("Please add subject");
      //   toast({
      //     title: "Missing Subject",
      //     description: "Please enter a launch subject.",
      //     variant: "destructive",
      //     duration: 1000
      //   });
      //   return;
      // }
      if (!acceptedTerms) {
        toast({
          title: "Terms Required",
          description: "Please accept the terms and conditions before sending.",
          variant: "destructive",
          duration: 1000
        });
        return;
      }
      if (!campaignType) {
        toast({
          title: "Missing launch Type",
          description: "Please select a launch type.",
          variant: "destructive",
          duration: 1000
        });
        return;
      }

      // If user chose "now", schedule the actual sending ~1 minute later so
      // DB save returns immediately and background worker processes the send.
      const scheduledToCheck =
        scheduledOverride ??
        (scheduleOption === "now"
          ? new Date(Date.now() + 60 * 1000).toISOString()
          : getEffectiveFirstScheduleDate());

      const recurringLaunchFields = buildRecurringLaunchFields({
        checkoutData,
        isRecurringCampaign,
        recurrenceType,
        recurringEndDate,
        customRecurringDates,
        scheduleOption,
        selectedDateTime,
        recurringStartDateTime,
      });

      const totalSelected = sendTo.database ? selectedDatasets.length : 0;
      const includedHubsPerSend = totalSelected > 0 ? 1 : 0;
      const extraHubsPerSend = Math.max(0, totalSelected - includedHubsPerSend);
      const totalSends =
        (Boolean(checkoutData?.recurrenceType) || isRecurringCampaign) && checkoutData?.recurringCount
          ? Number(checkoutData.recurringCount) || 1
          : 1;

      // Build ISO string for backend: avoid passing an already-ISO string through
      // `localToUtcIso` (which expects a `YYYY-MM-DDTHH:MM` local value). If we
      // are in the 'now' flow, use a direct UTC ISO timestamp; otherwise convert
      // the user-selected local datetime to UTC using the helper.
      const scheduled_date_for_backend =
        scheduleOption === "now"
          ? recurringLaunchFields.first_scheduled_date ||
          new Date(Date.now() + 60 * 1000).toISOString()
          : recurringLaunchFields.first_scheduled_date ||
          localToUtcIso(scheduledToCheck);

      if (!scheduledToCheck) {
        toast({
          title: "Missing Schedule",
          description: "Please select date and time.",
          variant: "destructive",
          duration: 1000
        });
        return;
      }

      // Ensure we compare the selected time in UTC (convert datetime-local to UTC ISO)
      const scheduledUtcIso =
        recurringLaunchFields.first_scheduled_date ||
        localToUtcIso(scheduledToCheck) ||
        scheduledToCheck;
      if (
        scheduleOption === "later" &&
        new Date(scheduledUtcIso) < new Date(Date.now() - 30 * 1000)
      ) {
        toast({
          title: "Invalid Date",
          description: "You cannot schedule a launch in the past.",
          variant: "destructive",
          duration: 1000
        });
        return;
      }

      if (
        selectedDatasets.length === 0 &&
        selectedCustomDatasets.length === 0
      ) {
        toast({
          title: "No Dataset",
          description: "Select at least one agent database or custom list.",
          variant: "destructive",
          duration: 1000
        });
        return;
      }
      setPlanLoading(true);

      // 1. Get fresh user data
      const { data: user } = await axiosInstance.get(endpoints.me);

      // ✅ CRITICAL: Update remaining campaigns/hub credits from fresh user data
      // This ensures that after payment completes, we have the latest allowances
      // and don't incorrectly trigger "launch limit exceeded" errors
      const freshRemainingCampaigns = user.get_remaining_campaigns || 0;
      const freshExtraHubsCredit = user.extra_hubs_credit || 0;
      setRemainingCampaigns(freshRemainingCampaigns);
      setExtraHubsCredit(freshExtraHubsCredit);

      if (user.pause_count > 0) {
        toast({
          title: "Subscription Paused",
          description:
            "Your subscription is currently paused. Please resume it in Billing to send launches.",
          variant: "destructive",
          duration: 1000
        });
        setPlanLoading(false);
        return;
      }

      // If user has no assigned plan, allow trial users and recently-paid users to continue
      // Only prompt non-trial users with no recent payment to subscribe.
      if (!user.plan_name && !user.is_in_active_trial && !paymentCompleted) {
        toast({
          title: "No Plan",
          description: "Subscribe first",
          variant: "destructive",
          duration: 1000
        });
        setShowPricingModal(true);
        setPlanLoading(false);
        return;
      }

      // ✅ REMOVED: Hard limit check that was blocking launches.
      // Users can now purchase additional campaigns at Step 7 (Payment).
      // No need to enforce a hard monthly limit here - allow payment to handle it.

      // ============ CHECK 7-DAY FREE TRIAL LIMITS ============
      // ✅ NEW BEHAVIOR: During active trial with remaining credits = 0:
      // - If user has NO paid plan: Block (show upgrade modal)
      // - If user HAS a paid plan: Allow creation but will be CHARGED for this campaign
      //
      // Only block if:
      // 1. User is in ACTIVE trial (is_in_active_trial = true)
      // 2. User has NO Stripe subscription AND NO assigned plan
      // 3. User has exhausted trial credits (remaining_trial_campaigns <= 0)
      //
      // Users WITH a paid plan can create campaigns during trial exhaustion
      // and will be charged immediately as addon/extra campaigns.
      //
      // After trial EXPIRES (is_in_active_trial = false):
      // All campaigns use paid plan credits with no special restrictions.

      if (user.is_in_active_trial && !user.plan && !trialValidated) {
        const remainingTrialCampaigns = user.remaining_trial_campaigns ?? 0;
        if (remainingTrialCampaigns <= 0) {
          toast({
            title: "Free Trial Limit Reached",
            description: `You've used all ${user.trial_campaigns_limit} free trial launches. Please upgrade or pay now to continue.`,
            variant: "destructive",
            duration: 1000
          });

          if (user.stripe_subscription_id) {
            setShowTrialPaymentModal(true);
          } else {
            setShowPricingModal(true);
          }

          setPlanLoading(false);
          return;
        }
      }

      // ✅ After trial expires: Reset trial validation flag to allow fresh checks
      // This ensures clean state for any subsequent operations
      if (!user.is_in_active_trial && trialValidated) {
        setTrialValidated(false);
      }

      setPlanLoading(true);
      toast({
        title: "Preparing launch...",
        description: "Generating launch",
        duration: 1000
      });

      // === REFETCH PROPERTY TO ENSURE LATEST CUSTOM DATA ===
      if (selectedProperty?.id) {
        try {
          const freshProperty = await axiosInstance.get(
            `${endpoints.properties}${selectedProperty.id}/`
          );
          setSelectedProperty(freshProperty.data);
        } catch (err: any) {
          // Log the error but don't crash - the property might have been deleted
          // We'll catch this more gracefully below during validation
          console.warn("Warning: Could not refetch property (may have been deleted or no longer accessible):", err.response?.status);
        }
      }

      // === STEP 1: Generate Screenshot of Template ===
      let generatedImageUrl: string | null = null;

      if (campaignType === "property" && selectedTemplate) {
        // Use the freshly refetched property with latest custom_template_data
        const html = await captureTemplateHTML(selectedTemplate, {
          ...propertyData,
          ...selectedProperty,
          keyFeatures,
          propertyListType: propertyLists.find(
            (l) => l.list_name === selectedPropertyList
          ),
        });

        if (html) {
          generatedImageUrl = await captureTemplateScreenshot(html);
        }
      }

      // For service campaigns (if you have a service template renderer)
      if (campaignType === "service" && selectedServiceTemplate) {
        // If you have a service template HTML generator, use it
        const serviceHtml = sessionStorage.getItem(
          "service_custom_template_html"
        );
        if (serviceHtml) {
          generatedImageUrl = await captureTemplateScreenshot(serviceHtml);
        }
      }

      // Fallback: use hero image if screenshot failed
      if (!generatedImageUrl) {
        generatedImageUrl =
          propertyData.heroImage ||
          selectedProperty?.image ||
          serviceData.heroImage ||
          "";
        // toast({
        //   title: "Using fallback image",
        //   description:
        //     "Template screenshot failed, using property/service image.",
        //   variant: "default",
        // });
      }

      // === STEP 2: Build Payload with image_url ===
      const associationIds = selectedDatasets
        .map((id) => {
          // Ensure we parse as integer, not float
          const parsed = parseInt(String(id), 10);
          return Number.isFinite(parsed) ? parsed : null;
        })
        .filter((n) => n !== null) as number[];

      const customAgentIds = selectedCustomDatasets.flatMap((sel) => {
        const selectedGroupId = String(sel);
        return contacts
          .filter((a: any) => {
            const agentGroupId =
              a.group ?? a.group_id ?? a.contact_group ?? a.groupId ?? null;
            return (
              String(agentGroupId ?? "") === selectedGroupId ||
              String(a.company?.trim() || "No Company") === selectedGroupId
            );
          })
          .map((a: any) => {
            const parsed = parseInt(String(a.id), 10);
            return Number.isFinite(parsed) ? parsed : null;
          })
          .filter((n: any) => n !== null) as number[];
      });

      const agentUserIds = Array.from(new Set(customAgentIds));
      const isMultiPropertyMode = sessionStorage.getItem("isMultiPropertyMode") === "true";
      const isMultiServiceMode = sessionStorage.getItem("isMultiServiceMode") === "true";
      const campaignTypeForPayload =
        campaignType === "property" && isMultiPropertyMode
          ? "multi_property"
          : campaignType === "service" && isMultiServiceMode
            ? "multi_service"
            : campaignType;
      const getTemplateIdFromObject = (obj: any): string | null => {
        const raw = obj?.id ?? obj?.templateId ?? obj?.template_id ?? null;
        if (raw === null || raw === undefined || raw === "") return null;
        const parsed = parseInt(String(raw), 10);
        return Number.isFinite(parsed) ? String(parsed) : null;
      };
      const getFirstMultiTemplateId = (isServiceMulti: boolean): string | null => {
        const fromState = isServiceMulti
          ? getTemplateIdFromObject(selectedMultipleServiceTemplates?.[0])
          : getTemplateIdFromObject(selectedMultipleTemplates?.[0]);
        if (fromState) return fromState;

        const key = isServiceMulti ? "multiSelectedServiceTemplateIds" : "multiSelectedTemplateIds";
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;
        try {
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed) && parsed.length > 0) {
            const first = parseInt(String(parsed[0]), 10);
            return Number.isFinite(first) ? String(first) : null;
          }
        } catch (_e) {
          return null;
        }
        return null;
      };
      const firstMultiPropertyTemplateId = getFirstMultiTemplateId(false);
      const firstMultiServiceTemplateId = getFirstMultiTemplateId(true);
      const getMultiItems = (key: "multiSelectedProperties" | "multiSelectedServices", inMemory: any[]) => {
        if (Array.isArray(inMemory) && inMemory.length > 0) return inMemory;
        const raw = sessionStorage.getItem(key);
        if (!raw) return [];
        try {
          const parsed = JSON.parse(raw);
          return Array.isArray(parsed) ? parsed : [];
        } catch (_e) {
          return [];
        }
      };
      const multiPropertiesPayload = getMultiItems("multiSelectedProperties", multiSelectedProperties as any[]);
      const multiServicesPayload = getMultiItems("multiSelectedServices", multiSelectedServices as any[]);
      const multiPropertyNameFallback =
        (multiSelectedProperties?.[0] as any)?.title ||
        (multiSelectedProperties?.[0] as any)?.headline ||
        "Multi Property Launch";
      const multiServiceNameFallback =
        (multiSelectedServices?.[0] as any)?.title ||
        (multiSelectedServices?.[0] as any)?.headline ||
        "Multi Service Launch";

      let serviceCustomTemplateId: number | null = null;
      let serviceTemplateName_stored: string = "";
      if (campaignType === "service") {
        serviceCustomTemplateId =
          savedServiceTemplateId ||
          (sessionStorage.getItem("service_custom_template_id")
            ? Number(sessionStorage.getItem("service_custom_template_id"))
            : null);
        serviceTemplateName_stored =
          sessionStorage.getItem("service_custom_template_name") ||
          serviceTemplateName;
      }

      // ✅ Declare payload here (outside try) so it's accessible in catch for error logging

      // Get the appropriate subject based on campaign type
      let campaignSubject = subject?.trim() || "";

      // For multi-property campaigns, retrieve subject from sessionStorage
      if (campaignTypeForPayload === "multi_property") {
        const multiPropertySubject = sessionStorage.getItem("multiPropertyEmailSubject");
        if (multiPropertySubject) {
          campaignSubject = multiPropertySubject.trim();
        }
      }

      // For multi-service campaigns, retrieve subject from sessionStorage
      if (campaignTypeForPayload === "multi_service") {
        const multiServiceSubject = sessionStorage.getItem("multiServiceEmailSubject");
        if (multiServiceSubject) {
          campaignSubject = multiServiceSubject.trim();
        }
      }

      // Use property/service title as fallback if no subject is set
      if (!campaignSubject) {
        campaignSubject = (
          campaignType === "service"
            ? serviceData?.headline || serviceData?.title || selectedService?.title
            : propertyData?.headline || selectedProperty?.title
        ) || "";
      }

      payload = {
        campaign_type: campaignTypeForPayload,
        campaign_subject: campaignSubject.trim(),
        campaign_name:
          campaignTypeForPayload === "multi_property"
            ? multiPropertyNameFallback
            : campaignTypeForPayload === "multi_service"
              ? multiServiceNameFallback
              : campaignType === "service"
                ? serviceData?.title || selectedService?.title || ""
                : propertyData?.headline || selectedProperty?.title || "",
        property_id: selectedProperty?.id ? parseInt(String(selectedProperty.id), 10) : null,
        // include service id when creating a service campaign so backend can link the ServiceListing
        ...((campaignType === "service" || campaignTypeForPayload === "multi_service") && {
          service_id: selectedService?.id ? parseInt(String(selectedService.id), 10) : (serviceCampaignId ? parseInt(String(serviceCampaignId), 10) : null),
        }),
        template:
          campaignType === "service"
            ? // Send as string 'template{id}' so backend can map to html template
            selectedServiceTemplate?.id
              ? `template${selectedServiceTemplate.id}`
              : serviceTemplateName_stored
            : campaignTypeForPayload === "multi_service"
              ? (firstMultiServiceTemplateId ? `template${firstMultiServiceTemplateId}` : "")
              : campaignTypeForPayload === "multi_property"
                ? (firstMultiPropertyTemplateId ? `template${firstMultiPropertyTemplateId}` : "")
                : selectedTemplate
                  ? `template${(selectedTemplate as any).id}`
                  : "",
        county_ids: associationIds,
        agent_user_ids: agentUserIds,
        custom_agent_user_ids: agentUserIds,
        // Persist selected My Hub/contact group IDs.
        custom_dataset_names: normalizeCustomDatasetIds(),
        custom_template_id:
          campaignType === "service"
            ? serviceCustomTemplateId
            : (selectedTemplate as any)?.is_custom
              ? (selectedTemplate as any)?.id ?? null
              : null,
        scheduled_date: scheduled_date_for_backend, // ISO string for backend (UTC)
        scheduled_timezone: effectiveTimezone,
        schedule_option: scheduleOption,
        image_url: generatedImageUrl, // ← NEW
        thumbnail_url: generatedImageUrl, // ← NEW (or generate smaller version)
        // 🆕 IMPORTANT: Send the calculated recipient count from frontend
        recipient_count: recipientCount,
        // Recurring schedule data (send now, schedule later, and custom dates)
        is_recurring: recurringLaunchFields.is_recurring,
        recurrence_type: recurringLaunchFields.recurrence_type,
        recurring_end_date: recurringLaunchFields.recurring_end_date,
        custom_recurring_dates: recurringLaunchFields.custom_recurring_dates,
        ...(recurringLaunchFields.recurring_count && {
          recurring_count: recurringLaunchFields.recurring_count,
        }),
        ...(trialCreditsToApply > 0 && {
          trial_credits_to_apply: trialCreditsToApply,
        }),
        // ✅ NEW: Include payment reference so backend validates with paid limits
        ...(paymentIntentId && {
          payment_intent_id: paymentIntentId,
        }),
        // ✅ NEW: Include extra hub credits to deduct from user account
        ...(extraHubsCredit && extraHubsPerSend > 0 && {
          extra_hubs_credit_to_use: Math.min(extraHubsCredit, totalSends * extraHubsPerSend),
        }),
        ...(campaignType === "service" && {
          service_type: serviceData.serviceType,
        }),
        ...(campaignTypeForPayload === "multi_property" && {
          message: JSON.stringify({
            properties: multiPropertiesPayload,
            template_path: "multiproperty/template.html",
          }),
        }),
        ...(campaignTypeForPayload === "multi_service" && {
          message: JSON.stringify({
            services: multiServicesPayload,
            template_path: "multiproperty/service/template.html",
          }),
        }),
        // 🆕 Include pre-rendered HTML from draft if available (for multi-property/service)
        ...(campaignTypeForPayload === "multi_property" && sessionStorage.getItem('campaignDraftState') && {
          html: sessionStorage.getItem('renderedHtml') || undefined,
        }),
        ...(campaignTypeForPayload === "multi_service" && sessionStorage.getItem('campaignDraftState') && {
          html: sessionStorage.getItem('renderedHtml') || undefined,
        }),
      };

      // === STEP 3: Create Campaign ===
      // 🆕 Validate critical fields before sending

      // Validate campaign_type
      if (!payload.campaign_type) {
        console.error('[handleSendCampaign] ERROR: campaign_type is missing!', { payload });
        toast({
          title: "Error",
          description: "Campaign type is missing. Please refresh and try again.",
          variant: "destructive",
        });
        setPlanLoading(false);
        return;
      }

      // 🔥 NEW: Validate property_id/service_id for non-multi campaigns
      const isPropertyCampaign = campaignTypeForPayload === "property";
      const isServiceCampaign = campaignTypeForPayload === "service";

      if (isPropertyCampaign && !payload.property_id) {
        console.error('[handleSendCampaign] ERROR: property_id is missing for property campaign!', { payload, selectedProperty });
        toast({
          title: "Error",
          description: "Property not found. Please select a property and try again.",
          variant: "destructive",
        });
        setPlanLoading(false);
        return;
      }

      // 🔥 NEW: Validate property_id is a valid integer
      if (isPropertyCampaign && payload.property_id && !Number.isInteger(payload.property_id)) {
        console.error('[handleSendCampaign] ERROR: property_id is not a valid integer!', { payload, propertyId: payload.property_id, type: typeof payload.property_id });
        toast({
          title: "Error",
          description: "Property ID is invalid. Please refresh and select a property again.",
          variant: "destructive",
        });
        setPlanLoading(false);
        return;
      }

      // 🆕 NEW: Pre-flight validation - verify property exists and belongs to user
      if (isPropertyCampaign && payload.property_id) {
        try {
          const propertyValidation = await axiosInstance.get(
            `${endpoints.properties}${payload.property_id}/`
          );
          if (!propertyValidation.data) {
            throw new Error("Property not found");
          }
        } catch (err: any) {
          console.error('[handleSendCampaign] Property validation failed:', {
            propertyId: payload.property_id,
            status: err.response?.status,
            error: err.response?.data
          });
          toast({
            title: "Property Not Found",
            description: `Property #${payload.property_id} no longer exists or is not accessible. Please select a different property.`,
            variant: "destructive",
          });
          setPlanLoading(false);
          return;
        }
      }

      if (isServiceCampaign && !payload.service_id) {
        console.error('[handleSendCampaign] ERROR: service_id is missing for service campaign!', { payload, selectedService });
        console.log('[handleSendCampaign] payload.service_id:', payload.service_id);
        toast({
          title: "Error",
          description: "Service not found. Please select a service and try again.",
          variant: "destructive",
        });
        setPlanLoading(false);
        return;
      }

      // 🔥 NEW: Validate service_id is a valid integer
      if (isServiceCampaign && payload.service_id && !Number.isInteger(payload.service_id)) {
        console.error('[handleSendCampaign] ERROR: service_id is not a valid integer!', { payload, serviceId: payload.service_id, type: typeof payload.service_id });
        toast({
          title: "Error",
          description: "Service ID is invalid. Please refresh and select a service again.",
          variant: "destructive",
        });
        setPlanLoading(false);
        return;
      }

      // 🆕 NEW: Pre-flight validation - verify service exists and belongs to user
      if (isServiceCampaign && payload.service_id) {
        try {
          const serviceValidation = await axiosInstance.get(
            `${endpoints.service_listings}${payload.service_id}/`
          );
          if (!serviceValidation.data) {
            throw new Error("Service not found");
          }
        } catch (err: any) {
          console.error('[handleSendCampaign] Service validation failed:', {
            serviceId: payload.service_id,
            status: err.response?.status,
            error: err.response?.data
          });
          toast({
            title: "Service Not Found",
            description: `Service #${payload.service_id} no longer exists or is not accessible. Please select a different service.`,
            variant: "destructive",
          });
          setPlanLoading(false);
          return;
        }
      }

      // 🔥 NEW: Validate template field
      // Skip template validation for multi-property/service campaigns (they use template_path in message)
      const isMultiCampaign = campaignTypeForPayload === "multi_property" || campaignTypeForPayload === "multi_service";
      if (!isMultiCampaign && (!payload.template || payload.template === "")) {
        console.error('[handleSendCampaign] ERROR: template is missing!', { payload, selectedTemplate });
        toast({
          title: "Error",
          description: "Template not found. Please select a template and try again.",
          variant: "destructive",
        });
        setPlanLoading(false);
        return;
      }

      // 🆕 Check campaign_subject has a value (either from input or from property title)
      if (!payload.campaign_subject || !payload.campaign_subject.trim()) {
        console.error('[handleSendCampaign] ERROR: campaign_subject could not be determined!', {
          subject,
          propertyTitle: propertyData?.headline || selectedProperty?.title,
          payload
        });
        toast({
          title: "Error",
          description: "Campaign needs a name. Please enter a campaign subject or property title.",
          variant: "destructive",
        });
        setPlanLoading(false);
        return;
      }

      // console.log('[handleSendCampaign] FINAL payload being sent to backend:', JSON.stringify(payload, null, 2));
      // console.log('[handleSendCampaign] ✅ Payment Intent ID being sent:', paymentIntentId || 'NOT SET');

      const response = await axiosInstance.post(
        endpoints.createCampaign,
        payload
      );

      // console.log('[handleSendCampaign] ✓ Campaign created successfully, response:', response.data);

      // Build toast message with recurring info if applicable
      let toastDescription =
        scheduleOption === "now"
          ? "Saved — sending will start in about 1 minute."
          : `Will run on ${formatDateTime(scheduledToCheck)} (${effectiveTimezone})`;

      if (isRecurringCampaign && checkoutData?.recurrenceType) {
        const recurrenceLabel = recurrenceType.charAt(0).toUpperCase() + recurrenceType.slice(1);
        toastDescription += ` • Recurring: ${recurrenceLabel}`;
        if (recurringEndDate) {
          // recurringEndDate is now date-only (YYYY-MM-DD format)
          toastDescription += ` until ${recurringEndDate}`;
        }
      }

      toast({
        title: "Launch Created!",
        description: toastDescription,
        variant: "success",
        duration: 1000
      });

      // If a draft exists for this campaign type, remove it from backend
      try {
        if (campaignType) {
          console.log('[handleSendCampaign] deleting draft for campaignType:', campaignType);
          await campaignDraftService.deleteDraftByType(campaignType as 'property' | 'service');
          if (campaignType === 'property') {
            setPropertyDraft(null);
            setDraft(serviceDraft);
            setHasDraft(serviceDraft !== null);
          } else {
            setServiceDraft(null);
            setDraft(propertyDraft);
            setHasDraft(propertyDraft !== null);
          }
          console.log('[handleSendCampaign] draft deleted successfully');
        }
      } catch (err) {
        console.warn('[handleSendCampaign] failed to delete draft after launch:', err);
      }

      // Clear unsaved changes flag so navigation warning won't show
      setHasUnsavedChanges(false);

      // Refresh user limits so `get_remaining_campaigns` and extra hub credits
      // reflect this launch (including recurring schedules) immediately in the UI.
      try {
        const { data: updatedUser } = await axiosInstance.get(endpoints.me);
        setPlanDetails(updatedUser);
        setRemainingCampaigns(updatedUser.get_remaining_campaigns || 0);
        setExtraHubsCredit(updatedUser.extra_hubs_credit || 0);

        // Deduct extra hub credits if any were used in this campaign
        if (extraHubsPerSend > 0 && totalSends > 0) {
          const creditsToDeduct = extraHubsPerSend * totalSends;
          console.log(`[handleSendCampaign] Deducting ${creditsToDeduct} extra hub credits (${extraHubsPerSend} hubs × ${totalSends} sends)`);
          // Backend will handle the actual deduction when campaign is created
          // This updates local UI to reflect the change
          const newBalance = Math.max(0, (updatedUser.extra_hubs_credit || 0) - creditsToDeduct);
          setExtraHubsCredit(newBalance);
        }

        // ✅ NEW: Update user profile with auto-detected timezone if not set
        // This ensures their timezone preference is saved in the backend
        if (!updatedUser.timezone && userTimezone && userTimezone !== "UTC") {
          try {
            const formData = new FormData();
            formData.append('timezone', userTimezone);
            await axiosInstance.put(endpoints.me, formData, {
              headers: { "Content-Type": undefined },
            });
            console.log(`✅ User profile updated with auto-detected timezone: ${userTimezone}`);
          } catch (tzErr) {
            console.warn(`⚠️ Failed to auto-save timezone to profile: ${userTimezone}`, tzErr);
            // Not a critical error - don't disrupt user experience
          }
        }

         window.dispatchEvent(new Event("user-updated"));
         
        // ✅ CAMPAIGN CREATED SUCCESSFULLY: Navigate to step 9
        setCurrentStep(9);
      } catch (err) {
        console.warn("[handleSendCampaign] failed to refresh user limits after launch:", err);
      }
    } catch (error: any) {
      console.error("Launch campaign failed:", error);

      // 🆕 Detailed error logging - handle all error response formats
      const errorData = error.response?.data || {};
      let errorMessage = "Failed to launch campaign";

      // Try to extract error message from various backend formats
      if (errorData.detail) {
        errorMessage = errorData.detail;
      } else if (errorData.message) {
        errorMessage = errorData.message;
      } else if (errorData.non_field_errors) {
        errorMessage = Array.isArray(errorData.non_field_errors)
          ? errorData.non_field_errors[0]
          : errorData.non_field_errors;
      } else {
        // Try to find first field error (prioritize property_id and service_id)
        const errorFields = ['property_id', 'service_id', ...Object.keys(errorData)];
        for (const field of errorFields) {
          const errors = errorData[field];
          if (Array.isArray(errors) && errors.length > 0) {
            // For property/service errors, show user-friendly message
            if (field === 'property_id' || field === 'service_id') {
              errorMessage = errors[0];
            } else {
              errorMessage = `${field}: ${errors[0]}`;
            }
            break;
          } else if (typeof errors === 'string' && errors.trim()) {
            errorMessage = field === 'property_id' || field === 'service_id'
              ? errors
              : `${field}: ${errors}`;
            break;
          }
        }
      }

      const errorStatus = error.response?.status;

      console.error("[handleSendCampaign] DETAILED ERROR:", {
        status: errorStatus,
        data: errorData,
        message: errorMessage,
        payload: payload, // payload is now in scope
      });

      toast({
        title: "Error",
        description: errorMessage,
        variant: "destructive",
      });
    } finally {
      setPlanLoading(false);
    }
  };

  //  VALIDATION: Check if template has required photos
  // Note: heroImage is the main image, photos/secondaryImage contain required secondary images
  const validateTemplatePhotos = (template: Template | null, data: any): { valid: boolean; message?: string } => {
    if (!template) {
      return { valid: false, message: "No template selected" };
    }

    const requiredPhotos = template.photoCount || 0;
    if (requiredPhotos <= 0) {
      return { valid: true };
    }

    const hasValidImageValue = (value: any): boolean => {
      if (!value) return false;
      if (typeof value === "string") return value.trim() !== "";
      if (typeof File !== "undefined" && value instanceof File) return true;
      if (typeof value === "object") {
        return [
          value.url,
          value.image,
          value.image_url,
          value.heroImage,
          value.hero_image,
          value.hero_image_url,
        ].some((nestedValue) => typeof nestedValue === "string" && nestedValue.trim() !== "");
      }
      return false;
    };

    const getImageKey = (value: any): string => {
      if (typeof value === "string") return value.trim();
      if (typeof File !== "undefined" && value instanceof File) {
        return `${value.name}-${value.size}-${value.lastModified}`;
      }
      if (typeof value === "object" && value) {
        const nestedValue =
          value.url ||
          value.image ||
          value.image_url ||
          value.heroImage ||
          value.hero_image ||
          value.hero_image_url;
        if (typeof nestedValue === "string") return nestedValue.trim();
      }
      return "";
    };

    const heroImageCandidates = [
      data.heroImage,
      data.hero_image,
      data.hero_image_url,
      data.image,
      data.image_url,
      data.mainImage,
      data.primaryImage,
    ];

    const hasHeroImage = heroImageCandidates.some(hasValidImageValue);
    if (!hasHeroImage) {
      return {
        valid: false,
        message: "Template requires a hero image. Please upload the hero image before sending.",
      };
    }

    const requiredSecondaryPhotos = Math.max(requiredPhotos - 1, 0);
    if (requiredSecondaryPhotos === 0) {
      return { valid: true };
    }

    const heroKeys = new Set(heroImageCandidates.filter(hasValidImageValue).map(getImageKey).filter(Boolean));
    const isValidSecondaryValue = (candidate: any): boolean => {
      if (!hasValidImageValue(candidate)) return false;
      const key = getImageKey(candidate);
      return !key || !heroKeys.has(key);
    };

    const getSecondarySlotCandidates = (slotIndex: number): any[] => {
      const candidates: any[] = [
        data[`photo${slotIndex + 2}`],
        data.photos?.[slotIndex],
        data.photos_urls?.[slotIndex],
        data.images?.[slotIndex],
        data.gallery?.[slotIndex],
      ];

      if (slotIndex === 0) {
        candidates.unshift(
          data.secondaryImage,
          data.secondary_image,
          data.secondary_image_url
        );
      }

      return candidates;
    };

    const missingSecondarySlots: number[] = [];
    for (let slotIndex = 0; slotIndex < requiredSecondaryPhotos; slotIndex += 1) {
      const hasSlotImage = getSecondarySlotCandidates(slotIndex).some(isValidSecondaryValue);
      if (!hasSlotImage) {
        missingSecondarySlots.push(slotIndex + 2);
      }
    }

    if (missingSecondarySlots.length > 0) {
      const availableSecondarySlots =
        requiredSecondaryPhotos - missingSecondarySlots.length;
      return {
        valid: false,
        message: `Template requires ${requiredSecondaryPhotos} secondary image${requiredSecondaryPhotos !== 1 ? "s" : ""} plus the hero image, but only ${availableSecondarySlots} secondary image${availableSecondarySlots === 1 ? "" : "s"} ${availableSecondarySlots === 1 ? "is" : "are"} available. Please upload photo ${missingSecondarySlots.join(", ")}.`,
      };
    }

    return { valid: true };
  };

  const handleSendProof = async () => {
    if (sendingProof) return;
    if (!selectedService?.id) {
      toast({
        title: "Save first",
        description: "You must save the service before sending proof",
        variant: "destructive",
        duration: 1000
      });
      return;
    }

    // VALIDATION: require at least one non-empty feature for service
    const svcFeatures = (serviceData.features || []).filter(
      (f: any) => f && f.toString().trim() !== ""
    );
    if (svcFeatures.length === 0) {
      toast({
        title: "Add At Least One Feature",
        description:
          "Please add at least one key feature to the service before sending a proof.",
        variant: "destructive",
        duration: 1000
      });
      return;
    }

    // ✅ VALIDATION: Check if template has required photos for services
    if (selectedServiceTemplate) {
      const photoValidation = validateTemplatePhotos(selectedServiceTemplate, serviceData);
      if (!photoValidation.valid) {
        toast({
          title: "Photos Required",
          description: photoValidation.message || "Please add photos to your template",
          variant: "destructive",
          duration: 3000,
        });
        return;
      }
    }

    setSendingProof(true);
    toast({ title: "Sending proof email...", description: "Please wait", duration: 1000 });

    try {
      const templateId =
        selectedServiceTemplate?.id ||
        savedServiceTemplateId ||
        (sessionStorage.getItem("service_custom_template_id")
          ? Number(sessionStorage.getItem("service_custom_template_id"))
          : null);

      const templateNum = templateId ? String(templateId) : "1";
      const sendPayload: any = {
        service_id: selectedService.id,
        template_id: templateId,
        template_path: `services/template${templateNum}.html`,
        subject: `Proof: ${serviceData.title || "Your Service Campaign"}`,
      };

      await axiosInstance.post(
        endpoints.send_service_proof,
        sendPayload
      );

      setProofSentCount((c) => c + 1);
      toast({
        title: "Proof sent!",
        description: "Check your email inbox.",
        variant: "success",
        duration: 1000
      });
    } catch (err: any) {
      toast({
        title: "Failed to send proof",
        description: err.response?.data?.error || "Please try again",
        variant: "destructive",
      });
    } finally {
      setSendingProof(false);
    }
  };
  const handleConfirmStepNav = () => {
    if (stepClickTarget !== null) {
      pendingStepNavigationAction?.();
      (window as any).__internalStepNav = true;
      setCurrentStep(stepClickTarget);
      setTimeout(() => {
        try { delete (window as any).__internalStepNav; } catch (e) { }
      }, 300);
    }
    setPendingStepNavigationAction(null);
    setStepClickTarget(null);
  };
  const handleCancelStepNav = () => {
    setPendingStepNavigationAction(null);
    setStepClickTarget(null);
  };
  /**
   * Capture rendered React component as HTML with inline styles.
   * This is used for file-based templates (template1, template2, etc.)
   */
  const captureTemplateHTML = async (
    template: Template,
    data?: any
  ): Promise<string | null> => {
    try {
      const visibleTemplate =
        document.querySelector(".template-preview-shell > *") ||
        document.querySelector(".template-fit-fixed-image > *") ||
        document.querySelector(".template-fit-fixed-image");
      const visibleWidth = visibleTemplate
        ? Math.round(visibleTemplate.getBoundingClientRect().width)
        : 0;
      const renderWidth = visibleWidth > 0 ? Math.min(1024, visibleWidth) : 720;

      const container = document.createElement("div");
      container.style.position = "fixed";
      container.style.left = "-9999px";
      container.style.top = "-9999px";
      container.style.width = `${renderWidth}px`;
      container.style.backgroundColor = "white";
      container.style.height = "auto";
      container.style.overflow = "visible";
      document.body.appendChild(container);
      // Render component into container using React
      const root = ReactDOM.createRoot(container);
      const TemplateComponent = template.component;
      // Find the propertyListType object for the selected list
      const selectedListObj = propertyLists.find(
        (l) => l.list_name === selectedPropertyList
      );
      const propertyListType = selectedListObj
        ? { id: selectedListObj.id, list_name: selectedListObj.list_name }
        : undefined;

      const templateData = data ?? {
        price: propertyData.price
          ? Number(String(propertyData.price).replace(/[^0-9.-]+/g, ""))
          : null,
        address: propertyData.address || "",
        title: propertyData.headline || "",
        description: propertyData.description,
        text_section: propertyData.text_section,
        bedrooms: propertyData.bedrooms ?? 0,
        bathrooms: propertyData.bathrooms ?? 0,
        area: propertyData.area ?? 0,
        image: propertyData.heroImage || selectedProperty?.image,
        id: selectedProperty?.id ?? 0,
        agentName: propertyData.agentName,
        agentPhone: propertyData.agentPhone,
        agentEmail: propertyData.agentEmail,
      };

      // Create property object with propertyListType AND is_open_house (separate fields)
      const propertyWithListType = {
        ...templateData,
        propertyListType,
        is_open_house: selectedProperty?.is_open_house ?? false, // Pass the boolean flag separately
        custom_template_data: selectedProperty?.custom_template_data ?? {}, // Include custom data from property
      };

      // Render the component with property prop (templates expect 'property' not 'data')
      // Also pass propertyLists and keyFeatures so templates that show features can render them
      root.render(
        <TemplateComponent
          property={propertyWithListType}
          propertyLists={propertyLists.filter(
            (l) => l.list_name !== "Open House"
          )}
          keyFeatures={keyFeatures}
          readOnly={true}
        />
      );

      // Wait for React and fonts and images to render
      await new Promise((resolve) => setTimeout(resolve, 250));
      if ((document as any).fonts && (document as any).fonts.ready) {
        try {
          await (document as any).fonts.ready;
        } catch (e) { }
      }

      // Sanitize the rendered DOM: replace interactive controls with static text,
      // remove scripts and editor-specific data- attributes so email shows design
      try {
        // remove script tags
        container.querySelectorAll("script").forEach((s) => s.remove());

        // replace inputs with their current value as text
        container.querySelectorAll("input").forEach((inp: HTMLInputElement) => {
          try {
            const type = (inp.getAttribute("type") || "text").toLowerCase();
            let text = "";
            if (type === "checkbox" || type === "radio") {
              text = inp.checked ? "✓" : "";
            } else if (type === "file") {
              text =
                (inp as any).files && (inp as any).files.length
                  ? (inp as any).files[0].name
                  : "";
            } else {
              text = inp.value || inp.getAttribute("value") || "";
            }
            const span = document.createElement("span");
            span.className = inp.className || "";
            span.textContent = text;
            inp.replaceWith(span);
          } catch (e) { }
        });

        // replace textareas with static divs
        container
          .querySelectorAll("textarea")
          .forEach((ta: HTMLTextAreaElement) => {
            try {
              const div = document.createElement("div");
              div.className = ta.className || "";
              div.textContent = ta.value || ta.textContent || "";
              ta.replaceWith(div);
            } catch (e) { }
          });

        // replace selects with their selected option text
        container
          .querySelectorAll("select")
          .forEach((sel: HTMLSelectElement) => {
            try {
              const opt = sel.options[sel.selectedIndex];
              const span = document.createElement("span");
              span.className = sel.className || "";
              span.textContent = opt ? opt.text : "";
              sel.replaceWith(span);
            } catch (e) { }
          });

        // replace contenteditable elements with static text
        container
          .querySelectorAll("[contenteditable]")
          .forEach((el: HTMLElement) => {
            try {
              const div = document.createElement("div");
              div.className = el.className || "";
              div.textContent = el.innerText || el.textContent || "";
              el.replaceWith(div);
            } catch (e) { }
          });

        // remove editor-specific data attributes and event handlers
        container.querySelectorAll("*").forEach((el: Element) => {
          try {
            Array.from(el.attributes).forEach((attr) => {
              const name = attr.name || "";
              if (
                name.startsWith("data-") ||
                name.startsWith("on") ||
                name === "contenteditable"
              ) {
                (el as HTMLElement).removeAttribute(name);
              }
            });
          } catch (e) { }
        });
      } catch (e) {
        // ignore sanitize errors, fallback to raw innerHTML
      }

      // Inline styles: collect style tags and computed styles
      const html = container.innerHTML;
      const styleElements = Array.from(
        document.querySelectorAll("style, link[rel=stylesheet]")
      );
      let embeddedStyles = "";
      // For <style> tags, take their textContent. For <link> tags, fetch the stylesheet text.
      const linkFetches: Promise<void>[] = [];
      styleElements.forEach((styleEl) => {
        try {
          if (styleEl.tagName.toLowerCase() === "link") {
            const href = (styleEl as HTMLLinkElement).href;
            if (href) {
              // fetch stylesheet content
              const p = fetch(href)
                .then((r) => r.text())
                .then((txt) => {
                  embeddedStyles += txt + "\n";
                })
                .catch(() => {
                  // ignore fetch errors
                });
              linkFetches.push(p as Promise<void>);
            }
          } else {
            embeddedStyles += (styleEl.textContent || "") + "\n";
          }
        } catch (e) { }
      });
      // wait for any stylesheet fetches
      try {
        await Promise.all(linkFetches);
      } catch (e) { }

      const computedCSSParts: string[] = [];
      const allElements = container.querySelectorAll("*");
      allElements.forEach((el: any) => {
        const styles = window.getComputedStyle(el);
        if (styles && styles.cssText) {
          const selector = el.className
            ? `.${el.className.split(" ").join(".")}`
            : el.tagName.toLowerCase();
          computedCSSParts.push(`${selector} { ${styles.cssText} }`);
        }
      });

      const finalHTML =
        `<div style="background:#fff;width:${renderWidth}px;max-width:100%;margin:0 auto;">` +
        `<style>${embeddedStyles}\n${computedCSSParts.join("\n")}</style>` +
        html +
        `</div>`;
      // Cleanup
      root.unmount();
      document.body.removeChild(container);
      sessionStorage.setItem("campaign_template_html", finalHTML);
      return finalHTML;
    } catch (error) {
      console.error("Error capturing template HTML:", error);
      return null;
    }
  };

  const handleTemplateSelect = async (template: Template) => {
    // Clear multi-mode flags when selecting a template in single-template flow
    try {
      sessionStorage.removeItem("isMultiPropertyMode");
      sessionStorage.removeItem("multiSelectedProperties");
      sessionStorage.removeItem("multiSelectedTemplateIds");
    } catch (e) {
      console.warn("Could not clear multi-mode session storage:", e);
    }
    setSelectedMultipleTemplates([]);
    setMultiSelectedProperties([]);
    setMultipleTemplatePropertyData(null);
    setIsMultipleTemplateMode(false);

    // Refetch property before rendering preview to get latest custom_template_data
    if (selectedProperty?.id) {
      try {
        const freshProperty = await axiosInstance.get(
          `${endpoints.properties}${selectedProperty.id}/`
        );
        setSelectedProperty(freshProperty.data);
      } catch (err) {
        console.error("Error refetching property for preview:", err);
      }
    }

    const html = await captureTemplateHTML(template);
    setSelectedTemplate({ ...template, html } as any);
    setCurrentStep(4);
  };

  const handleTemplateSelectCustom = (ct: any) => {
    // Clear multi-mode flags when selecting a custom template in single-template flow
    try {
      sessionStorage.removeItem("isMultiPropertyMode");
      sessionStorage.removeItem("multiSelectedProperties");
      sessionStorage.removeItem("multiSelectedTemplateIds");
    } catch (e) {
      console.warn("Could not clear multi-mode session storage:", e);
    }
    setSelectedMultipleTemplates([]);
    setMultiSelectedProperties([]);
    setMultipleTemplatePropertyData(null);
    setIsMultipleTemplateMode(false);

    setSelectedTemplate({
      id: ct.id,
      name: ct.name || `Custom ${ct.id}`,
      is_custom: true,
      html: ct.html,
    } as any);
    setCurrentStep(4);
  };

  // Sole owner of the "update property list type" PATCH request. Templates report
  // selections here instead of patching the property themselves, so only one request
  // is ever in flight for a given change (avoids a race where multiple concurrent
  // PATCHes to the same property resolve out of order and clobber each other's result).
  const handlePropertyListChange = async (newListName: string, listId?: number) => {
    setSelectedPropertyList(newListName); // ✅ This should update immediately

    // Prefer an explicit id (e.g. a list just created by the caller, which may not be
    // in `propertyLists` yet) over a name lookup against the possibly-stale local list.
    const resolvedId = listId ?? propertyLists.find((l) => l.list_name === newListName)?.id;
    if (!selectedProperty || !resolvedId) return;

    try {
      const token = localStorage.getItem("access_token");
      await axiosInstance.patch(
        `${endpoints.properties}${selectedProperty.id}/`,
        { propertyListType_id: resolvedId },
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );

      setSelectedProperty((prev) =>
        prev
          ? ({
            ...prev,
            propertyListType: {
              id: resolvedId,
              list_name: newListName,
            },
          } as Property)
          : prev
      );
      setIsDirty(true);
    } catch (err) {
      console.error("Error updating list:", err);
      toast({
        title: "Error",
        description: "Failed to update property list",
        variant: "destructive",
      });
    }
  };


  // ============ SERVICE CAMPAIGN DATA SAVE (NEW) ============
  const saveServiceCampaignData = async (advanceStep: boolean = true) => {

    // Validate required fields
    if (!serviceData.title?.trim()) {
      toast({
        title: "Title Required",
        description: "Please enter a service title before saving.",
        variant: "destructive",
        duration: 1000
      });
      setIsSavingServiceData(false);
      return;
    }

    if (!serviceData.serviceType?.trim()) {
      toast({
        title: "Service Type Required",
        description: "Please select or enter a service type.",
        variant: "destructive",
        duration: 1000
      });
      return;
    }

    // Filter out empty features
    const cleanedFeatures = (serviceData.features || []).filter(
      (f) => f && f.toString().trim() !== ""
    );

    if (cleanedFeatures.length === 0) {
      toast({
        title: "At Least One Feature Required",
        description: "Please add at least one service feature.",
        variant: "destructive",
        duration: 1000
      });
      return;
    }

    // 🔥 VALIDATION: Check field lengths before saving
    const fieldLimits = {
      title: 255,
      serviceType: 100,
      description: 500,
      phone: 20,
      email: 100,
      address: 255,
      website: 255,
    };

    const tooLongFields: string[] = [];
    if (serviceData.title.length > fieldLimits.title) tooLongFields.push(`Title (${serviceData.title.length}/${fieldLimits.title})`);
    if (serviceData.serviceType.length > fieldLimits.serviceType) tooLongFields.push(`Service Type (${serviceData.serviceType.length}/${fieldLimits.serviceType})`);
    if (serviceData.description.length > fieldLimits.description) tooLongFields.push(`Description (${serviceData.description.length}/${fieldLimits.description})`);
    if (serviceData.phone?.length > fieldLimits.phone) tooLongFields.push(`Phone (${serviceData.phone.length}/${fieldLimits.phone})`);
    if (serviceData.email?.length > fieldLimits.email) tooLongFields.push(`Email (${serviceData.email.length}/${fieldLimits.email})`);
    if (serviceData.address?.length > fieldLimits.address) tooLongFields.push(`Address (${serviceData.address.length}/${fieldLimits.address})`);
    if (serviceData.website?.length > fieldLimits.website) tooLongFields.push(`Website (${serviceData.website.length}/${fieldLimits.website})`);

    if (tooLongFields.length > 0) {
      toast({
        title: "Field Too Long",
        description: `Please reduce these fields: ${tooLongFields.join(", ")}.`,
        variant: "destructive",
        duration: 1500
      });
      return;
    }

    setIsSavingServiceData(true);
    const token = localStorage.getItem("access_token");
    const headers = { Authorization: `Bearer ${token}` };

    // Helper to convert base64 to File
    const base64ToFile = (
      base64String: string,
      filename: string
    ): File | null => {
      try {
        if (!base64String.startsWith("data:")) {
          return null;
        }
        const arr = base64String.split(",");
        const mimeMatch = arr[0].match(/:(.*?);/);
        if (!mimeMatch) return null;

        const mime = mimeMatch[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        const extension = mime.split("/")[1] || "jpg";
        return new File([u8arr], `${filename}.${extension}`, { type: mime });
      } catch (err) {
        console.error("Error converting base64 to file:", err);
        return null;
      }
    };

    const isBase64 = (str: string): boolean => {
      return str && typeof str === "string" && str.startsWith("data:");
    };

    // Convert base64 images to File objects and include in FormData
    const formData = new FormData();

    // Add title, service_type, description, phone, email, address, website
    formData.append("title", serviceData.title.trim());
    formData.append("service_type", serviceData.serviceType.trim());
    formData.append("description", serviceData.description.trim());
    // Only append optional fields if they have values (prevents validation errors on empty strings)
    if (serviceData.phone?.trim()) {
      formData.append("phone", serviceData.phone.trim());
    }
    if (serviceData.email?.trim()) {
      formData.append("email", serviceData.email.trim());
    }
    if (serviceData.address?.trim()) {
      formData.append("address", serviceData.address.trim());
    }
    if (serviceData.website?.trim()) {
      formData.append("website", serviceData.website.trim());
    }

    // Add hero image if it's base64
    // 🆕 Use stable filename (service title) instead of Date.now() to prevent S3 key conflicts
    if (serviceData.heroImage && isBase64(serviceData.heroImage)) {
      try {
        const safeTitle = serviceData.title.replace(/[^a-z0-9]/gi, '_').toLowerCase().slice(0, 50);
        const stableFilename = `service_hero_${safeTitle || 'image'}`;
        const file = base64ToFile(
          serviceData.heroImage,
          stableFilename
        );
        if (file) {
          formData.append("hero_image", file);
        }
      } catch (err) {
        console.error("Error converting hero image:", err);
      }
    } else if (serviceData.heroImage && !isBase64(serviceData.heroImage)) {
      // If it's already a URL, do NOT append the string to multipart data.
      // Sending a URL string to an ImageField can cause validation errors.
      // The backend will keep the existing image if no file is uploaded.
      // (No action required here.)
    }

    // Add features as JSON array
    formData.append(
      "features",
      JSON.stringify(
        cleanedFeatures.map((name, index) => ({
          name: name.toString().trim(),
          order: index,
        }))
      )
    );

    // Store images info in sessionStorage for preview
    try {
      sessionStorage.setItem(
        "service_campaign_images",
        JSON.stringify({
          heroImage: serviceData.heroImage,
          secondaryImage: secondaryImage,
        })
      );
    } catch (e) {
      console.warn("Could not save service images to sessionStorage");
    }

    // Create or update service listing with multipart form data
    try {
      if (serviceCampaignId) {
        // Update existing
        const res = await axiosInstance.patch(
          `${endpoints.service_listings}${serviceCampaignId}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // update local state from response
        try {
          setSelectedService(res.data);
          setServiceData((prev) => ({
            ...prev,
            title: res.data.title || prev.title,
            serviceType: res.data.service_type || prev.serviceType,
            description: res.data.description || prev.description,
            heroImage: res.data.hero_image || prev.heroImage,
            phone: res.data.phone || prev.phone,
            email: res.data.email || prev.email,
            address: res.data.address || prev.address,
            website: res.data.website || prev.website,
            features: (res.data.features || []).map((f: any) => f.name || ""),
          }));
        } catch (e) {
          // ignore
        }
        toast({
          title: "Service Updated!",
          description: "Your service has been updated.",
          variant: "success",
          duration: 1000
        });
      } else {
        // Create new
        const res = await axiosInstance.post(
          endpoints.service_listings,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setServiceCampaignId(res.data.id);

        // update local selectedService and serviceData
        try {
          setSelectedService(res.data);
          setServiceData((prev) => {
            const updated = {
              ...prev,
              title: res.data.title || prev.title,
              serviceType: res.data.service_type || prev.serviceType,
              description: res.data.description || prev.description,
              heroImage: res.data.hero_image || prev.heroImage,
              phone: res.data.phone || prev.phone,
              email: res.data.email || prev.email,
              address: res.data.address || prev.address,
              website: res.data.website || prev.website,
              features: (res.data.features || []).map((f: any) => f.name || ""),
            };

            return updated;
          });
        } catch (e) {
          console.error("[saveServiceCampaignData] Error updating local state:", e);
        }
      }

      if (advanceStep) {

        setCurrentStep(5);
      }
    } catch (err: any) {
      console.error("[saveServiceCampaignData] Error:", err);
      // Log server response body for debugging validation errors
      console.error("[saveServiceCampaignData] Server response:", err.response?.data);
      toast({
        title: "Save Failed",
        description:
          err.response?.data?.error ||
          (err.response?.data || "Failed to save service campaign. Please try again."),
        variant: "destructive",
      });
    } finally {
      setIsSavingServiceData(false);
    }
  };

  const saveChanges = async (advanceStep: boolean = true) => {
    // If we're in the service flow, delegate to saveServiceCampaignData
    if (campaignType === "service") {
      await saveServiceCampaignData(advanceStep);
      return;
    }

    if (!selectedProperty?.id) {
      if (advanceStep) setCurrentStep(5);
      return;
    }

    //  FILTER OUT EMPTY FEATURES
    const cleanedFeatures = (propertyData.features || []).filter(
      (f) => f.feature_name && f.feature_name.trim() !== ""
    );

    //  CHECK FEATURE LIMIT
    if (cleanedFeatures.length > 10) {
      toast({
        title: "Too Many Features",
        description:
          "You can only save up to 10 features. Please remove some features and try again.",
        variant: "destructive",
        duration: 1000
      });
      return; // Stop save
    }

    // Update propertyData with cleaned features
    if (cleanedFeatures.length !== (propertyData.features || []).length) {
      setPropertyData((prev) => ({ ...prev, features: cleanedFeatures }));
    }

    // Check if there are any real changes
    if (!isDirty && cleanedFeatures.length === originalKeyFeatures.length) {
      // toast({
      //   title: "No Changes",
      //   description: "No changes to save",
      //   variant: "default",
      //   duration: 3000,
      // });
      if (advanceStep) setCurrentStep(5);
      return;
    }

    // 🔥 VALIDATION: Check field lengths before saving property
    const propertyFieldLimits = {
      address: 255,
      city: 100,
      title: 255,
      description: 500,
    };

    const tooLongPropertyFields: string[] = [];
    if (propertyData.address?.length > propertyFieldLimits.address) tooLongPropertyFields.push(`Address (${propertyData.address.length}/${propertyFieldLimits.address})`);
    if (propertyData.city?.length > propertyFieldLimits.city) tooLongPropertyFields.push(`City (${propertyData.city.length}/${propertyFieldLimits.city})`);
    if (propertyData.title?.length > propertyFieldLimits.title) tooLongPropertyFields.push(`Title (${propertyData.title.length}/${propertyFieldLimits.title})`);
    if (propertyData.description?.length > propertyFieldLimits.description) tooLongPropertyFields.push(`Description (${propertyData.description.length}/${propertyFieldLimits.description})`);

    if (tooLongPropertyFields.length > 0) {
      toast({
        title: "Field Too Long",
        description: `Please reduce these fields: ${tooLongPropertyFields.join(", ")}.`,
        variant: "destructive",
        duration: 1500
      });
      return;
    }

    const token = localStorage.getItem("access_token");
    const headers = { Authorization: `Bearer ${token}` };

    const base64ToFile = (
      base64String: string,
      filename: string
    ): File | null => {
      try {
        if (!base64String.startsWith("data:")) {
          return null;
        }

        const arr = base64String.split(",");
        const mimeMatch = arr[0].match(/:(.*?);/);
        if (!mimeMatch) return null;

        const mime = mimeMatch[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        const extension = mime.split("/")[1] || "jpg";
        return new File([u8arr], `${filename}.${extension}`, { type: mime });
      } catch (err) {
        console.error("Error converting base64 to file:", err);
        return null;
      }
    };

    const isBase64 = (str: string): boolean => {
      return str && typeof str === "string" && str.startsWith("data:");
    };

    let uploadedImageUrl: string | null = null;

    if (
      dirtyFields.has("heroImage") &&
      propertyData.heroImage &&
      isBase64(propertyData.heroImage)
    ) {
      try {
        const file = base64ToFile(
          propertyData.heroImage,
          `property_${selectedProperty.id}_hero`
        );

        if (file) {
          const formData = new FormData();
          formData.append("image", file);

          toast({ title: "Uploading image...", description: "Please wait", duration: 1000 });

          const imgRes = await axiosInstance.patch(
            `${endpoints.properties}${selectedProperty.id}/`,
            formData,
            {
              headers: {
                ...headers,
                "Content-Type": "multipart/form-data",
              },
            }
          );

          uploadedImageUrl = imgRes.data?.image || null;

          if (uploadedImageUrl) {
            setPropertyData((prev) => ({
              ...prev,
              heroImage: uploadedImageUrl!,
            }));
            setSelectedProperty((prev) =>
              prev ? { ...prev, image: uploadedImageUrl! } : prev
            );
          }

          toast({
            title: "Image uploaded",
            description: "Image saved successfully",
            duration: 1000
          });
        }
      } catch (err: any) {
        console.error("Error uploading image:", err);
        toast({
          title: "Error",
          description:
            "Failed to upload image: " +
            (err.response?.data?.detail || err.message),
          variant: "destructive",
        });
        return;
      }
    }

    if (
      dirtyFields.has("photos") &&
      propertyData.photos &&
      Array.isArray(propertyData.photos)
    ) {
      const uploadedPhotos: string[] = [];

      for (let i = 0; i < propertyData.photos.length; i++) {
        const photo = propertyData.photos[i];

        if (!photo) continue;

        if (isBase64(photo)) {
          try {
            const file = base64ToFile(
              photo,
              `property_${selectedProperty.id}_photo_${i}`
            );

            if (file) {
              const formData = new FormData();
              formData.append("image", file);

              const uploadRes = await axiosInstance.post(
                endpoints.mls_uploads,
                formData,
                {
                  headers: {
                    ...headers,
                    "Content-Type": "multipart/form-data",
                  },
                }
              );

              if (uploadRes.data?.url) {
                uploadedPhotos.push(uploadRes.data.url);
              }
            }
          } catch (err) {
            console.error(`Error uploading photo ${i}:`, err);
          }
        } else if (photo.startsWith("http") || photo.startsWith("/media/")) {
          uploadedPhotos.push(photo);
        }
      }

      if (uploadedPhotos.length > 0) {
        setPropertyData((prev) => ({ ...prev, photos: uploadedPhotos }));
      }
    }

    const updates: any = {};
    let hasRealChange = false;

    if (
      dirtyFields.has("headline") &&
      propertyData.headline !== selectedProperty.title
    ) {
      updates.title = propertyData.headline;
      hasRealChange = true;
    }

    if (
      dirtyFields.has("price") &&
      Number(propertyData.price) !== selectedProperty.price
    ) {
      updates.price = Number(propertyData.price);
      hasRealChange = true;
    }

    if (
      dirtyFields.has("address") &&
      propertyData.address !== selectedProperty.address
    ) {
      updates.address = propertyData.address;
      hasRealChange = true;
    }

    if (
      dirtyFields.has("bedrooms") &&
      propertyData.bedrooms !== selectedProperty.bedrooms
    ) {
      updates.bedrooms =
        propertyData.bedrooms !== null ? Number(propertyData.bedrooms) : null;
      hasRealChange = true;
    }

    if (
      dirtyFields.has("bathrooms") &&
      propertyData.bathrooms !== selectedProperty.bathrooms
    ) {
      updates.bathrooms =
        propertyData.bathrooms !== null ? Number(propertyData.bathrooms) : null;
      hasRealChange = true;
    }

    const isAreaDirty =
      dirtyFields.has("area") || dirtyFields.has("sqft");
    const updatedArea =
      propertyData.area !== undefined && propertyData.area !== null
        ? propertyData.area
        : propertyData.sqft;

    if (isAreaDirty && updatedArea !== selectedProperty.area) {
      updates.area = updatedArea !== null ? Number(updatedArea) : null;
      hasRealChange = true;
    }

    if (
      dirtyFields.has("description") &&
      propertyData.description !== selectedProperty.description
    ) {
      updates.description = propertyData.description;
      hasRealChange = true;
    }

    if (
      dirtyFields.has("heroImage") &&
      propertyData.heroImage &&
      !isBase64(propertyData.heroImage) &&
      !uploadedImageUrl &&
      propertyData.heroImage !== selectedProperty.image
    ) {
      updates.image = propertyData.heroImage;
      hasRealChange = true;
    }

    if (
      dirtyFields.has("photos") &&
      propertyData.photos &&
      Array.isArray(propertyData.photos)
    ) {
      const validPhotos = propertyData.photos.filter(
        (url) =>
          url &&
          !isBase64(url) &&
          (url.startsWith("http") || url.startsWith("/media/"))
      );

      if (validPhotos.length > 0) {
        updates.photos = validPhotos;
        hasRealChange = true;
      }
    }

    // ✅ HANDLE FEATURES WITH CLEANED DATA
    if (dirtyFields.has("features")) {
      const currentFeatures = cleanedFeatures;
      const originalFeatures = originalKeyFeatures;

      // ✅ DOUBLE CHECK LIMIT BEFORE API CALLS
      if (currentFeatures.length > 10) {
        toast({
          title: "Feature Limit Exceeded",
          description: "Maximum 10 features allowed per property.",
          variant: "destructive",
          duration: 1000
        });
        return;
      }

      const toCreate = currentFeatures
        .filter((f) => !f.id)
        .map((f) => ({
          feature_name: f.feature_name.trim(),
          propetyId: selectedProperty.id,
        }));

      const toUpdate = currentFeatures
        .filter((f) => f.id)
        .filter(
          (f) =>
            !originalFeatures.find(
              (orig) => orig.id === f.id && orig.feature_name === f.feature_name
            )
        )
        .map((f) => ({ id: f.id, feature_name: f.feature_name.trim() }));

      const toDelete = originalFeatures
        .filter((orig) => !currentFeatures.some((f) => f.id === orig.id))
        .map((f) => f.id);

      try {
        if (toCreate.length > 0) {
          await Promise.all(
            toCreate.map((f) => axiosInstance.post(endpoints.keyfeatures, f))
          );
        }
        if (toUpdate.length > 0) {
          await Promise.all(
            toUpdate.map((f) =>
              axiosInstance.patch(`${endpoints.keyfeatures}${f.id}/`, {
                feature_name: f.feature_name,
              })
            )
          );
        }
        if (toDelete.length > 0) {
          await Promise.all(
            toDelete.map((id) =>
              axiosInstance.delete(`${endpoints.keyfeatures}${id}/`)
            )
          );
        }

        const res = await axiosInstance.get(endpoints.keyfeatures);
        const updatedFeatures = res.data.filter(
          (f: any) => Number(f.propetyId) === Number(selectedProperty.id)
        );

        // ✅ VALIDATE RETURNED FEATURES DON'T EXCEED LIMIT
        const validatedFeatures = updatedFeatures.slice(0, 10);

        setKeyFeatures(validatedFeatures);
        setOriginalKeyFeatures([...validatedFeatures]);
        setPropertyData((prev) => ({ ...prev, features: validatedFeatures }));
        hasRealChange = true;
      } catch (err: any) {
        console.error("Failed to save features:", err);

        const errorMsg =
          err.response?.data?.detail ||
          err.response?.data?.feature_name?.[0] ||
          err.response?.data?.error ||
          "Failed to save features. Please ensure all features have valid names.";

        toast({
          title: "Error Saving Features",
          description: errorMsg,
          variant: "destructive",
        });
        return;
      }
    }

    if (hasRealChange && Object.keys(updates).length > 0) {
      try {
        const response = await axiosInstance.patch(
          `${endpoints.properties}${selectedProperty.id}/`,
          updates,
          { headers }
        );

        setSelectedProperty((prev) =>
          prev ? ({ ...prev, ...updates, ...response.data } as Property) : prev
        );

        toast({
          title: "Success",
          description: "Property updated successfully",
          duration: 1000
        });
      } catch (err: any) {
        const errorData = err.response?.data;
        let errorMsg = err.message;

        if (errorData) {
          if (typeof errorData === "string") {
            errorMsg = errorData;
          } else if (errorData.detail) {
            errorMsg = errorData.detail;
          } else {
            errorMsg = Object.entries(errorData)
              .map(
                ([field, msgs]: [string, any]) =>
                  `${field}: ${Array.isArray(msgs) ? msgs.join(", ") : msgs}`
              )
              .join(" | ");
          }
        }

        toast({
          title: "Error Saving Property",
          description: errorMsg,
          variant: "destructive",
          duration: 1000
        });
        return;
      }
    } else if (uploadedImageUrl) {
      toast({
        title: "Success",
        description: "Image updated successfully",
        duration: 1000
      });
    } else {
      toast({
        title: "Success",
        description: "Changes saved successfully",
        duration: 1000
      });
    }

    setIsDirty(false);
    setDirtyFields(new Set());
    if (advanceStep) setCurrentStep(5);
  };

  const saveServiceChanges = async (advanceStep: boolean = true): Promise<Record<string, any> | null> => {
    if (savingTemplate) return null;
    setSavingTemplate(true);
    try {
      // VALIDATION: ensure at least one feature and no empty entries
      const rawFeatures = serviceData.features || [];
      if (rawFeatures.length === 0) {
        toast({
          title: "Add At Least One Feature",
          description: "Please add at least one key feature before continuing.",
          variant: "destructive",
          duration: 1000
        });
        setSavingTemplate(false);
        return null;
      }
      const emptyIndex = rawFeatures.findIndex(
        (f: string) => !f || f.toString().trim() === ""
      );
      if (emptyIndex !== -1) {
        toast({
          title: "Invalid Feature",
          description: `Feature ${emptyIndex + 1
            } cannot be empty. Please fill it in or remove it.`,
          variant: "destructive",
        });
        setSavingTemplate(false);
        return null;
      }

      // Helper to convert base64 to File
      const base64ToFile = (
        base64String: string,
        filename: string
      ): File | null => {
        try {
          if (!base64String.startsWith("data:")) {
            return null;
          }
          const arr = base64String.split(",");
          const mimeMatch = arr[0].match(/:(.*?);/);
          if (!mimeMatch) return null;

          const mime = mimeMatch[1];
          const bstr = atob(arr[1]);
          let n = bstr.length;
          const u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }

          const extension = mime.split("/")[1] || "jpg";
          return new File([u8arr], `${filename}.${extension}`, { type: mime });
        } catch (err) {
          console.error("Error converting base64 to file:", err);
          return null;
        }
      };

      const isBase64 = (str: string): boolean => {
        return str && typeof str === "string" && str.startsWith("data:");
      };

      const token = localStorage.getItem("access_token");
      const headers = { Authorization: `Bearer ${token}` };

      // Upload primary image if it's base64
      let heroImageUrl = serviceData.heroImage;
      if (serviceData.heroImage && isBase64(serviceData.heroImage)) {
        try {
          // 🆕 Use stable filename based on service title instead of timestamp
          const safeTitle = serviceData.title.replace(/[^a-z0-9]/gi, '_').toLowerCase().slice(0, 50);
          const stableFilename = `service_hero_${safeTitle || 'image'}`;
          const file = base64ToFile(
            serviceData.heroImage,
            stableFilename
          );
          if (file) {
            const formData = new FormData();
            formData.append("image", file);

            const imgRes = await axiosInstance.post(
              endpoints.upload_image || "/api/upload/image/",
              formData,
              {
                headers: {
                  ...headers,
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            heroImageUrl = imgRes.data.url || imgRes.data.image_url || heroImageUrl;
          }
        } catch (err) {
          console.error("Error uploading primary image:", err);
        }
      }

      // Upload secondary image if it's base64
      let secondaryImageUrl = secondaryImage;
      if (secondaryImage && isBase64(secondaryImage)) {
        try {
          const file = base64ToFile(
            secondaryImage,
            `service_secondary_${Date.now()}`
          );
          if (file) {
            const formData = new FormData();
            formData.append("image", file);

            const imgRes = await axiosInstance.post(
              endpoints.upload_image || "/api/upload/image/",
              formData,
              {
                headers: {
                  ...headers,
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            secondaryImageUrl = imgRes.data.url || imgRes.data.image_url || secondaryImageUrl;
          }
        } catch (err) {
          console.error("Error uploading secondary image:", err);
        }
      }

      const payload: any = {
        title: serviceData.title,
        service_type: serviceData.serviceType,
        headline: serviceData.headline,
        description: serviceData.description,
        phone: serviceData.phone,
        email: serviceData.email,
        address: serviceData.address,
        website: serviceData.website,
        hero_image: heroImageUrl || null,
        // Trim and map features; empty ones already rejected above
        features: (serviceData.features || []).map((f: string) => ({
          name: f.toString().trim(),
        })),
      };

      let res;
      if (selectedService && (selectedService as any).id) {
        res = await axiosInstance.patch(
          `${endpoints.service_listings}${(selectedService as any).id}/`,
          payload,
          { headers }
        );
      } else if (serviceCampaignId) {
        res = await axiosInstance.patch(
          `${endpoints.service_listings}${serviceCampaignId}/`,
          payload,
          { headers }
        );
      } else {
        res = await axiosInstance.post(
          endpoints.service_listings,
          payload,
          { headers }
        );
        const newId = res.data.id;
        setServiceCampaignId(newId);
        try {
          sessionStorage.setItem("service_campaign_id", String(newId));
        } catch (e) {
          console.warn("Could not save service campaign ID to sessionStorage");
        }
      }

      let data = res.data;
      const serviceId = data?.id || (selectedService as any)?.id || serviceCampaignId;
      if (serviceId) {
        try {
          const fullRes = await axiosInstance.get(`${endpoints.service_listings}${serviceId}/`);
          if (fullRes.data) data = fullRes.data;
        } catch (refetchErr) {
          console.warn("Could not refetch service after save:", refetchErr);
        }
      }

      const heroRaw =
        data.hero_image_url ||
        data.hero_image ||
        data.image ||
        heroImageUrl ||
        "";
      const heroFull = heroRaw ? getFullUrl(heroRaw) : "";
      const secondaryFull = secondaryImageUrl ? getFullUrl(secondaryImageUrl) : "";
      const photosList = (Array.isArray(data.photos) ? data.photos : []).map((p: string) =>
        getFullUrl(p)
      );
      const normalizedFeatures = (data.features || [])
        .map((f: any) => (typeof f === "string" ? f : f.name || f.feature_name || ""))
        .filter((f: string) => f.trim().length > 0);

      const previewSnapshot: Record<string, any> = {
        id: data.id,
        title: data.title || serviceData.title || "",
        headline: data.headline || data.title || serviceData.headline || "",
        serviceType: data.service_type || serviceData.serviceType || "",
        service_type: data.service_type || serviceData.serviceType || "",
        description: data.description || serviceData.description || "",
        phone: data.phone || serviceData.phone || "",
        email: data.email || serviceData.email || "",
        website: data.website || serviceData.website || "",
        address: data.address || serviceData.address || "",
        heroImage: heroFull,
        hero_image_url: heroFull,
        image: heroFull,
        secondaryImage: secondaryFull,
        photos: photosList.filter((p: string) => p && p !== heroFull),
        photos_urls: photosList.filter((p: string) => p && p !== heroFull),
        features: normalizedFeatures,
        subject: data.subject || serviceData.subject || subject || "",
      };

      setSelectedService(data);
      setServiceData((prev) => ({
        ...prev,
        title: previewSnapshot.title,
        serviceType: previewSnapshot.serviceType,
        headline: previewSnapshot.headline,
        description: previewSnapshot.description,
        heroImage: previewSnapshot.heroImage,
        hero_image_url: previewSnapshot.hero_image_url,
        image: previewSnapshot.image,
        phone: previewSnapshot.phone,
        email: previewSnapshot.email,
        address: previewSnapshot.address,
        website: previewSnapshot.website,
        features: normalizedFeatures,
        subject: previewSnapshot.subject,
      }));
      setServicePreviewSnapshot(previewSnapshot);

      setOriginalServiceFeatures(
        (data.features || []).map((f: any) => ({
          id: f.id,
          feature_name: f.name || f.feature_name,
        }))
      );

      toast({
        title: "Saved",
        description: "Service saved successfully",
        variant: "success",
        duration: 1000
      });
      return previewSnapshot;
    } catch (err: any) {
      console.error("Failed to save service listing:", err);
      return null;
    } finally {
      setSavingTemplate(false);
      if (advanceStep) setCurrentStep(5);
    }
  };

  const discardTemplateEdits = useCallback(() => {
    if (campaignType === 'service') {
      if (serviceEditSnapshot) {
        const restoredService = {
          ...serviceEditSnapshot,
          features: Array.isArray(serviceEditSnapshot.features) ? [...serviceEditSnapshot.features] : [],
          photos: Array.isArray(serviceEditSnapshot.photos) ? [...serviceEditSnapshot.photos] : [],
          photos_urls: Array.isArray(serviceEditSnapshot.photos_urls) ? [...serviceEditSnapshot.photos_urls] : [],
        };
        setServiceData((prev) => ({ ...prev, ...restoredService }));
        setSelectedService((prev) => (prev ? { ...prev, ...restoredService } : prev));
        setServicePreviewSnapshot(restoredService);
      }
      setServiceEditSnapshot(null);
      setServiceKeyFeaturesSnapshot([]);
    } else {
      if (propertyEditSnapshot) {
        setPropertyData((prev) => ({ ...prev, ...propertyEditSnapshot }));
        setKeyFeatures(propertyKeyFeaturesSnapshot);
        setOriginalKeyFeatures([...propertyKeyFeaturesSnapshot]);
      }
      setPropertyEditSnapshot(null);
    }
    setIsEditingTemplate(false);
    setIsDirty(false);
    setDirtyFields(new Set());
    setPreviewRefresh((p) => p + 1);
  }, [campaignType, serviceEditSnapshot, propertyEditSnapshot, propertyKeyFeaturesSnapshot]);

  const saveTemplateEditsAndProceed = useCallback(async (): Promise<boolean> => {
    setIsSavingTemplateEditLeave(true);
    try {
      if (campaignType === 'service') {
        if (selectedService?.id) {
          const saved = await saveServiceChanges(false);
          if (saved) setServicePreviewSnapshot(saved);
        }
        setServiceEditSnapshot(null);
        setServiceKeyFeaturesSnapshot([]);
      } else {
        await saveChanges(false);
        setPropertyEditSnapshot(null);
      }
      setIsEditingTemplate(false);
      setIsDirty(false);
      setDirtyFields(new Set());
      setPreviewRefresh((p) => p + 1);
      return true;
    } catch (err) {
      console.error('[saveTemplateEditsAndProceed] failed:', err);
      toast({
        title: "Save Failed",
        description: "Could not save your changes. Please try again.",
        variant: "destructive",
      });
      return false;
    } finally {
      setIsSavingTemplateEditLeave(false);
    }
  }, [campaignType, selectedService, saveChanges, saveServiceChanges, toast]);

  const handleTemplateEditModalSave = async () => {
    const success = await saveTemplateEditsAndProceed();
    if (success) {
      setShowTemplateEditLeaveModal(false);
      const action = templateEditLeaveAction;
      setTemplateEditLeaveAction(null);
      action?.();
    }
  };

  const handleTemplateEditModalDiscard = () => {
    discardTemplateEdits();
    setShowTemplateEditLeaveModal(false);
    const action = templateEditLeaveAction;
    setTemplateEditLeaveAction(null);
    action?.();
  };

  const handleTemplateEditModalStay = () => {
    setShowTemplateEditLeaveModal(false);
    setTemplateEditLeaveAction(null);
  };

  const handleAddFeature = () => {
    // Prevent adding more than 10 features
    const current = serviceData.features || [];
    if (current.length >= 10) {
      toast({
        title: "Too Many Features",
        description: "You can only add up to 10 features.",
        variant: "destructive",
        duration: 1000
      });
      return;
    }
    setServiceData((prev) => ({
      ...prev,
      features: [...(prev.features || []), ""],
    }));
  };

  const handleUpdateFeature = (index: number, value: string) => {
    const updated = [...(serviceData.features || [])];
    // updated[index] = value;
    updated[index] = value.slice(0, 30);

    setServiceData((prev) => ({ ...prev, features: updated }));
  };

  const handleRemoveFeature = (index: number) => {
    const updated = (serviceData.features || []).filter((_, i) => i !== index);
    setServiceData((prev) => ({ ...prev, features: updated }));
  };
  const getButtonText = () => {
    if (generationCount === 0) {
      return "Generate";
    } else if (generationCount < 3) {
      return "Regenerate";
    } else {
      return "You Reached The Limit";
    }
  };
  const handleRegenerateSubject = async () => {
    if (isRegenerating || subjectGenCount >= 3) return;
    setIsRegenerating(true);
    const userDesc = serviceData.description?.trim() || "a real-estate service";
    const prompt = `
      You are a marketing copywriter. Create a catchy, 6-8 word email subject line for a service launch.
      Use the client’s description only. Make it urgent, benefit-driven and under 60 characters.
      Client description: "${userDesc}"
    `.trim();
    try {
      const resp = await axiosInstance.post(endpoints.generate_subject, {
        headline: serviceData.serviceType || "",
        description: userDesc,
      });

      const subjects: string[] = resp.data?.subjects || [];
      const newSubject = subjects.length ? subjects[0] : null;
      if (newSubject) {
        setSubject(newSubject);
        toast({
          title: "Subject Generated",
          description: "AI created a new subject line!",
          variant: "default",
          duration: 1000
        });
        setSubjectGenCount((c) => c + 1);
      }
    } catch (e: any) {
      toast({
        title: "Failed",
        description: "Could not generate subject",
        variant: "destructive",
      });
    } finally {
      setIsRegenerating(false);
    }
  };
  // const handleAddDataset = (id: string) =>
  //   setSelectedDatasets((prev) => {
  //     // if already selected, keep as-is
  //     if (prev.includes(id)) return prev;

  //     // if a numeric remaining limit exists, enforce it using server-side
  //     // remaining = associationLimit - associationsUsed (we don't pre-decrement
  //     // for current selections in the displayed remaining value).
  //     if (associationLimit !== null) {
  //       const allowed = Math.max(0, (associationLimit ?? 0) - associationsUsed);
  //       if (prev.length >= allowed) {
  //         toast({
  //           title: "Association Limit Reached",
  //           description: `You have no remaining associations. Upgrade your plan or remove a previously selected association.`,
  //           variant: "destructive",
  //         });
  //         // Open association add-on modal to let user purchase
  //         setShowAddOnModalType("association");
  //         return prev;
  //       }
  //     }

  //     return [...prev.filter((x) => x !== id), id];
  //   });

  const handleAddDataset = (id: string | number) => {
    const normalizedId = String(id);
    // NOTE: Temporarily allow users to select more associations than their
    // remaining quota so they can build a campaign freely. The checkout for
    // any extra associations will be handled when the user clicks Continue.
    // The original behavior below opened the add-on / upgrade modals immediately
    // when selections would exceed remaining credits — that logic is commented
    // out for now.

    /*
    // 1. If no plan, trigger "campaign" (The Pricing Modal)
    if (!user?.plan_name) {
      setShowAddOnModalType("campaign");
      return;
    }

    // 2. If plan exists but associations are 0, trigger "association" (The Add-on Modal)
    if (associationsRemaining !== null && associationsRemaining <= 0) {
      setShowAddOnModalType("association");
      return;
    }

    // 2b. If adding this dataset would exceed the remaining associations,
    // show the association add-on modal.
    if (
      associationsRemaining !== null &&
      !selectedDatasets.includes(id) &&
      selectedDatasets.length >= associationsRemaining
    ) {
      setShowAddOnModalType("association");
      return;
    }
    */

    // 3. Success - add the dataset if not already present (normalize to string for consistent comparison)
    setSelectedDatasets((prev) => {
      if (prev.some((x) => String(x) === normalizedId)) return prev;
      return [...prev, normalizedId];
    });
  };

  const handleRemoveDataset = (id: string | number) => {
    const normalizedId = String(id);
    setSelectedDatasets((prev) => prev.filter((x) => String(x) !== normalizedId));
  };
  const pad = (n: number) => n.toString().padStart(2, "0");
  // Auto-scroll to hub section when mycontacts is selected
  const handleHubCheckboxChange = (checked: boolean) => {
    setSendTo((s) => ({ ...s, mycontacts: checked }));

    if (checked) {
      // ✅ Auto-save draft when hub is selected at Step 5
      if (currentStep === 5) {
        handleSaveDraftBeforePayment().catch((err) => {
          console.error("Failed to auto-save draft on hub selection:", err);
        });
      }

      // scroll only — DO NOT touch LaunchIQ data
      setTimeout(() => {
        if (hubSectionRef.current) {
          hubSectionRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });

          hubSectionRef.current.classList.add("highlight-section");
          setTimeout(() => {
            hubSectionRef.current?.classList.remove("highlight-section");
          }, 2000);
        }
      }, 100);
    } else {
      // ✅ clear My Hub selections ONLY when hub is turned off
      setSelectedCustomDatasets([]);
    }
  };

  const handlePropertySelect = useCallback((property: any) => {
    const mergedImages = getMergedPropertyImageState(property);
    const normalizedProperty = {
      ...property,
      image: mergedImages.heroImage || property.image || "",
      heroImage:
        mergedImages.heroImage ||
        property.heroImage ||
        property.image ||
        "",
      photos: mergedImages.photos,
    };

    setSelectedProperty(normalizedProperty);

    if (normalizedProperty.propertyListType?.list_name) {
      setSelectedPropertyList(normalizedProperty.propertyListType.list_name);
    }

    setPropertyData({
      headline: normalizedProperty.title || normalizedProperty.headline || "",
      address: normalizedProperty.address || "",
      price: normalizedProperty.price ?? null,
      bedrooms: normalizedProperty.bedrooms ?? null,
      bathrooms: normalizedProperty.bathrooms ?? null,
      area: normalizedProperty.area ?? normalizedProperty.sqft ?? null,
      description: normalizedProperty.description || "",
      text_section: normalizedProperty.text_section || "",
      image: normalizedProperty.image || normalizedProperty.heroImage || "",
      heroImage: normalizedProperty.heroImage || normalizedProperty.image || "",
      photos: mergedImages.photos,
      agentName: normalizedProperty.agentName || normalizedProperty.agent?.name || "",
      agentPhone: normalizedProperty.agentPhone || normalizedProperty.agent?.phone || "",
      agentEmail: normalizedProperty.agentEmail || normalizedProperty.agent?.email || "",
    });

    setCurrentStep(3);
  }, [propertyData]);

  const handlePropertyAdd = useCallback((newProperty: SavedProperty) => {
    setProperties((prev) => {
      const normalizedId = String(newProperty.id);
      const existingIndex = prev.findIndex((p) => String(p.id) === normalizedId);
      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = newProperty;
        return updated;
      }
      return [newProperty, ...prev];
    });
  }, []);

  // Handler for deleting property
  const handlePropertyDelete = useCallback((propertyId: string | number) => {
    setProperties((prev) =>
      prev.filter((p) => String(p.id) !== String(propertyId))
    );
  }, []);

  const handlePropertyUpdate = useCallback(
    (updatedProperty: SavedProperty) => {
      const mergedImages = getMergedPropertyImageState(updatedProperty);

      // ✅ Force create new reference to trigger re-renders
      const propertyWithNewRef = {
        ...updatedProperty,
        image: mergedImages.heroImage || updatedProperty.image || "",
        heroImage:
          mergedImages.heroImage ||
          updatedProperty.heroImage ||
          updatedProperty.image ||
          "",
        // Ensure photos array is a new reference
        photos: mergedImages.photos,
        // Add timestamp to force detection of changes
        _lastUpdated: Date.now(),
      };

      // Update the selected property if it's the one being edited
      if (
        selectedProperty?.id === updatedProperty.id ||
        String(selectedProperty?.id) === String(updatedProperty.id)
      ) {
        setSelectedProperty(propertyWithNewRef);

        if (updatedProperty.propertyListType?.list_name) {
          setSelectedPropertyList(updatedProperty.propertyListType.list_name);
        }

        // ✅ Also update propertyData to sync with templates
        setPropertyData((prev) => ({
          ...prev,
          headline: updatedProperty.title || "",
          address: updatedProperty.address || "",
          price: updatedProperty.price || 0,
          bedrooms: updatedProperty.bedrooms || 0,
          bathrooms: updatedProperty.bathrooms || 0,
          area: updatedProperty.area || 0,
          description: updatedProperty.description || "",
          image: propertyWithNewRef.image,
          heroImage: propertyWithNewRef.heroImage,
          photos: propertyWithNewRef.photos,
          _imgTs: Date.now(),
        }));
        // ✅ Increment refresh counter to force template re-render
        setPreviewRefresh((p) => p + 1);

      }

      // ✅ Update properties list with new reference
      setProperties((prev) =>
        prev.map((p) =>
          String(p.id) === String(updatedProperty.id)
            ? { ...propertyWithNewRef }
            : p
        )
      );
    },
    [selectedProperty?.id, propertyData]
  );

  const refreshProperties = useCallback(async () => {
    try {
      const response = await axiosInstance.get(endpoints.properties);
      setProperties(response.data || []);
    } catch (error) {
      console.error("Failed to refresh properties:", error);
    }
  }, []);

  useEffect(() => {
    if (selectedTemplate?.id) {
      try {
        sessionStorage.setItem(
          "selectedTemplateId",
          String(selectedTemplate.id)
        );
      } catch (e) {
        console.warn("Could not save template to session storage");
      }
    }
  }, [selectedTemplate]);

  // Persist selectedProperty to sessionStorage
  useEffect(() => {
    if (selectedProperty?.id) {
      try {
        sessionStorage.setItem(
          "selectedPropertyId",
          String(selectedProperty.id)
        );
      } catch (e) {
        console.warn("Could not save property to session storage");
      }
    }
  }, [selectedProperty]);

  useEffect(() => {
    if (selectedProperty?.propertyListType?.list_name) {
      setSelectedPropertyList(selectedProperty.propertyListType.list_name);
    }
  }, [selectedProperty?.propertyListType?.list_name]);

  // Persist subject to sessionStorage
  useEffect(() => {
    if (subject && subject.trim() !== "") {
      try {
        sessionStorage.setItem("campaignSubject", subject);
      } catch (e) {
        console.warn("Could not save subject to session storage");
      }
    }
  }, [subject]);

  // Restore all states when entering step 4
  useEffect(() => {
    if (currentStep === 4) {
      // Restore template if missing
      if (!selectedTemplate && !isAutoAIMode) {
        try {
          const savedTemplateId = sessionStorage.getItem("selectedTemplateId");
          if (savedTemplateId) {
            const foundTemplate = filteredTemplates.find(
              (t) => String(t.id) === savedTemplateId
            );
            if (foundTemplate) {
              setSelectedTemplate(foundTemplate);

            }
          }
        } catch (e) {
          console.warn("Could not restore template from session storage");
        }
      }

      // Restore subject if missing
      if (!subject || subject.trim() === "") {
        try {
          const savedSubject = sessionStorage.getItem("campaignSubject");
          if (savedSubject && savedSubject.trim() !== "") {
            setSubject(savedSubject);
          }
        } catch (e) {
          console.warn("Could not restore subject from session storage");
        }
      }
    }
  }, [currentStep, selectedTemplate, isAutoAIMode, filteredTemplates, subject]);

  // Restore on initial component mount
  useEffect(() => {
    try {
      // Restore subject
      const savedSubject = sessionStorage.getItem("campaignSubject");
      if (savedSubject && savedSubject.trim() !== "") {
        setSubject(savedSubject);
      }

      // Restore template
      const savedTemplateId = sessionStorage.getItem("selectedTemplateId");
      if (savedTemplateId && !selectedTemplate) {
        const foundTemplate = filteredTemplates.find(
          (t) => String(t.id) === savedTemplateId
        );
        if (foundTemplate) {
          setSelectedTemplate(foundTemplate);
        }
      }
    } catch (e) {
      console.warn("Could not restore state on mount");
    }
  }, []); // Empty dependency - runs once on mount

  // ============ SERVICE CAMPAIGN DATA RESTORATION (NEW) ============
  useEffect(() => {
    if (currentStep === 4 && campaignType === "service") {
      const draftRestored = sessionStorage.getItem("draftRestored") === "true";

      // If we are restoring from a saved draft, don't overwrite restored serviceData
      // with the persisted service listing values from the backend.
      if (draftRestored) {
        console.log("[Step 4 Restoration] Draft restored; skipping backend service fetch.");
        sessionStorage.removeItem("draftRestored");
        return;
      }

      // If service data is already populated, there is nothing to fetch.
      if (serviceData.title && serviceData.title.trim() !== "") {
        return;
      }

      // Load service campaign data from sessionStorage or database
      try {
        // Try to load from sessionStorage first
        const savedServiceId = sessionStorage.getItem("service_campaign_id");
        const savedImages = sessionStorage.getItem("service_campaign_images");
        if (savedImages) {
          const images = JSON.parse(savedImages);
          setSecondaryImage(images.secondaryImage || "");
        }

        // If we have a service campaign ID, fetch the latest data from backend
        const idToUse = serviceCampaignId || (savedServiceId ? parseInt(savedServiceId) : null);

        if (idToUse) {
          axiosInstance
            .get(`${endpoints.service_listings}${idToUse}/`)
            .then((res) => {
              const data = res.data;
              // Restore service data only when there is no active draft state.
              setServiceCampaignId(data.id);
              setServiceData((prev) => {
                const mergedImages = getMergedServiceImageState({
                  ...data,
                  heroImage: data.heroImage || data.hero_image || data.hero_image_url || data.image || "",
                  hero_image_url: data.hero_image_url || data.heroImage || data.hero_image || data.image || "",
                  image: data.image || data.hero_image_url || data.hero_image || data.heroImage || "",
                  photos: Array.isArray(data.photos_urls) && data.photos_urls.length > 0
                    ? data.photos_urls
                    : data.photos,
                });
                const updated = {
                  ...prev,
                  title: data.title || "",
                  serviceType: data.service_type || "",
                  description: data.description || "",
                  heroImage:
                    mergedImages.heroImage ||
                    data.hero_image ||
                    data.hero_image_url ||
                    "",
                  hero_image_url:
                    mergedImages.heroImage ||
                    data.hero_image_url ||
                    data.hero_image ||
                    "",
                  image:
                    mergedImages.heroImage ||
                    data.image ||
                    data.hero_image_url ||
                    data.hero_image ||
                    "",
                  phone: data.phone || "",
                  email: data.email || "",
                  address: data.address || "",
                  website: data.website || "",
                  photos: mergedImages.photos,
                  features: (data.features || []).map((f: any) =>
                    typeof f === "string" ? f : f.name || ""
                  ),
                };

                return updated;
              });
            })
            .catch((err) => {
              console.warn("[Step 4 Restoration] Could not load service campaign from backend:", err);
            });
        } else {
          console.warn("[Step 4 Restoration] No service campaign ID found");
        }
      } catch (e) {
        console.warn("[Step 4 Restoration] Could not restore service campaign data:", e);
      }
    }
  }, [currentStep, campaignType, serviceCampaignId, serviceData.title]);

  // const getFullUrl = useCallback((url: string | null | undefined): string => {
  //   if (!url) return "";
  //   if (url.startsWith("http") || url.startsWith("blob:") || url.startsWith("data:")) {
  //     return url;
  //   }
  //   const baseUrl = axiosInstance?.defaults?.baseURL || "";
  //   return `${baseUrl}${url.startsWith("/") ? "" : "/"}${url}`;
  // }, []);

  const formatPaymentDate = (dateString?: string | null): string => {
    if (!dateString) return "Not scheduled";

    try {
      const normalized =
        typeof dateString === "string" &&
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(dateString)
          ? `${dateString}:00`
          : dateString;
      return formatDateTime(normalized, {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
      });
    } catch (error) {
      return String(dateString);
    }
  };

  const sortDateStringsAscending = (dates?: string[] | null): string[] => {
    if (!Array.isArray(dates)) return [];

    return [...dates].sort((left, right) => {
      const leftTime = new Date(left).getTime();
      const rightTime = new Date(right).getTime();

      if (Number.isNaN(leftTime) && Number.isNaN(rightTime)) {
        return String(left).localeCompare(String(right));
      }
      if (Number.isNaN(leftTime)) return 1;
      if (Number.isNaN(rightTime)) return -1;

      return leftTime - rightTime;
    });
  };

  const countRecurringSendsBetween = (
    type: "daily" | "weekly" | "monthly",
    startIso: string,
    endIso: string
  ): number => {
    const start = new Date(startIso);
    const end = new Date(endIso);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) {
      return 0;
    }

    let count = 0;
    const current = new Date(start);
    const maxOccurrences = 100;

    while (current <= end && count < maxOccurrences) {
      count += 1;
      const next = new Date(current);
      if (type === "daily") {
        next.setDate(next.getDate() + 1);
      } else if (type === "weekly") {
        next.setDate(next.getDate() + 7);
      } else {
        next.setMonth(next.getMonth() + 1);
      }
      if (next.getTime() <= current.getTime()) break;
      current.setTime(next.getTime());
    }

    return count;
  };

  const validateRecurringScheduleInput = (): string | null => {
    if (recurrenceType === "custom") {
      if (customRecurringDates.length === 0) {
        return "Add at least one custom send date and time.";
      }
      return null;
    }

    const firstLocal =
      scheduleOption === "later" ? selectedDateTime : recurringStartDateTime;
    if (!firstLocal) {
      return scheduleOption === "later"
        ? "Select the first send date and time before applying recurring."
        : "Select the first send date and time for your recurring launch.";
    }
    if (!recurringEndDate) {
      return "Select an end date and time for the recurring schedule.";
    }
    return null;
  };

  const buildRecurringCheckoutData = () => {
    const validationError = validateRecurringScheduleInput();
    if (validationError) {
      return { error: validationError, data: null as any };
    }

    const totalSelected = sendTo.database ? selectedDatasets.length : 0;

    if (recurrenceType === "custom") {
      const customUtc = sortDateStringsAscending(
        customRecurringDates
          .map((date) => localToUtcIso(date) || date)
          .filter(Boolean) as string[]
      );

      if (customUtc.length === 0) {
        return { error: "Add at least one valid custom send date and time.", data: null };
      }

      return {
        error: null,
        data: {
          extraAssociationsCount: 0,
          selectedAssociations: totalSelected,
          campaignNeedsPayment: false,
          firstDate: customUtc[0],
          endDate: customUtc[customUtc.length - 1],
          recurrenceType: "custom" as const,
          recurringCount: customUtc.length,
          customRecurringDates: customUtc,
          selectedOneTimePlan: Boolean(selectedOneTimePlan),
          oneTimePlanId: selectedOneTimePlan?.id || null,
          oneTimePlanPrice: selectedOneTimePrice,
        },
      };
    }

    const firstLocal =
      scheduleOption === "later" ? selectedDateTime : recurringStartDateTime;
    const firstUtc = localToUtcIso(firstLocal!) || firstLocal!;
    
    // Extract the time from the first send and append it to the end date
    const timeFromFirstSend = firstLocal!.substring(11, 16); // Extract HH:mm
    const endDateWithTime = recurringEndDate ? `${recurringEndDate}T${timeFromFirstSend}` : "";
    const endUtc = localToUtcIso(endDateWithTime) || endDateWithTime;
    
    const recurringCount = countRecurringSendsBetween(
      recurrenceType,
      firstUtc,
      endUtc
    );

    if (recurringCount < 1) {
      return {
        error: "End date must be on or after the first send date.",
        data: null,
      };
    }

    return {
      error: null,
      data: {
        extraAssociationsCount: 0,
        selectedAssociations: totalSelected,
        campaignNeedsPayment: false,
        firstDate: firstUtc,
        endDate: endUtc,
        recurrenceType,
        recurringCount,
        customRecurringDates: [] as string[],
        selectedOneTimePlan: Boolean(selectedOneTimePlan),
        oneTimePlanId: selectedOneTimePlan?.id || null,
        oneTimePlanPrice: selectedOneTimePrice,
      },
    };
  };

  const applyRecurringSchedule = () => {
    const { error, data } = buildRecurringCheckoutData();
    if (error || !data) {
      toast({
        title: "Recurring schedule incomplete",
        description: error || "Please complete your recurring schedule.",
        variant: "destructive",
        duration: 2500,
      });
      return;
    }

    setIsRecurringCampaign(true);
    setCheckoutData(data);
    setRecurringReviewConfirmed(false);
    setRecurringReviewAmount(0);
    setShowRecurringModal(false);

    const totalSelected = sendTo.database ? selectedDatasets.length : 0;
    const billing = calculateBillingDetails({
      totalSelected: Number(data.selectedAssociations ?? totalSelected),
      totalSends: Number(data.recurringCount) || 1,
      remainingCamps: remainingCampaigns ?? 0,
      extraLaunchCredits: extraLaunchCredits ?? 0,
      isOneTimePlan: data.selectedOneTimePlan || selectedOneTimePlan,
      oneTimePlanPrice: data.oneTimePlanPrice || selectedOneTimePrice,
    });

    toast({
      title: "Recurring schedule applied",
      description:
        billing.totalCharge <= 0
          ? `${data.recurringCount} send${data.recurringCount === 1 ? "" : "s"} configured. No payment required — click Continue.`
          : `${data.recurringCount} send${data.recurringCount === 1 ? "" : "s"} configured. Click Continue to review payment.`,
      duration: 2000,
    });
  };

  /** When credits cover all recurring sends, skip the review modal and advance directly. */
  const autoConfirmFreeRecurringReview = (
    data: Record<string, unknown>,
    totalSends: number,
    totalSelected: number
  ): boolean => {
    const billing = calculateBillingDetails({
      totalSelected: Number(data.selectedAssociations ?? totalSelected),
      totalSends,
      remainingCamps: remainingCampaigns ?? 0,
      extraLaunchCredits: extraLaunchCredits ?? 0,
      isOneTimePlan: (data.selectedOneTimePlan as boolean) || selectedOneTimePlan,
      oneTimePlanPrice: Number(data.oneTimePlanPrice ?? selectedOneTimePrice),
    });

    if (billing.totalCharge > 0) {
      return false;
    }

    setCheckoutData({
      ...data,
      extraAssociationsCount: billing.totalExtraHubs ?? data.extraAssociationsCount,
      campaignNeedsPayment: false,
      reviewTotalCharge: 0,
      reviewConfirmed: true,
    });
    setRecurringReviewConfirmed(true);
    setRecurringReviewAmount(0);
    setPaymentAmount(0);
    setNeedsPayment(false);
    setShowPaymentForm(false);
    setShowCheckoutModal(false);
    return true;
  };

  const buildRecurringLaunchFields = (options: {
    checkoutData: any;
    isRecurringCampaign: boolean;
    recurrenceType: "daily" | "weekly" | "monthly" | "custom";
    recurringEndDate: string;
    customRecurringDates: string[];
    scheduleOption: "now" | "later";
    selectedDateTime: string;
    recurringStartDateTime: string;
  }) => {
    const hasRecurring =
      Boolean(options.checkoutData?.recurrenceType) || options.isRecurringCampaign;

    if (!hasRecurring) {
      return {
        is_recurring: false,
        recurrence_type: null,
        recurring_end_date: null,
        custom_recurring_dates: null,
        recurring_count: undefined as number | undefined,
        first_scheduled_date: null as string | null,
      };
    }

    const activeRecurrenceType =
      (options.checkoutData?.recurrenceType as typeof options.recurrenceType) ||
      options.recurrenceType;

    const customFromCheckout = Array.isArray(options.checkoutData?.customRecurringDates)
      ? options.checkoutData.customRecurringDates
      : [];
    const customFromState = options.customRecurringDates || [];
    const customDatesSource =
      customFromCheckout.length > 0 ? customFromCheckout : customFromState;

    const customUtc =
      activeRecurrenceType === "custom"
        ? sortDateStringsAscending(
          customDatesSource
            .map((date) => localToUtcIso(date) || date)
            .filter(Boolean) as string[]
        )
        : null;

    const endDateSource =
      options.checkoutData?.endDate || options.recurringEndDate || "";
    
    // If endDateSource is a date-only string (YYYY-MM-DD format), append the start time
    let recurringEndUtc: string | null = null;
    if (activeRecurrenceType !== "custom" && endDateSource) {
      let endDateToUse = endDateSource;
      // Check if it's a date-only string (no time component)
      if (endDateSource.length === 10 && endDateSource.match(/^\d{4}-\d{2}-\d{2}$/)) {
        // Get the time from first send
        let timeFromFirstSend = "";
        if (options.checkoutData?.firstDate) {
          timeFromFirstSend = options.checkoutData.firstDate.substring(11, 16);
        } else if (options.recurringStartDateTime) {
          timeFromFirstSend = options.recurringStartDateTime.substring(11, 16);
        } else if (options.selectedDateTime) {
          timeFromFirstSend = options.selectedDateTime.substring(11, 16);
        }
        if (timeFromFirstSend) {
          endDateToUse = `${endDateSource}T${timeFromFirstSend}`;
        }
      }
      recurringEndUtc = localToUtcIso(endDateToUse) || endDateToUse;
    }

    let firstScheduledDate: string | null = null;
    if (activeRecurrenceType === "custom" && customUtc && customUtc.length > 0) {
      firstScheduledDate = customUtc[0];
    } else if (options.scheduleOption === "later" && options.selectedDateTime) {
      firstScheduledDate =
        localToUtcIso(options.selectedDateTime) || options.selectedDateTime;
    } else if (options.recurringStartDateTime) {
      firstScheduledDate =
        localToUtcIso(options.recurringStartDateTime) || options.recurringStartDateTime;
    } else if (options.checkoutData?.firstDate) {
      firstScheduledDate = options.checkoutData.firstDate;
    }

    const recurringCount =
      Number(options.checkoutData?.recurringCount) ||
      (activeRecurrenceType === "custom" ? customUtc?.length || 0 : 0) ||
      undefined;

    return {
      is_recurring: true,
      recurrence_type: activeRecurrenceType,
      recurring_end_date: recurringEndUtc,
      custom_recurring_dates:
        activeRecurrenceType === "custom" ? customUtc : null,
      recurring_count:
        recurringCount && recurringCount > 0 ? recurringCount : undefined,
      first_scheduled_date: firstScheduledDate,
    };
  };

  const getCheckoutSendDates = (data: any): string[] => {
    if (!data) return [];

    if (data.recurrenceType === "custom") {
      return sortDateStringsAscending(data.customRecurringDates);
    }

    const totalSends = Number(data.recurringCount) || 1;
    const firstDate = data.firstDate || selectedDateTime || new Date().toISOString();

    if (!data.recurrenceType || totalSends <= 1) {
      return [firstDate];
    }

    const dates: string[] = [];
    let current = new Date(firstDate);

    for (let index = 0; index < totalSends; index += 1) {
      dates.push(current.toISOString());

      const next = new Date(current);
      if (data.recurrenceType === "daily") {
        next.setDate(next.getDate() + 1);
      } else if (data.recurrenceType === "weekly") {
        next.setDate(next.getDate() + 7);
      } else if (data.recurrenceType === "monthly") {
        next.setMonth(next.getMonth() + 1);
      }
      current = next;
    }

    return dates;
  };

  const getEffectiveFirstScheduleDate = () => {
    if (checkoutData?.recurrenceType === "custom" && Array.isArray(checkoutData.customRecurringDates) && checkoutData.customRecurringDates.length > 0) {
      return sortDateStringsAscending(checkoutData.customRecurringDates)[0];
    }
    if (Array.isArray(customRecurringDates) && customRecurringDates.length > 0 && recurrenceType === "custom") {
      return sortDateStringsAscending(
        customRecurringDates
          .map((date) => localToUtcIso(date) || date)
          .filter(Boolean) as string[]
      )[0];
    }
    return checkoutData?.firstDate || selectedDateTime || "";
  };

  const renderPaymentSummaryCard = (
    variant: "modal" | "page" = "page",
    showRecurringSummary = isRecurringCampaign
  ) => {
    if (!checkoutData) return null;

    const totalSelected = Number(checkoutData.selectedAssociations ?? 0);
    const totalSends =
      showRecurringSummary && checkoutData.recurringCount
        ? Number(checkoutData.recurringCount) || 1
        : 1;
    const remainingCamps = remainingCampaigns ?? 0;
    const effectiveOneTimePlan =
      Boolean(checkoutData.selectedOneTimePlan) || Boolean(selectedOneTimePlan);
    const effectiveOneTimePrice =
      Number(checkoutData.oneTimePlanPrice ?? selectedOneTimePrice ?? 0);

    const billing = calculateBillingDetails({
      totalSelected,
      totalSends,
      remainingCamps,
      extraHubsCredit: extraHubsCredit || 0,
      extraLaunchCredits: extraLaunchCredits ?? 0,
      isOneTimePlan: effectiveOneTimePlan,
      oneTimePlanPrice: effectiveOneTimePrice,
    });

    // Use billing.freeLaunches which includes both monthly quota + extra launch credits
    const freeLaunches = billing.freeLaunches ?? 0;
    const extraHubsPerSend = billing.extraHubsPerSend ?? 0;
    const sendDates = getCheckoutSendDates(checkoutData);
    const scheduledStart = sendDates[0] || checkoutData.firstDate;
    const scheduledEnd = sendDates[sendDates.length - 1] || checkoutData.endDate;
    const creditsRemainingAfterFirstSend = Math.max(0, freeLaunches - 1);

    const sendRows = Array.from({ length: totalSends }, (_, index) => {
      const isCoveredByCredit = index < freeLaunches;
      const launchCharge = isCoveredByCredit ? 0 : campaignAddOnPrice;

      // Calculate extra hub credits used for this send
      let hubsCreditUsedThisSend = 0;
      let hubsToChargeThisSend = extraHubsPerSend;

      if (extraHubsPerSend > 0 && extraHubsCredit !== undefined && extraHubsCredit > 0) {
        hubsCreditUsedThisSend = Math.min(extraHubsCredit - (extraHubsPerSend * index), extraHubsPerSend);
        hubsCreditUsedThisSend = Math.max(0, hubsCreditUsedThisSend);
        hubsToChargeThisSend = Math.max(0, extraHubsPerSend - hubsCreditUsedThisSend);
      }

      const extraHubCharge = hubsToChargeThisSend * associationAddOnPrice;
      const totalCharge = launchCharge + extraHubCharge;

      let launchLine = "";
      if (isCoveredByCredit) {
        launchLine = "Launch covered by plan = $0.00";
      } else {
        launchLine = `Paid launch = $${campaignAddOnPrice.toFixed(2)}`;
      }

      let hubsLine = "";
      if (extraHubsPerSend > 0) {
        if (hubsCreditUsedThisSend > 0 && hubsToChargeThisSend > 0) {
          hubsLine = `${extraHubsPerSend} extra hub${extraHubsPerSend !== 1 ? "s" : ""}: ${hubsCreditUsedThisSend} credit${hubsCreditUsedThisSend !== 1 ? "s" : ""} + ${hubsToChargeThisSend} x $${associationAddOnPrice.toFixed(2)} = $${extraHubCharge.toFixed(2)}`;
        } else if (hubsCreditUsedThisSend > 0) {
          hubsLine = `${extraHubsPerSend} extra hub${extraHubsPerSend !== 1 ? "s" : ""} covered by credits = $0.00`;
        } else {
          hubsLine = `${extraHubsPerSend} extra hub${extraHubsPerSend !== 1 ? "s" : ""} x $${associationAddOnPrice.toFixed(2)} = $${extraHubCharge.toFixed(2)}`;
        }
      } else {
        hubsLine = "1 hub included, no extra hub charge";
      }

      return {
        id: index + 1,
        date: sendDates[index] || checkoutData.firstDate,
        isCoveredByCredit,
        totalCharge,
        launchLine,
        hubsLine,
        hubsCreditUsedThisSend,
        hubsToChargeThisSend,
      };
    });

    const firstSendRow = sendRows[0] ?? null;
    const remainingSendRows = sendRows.slice(1);
    const remainingSendCharge = remainingSendRows.reduce(
      (sum, send) => sum + send.totalCharge,
      0
    );
    const remainingPaidLaunches = remainingSendRows.filter(
      (send) => !send.isCoveredByCredit
    ).length;
    const remainingExtraHubCharge =
      remainingSendRows.length * extraHubsPerSend * associationAddOnPrice;
    const remainingCoveredLaunches = remainingSendRows.filter(
      (send) => send.isCoveredByCredit
    ).length;

    const frequencyLabel = showRecurringSummary
      ? checkoutData.recurrenceType === "custom"
        ? "Custom schedule"
        : `${String(checkoutData.recurrenceType || "Recurring").charAt(0).toUpperCase()}${String(checkoutData.recurrenceType || "Recurring").slice(1)} recurring`
      : scheduleOption === "now"
        ? "Send now"
        : "One-time send";

    const wrapperClass =
      variant === "page"
        ? "mb-6 overflow-hidden rounded-3xl border border-stone-200 bg-white shadow-sm"
        : "overflow-hidden rounded-3xl border border-stone-200 bg-white shadow-sm";

    return (
      <div className={wrapperClass}>
        <div className="border-b border-stone-200 bg-stone-50 px-5 py-4 sm:px-6">
          <div className="flex flex-wrap items-center gap-2">
            <Badge className="bg-blue-100 text-blue-700 hover:bg-blue-100">
              {effectiveOneTimePlan ? "One-time launch plan" : "Payment summary"}
            </Badge>
            {!effectiveOneTimePlan && remainingCamps > 0 && (
              <Badge className="bg-emerald-100 text-emerald-700 hover:bg-emerald-100">
                {remainingCamps} credit{remainingCamps !== 1 ? "s" : ""} available
              </Badge>
            )}
            {!effectiveOneTimePlan && extraLaunchCredits !== undefined && extraLaunchCredits > 0 && (
              <Badge className="bg-emerald-100 text-emerald-700 hover:bg-emerald-100">
                {extraLaunchCredits} refund launche{extraLaunchCredits !== 1 ? "s" : ""} available
              </Badge> )}
          </div>
          <h3 className="mt-3 text-xl font-semibold text-stone-900">
            {variant === "page" ? "Complete payment" : "Review your payment"}
          </h3>
          <p className="mt-1 text-sm text-stone-600">
            {showRecurringSummary
              ? `${frequencyLabel} • ${formatPaymentDate(scheduledStart)}${scheduledEnd && scheduledEnd !== scheduledStart ? ` to ${formatPaymentDate(scheduledEnd)}` : ""}`
              : `Scheduled for ${formatPaymentDate(scheduledStart)}`}
          </p>
        </div>
        <div className="space-y-6 px-5 py-5 sm:px-6">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-stone-500">
              Schedule At A Glance
            </p>
            <div className="mt-3 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
              <div className="rounded-2xl border border-stone-200 bg-stone-50 p-3">
                <p className="text-xs text-stone-500">Frequency</p>
                <p className="mt-1 text-sm font-semibold text-stone-900">
                  {frequencyLabel}
                </p>
              </div>
              <div className="rounded-2xl border border-stone-200 bg-stone-50 p-3">
                <p className="text-xs text-stone-500">First launch</p>
                <p className="mt-1 text-sm font-semibold text-stone-900">
                  {formatPaymentDate(scheduledStart)}
                </p>
              </div>
              <div className="rounded-2xl border border-stone-200 bg-stone-50 p-3">
                <p className="text-xs text-stone-500">Total sends</p>
                <p className="mt-1 text-sm font-semibold text-stone-900">
                  {totalSends}
                </p>
              </div>
              <div className="rounded-2xl border border-stone-200 bg-stone-50 p-3">
                <p className="text-xs text-stone-500">Extra billable hubs per send</p>
                <p className="mt-1 text-sm font-semibold text-stone-900">
                  {extraHubsPerSend}
                </p>
              </div>
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-stone-500">
              Recipients & Hubs
            </p>
            <div className="mt-3 grid gap-3 sm:grid-cols-2">
              <div className="rounded-2xl border border-stone-200 bg-stone-50 p-3">
                <div className="flex items-center justify-between text-sm text-stone-700">
                  <span>LaunchIQ database hubs</span>
                  <span className="font-semibold text-stone-900">
                    {sendTo.database ? selectedDatasets.length : 0}
                  </span>
                </div>
                <div className="mt-2 flex items-center justify-between text-sm text-stone-700">
                  <span>Your agent datasets</span>
                  <span className="font-semibold text-stone-900">
                    {sendTo.mycontacts ? selectedCustomDatasets.length : 0}
                  </span>
                </div>
              </div>
              <div className="rounded-2xl border border-stone-200 bg-stone-50 p-3">
                <div className="flex items-center justify-between text-sm text-stone-700">
                  <span>Included hub per send</span>
                  <span className="font-semibold text-emerald-700">
                    {totalSelected > 0 ? "1 free" : "0"}
                  </span>
                </div>
                <div className="mt-2 flex items-center justify-between text-sm text-stone-700">
                  <span>Extra billable hubs</span>
                  <span className="font-semibold text-stone-900">
                    {extraHubsPerSend > 0
                      ? `${extraHubsPerSend} x ${totalSends} sends`
                      : "None"}
                  </span>
                </div>
              </div>
            </div>
            {extraHubsPerSend > 0 && (
              <div className="mt-3 rounded-2xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800">
                Each send includes 1 hub. Any hub above that is billed at $
                {associationAddOnPrice.toFixed(2)} per send.
              </div>
            )}

            {/* Extra Hub Credits Available */}
            {extraHubsCredit !== undefined && (
              <div className="mt-3 inline-flex items-center rounded-full border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm shadow-sm">
                <span className="font-semibold text-emerald-700">
                  Extra hub credits available:
                </span>
                <span className="ml-2 rounded-full bg-white px-2 py-0.5 font-bold text-emerald-900 border border-emerald-100">
                  {extraHubsCredit || 0}
                </span>
              </div>
            )}

            {/* Extra Hub Credits Deduction Summary */}
            {extraHubsPerSend > 0 && totalSends > 0 && billing && (
              <div className="mt-3 rounded-lg border border-emerald-300 bg-emerald-50 px-4 py-3 text-sm text-emerald-900">
                <p className="font-semibold mb-2">Extra Hub Credits Breakdown</p>
                <div className="space-y-1 text-xs">
                  <div className="flex items-center justify-between">
                    <span>Extra hubs needed</span>
                    <span className="font-semibold">{billing.totalExtraHubs}</span>
                  </div>
                  {billing.extraHubsCreditUsed && billing.extraHubsCreditUsed > 0 && (
                    <div className="flex items-center justify-between text-emerald-700">
                      <span>Extra hub credits applied</span>
                      <span className="font-semibold">-{billing.extraHubsCreditUsed}</span>
                    </div>
                  )}
                  {billing.extraHubsToCharge && billing.extraHubsToCharge > 0 && (
                    <div className="flex items-center justify-between">
                      <span>Extra hubs to pay for</span>
                      <span className="font-semibold">{billing.extraHubsToCharge}</span>
                    </div>
                  )}
                  {extraHubsCredit !== undefined && billing.extraHubsCreditUsed && (
                    <div className="border-t border-emerald-200 pt-1 mt-1 flex items-center justify-between text-emerald-700 font-semibold">
                      <span>Credits remaining after launch</span>
                      <span>{Math.max(0, (extraHubsCredit || 0) - (billing.extraHubsCreditUsed || 0))}</span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Legacy warning for not enough credits */}
            {extraHubsPerSend > 0 && totalSends > 0 && (
              <>
                {extraHubsCredit !== null && extraHubsPerSend * totalSends > extraHubsCredit && (
                  <div className="mt-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900">
                    <p className="font-semibold">⚠️ Limited extra hub credits available</p>
                    <p className="mt-1">You have {extraHubsCredit} credits but need {extraHubsPerSend * totalSends}. The remaining {(extraHubsPerSend * totalSends) - extraHubsCredit} extra hub{((extraHubsPerSend * totalSends) - extraHubsCredit) !== 1 ? "s" : ""} will be charged.</p>
                  </div>
                )}
              </>
            )}
          </div>

          {!effectiveOneTimePlan && (
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-stone-500">
                Launch Credits Applied
              </p>
              <div className="mt-3 rounded-2xl border border-emerald-200 bg-emerald-50 p-4">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <p className="text-sm font-semibold text-emerald-900">
                      {freeLaunches > 0
                        ? `${freeLaunches} launch credit${freeLaunches !== 1 ? "s" : ""} will be used first`
                        : "No launch credits left for this billing period"}
                    </p>
                    <p className="mt-1 text-xs text-emerald-800">
                      {freeLaunches > 0
                        ? "Credits reduce the launch charge to $0.00 for the earliest scheduled sends."
                        : "Any scheduled send without credit coverage will be billed as a paid launch."}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-xs uppercase tracking-wide text-emerald-700">
                      Covered launches
                    </p>
                    <p className="text-lg font-semibold text-emerald-900">
                      {freeLaunches}/{totalSends}
                    </p>
                  </div>
                </div>
                {totalSends > 0 && (
                  <div className="mt-3 flex items-center justify-between border-t border-emerald-200 pt-3 text-xs text-emerald-800">
                    <span>Launch credits remaining after Send 1</span>
                    <span>{creditsRemainingAfterFirstSend}</span>
                  </div>
                )}

                {/* Show extra launch credits breakdown */}
                {extraLaunchCredits > 0 && (
                  <div className="mt-3 border-t border-emerald-200 pt-3">
                    <p className="text-xs font-semibold text-emerald-900 mb-2">Credits breakdown:</p>
                    <div className="space-y-1 text-xs text-emerald-800">
                      <div className="flex items-center justify-between">
                        <span>Plan Launch used</span>
                        <span className="font-medium">{Math.min(remainingCamps, freeLaunches)} launches</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span>Refund Launch used</span>
                        <span className="font-medium text-emerald-700">{Math.max(0, freeLaunches - remainingCamps)} launches</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-stone-500">
              Pricing Breakdown By Send
            </p>
            <div className="mt-3 space-y-3">
              {sendRows.map((sendRow) => (
                <div key={sendRow.id} className="rounded-2xl border border-stone-200 bg-stone-50 p-4">
                  <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
                    <div>
                      <div className="flex flex-wrap items-center gap-2">
                        <p className="text-sm font-semibold text-stone-900">
                          {/* Send to launch {sendRow.id} */}
                          Send to launch
                        </p>
                        <Badge
                          className={
                            sendRow.isCoveredByCredit
                              ? "bg-emerald-100 text-emerald-700 hover:bg-emerald-100"
                              : "bg-stone-200 text-stone-700 hover:bg-stone-200"
                          }
                        >
                          {sendRow.isCoveredByCredit ? "Launch Credit applied" : "Billable"}
                        </Badge>
                      </div>
                      <p className="mt-1 text-sm text-stone-600">
                        {formatPaymentDate(sendRow.date)}
                      </p>
                    </div>
                    <p className="text-lg font-semibold text-stone-900">
                      ${sendRow.totalCharge.toFixed(2)}
                    </p>
                  </div>
                  <div className="mt-3 space-y-1 text-xs text-stone-600">
                    <p>{sendRow.launchLine}</p>
                    <p>{sendRow.hubsLine}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-stone-500">
              Charge Summary
            </p>
            <div className="mt-3 rounded-2xl border border-stone-200 bg-stone-50 p-4">
              <div className="space-y-2 text-sm text-stone-700">
                <div className="flex items-center justify-between">
                  <span>Paid launches</span>
                  <span className="font-semibold text-stone-900">
                    ${Number(billing.campaignCharge ?? 0).toFixed(2)}
                  </span>
                </div>

                {/* Launch Credits Breakdown */}
                {!effectiveOneTimePlan && billing.freeLaunches && billing.freeLaunches > 0 && (
                  <div className="flex items-center justify-between text-emerald-700">
                    <span>Launch credits applied</span>
                    <span className="font-semibold">
                      -{billing.freeLaunches} launch{billing.freeLaunches !== 1 ? "es" : ""}
                    </span>
                  </div>
                )}

                {/* Extra Hubs Breakdown */}
                {billing.totalExtraHubs && billing.totalExtraHubs > 0 && (
                  <>
                    <div className="border-t border-stone-200 pt-2 mt-2">
                      <div className="flex items-center justify-between">
                        <span>Extra hubs needed</span>
                        <span className="font-semibold text-stone-900">
                          {billing.totalExtraHubs}
                        </span>
                      </div>
                    </div>

                    {/* Extra Hub Credits Deduction */}
                    {billing.extraHubsCreditUsed && billing.extraHubsCreditUsed > 0 && (
                      <div className="flex items-center justify-between text-emerald-700">
                        <span>Extra hub credits applied</span>
                        <span className="font-semibold">
                          -{billing.extraHubsCreditUsed}
                        </span>
                      </div>
                    )}

                    {/* Extra Hubs to Charge */}
                    {billing.extraHubsToCharge && billing.extraHubsToCharge > 0 && (
                      <div className="flex items-center justify-between">
                        <span>Extra hubs to charge for</span>
                        <span className="font-semibold text-stone-900">
                          {billing.extraHubsToCharge}
                        </span>
                      </div>
                    )}

                    <div className="flex items-center justify-between font-semibold">
                      <span>Extra hubs charge</span>
                      <span className="text-stone-900">
                        ${Number(billing.associationCharge ?? 0).toFixed(2)}
                      </span>
                    </div>
                  </>
                )}

                {!billing.totalExtraHubs && (
                  <div className="flex items-center justify-between">
                    <span>Extra hubs</span>
                    <span className="font-semibold text-stone-900">
                      ${Number(billing.associationCharge ?? 0).toFixed(2)}
                    </span>
                  </div>
                )}
              </div>
              <div className="mt-4 flex items-end justify-between border-t border-stone-200 pt-4">
                <div>
                  <p className="text-sm font-medium text-stone-700">Total due today</p>
                  <p className="mt-1 text-xs text-stone-500">
                    Covers {totalSends} send{totalSends !== 1 ? "s" : ""}
                    {scheduledStart ? ` starting ${formatPaymentDate(scheduledStart)}` : ""}
                  </p>
                </div>
                <p className="text-3xl font-semibold text-stone-900">
                  ${Number(billing.totalCharge ?? 0).toFixed(2)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const getCheckoutPaymentAmount = (
    data = checkoutData,
    showRecurringSummary = isRecurringCampaign
  ) => {
    if (!data) return paymentAmount || 0;

    // const totalSelected = Number(data.selectedAssociations ?? 0);
    const totalSelected = sendTo.database ? selectedDatasets.length : Number(data.selectedAssociations ?? 0);
    const totalSends =
      showRecurringSummary && data.recurringCount
        ? Number(data.recurringCount) || 1
        : 1;
    const effectiveOneTimePlan =
      Boolean(data.selectedOneTimePlan) || Boolean(selectedOneTimePlan);
    const effectiveOneTimePrice =
      Number(data.oneTimePlanPrice ?? selectedOneTimePrice ?? 0);

    return calculateBillingDetails({
      totalSelected,
      totalSends,
      remainingCamps: remainingCampaigns ?? 0,
      extraHubsCredit: extraHubsCredit || 0,
      extraLaunchCredits: extraLaunchCredits ?? 0,
      isOneTimePlan: effectiveOneTimePlan,
      oneTimePlanPrice: effectiveOneTimePrice,
    }).totalCharge;
  };


  const getNormalizedImageArray = (images: any): string[] =>
    Array.isArray(images)
      ? images.filter(
        (image): image is string =>
          typeof image === "string" && image.trim() !== ""
      )
      : [];

  const getPropertyPrimaryImage = (item: any): string => {
    const candidates = [
      item?.heroImage,
      item?.image,
      ...(Array.isArray(item?.photos) ? item.photos : []),
    ];

    for (const candidate of candidates) {
      if (typeof candidate === "string" && candidate.trim() !== "") {
        return candidate;
      }
    }

    return "";
  };

  const getServicePrimaryImage = (item: any): string => {
    const candidates = [
      item?.heroImage,
      item?.hero_image_url,
      item?.hero_image,
      item?.image,
      ...(Array.isArray(item?.photos) ? item.photos : []),
    ];

    for (const candidate of candidates) {
      if (typeof candidate === "string" && candidate.trim() !== "") {
        return candidate;
      }
    }

    return "";
  };

  const buildMergedImageState = (
    incomingHero: string,
    incomingPhotos: string[],
    localHero: string,
    localPhotos: string[]
  ) => {
    if (!localHero || localHero === incomingHero) {
      return {
        heroImage: incomingHero,
        photos: incomingPhotos,
      };
    }

    const nextPhotosSource = localPhotos.length > 0 ? localPhotos : incomingPhotos;
    const nextPhotos = [
      localHero,
      ...nextPhotosSource.filter((photo) => photo !== localHero),
    ];

    return {
      heroImage: localHero,
      photos: nextPhotos,
    };
  };

  const getMergedPropertyImageState = (incomingProperty: any) => {
    const incomingHero = getPropertyPrimaryImage(incomingProperty);
    const incomingPhotos = getNormalizedImageArray(incomingProperty?.photos);
    const localHero =
      (isValidPhotoUrl(propertyData?.heroImage) && propertyData.heroImage) ||
      (isValidPhotoUrl((propertyData as any)?.image) &&
        (propertyData as any).image) ||
      "";
    const localPhotos = getNormalizedImageArray(propertyData?.photos);
    const sameProperty =
      (!incomingProperty?.id && !selectedProperty?.id) ||
      String(incomingProperty?.id ?? "") === String(selectedProperty?.id ?? "") ||
      (String(propertyData?.address ?? "").trim() !== "" &&
        String(propertyData?.address ?? "").trim() ===
        String(incomingProperty?.address ?? "").trim()) ||
      (String(propertyData?.headline ?? "").trim() !== "" &&
        String(propertyData?.headline ?? "").trim() ===
        String(
          incomingProperty?.title ?? incomingProperty?.headline ?? ""
        ).trim());

    return buildMergedImageState(
      incomingHero,
      incomingPhotos,
      sameProperty ? localHero : "",
      localPhotos
    );
  };

  const getMergedServiceImageState = (incomingService: any) => {
    const incomingHero = getServicePrimaryImage(incomingService);
    const incomingPhotos = getNormalizedImageArray(incomingService?.photos);
    const localHero =
      (isValidPhotoUrl(serviceData?.heroImage) && serviceData.heroImage) ||
      (isValidPhotoUrl(serviceData?.hero_image_url) &&
        serviceData.hero_image_url) ||
      (isValidPhotoUrl(serviceData?.image) && serviceData.image) ||
      "";
    const localPhotos = getNormalizedImageArray(serviceData?.photos);
    const sameService =
      (!incomingService?.id && !selectedService?.id) ||
      String(incomingService?.id ?? "") === String(selectedService?.id ?? "") ||
      (String(serviceData?.title ?? "").trim() !== "" &&
        String(serviceData?.title ?? "").trim() ===
        String(incomingService?.title ?? incomingService?.headline ?? "").trim()) ||
      (String(serviceData?.address ?? "").trim() !== "" &&
        String(serviceData?.address ?? "").trim() ===
        String(incomingService?.address ?? "").trim());

    return buildMergedImageState(
      incomingHero,
      incomingPhotos,
      sameService ? localHero : "",
      localPhotos
    );
  };

  // ADD this new callback near other handlers:
  const handleEnhancedImageUpdate = useCallback(
    (
      type: "property" | "service",
      payload: EnhancedImageUpdatePayload
    ) => {
      const { originalUrl, enhancedUrl, isHero } = payload;
      if (!enhancedUrl) return;

      const replacePhotos = (photos: any) =>
        Array.isArray(photos)
          ? photos.map((photo) => (photo === originalUrl ? enhancedUrl : photo))
          : photos;

      const shouldReplaceHeroProperty = (prev: any) =>
        isHero ||
        prev?.heroImage === originalUrl ||
        prev?.image === originalUrl ||
        (Array.isArray(prev?.photos) && prev.photos[0] === originalUrl);

      const shouldReplaceHeroService = (prev: any) =>
        isHero ||
        prev?.heroImage === originalUrl ||
        prev?.hero_image_url === originalUrl ||
        (Array.isArray(prev?.photos) && prev.photos[0] === originalUrl);

      if (type === "property") {
        setPropertyData((prev) => {
          const shouldReplace = shouldReplaceHeroProperty(prev);
          return {
            ...prev,
            image: shouldReplace ? enhancedUrl : prev.image,
            heroImage: shouldReplace ? enhancedUrl : prev.heroImage,
            photos: replacePhotos(prev.photos),
            _imgTs: Date.now(),
          };
        });

        setSelectedProperty((prev) => {
          if (!prev) return prev;
          return {
            ...prev,
            image: shouldReplaceHeroProperty(prev)
              ? enhancedUrl
              : prev.image,
            heroImage: shouldReplaceHeroProperty(prev)
              ? enhancedUrl
              : prev.heroImage,
            photos: replacePhotos(prev.photos),
          };
        });
      } else {
        setServiceData((prev) => ({
          ...prev,
          image: shouldReplaceHeroService(prev)
            ? enhancedUrl
            : prev.image,
          hero_image_url: shouldReplaceHeroService(prev)
            ? enhancedUrl
            : prev.hero_image_url,
          heroImage: shouldReplaceHeroService(prev)
            ? enhancedUrl
            : prev.heroImage,
          photos: replacePhotos(prev.photos),
        }));

        setSelectedService((prev) => {
          if (!prev) return prev;
          return {
            ...prev,
            image: shouldReplaceHeroService(prev)
              ? enhancedUrl
              : prev.image,
            hero_image_url: shouldReplaceHeroService(prev)
              ? enhancedUrl
              : prev.hero_image_url,
            heroImage: shouldReplaceHeroService(prev)
              ? enhancedUrl
              : prev.heroImage,
            photos: replacePhotos(prev.photos),
          };
        });
      }
      setPreviewRefresh((p) => p + 1);
    },
    []
  );

  const handleCancelTemplateEdit = useCallback(() => {
    if (!isDirty) {
      discardTemplateEdits();
      return;
    }
    setTemplateEditLeaveAction(() => () => { });
    setShowTemplateEditLeaveModal(true);
  }, [isDirty, discardTemplateEdits]);


  const renderStepContent = () => {
    const now = new Date();
    const minLocal = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
      now.getDate()
    )}T${pad(now.getHours())}:${pad(now.getMinutes())}`;

    const formatUtcDisplay = (dateString: string): string => {
      if (!dateString) return "";
      return formatDateTime(dateString, {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        timeZoneName: "short",
      });
    };

    // Cost calculation for final step (computed once per render)
    const baseCostPerContact = 0.05; // $0.05 per contact
    const totalCost = recipientCount * baseCostPerContact;

    const handleThumbnailUpload = async (e: any) => {
      const file = e.target.files?.[0];
      if (!file) return;

      // Show preview immediately
      setThumbnailPreview(URL.createObjectURL(file));

      const formData = new FormData();
      formData.append("image", file);

      try {
        const res = await axiosInstance.post(
          endpoints.upload_image || "/api/upload/image/",
          formData
        );
        setThumbnailUrl(res.data.url || res.data.image_url || "");
        toast({ title: "Thumbnail uploaded!", variant: "success", duration: 1000 });
      } catch (err) {
        toast({ title: "Upload failed", variant: "destructive", duration: 1000, });
      }
    };
    // recipientCount is computed at component level (use the memoized value)

    // const recipientCount =
    //       selectedDatasets.length > 0
    //         ? agentLists.reduce(
    //             (sum, list) =>
    //               selectedDatasets.includes(list.id)
    //                 ? sum + (list.count || 0)
    //                 : sum,
    //             0
    //           )
    //         : selectedCustomDatasets.length > 0
    //         ? customAgentLists.reduce(
    //             (sum, list) =>
    //               selectedCustomDatasets.includes(list.id)
    //                 ? sum + (list.count || 0)
    //                 : sum,
    //             0
    //           )
    //         : 0;

    switch (currentStep) {
      // =========================================================================
      // STEP 1: Choose Campaign Type
      // =========================================================================
      case 1:
        return (
          <div className="w-full max-w-xl mx-auto px-2 sm:px-0">
            <div className="space-y-6">
              {showDraftPreview ? (
                <div className="p-4 sm:p-5 border-2 border-blue-300 rounded-xl bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 shadow-lg">
                  {/* Header */}
                  <div className="flex items-center justify-between mb-4 gap-2">
                    <div className="flex items-center gap-2 min-w-0">
                      <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                        <FileText className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600" />
                      </div>
                      <div className="min-w-0">
                        <h3 className="font-semibold text-gray-900 text-sm sm:text-base">Your Saved Draft</h3>
                        <p className="text-xs text-gray-500">Continue where you left off</p>
                      </div>
                    </div>
                    <button
                      onClick={() => setShowDraftPreview(false)}
                      className="text-gray-400 hover:text-gray-600 p-1 rounded-full hover:bg-gray-100 flex-shrink-0"
                    >
                      <X className="h-5 w-5" />
                    </button>
                  </div>

                  {isDraftLoading ? (
                    <div className="flex items-center justify-center py-10">
                      <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
                      <span className="ml-3 text-gray-600 text-sm">Loading your draft...</span>
                    </div>
                  ) : draft ? (
                    <>
                      {(() => {
                        const savedStep = draft.current_step || draft.currentStep || draft.step || 5;
                        return (
                          <>
                            {/* Step Indicator */}
                            <div className="mb-4 p-3 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-lg text-white">
                              <div className="flex items-center justify-between gap-2">
                                <div className="flex items-center gap-2 min-w-0">
                                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                                    <span className="font-bold text-sm">{savedStep}</span>
                                  </div>
                                  <div className="min-w-0">
                                    <p className="font-semibold text-sm truncate">
                                      {launchSteps[savedStep - 1]?.title || "Unknown Step"}
                                    </p>
                                    <p className="text-xs text-blue-100 truncate">
                                      {launchSteps[savedStep - 1]?.subtitle || ""}
                                    </p>
                                  </div>
                                </div>
                                <ArrowRight className="h-5 w-5 flex-shrink-0" />
                              </div>
                            </div>

                            {/* Campaign Type Badge Row */}
                            <div className="flex flex-wrap items-center gap-2 mb-4">
                              <Badge className={`text-white text-xs px-3 py-1 ${draft.campaign_type === 'service' ? 'bg-purple-500' : 'bg-blue-500'}`}>
                                {draft.campaign_type === 'service' ? (
                                  <span className="flex items-center gap-1">
                                    <Briefcase className="h-3 w-3" />
                                    Service
                                  </span>
                                ) : (
                                  <span className="flex items-center gap-1">
                                    <Home className="h-3 w-3" />
                                    Property
                                  </span>
                                )}
                              </Badge>
                              <Badge className="bg-amber-500 text-white text-xs">Draft</Badge>
                              {draft.time_since_update && (
                                <span className="text-xs text-gray-500 flex items-center gap-1">
                                  <Calendar className="h-3 w-3 flex-shrink-0" />
                                  <span>{draft.time_since_update}</span>
                                </span>
                              )}
                            </div>

                            {/* Details Card */}
                            <div className="flex items-start gap-3 p-3 sm:p-4 bg-white rounded-lg border shadow-sm">
                              {/* Thumbnail — responsive size, never shrinks to zero */}
                              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg overflow-hidden bg-gray-200 flex-shrink-0">
                                {(() => {
                                  const imageUrl =
                                    draft.image_url || draft.image || draft.heroImage ||
                                    draft.hero_image || (draft.photos?.[0]) || null;
                                  if (imageUrl) {
                                    return (
                                      <img
                                        src={imageUrl}
                                        alt="Draft"
                                        className="w-full h-full object-cover"
                                        onError={(e) => {
                                          (e.target as HTMLImageElement).style.display = "none";
                                        }}
                                      />
                                    );
                                  }
                                  return (
                                    <div className="w-full h-full flex items-center justify-center bg-blue-100">
                                      {draft.campaign_type === 'service' ? (
                                        <Briefcase className="h-8 w-8 text-purple-400" />
                                      ) : (
                                        <Home className="h-8 w-8 text-blue-400" />
                                      )}
                                    </div>
                                  );
                                })()}
                              </div>

                              {/* Info — min-w-0 prevents flex overflow */}
                              <div className="flex-1 min-w-0">
                                <h4 className="font-bold text-gray-900 truncate text-sm sm:text-base">
                                  {draft.title || draft.headline || draft.campaign_name || draft.address ||
                                    (draft.campaign_type === 'service' ? "Untitled Service" : "Untitled Property")}
                                </h4>

                                {draft.campaign_type === 'service' && draft.service_type && (
                                  <p className="text-xs sm:text-sm text-purple-600 font-medium mt-0.5">{draft.service_type}</p>
                                )}

                                {draft.campaign_type !== 'service' && draft.address && (
                                  <p className="text-xs sm:text-sm text-gray-600 flex items-center gap-1 mt-1">
                                    <MapPin className="h-3 w-3 flex-shrink-0" />
                                    <span className="truncate">{draft.address}</span>
                                  </p>
                                )}

                                {/* Property tags */}
                                {draft.campaign_type !== 'service' && (
                                  <div className="flex flex-wrap gap-1.5 mt-2">
                                    {draft.price && Number(draft.price) > 0 && (
                                      <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded whitespace-nowrap">
                                        ${Number(draft.price).toLocaleString()}
                                      </span>
                                    )}
                                    {draft.bedrooms > 0 && (
                                      <span className="text-xs bg-gray-100 text-gray-700 px-2 py-0.5 rounded whitespace-nowrap">
                                        {draft.bedrooms} Beds
                                      </span>
                                    )}
                                    {draft.bathrooms > 0 && (
                                      <span className="text-xs bg-gray-100 text-gray-700 px-2 py-0.5 rounded whitespace-nowrap">
                                        {draft.bathrooms} Baths
                                      </span>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* What's Saved */}
                            <div className="mt-4 p-3 bg-gray-50 rounded-lg border">
                              <p className="text-xs font-semibold text-gray-600 mb-2">What's saved in this draft:</p>
                              <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 text-xs">
                                {savedStep >= 2 && (draft.title || draft.address) && (
                                  <div className="flex items-center gap-1 text-gray-600">
                                    <CheckCircle className="h-3 w-3 text-green-500 flex-shrink-0" />
                                    <span>{draft.campaign_type === 'service' ? 'Service details' : 'Property details'}</span>
                                  </div>
                                )}
                                {savedStep >= 3 && draft.selected_template_id && (
                                  <div className="flex items-center gap-1 text-gray-600">
                                    <CheckCircle className="h-3 w-3 text-green-500 flex-shrink-0" />
                                    <span>Template selected</span>
                                  </div>
                                )}
                                {savedStep >= 4 && (draft.subject || draft.campaign_subject) && (
                                  <div className="flex items-center gap-1 text-gray-600">
                                    <CheckCircle className="h-3 w-3 text-green-500 flex-shrink-0" />
                                    <span>Subject line</span>
                                  </div>
                                )}
                                {savedStep >= 5 &&
                                  (draft.selected_datasets?.length > 0 || draft.selected_custom_datasets?.length > 0) && (
                                    <div className="flex items-center gap-1 text-gray-600">
                                      <CheckCircle className="h-3 w-3 text-green-500 flex-shrink-0" />
                                      <span>
                                        Recipients ({(draft.selected_datasets?.length || 0) + (draft.selected_custom_datasets?.length || 0)})
                                      </span>
                                    </div>
                                  )}
                                {savedStep >= 6 && draft.schedule_option && (
                                  <div className="flex items-center gap-1 text-gray-600">
                                    <CheckCircle className="h-3 w-3 text-green-500 flex-shrink-0" />
                                    <span>Schedule: {draft.schedule_option === 'now' ? 'Send Now' : 'Scheduled'}</span>
                                  </div>
                                )}
                                {savedStep >= 7 && (
                                  <div className="flex items-center gap-1 text-gray-600">
                                    <CheckCircle className="h-3 w-3 text-green-500 flex-shrink-0" />
                                    <span>Payment: {draft.payment_completed ? 'Complete' : 'Pending'}</span>
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Progress Bar */}
                            <div className="mt-4 p-3 bg-white rounded-lg border">
                              <div className="flex items-center justify-between mb-2">
                                <span className="text-xs font-semibold text-gray-600">Progress</span>
                                <span className="text-xs text-gray-500">Step {savedStep} of {launchSteps.length}</span>
                              </div>
                              <div className="w-full bg-gray-200 rounded-full h-2">
                                <div
                                  className="bg-gradient-to-r from-blue-400 to-blue-600 h-2 rounded-full transition-all"
                                  style={{ width: `${(savedStep / launchSteps.length) * 100}%` }}
                                />
                              </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="flex items-center gap-2 mt-5 pt-4 border-t">
                              {/* Delete — fixed width, never shrinks */}
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={handleDeleteDraft}
                                disabled={isDraftDeleting}
                                className="text-red-600 hover:bg-red-50 flex-shrink-0 px-3"
                              >
                                {isDraftDeleting ? (
                                  <><Loader2 className="h-4 w-4 animate-spin mr-1.5" /><span className="hidden sm:inline">Deleting...</span></>
                                ) : (
                                  <><Trash2 className="h-4 w-4 mr-1.5" /><span>Delete</span></>
                                )}
                              </Button>

                              {/* Continue — takes remaining space, text truncates instead of overflowing */}
                              <Button
                                onClick={handleUseDraft}
                                className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white flex-1 min-w-0 px-3"
                              >
                                <Sparkles className="h-4 w-4 mr-1.5 flex-shrink-0" />
                                <span className="truncate">Continue from Step {savedStep}</span>
                                <ArrowRight className="h-4 w-4 ml-1.5 flex-shrink-0" />
                              </Button>
                            </div>
                          </>
                        );
                      })()}
                    </>
                  ) : (
                    <div className="text-center py-8">
                      <AlertCircle className="h-12 w-12 text-gray-400 mx-auto mb-3" />
                      <p className="text-gray-600 text-sm">No draft found</p>
                      <Button variant="outline" onClick={() => setShowDraftPreview(false)} className="mt-4">
                        Start New Campaign
                      </Button>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <h2 className="text-xl sm:text-2xl font-bold text-primary mb-6 sm:mb-8 text-center">Pick Your Launch!</h2>

                  {hasDraft && (
                    <div className="flex flex-col gap-3 mb-6">
                      {propertyDraft && (
                        <button
                          onClick={async () => {
                            setIsDraftLoading(true);
                            setShowDraftPreview(true);
                            try {
                              setDraft(propertyDraft);
                              setCampaignType("property");
                            } catch (error) {
                              toast({ title: "Error", description: "Failed to load draft.", variant: "destructive" });
                            } finally {
                              setIsDraftLoading(false);
                            }
                          }}
                          className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium text-sm px-4 py-2.5 rounded-xl bg-blue-50 hover:bg-blue-100 border border-blue-200 shadow-sm w-full justify-center"
                        >
                          <FileText className="h-4 w-4 flex-shrink-0" />
                          <span className="truncate">Property Draft — Click to view</span>
                          <ArrowRight className="h-4 w-4 flex-shrink-0" />
                        </button>
                      )}

                      {serviceDraft && (
                        <button
                          onClick={async () => {
                            setIsDraftLoading(true);
                            setShowDraftPreview(true);
                            try {
                              setDraft(serviceDraft);
                              setCampaignType("service");
                            } catch (error) {
                              toast({ title: "Error", description: "Failed to load draft.", variant: "destructive" });
                            } finally {
                              setIsDraftLoading(false);
                            }
                          }}
                          className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-medium text-sm px-4 py-2.5 rounded-xl bg-emerald-50 hover:bg-emerald-100 border border-emerald-200 shadow-sm w-full justify-center"
                        >
                          <FileText className="h-4 w-4 flex-shrink-0" />
                          <span className="truncate">Service Draft — Click to view</span>
                          <ArrowRight className="h-4 w-4 flex-shrink-0" />
                        </button>
                      )}
                    </div>
                  )}

                  {/* Campaign Type Selection */}
                  <div className="space-y-4">
                    <div
                      onClick={() => setCampaignType("property")}
                      className={`cursor-pointer rounded-xl border-2 p-4 sm:p-5 ${campaignType === "property"
                        ? "border-blue-500 bg-blue-50 ring-2 ring-blue-200"
                        : "border-gray-200 hover:border-gray-300"
                        } flex items-start gap-3 sm:gap-4`}
                    >
                      <div className={`mt-0.5 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${campaignType === "property" ? "border-blue-500" : "border-gray-300"
                        }`}>
                        {campaignType === "property" && <div className="w-2.5 h-2.5 rounded-full bg-blue-500" />}
                      </div>
                      <Home className={`h-7 w-7 sm:h-8 sm:w-8 flex-shrink-0 ${campaignType === "property" ? "text-blue-600" : "text-gray-700"}`} />
                      <div className="min-w-0">
                        <p className={`font-semibold text-sm sm:text-base ${campaignType === "property" ? "text-blue-900" : "text-gray-900"}`}>
                          Property Launch
                        </p>
                        <p className="text-xs sm:text-sm text-gray-600 mt-1">Create launches for property listings</p>
                      </div>
                    </div>

                    <div
                      onClick={() => setCampaignType("service")}
                      className={`cursor-pointer rounded-xl border-2 p-4 sm:p-5 ${campaignType === "service"
                        ? "border-blue-500 bg-blue-50 ring-2 ring-blue-200"
                        : "border-gray-200 hover:border-gray-300"
                        } flex items-start gap-3 sm:gap-4`}
                    >
                      <div className={`mt-0.5 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${campaignType === "service" ? "border-blue-500" : "border-gray-300"
                        }`}>
                        {campaignType === "service" && <div className="w-2.5 h-2.5 rounded-full bg-blue-500" />}
                      </div>
                      <Briefcase className={`h-7 w-7 sm:h-8 sm:w-8 flex-shrink-0 ${campaignType === "service" ? "text-blue-600" : "text-gray-700"}`} />
                      <div className="min-w-0">
                        <p className={`font-semibold text-sm sm:text-base ${campaignType === "service" ? "text-blue-900" : "text-gray-900"}`}>
                          Service Launch
                        </p>
                        <p className="text-xs sm:text-sm text-gray-600 mt-1">Create launches for service businesses</p>
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-center pt-4">
                    <button
                      disabled={!campaignType}
                      onClick={() => {
                        setIsServiceFlow(campaignType === "service");
                        setCurrentStep(2);
                      }}
                      className={`w-full sm:w-auto rounded-full px-8 py-3 text-white font-medium text-sm sm:text-base ${campaignType
                        ? "bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700"
                        : "bg-gray-300 cursor-not-allowed"
                        }`}
                    >
                      Start New Launch
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        );
      // =========================================================================
      // STEP 2: Property Selection OR Service Details
      // =========================================================================
      case 2:
        if (campaignType === "property") {
          return (
            <div className="w-full">
              {/* Multiple Templates Toggle - More visible ON/OFF switch */}
              <h2 className="text-2xl font-bold text-primary mb-8 text-center">
                {isMultipleTemplateMode ? "Select Multiple Templates & Properties" : "Select or Add a Property"}
              </h2>

              <div className="mx-auto mb-6 w-full max-w-6xl px-4 overflow-hidden">
                <div className="flex flex-wrap gap-4 rounded-xl border border-blue-200 bg-gradient-to-r from-blue-50 to-indigo-50 p-4 items-center justify-between">
                  <div className="flex min-w-0 items-start gap-3">
                    <div className={`p-2 rounded-lg ${isMultipleTemplateMode ? 'bg-blue-500' : 'bg-gray-300'}`}>
                      <Layout className="h-5 w-5 text-white" />
                    </div>

                    <div className="min-w-0">
                      <h3 className="font-semibold text-gray-900">Multi-Mode Template</h3>
                      <p className="break-words text-sm text-gray-600">
                        {isMultipleTemplateMode
                          ? "Select multiple templates and properties at once"
                          : "When enabled, add multiple properties in one single launch."}
                      </p>
                    </div>
                  </div>

                  {/* Toggle Switch */}
                  <button
                    // Around line where you handle the Multi-Mode toggle (Step 2, case 2)
                    onClick={() => {
                      setIsMultipleTemplateMode((v) => {
                        const next = !v;
                        if (!next) {
                          try {
                            sessionStorage.removeItem("isMultiPropertyMode");
                            sessionStorage.removeItem("multiSelectedProperties");
                            sessionStorage.removeItem("multiSelectedTemplateIds");
                          } catch (e) { }
                          setSelectedMultipleTemplates([]);
                          setMultiSelectedProperties([]);
                          setMultipleTemplatePropertyData(null);

                          // ✅ ADD THESE THREE LINES:
                          setIsAutoAIMode(false);
                          setAutoAITemplateId(null);
                          setSelectedTemplate(null); // clear any previously AI-selected template
                        }
                        return next;
                      });
                    }}
                    className={`
  relative inline-flex h-8 w-16 shrink-0 self-center items-center rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
  ${isMultipleTemplateMode ? 'bg-blue-600' : 'bg-gray-300'}
`}
                  >
                    <span
                      className={`
                        inline-block h-6 w-6 transform rounded-full bg-white shadow-lg transition-transform duration-300
                        ${isMultipleTemplateMode ? 'translate-x-9' : 'translate-x-1'}
                      `}
                    />
                    <span className={`absolute left-1.5 text-[9px] font-bold uppercase text-white transition-opacity duration-200 ${isMultipleTemplateMode ? 'opacity-100' : 'opacity-0'}`}>
                      ON
                    </span>
                    <span className={`absolute right-1.5 text-[9px] font-bold uppercase text-gray-500 transition-opacity duration-200 ${isMultipleTemplateMode ? 'opacity-0' : 'opacity-100'}`}>
                      OFF
                    </span>
                  </button>
                </div>
              </div>

              {/* Conditional rendering based on mode */}
              {isMultipleTemplateMode ? (
                // MULTIPLE MODE: Show combined property + template selection
                <MultipleTemplateSelector
                  templates={filteredTemplates as any}
                  savedProperties={properties.map(p => ({
                    ...p,
                    id: String(p.id),
                    image: p.image || p.heroImage || "",
                    bedrooms: p.bedrooms ?? 0,
                    bathrooms: p.bathrooms ?? 0,
                    area: p.area ?? p.sqft ?? 0,
                    price: Number(p.price || 0),
                    address: p.address || "",
                  })) as any}
                  loadingProperties={loadingProperties}
                  getFullUrl={getFullUrl}
                  onPropertyAdd={handlePropertyAdd}
                  onBack={() => {
                    setIsMultipleTemplateMode(false);
                  }}
                  onContinue={(selectedTemplates, selectedProperties) => {
                    setSelectedMultipleTemplates(selectedTemplates as any);
                    setMultiSelectedProperties(selectedProperties as any);

                    try {
                      sessionStorage.setItem(
                        "multiSelectedProperties",
                        JSON.stringify(selectedProperties)
                      );
                      sessionStorage.setItem(
                        "multiSelectedTemplateIds",
                        JSON.stringify((selectedTemplates || []).map((t: any) => t.id))
                      );
                      sessionStorage.setItem("isMultiPropertyMode", "true");
                    } catch (e) {
                      console.warn("Could not save to session storage");
                    }

                    // Skip Step 3, go directly to Step 4
                    setCurrentStep(4);
                  }}
                />
              ) : (
                // SINGLE MODE: Show normal property selection
                <PropertyStep
                  currentStep={currentStep}
                  handleBack={handleBack}
                  handlePropertySelect={handlePropertySelect}
                  properties={properties}
                  loadingProperties={loadingProperties}
                  setCampaignSubject={setSubject}
                  onEditProperty={handleEditProperty}
                  onAutoAISelect={handleAutoAISelect}
                  onPropertyUpdate={handlePropertyUpdate}
                  onPropertyAdd={handlePropertyAdd}        // ✅ ADD THIS
                  onPropertyDelete={handlePropertyDelete}  // ✅ ADD THIS
                  currentUserId={planDetails?.id}
                  userPlan={userPlan}
                  getPropertyExpiry={getPropertyExpiry}
                  formatExpiryMessage={formatExpiryMessage}
                  getPropertyAvailabilityDays={getPropertyAvailabilityDays}
                  onEnhancedImageUpdate={(payload) => handleEnhancedImageUpdate("property", payload)}
                />
              )}
            </div>
          );
        }

        return (
          <div className="w-full">
            <h2 className="text-2xl font-bold text-primary mb-8 text-center">
              {isMultipleServiceTemplateMode ? "Select Multiple Templates & Services" : "Select or Add a Service"}
            </h2>
            {/* Multiple Templates Toggle - More visible ON/OFF switch */}
            <div className="mx-auto mb-6 w-full max-w-6xl px-4 overflow-hidden">
              <div className="flex flex-wrap gap-4 rounded-xl border border-blue-200 bg-gradient-to-r from-blue-50 to-indigo-50 p-4 items-center justify-between">
                <div className="flex min-w-0 items-start gap-3">
                  <div className={`p-2 rounded-lg ${isMultipleServiceTemplateMode ? 'bg-blue-500' : 'bg-gray-300'}`}>
                    <Layout className="h-5 w-5 text-white" />
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-semibold text-gray-900">Multi-Mode Template</h3>
                    <p className="break-words text-sm text-gray-600">
                      {isMultipleServiceTemplateMode
                        ? "Select multiple templates and services at once"
                        : "When enabled, add multiple properties in one single launch."}
                    </p>
                  </div>
                </div>

                {/* Toggle Switch */}
                <button
                  onClick={() => {
                    setIsMultipleServiceTemplateMode((v) => {
                      const next = !v;
                      if (!next) {
                        // If turning OFF, clear multi-mode state
                        try {
                          sessionStorage.removeItem("isMultiServiceMode");
                          sessionStorage.removeItem("multiSelectedServices");
                          sessionStorage.removeItem("multiSelectedServiceTemplateIds");
                        } catch (e) { }
                        setSelectedMultipleServiceTemplates([]);
                        setMultiSelectedServices([]);
                      }
                      return next;
                    });
                  }}
                  className={`
                    relative inline-flex h-8 w-16 shrink-0 self-start items-center rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:self-center
                    ${isMultipleServiceTemplateMode ? 'bg-blue-600' : 'bg-gray-300'}
                  `}
                >
                  <span
                    className={`
                      inline-block h-6 w-6 transform rounded-full bg-white shadow-lg transition-transform duration-300
                      ${isMultipleServiceTemplateMode ? 'translate-x-9' : 'translate-x-1'}
                    `}
                  />
                  <span className={`
                    absolute text-[10px] font-bold uppercase
                    ${isMultipleServiceTemplateMode ? 'left-2 text-white' : 'right-2 text-gray-500'}
                  `}>
                    {isMultipleServiceTemplateMode ? 'ON' : 'OFF'}
                  </span>
                </button>
              </div>
            </div>

            {/* Conditional rendering based on mode */}
            {isMultipleServiceTemplateMode ? (
              // MULTIPLE MODE: Show combined service + template selection
              <MultipleServiceSelector
                templates={serviceTemplates as any}
                savedServices={savedServices.map(s => {
                  const heroUrl = s.hero_image_url || s.hero_image || s.image || "";
                  return {
                    ...s,
                    id: String(s.id),
                    image: heroUrl ? getFullUrl(heroUrl) : "",
                    hero_image_url: heroUrl ? getFullUrl(heroUrl) : "",
                  };
                }) as any}
                loadingServices={loadingServices}
                getFullUrl={getFullUrl}
                onServiceAdd={handleServiceAdd}
                onBack={() => {
                  setIsMultipleServiceTemplateMode(false);
                }}
                onContinue={(selectedTemplates, selectedServices) => {
                  setSelectedMultipleServiceTemplates(selectedTemplates as any);
                  setMultiSelectedServices(selectedServices as any);

                  try {
                    sessionStorage.setItem(
                      "multiSelectedServices",
                      JSON.stringify(selectedServices)
                    );
                    sessionStorage.setItem(
                      "multiSelectedServiceTemplateIds",
                      JSON.stringify((selectedTemplates || []).map((t: any) => t.id))
                    );
                    sessionStorage.setItem("isMultiServiceMode", "true");
                  } catch (e) {
                    console.warn("Could not save to session storage");
                  }

                  // Skip Step 3, go directly to Step 4
                  setCurrentStep(4);
                }}
              />
            ) : (
              // SINGLE MODE: Show normal service selection
              <ServiceStep
                currentStep={currentStep}
                handleBack={handleBack}
                handleServiceSelect={handleServiceSelect}
                services={savedServices}
                loadingServices={loadingServices}
                setCampaignSubject={setSubject}
                onAutoAISelect={handleAutoAISelectService}
                onServiceUpdate={handleServiceUpdate}
                currentUserId={planDetails?.id}
                onServiceAdd={handleServiceAdd}
                onServiceDelete={handleServiceDelete}
                onEnhancedImageUpdate={(payload) => handleEnhancedImageUpdate("service", payload)}
              />
            )}
          </div>
        );

      // =========================================================================
      // STEP 3: Template Selection OR Service Template Builder
      // =========================================================================
      case 3:
        if (campaignType === "property") {
          // If somehow we got here in multi-mode, redirect back
          if (isMultipleTemplateMode) {
            setCurrentStep(2);
            return null;
          }

          // Normal single template selection
          return (
            <div className="flex min-h-[calc(95vh-140px)] w-full min-w-0 flex-col">
              {/* HEADER */}
              <div className="text-center mb-2 shrink-0">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-primary">
                  Template Gallery
                </h2>
                <p className="text-xs sm:text-sm text-muted-foreground">
                  Choose from professionally designed templates.
                </p>
              </div>

              {/* FILTER BAR */}
              <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-4">

                {/* SEARCH */}
                <div className="relative w-full sm:w-[220px] shrink-0">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                  <Input
                    className="pl-9 h-9"
                    placeholder="Search templates..."
                  />
                </div>

                {/* FILTER BUTTONS — single row, no wrap */}
                <div className="flex items-center gap-1 sm:gap-1.5 overflow-x-auto pb-0.5">
                  {[
                    { label: "All", value: "all" },
                    { label: "1 Photo", value: 1 },
                    { label: "2 Photos", value: 2 },
                    { label: "3 Photos", value: 3 },
                    { label: "4 Photos", value: 4 },
                  ].map((item) => (
                    <Button
                      key={item.label}
                      size="sm"
                      onClick={() => setPhotoFilter(item.value)}
                      variant={photoFilter === item.value ? "default" : "outline"}
                      className="h-8 md:h-9 px-2.5 sm:px-3 text-xs sm:text-sm shrink-0 whitespace-nowrap"
                    >
                      {item.label}
                    </Button>
                  ))}
                </div>
              </div>

              {/* GRID */}
              <div className="flex-1">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                  {filteredTemplates
                    .filter((template) =>
                      photoFilter === "all"
                        ? true
                        : template.photoCount === photoFilter
                    )
                    .map((template) => {
                      const TemplateComponent = template.component;
                      const isSelected = selectedTemplate?.id === template.id;

                      const scale = 0.3;
                      const scalePercent = `${(1 / scale) * 100}%`;

                      return (
                        <Card
                          key={template.id}
                          onClick={() => {
                            // Clear multi-mode flags when selecting a template in single-template flow
                            try {
                              sessionStorage.removeItem("isMultiPropertyMode");
                              sessionStorage.removeItem("multiSelectedProperties");
                              sessionStorage.removeItem("multiSelectedTemplateIds");
                            } catch (e) {
                              console.warn("Could not clear multi-mode session storage:", e);
                            }
                            setSelectedMultipleTemplates([]);
                            setMultiSelectedProperties([]);
                            setMultipleTemplatePropertyData(null);
                            setIsMultipleTemplateMode(false);

                            const templateCopy = { ...template };
                            setSelectedTemplate(templateCopy);
                            setIsAutoAIMode(false);
                            setAutoAITemplateId(null);

                            try {
                              sessionStorage.setItem(
                                "selectedTemplateId",
                                String(template.id)
                              );
                            } catch (e) {
                              console.warn(
                                "Could not save template to session storage"
                              );
                            }
                          }}
                          className={`
                            relative cursor-pointer border-2 transition-all
                            ${isSelected
                              ? "border-primary ring-2 ring-primary/30"
                              : "hover:border-primary/50"
                            }
                          `}
                        >
                          <CardContent className="p-0 flex flex-col">
                            {isSelected && (
                              <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/30">
                                <CheckCircle2 className="h-12 w-12 sm:h-16 sm:w-16 md:h-20 md:w-20 text-green-500 drop-shadow-lg" />
                              </div>
                            )}

                            <PropertyTemplatePreview
                              template={template}
                              propertyData={{
                                id: 1,
                                title: "Luxury Modern Estate",
                                image: heroPropertyImage,
                                photos: [
                                  heroproperties,
                                  landscaping,
                                  heroPropertyImage,
                                ],
                                price: 2343434,
                                address: "123 Luxury Ave",
                                bedrooms: 4,
                                bathrooms: 3,
                                area: 4000,
                                description: "Luxury property",
                                propertyListType: {
                                  id: 1,
                                  list_name: "",
                                },
                              }}
                            />

                            <div className="p-2 sm:p-3 flex flex-col gap-1 sm:gap-2">
                              <div>
                                <div className="flex justify-between text-xs sm:text-sm font-semibold">
                                  <span className="truncate">{template.name}</span>
                                  <span className="flex items-center gap-1 shrink-0">
                                    ⭐ {template.rating}
                                  </span>
                                </div>

                                <Badge className="text-[9px] sm:text-[10px] mt-1">
                                  {template.tag}
                                </Badge>
                              </div>

                              <div className="flex justify-between text-[10px] sm:text-[11px] text-muted-foreground">
                                <span>{template.uses} uses</span>
                                <span>{template.category}</span>
                              </div>
                            </div>
                          </CardContent>
                        </Card>
                      );
                    })}
                </div>
              </div>

              <div className="mt-3 flex shrink-0 flex-col gap-2 sm:mt-2 sm:flex-row sm:justify-between">
                <Button variant="outline" onClick={() => requestStepNavigation(2)} className="w-full text-xs sm:w-auto sm:text-sm">
                  ← Back
                </Button>

                <Button
                  disabled={!selectedTemplate}
                  onClick={() => {
                    if (!selectedTemplate) {
                      toast({
                        title: "Select a Template",
                        description:
                          "Please select a template before continuing.",
                        variant: "destructive",
                        duration: 1000
                      });
                      return;
                    }

                    if (!selectedProperty) {
                      toast({
                        title: "No Property Selected",
                        description:
                          "Please go back and select a property first.",
                        variant: "destructive",
                      });
                      requestStepNavigation(2);
                      return;
                    }

                    // Clear multi-mode flags when continuing from Step 3 with a selected template
                    try {
                      sessionStorage.removeItem("isMultiPropertyMode");
                      sessionStorage.removeItem("multiSelectedProperties");
                      sessionStorage.removeItem("multiSelectedTemplateIds");
                    } catch (e) {
                      console.warn("Could not clear multi-mode session storage:", e);
                    }
                    setSelectedMultipleTemplates([]);
                    setMultiSelectedProperties([]);
                    setMultipleTemplatePropertyData(null);
                    setIsMultipleTemplateMode(false);

                    setIsAutoAIMode(false);
                    setAutoAITemplateId(null);
                    setCurrentStep(4);
                  }}
                  className={`
                    w-full text-white text-xs sm:w-auto sm:text-sm
                    ${selectedTemplate
                      ? "bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 hover:from-blue-500 hover:via-blue-600 hover:to-blue-700"
                      : "bg-blue-200 cursor-not-allowed"
                    }
                  `}
                >
                  Continue →
                </Button>
              </div>
            </div>
          );
        }


        const serviceDummyData = {
          // Data object that most service templates expect
          data: {
            headline: "Professional Real Estate Services",
            subheadline: "Your Trusted Partner in Real Estate",
            description: "We provide comprehensive real estate services including property management, buying, selling, and investment consulting. Our team of experts is dedicated to helping you achieve your real estate goals.",
            serviceName: "Premium Property Management",
            serviceTitle: "Expert Real Estate Solutions",
            companyName: "Premier Real Estate Group",
            tagline: "Excellence in Every Transaction",

            // Agent/Contact info
            agentName: "John Smith",
            agentTitle: "Senior Real Estate Agent",
            agentPhone: "(555) 123-4567",
            agentEmail: "john.smith@realestate.com",
            phone: "(555) 123-4567",
            email: "john.smith@realestate.com",
            website: "www.premierrealestate.com",
            address: "123 Main Street, Beverly Hills, CA 90210",

            // ALL POSSIBLE IMAGE PROP NAMES
            heroImage: heroPropertyImage,
            image: heroPropertyImage,
            mainImage: heroPropertyImage,
            backgroundImage: heroPropertyImage,
            agentImage: heroPropertyImage,
            agentPhoto: heroPropertyImage,
            logo: heroPropertyImage,
            companyLogo: heroPropertyImage,
            profileImage: heroPropertyImage,
            coverImage: heroPropertyImage,
            bannerImage: heroPropertyImage,
            primaryImage: heroPropertyImage,
            secondaryImage: heroproperties,
            photo: heroPropertyImage,
            photos: [heroPropertyImage, heroproperties, landscaping],
            images: [heroPropertyImage, heroproperties, landscaping],
            gallery: [heroPropertyImage, heroproperties, landscaping],

            // Service type
            serviceType: "Real Estate Services",
            service_type: "Real Estate Services",

            // Services list
            services: [
              "Property Valuation",
              "Market Analysis",
              "Home Staging",
              "Professional Photography",
              "Virtual Tours",
              "Negotiation Support"
            ],

            // Features - both array of strings and array of objects
            features: [
              { id: 1, feature_name: "24/7 Support" },
              { id: 2, feature_name: "Free Consultation" },
              { id: 3, feature_name: "Expert Team" },
              { id: 4, feature_name: "Fast Response" },
              { id: 5, feature_name: "Proven Results" }
            ],
            featuresList: [
              "24/7 Support",
              "Free Consultation",
              "Expert Team",
              "Fast Response",
              "Proven Results"
            ],

            // Stats
            stats: {
              propertiesSold: "500+",
              yearsExperience: "15+",
              happyClients: "1000+",
              awards: "25+"
            },

            // Testimonial
            testimonial: "Best real estate service I've ever used! Highly recommended.",
            testimonialAuthor: "Sarah Johnson",
            testimonialRole: "Happy Homeowner",

            // CTA
            ctaText: "Contact Us Today",
            ctaButton: "Get Started",
          },

          // ============ DIRECT PROPS (for templates that don't use data wrapper) ============

          // ALL POSSIBLE IMAGE PROP NAMES AS DIRECT PROPS
          heroImage: heroPropertyImage,
          image: heroPropertyImage,
          mainImage: heroPropertyImage,
          backgroundImage: heroPropertyImage,
          agentImage: heroPropertyImage,
          agentPhoto: heroPropertyImage,
          logo: heroPropertyImage,
          companyLogo: heroPropertyImage,
          profileImage: heroPropertyImage,
          coverImage: heroPropertyImage,
          bannerImage: heroPropertyImage,
          primaryImage: heroPropertyImage,
          secondaryImage: heroproperties,
          photo: heroPropertyImage,
          photos: [heroPropertyImage, heroproperties, landscaping],
          images: [heroPropertyImage, heroproperties, landscaping],
          gallery: [heroPropertyImage, heroproperties, landscaping],

          // Text content
          headline: "Professional Real Estate Services",
          subheadline: "Your Trusted Partner in Real Estate",
          description: "We provide comprehensive real estate services including property management, buying, selling, and investment consulting.",
          serviceName: "Premium Property Management",
          serviceType: "Real Estate Services",
          service_type: "Real Estate Services",
          title: "Professional Real Estate Services",

          // Contact info as direct props
          agentName: "John Smith",
          name: "John Smith",
          agentPhone: "(555) 123-4567",
          agentEmail: "john.smith@realestate.com",
          phone: "(555) 123-4567",
          email: "john.smith@realestate.com",
          companyName: "Premier Real Estate Group",
          company: "Premier Real Estate Group",
          website: "www.premierrealestate.com",
          address: "123 Main Street, Beverly Hills, CA 90210",

          // Services and features as direct props
          services: [
            "Property Valuation",
            "Market Analysis",
            "Home Staging",
            "Professional Photography"
          ],
          features: [
            { id: 1, feature_name: "24/7 Support" },
            { id: 2, feature_name: "Free Consultation" },
            { id: 3, feature_name: "Expert Team" },
            { id: 4, feature_name: "Fast Response" }
          ],
          featuresList: [
            "24/7 Support",
            "Free Consultation",
            "Expert Team",
            "Fast Response"
          ],

          // Control props
          readOnly: true,
          isPreview: true,
          editable: false,
          preview: true,
          onChange: () => { },
          onSave: () => { },
          onUpdate: () => { },
        };

        // Create a service-like object for templates that expect a 'service' prop
        const dummyService = {
          id: 1,
          title: "Professional Real Estate Services",
          headline: "Professional Real Estate Services",
          description: "We provide comprehensive real estate services including property management, buying, selling, and investment consulting.",
          serviceType: "Real Estate Services",
          service_type: "Real Estate Services",
          // Images
          heroImage: heroPropertyImage,
          image: heroPropertyImage,
          mainImage: heroPropertyImage,
          secondaryImage: heroproperties,
          photo: heroPropertyImage,
          photos: [heroPropertyImage, heroproperties, landscaping],
          images: [heroPropertyImage, heroproperties, landscaping],
          // Contact
          phone: "(555) 123-4567",
          email: "john.smith@realestate.com",
          address: "123 Main Street, Beverly Hills, CA 90210",
          website: "www.premierrealestate.com",
          agentName: "John Smith",
          name: "John Smith",
          companyName: "Premier Real Estate Group",
          // Features
          features: [
            { id: 1, feature_name: "24/7 Support" },
            { id: 2, feature_name: "Free Consultation" },
            { id: 3, feature_name: "Expert Team" },
            { id: 4, feature_name: "Fast Response" }
          ],
        };

        return (
          <div className="flex min-h-[calc(95vh-140px)] w-full min-w-0 flex-col">
            {/* HEADER */}
            <div className="text-center mb-2 shrink-0">
              <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-primary">
                Service Template Gallery
              </h2>
              <p className="text-xs sm:text-sm text-muted-foreground">
                Choose from professionally designed templates for your service launch.
              </p>
            </div>
            {/* FILTER BAR */}
            <div className="mb-4 w-full">
              <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-3">

                {/* Search — full width on mobile, capped on xl */}
                <div className="w-full xl:max-w-[300px]">
                  <div className="relative w-full">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                    <Input
                      className="pl-9 h-10 w-full"
                      placeholder="Search templates..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>

                {/* Controls row */}
                <div className="flex items-center justify-between xl:justify-end gap-2 flex-wrap sm:flex-nowrap">

                  {/* Filter buttons */}
                  <div className="flex items-center gap-2">
                    {[
                      { label: "All", value: "all" },
                      { label: "1 Photo", value: 1 },
                      { label: "2 Photos", value: 2 },
                    ].map((item) => (
                      <Button
                        key={item.label}
                        size="sm"
                        onClick={() => setPhotoFilter(item.value)}
                        variant={photoFilter === item.value ? "default" : "outline"}
                        className="h-10 px-4 text-sm whitespace-nowrap"
                      >
                        {item.label}
                      </Button>
                    ))}
                  </div>

                  <Button
                    size="sm"
                    className="relative h-10 px-4 text-sm text-gray-700 bg-gray-200 hover:bg-gray-300 whitespace-nowrap flex items-center gap-2 shrink-0 group overflow-visible"
                    onClick={() => setOpen(true)}
                  >
                    <Layout className="h-4 w-4 shrink-0" />
                    <span>Create Custom Template</span>

                    {/* Hover tooltip — overflow-visible on button is required */}
                    <span className="pointer-events-none absolute -top-9 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-md bg-gradient-to-r from-red-500 to-red-600 px-2.5 py-1 text-xs font-semibold text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-50">
                      Coming Soon
                    </span>
                  </Button>
                </div>

              </div>
            </div>

            {/* GRID - 2 columns for service templates */}
            <div className="flex-1 pb-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 md:gap-6">
                {(filteredServiceTemplates.length > 0 ? filteredServiceTemplates : serviceTemplates)
                  .filter((template) =>
                    photoFilter === "all"
                      ? true
                      : template.photoCount === photoFilter
                  )
                  .map((template) => {
                    const TemplateComponent = template.component;
                    const isSelected = selectedServiceTemplate?.id === template.id;

                    return (
                      <Card
                        key={template.id}
                        onClick={() => handleSelectServiceTemplate(template)}
                        className={`
                          relative cursor-pointer border-2 transition-all overflow-hidden
                          ${isSelected
                            ? "border-primary ring-2 ring-primary/30"
                            : "hover:border-primary/50"
                          }
                        `}
                      >
                        <CardContent className="p-0 flex flex-col">
                          {isSelected && (
                            <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/30 rounded-lg">
                              <CheckCircle2 className="h-12 w-12 sm:h-16 sm:w-16 md:h-20 md:w-20 text-green-500 drop-shadow-lg" />
                            </div>
                          )}

                          <ServiceTemplatePreview
                            template={template}
                            serviceDummyData={serviceDummyData}
                            dummyService={dummyService}
                          />

                          {/* Template Info */}
                          <div className="p-2 sm:p-3 md:p-4 flex flex-col gap-1 sm:gap-2 bg-white">
                            <div>
                              <div className="flex justify-between items-center">
                                <span className="text-xs sm:text-sm font-semibold text-gray-900 truncate">
                                  {template.name}
                                </span>
                                <span className="flex items-center gap-1 text-xs sm:text-sm shrink-0">
                                  <Star className="h-3 w-3 sm:h-4 sm:w-4 fill-yellow-400 text-yellow-400" />
                                  {template.rating}
                                </span>
                              </div>

                              <div className="flex gap-1 sm:gap-2 mt-1 sm:mt-2 flex-wrap">
                                <Badge variant="secondary" className="text-[9px] sm:text-[10px]">
                                  {template.tag || "Service"}
                                </Badge>
                                <Badge variant="outline" className="text-[9px] sm:text-[10px]">
                                  {template.photoCount} Photo{template.photoCount > 1 ? 's' : ''}
                                </Badge>
                              </div>
                            </div>

                            <div className="flex justify-between text-[9px] sm:text-[11px] text-muted-foreground pt-1">
                              <span>{template.uses?.toLocaleString() || 0} uses</span>
                              <span>{template.category}</span>
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                    );
                  })}
              </div>
            </div>

            {/* FOOTER */}
            <div className="mt-3 flex shrink-0 flex-col gap-2 border-t pt-3 sm:mt-4 sm:flex-row sm:justify-between sm:pt-4">
              <Button variant="outline" onClick={handleBack} className="w-full text-xs sm:w-auto sm:text-sm">
                <ArrowLeft className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                Back
              </Button>

              <Button
                disabled={!selectedServiceTemplate}
                onClick={() => {
                  if (!selectedServiceTemplate) {
                    toast({
                      title: "Select a Template",
                      description: "Please select a template before continuing.",
                      variant: "destructive",
                      duration: 1000
                    });
                    return;
                  }
                  // Clear multi-service mode flags when continuing from Step 3 with a selected template
                  try {
                    sessionStorage.removeItem("isMultiServiceMode");
                    sessionStorage.removeItem("multiSelectedServices");
                    sessionStorage.removeItem("multiSelectedServiceTemplateIds");
                  } catch (e) {
                    console.warn("Could not clear multi-service session storage:", e);
                  }
                  setSelectedMultipleServiceTemplates([]);
                  setMultiSelectedServices([]);
                  setIsMultipleServiceTemplateMode(false);
                  setCurrentStep(4);
                }}
                className={`
                  w-full text-white text-xs sm:w-auto sm:text-sm
                  ${selectedServiceTemplate
                    ? "bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 hover:from-blue-500 hover:via-blue-600 hover:to-blue-700"
                    : "bg-blue-200 cursor-not-allowed"
                  }
                `}
              >
                Continue
                <ArrowRight className="h-3 w-3 sm:h-4 sm:w-4 ml-1 sm:ml-2" />
              </Button>
            </div>
          </div>
        );
      // =========================================================================
      // STEP 4: Template Preview/Edit (Property) OR Dataset Selection (Service)
      // =========================================================================
      case 4:
        // =========================================================================
        // MULTI-MODE CHECKS FIRST
        // =========================================================================
        if (campaignType === "property") {
          const isMultiMode = sessionStorage.getItem("isMultiPropertyMode") === "true";
          let multiProperties = multiSelectedProperties;

          if ((!multiProperties || multiProperties.length === 0) && isMultiMode) {
            try {
              const stored = sessionStorage.getItem("multiSelectedProperties");
              if (stored) {
                multiProperties = JSON.parse(stored);
              }
            } catch (e) {
              console.warn("Could not restore multi properties");
            }
          }

          if (isMultiMode && multiProperties && multiProperties.length > 0) {
            let templateIds: (string | number)[] = [];
            try {
              const storedIds = sessionStorage.getItem("multiSelectedTemplateIds");
              if (storedIds) templateIds = JSON.parse(storedIds);
            } catch (e) { }

            return (
              <MultiPropertyPreviewPage
                properties={multiProperties}
                getFullUrl={getFullUrl}
                selectedTemplateCount={(templateIds || selectedMultipleTemplates || []).length}
                onBack={() => {
                  requestStepNavigation(3, () => {
                    setIsMultipleTemplateMode(true);
                  });
                }}
                onContinue={() => {
                  // MultiPropertyPreviewPage already saved its up-to-date
                  // properties (including any Edit Image crops) to
                  // sessionStorage before calling onContinue. Read that back
                  // into multiSelectedProperties so the next step — and the
                  // final send payload, which prefers this in-memory state
                  // over sessionStorage — use the edited data instead of the
                  // stale snapshot from when properties were first selected.
                  try {
                    const stored = sessionStorage.getItem("multiSelectedProperties");
                    if (stored) {
                      const updated = JSON.parse(stored);
                      if (Array.isArray(updated) && updated.length > 0) {
                        setMultiSelectedProperties(updated);
                      }
                    }
                  } catch (e) {
                    console.warn("Could not sync properties from preview:", e);
                  }
                  setCurrentStep(5);
                }}
              />
            );
          }
        } else if (campaignType === "service") {
          // Check for multi-service mode
          const isMultiServiceMode = sessionStorage.getItem("isMultiServiceMode") === "true";
          let multiServices = multiSelectedServices;

          if ((!multiServices || multiServices.length === 0) && isMultiServiceMode) {
            try {
              const stored = sessionStorage.getItem("multiSelectedServices");
              if (stored) {
                multiServices = JSON.parse(stored);
              }
            } catch (e) {
              console.warn("Could not restore multi services");
            }
          }

          if (isMultiServiceMode && multiServices && multiServices.length > 0) {
            let templateIds: (string | number)[] = [];
            try {
              const storedIds = sessionStorage.getItem("multiSelectedServiceTemplateIds");
              if (storedIds) templateIds = JSON.parse(storedIds);
            } catch (e) { }

            return (
              <MultiServicePreviewPage
                services={multiServices}
                getFullUrl={getFullUrl}
                selectedTemplateCount={(templateIds || selectedMultipleServiceTemplates || []).length}
                onBack={() => {
                  requestStepNavigation(2, () => {
                    setIsMultipleServiceTemplateMode(true);
                    try {
                      const stored = sessionStorage.getItem("multiSelectedServices");
                      if (stored) {
                        const updated = JSON.parse(stored);
                        if (Array.isArray(updated) && updated.length > 0) {
                          setMultiSelectedServices(updated);
                          setSavedServices((prev) => {
                            const byId = new Map(prev.map((s) => [String(s.id), s]));
                            updated.forEach((svc: any) => {
                              const id = String(svc.id);
                              const heroUrl = svc.image || svc.hero_image_url || svc.hero_image || "";
                              byId.set(id, {
                                ...(byId.get(id) || {}),
                                ...svc,
                                id,
                                image: heroUrl ? getFullUrl(heroUrl) : "",
                                hero_image_url: heroUrl ? getFullUrl(heroUrl) : "",
                              });
                            });
                            return Array.from(byId.values());
                          });
                        }
                      }
                    } catch (e) {
                      console.warn("Could not sync services from preview:", e);
                    }
                  });
                }}
                onContinue={() => {
                  // MultiServicePreviewPage saves updated services to sessionStorage before calling onContinue
                  try {
                    const stored = sessionStorage.getItem("multiSelectedServices");
                    if (stored) {
                      const updated = JSON.parse(stored);
                      if (Array.isArray(updated) && updated.length > 0) {
                        setMultiSelectedServices(updated);
                        setSavedServices((prev) => {
                          const byId = new Map(prev.map((s) => [String(s.id), s]));
                          updated.forEach((svc: any) => {
                            const id = String(svc.id);
                            const heroUrl = svc.image || svc.hero_image_url || svc.hero_image || "";
                            byId.set(id, {
                              ...(byId.get(id) || {}),
                              ...svc,
                              id,
                              image: heroUrl ? getFullUrl(heroUrl) : "",
                              hero_image_url: heroUrl ? getFullUrl(heroUrl) : "",
                            });
                          });
                          return Array.from(byId.values());
                        });
                      }
                    }
                  } catch (e) {
                    console.warn("Could not sync services after preview:", e);
                  }
                  setCurrentStep(5);
                }}
              />
            );
          }
        }

        // =========================================================================
        // SINGLE TEMPLATE MODE - PROPERTY
        // =========================================================================
        if (campaignType === "property") {
          let currentTemplate = selectedTemplate;
          if (!currentTemplate && !isAutoAIMode) {
            try {
              const savedTemplateId =
                sessionStorage.getItem("selectedTemplateId");
              if (savedTemplateId) {
                const foundTemplate = filteredTemplates.find(
                  (t) => String(t.id) === savedTemplateId
                );
                if (foundTemplate) {
                  currentTemplate = foundTemplate;

                  setSelectedTemplate(foundTemplate);

                }
              }
            } catch (e) {
              console.warn("Could not restore template from session storage");
            }
          }

          let currentProperty = selectedProperty;
          if (!currentProperty) {
            try {
              const savedPropertyId =
                sessionStorage.getItem("selectedPropertyId");
              if (savedPropertyId) {

              }
            } catch (e) {
              console.warn("Could not restore property from session storage");
            }
          }

          const hasTemplate =
            currentTemplate || (isAutoAIMode && autoAITemplateId);

          if (!hasTemplate && !currentProperty) {
            return (
              <div className="text-center py-20">
                <AlertCircle className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
                <p className="text-lg text-muted-foreground mb-2">
                  No template or property selected.
                </p>
                <p className="text-sm text-muted-foreground mb-4">
                  Please go back and make your selections.
                </p>
                <div className="flex gap-3 justify-center mt-4">
                  <Button variant="outline" onClick={() => requestStepNavigation(2)}>
                    Select Property
                  </Button>
                  <Button onClick={() => requestStepNavigation(3)}>
                    Select Template
                  </Button>
                </div>
              </div>
            );
          }

          if (!hasTemplate) {
            return (
              <div className="text-center py-20">
                <AlertCircle className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
                <p className="text-lg text-muted-foreground">
                  No template selected.
                </p>
                <p className="text-sm text-muted-foreground mb-4">
                  Please select a template to continue.
                </p>
                <Button onClick={() => requestStepNavigation(3)} className="mt-4">
                  Go to Template Gallery
                </Button>
              </div>
            );
          }

          if (!currentProperty) {
            return (
              <div className="text-center py-20">
                <AlertCircle className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
                <p className="text-lg text-muted-foreground">
                  No property selected.
                </p>
                <p className="text-sm text-muted-foreground mb-4">
                  Please select a property to continue.
                </p>
                <Button onClick={() => requestStepNavigation(2)} className="mt-4">
                  Select Property
                </Button>
              </div>
            );
          }

          // Get the template component - prioritize Auto AI selection
          const activeTemplate =
            isAutoAIMode && autoAITemplateId
              ? AUTO_AI_TEMPLATES[autoAITemplateId]
              : currentTemplate;

          if (!activeTemplate) {
            return (
              <div className="text-center py-20">
                <AlertCircle className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
                <p className="text-lg text-muted-foreground">
                  Template not found.
                </p>
                <Button onClick={() => requestStepNavigation(3)} className="mt-4">
                  Go to Template Gallery
                </Button>
              </div>
            );
          }

          // =========================================================================
          // MERGED PREVIEW PROPERTY
          // =========================================================================
          const {
            propertyListType: currentPropertyListType,
            ...currentPropertyWithoutListType
          } = currentProperty || {};
          const previewPropertyListType =
            propertyLists.find((l) => l.list_name === selectedPropertyList) ||
            currentPropertyListType;

          //-------- IMPORTANT NOTE ---------------
          // Please do not change it it will cause issue like Property feature not adding
          const previewProperty = {
            ...currentPropertyWithoutListType,
            title: propertyData?.headline || currentProperty?.title || "",

            price: (() => {
              if (
                propertyData?.price !== undefined &&
                propertyData?.price !== null &&
                propertyData?.price !== ""
              ) {
                const priceValue =
                  typeof propertyData.price === "string"
                    ? propertyData.price.replace(/[^0-9.-]+/g, "")
                    : String(propertyData.price);
                const numPrice = Number(priceValue);
                return !isNaN(numPrice)
                  ? numPrice
                  : currentProperty?.price || 0;
              }
              return currentProperty?.price || 0;
            })(),

            address: propertyData?.address || currentProperty?.address || "",
            city: propertyData?.city || currentProperty?.city || "",
            state: propertyData?.state || currentProperty?.state || "",
            bedrooms: propertyData?.bedrooms ?? currentProperty?.bedrooms ?? 0,
            bathrooms:
              propertyData?.bathrooms ?? currentProperty?.bathrooms ?? 0,
            area:
              propertyData?.area ?? propertyData?.sqft ?? currentProperty?.area ?? 0,
            sqft:
              propertyData?.sqft ?? propertyData?.area ?? currentProperty?.area ?? 0,
            description:
              propertyData?.description || currentProperty?.description || "",
            text_section:
              propertyData?.text_section || currentProperty?.text_section || "",
            heroImage: propertyData?.heroImage || currentProperty?.heroImage || "",

            // ✅ FIXED: Main image - check multiple sources and fallback to first photo
            image: (() => {
              if (
                propertyData?.heroImage &&
                propertyData.heroImage.trim() !== ""
              ) {
                return propertyData.heroImage;
              }
              if (
                propertyData?.image &&
                propertyData.image.trim() !== ""
              ) {
                return propertyData.image;
              }
              if (
                currentProperty?.image &&
                currentProperty.image.trim() !== ""
              ) {
                return currentProperty.image;
              }
              if (
                currentProperty?.heroImage &&
                currentProperty.heroImage.trim() !== ""
              ) {
                return currentProperty.heroImage;
              }
              if (
                Array.isArray(propertyData?.photos) &&
                propertyData.photos.length > 0 &&
                propertyData.photos[0].trim() !== ""
              ) {
                return propertyData.photos[0];
              }
              if (
                Array.isArray(currentProperty?.photos) &&
                currentProperty.photos.length > 0 &&
                currentProperty.photos[0].trim() !== ""
              ) {
                return currentProperty.photos[0];
              }
              return "";
            })(),

            // ✅ FIXED: Secondary photos - ensure proper array handling
            photos: (() => {
              // Check propertyData first
              if (
                Array.isArray(propertyData?.photos) &&
                propertyData.photos.length > 0
              ) {
                // Filter out empty strings and create new array reference
                return propertyData.photos.filter(
                  (p: string) => p && p.trim() !== ""
                );
              }
              // Fall back to currentProperty
              if (
                Array.isArray(currentProperty?.photos) &&
                currentProperty.photos.length > 0
              ) {
                return currentProperty.photos.filter(
                  (p: string) => p && p.trim() !== ""
                );
              }
              return [];
            })(),

            agentName:
              propertyData?.agentName || currentProperty?.agentName || "",
            agentPhone:
              propertyData?.agentPhone || currentProperty?.agentPhone || "",
            agentEmail:
              propertyData?.agentEmail || currentProperty?.agentEmail || "",
            is_open_house: currentProperty?.is_open_house ?? false,
            propertyListType: previewPropertyListType,

            features: keyFeatures.map((feature) => feature.feature_name || ""),

            // ✅ Add timestamp for change detection
            _lastUpdated: Date.now(),
          };

          const TemplateComponent = activeTemplate.component;

          // =========================================================================
          // EDIT TEMPLATE MODE
          // =========================================================================
          if (isEditingTemplate) {
            return (
              <div className="w-full px-4">
                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-3">
                    <h2 className="text-2xl font-bold text-primary">
                      Edit Template – {activeTemplate.name}
                    </h2>
                    {isAutoAIMode && (
                      <span className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
                        <Wand2 className="h-3 w-3" />
                        AI Selected
                      </span>
                    )}
                  </div>
                  <Button
                    variant="outline"
                    // onClick={() => {
                    //   if (confirmLeaveTemplateEdit()) {
                    //     setIsEditingTemplate(false);
                    //   }
                    // }}
                    onClick={handleCancelTemplateEdit}
                  >
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Cancel
                  </Button>
                </div>

                {/* Info */}
                <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                  <p className="text-sm text-blue-800">
                    <strong>Editing Mode:</strong> Make changes to your template
                    below. Click on any field to edit it directly.
                  </p>
                </div>

                {/* Editor - Render the actual template component in edit mode */}
                <div className="border rounded-xl p-6 bg-white shadow-lg">
                  <div className="w-full max-w-none">
                    <div
                      className="service-template-clean template-fit-fixed-image relative"
                      onChangeCapture={handleTemplateImageInputChangeCapture}
                    >
                      {isTemplateImageLoading && (
                        <div className="absolute inset-0 z-20 flex items-center justify-center bg-white/80 backdrop-blur-sm">
                          <div className="flex flex-col items-center gap-2 rounded-2xl bg-white/90 p-4 shadow-lg">
                            <Loader2 className="h-10 w-10 animate-spin text-blue-600" />
                            <span className="text-sm font-medium text-slate-700">
                              Updating images...
                            </span>
                          </div>
                        </div>
                      )}
                      <TemplateComponent
                        key={`${previewProperty?.heroImage || ''}-${JSON.stringify(previewProperty?.photos || [])}`}
                        property={previewProperty}
                        propertyLists={(() => {
                          const currentListType =
                            previewProperty?.propertyListType ||
                            currentProperty?.propertyListType;
                          if (
                            !currentListType?.list_name ||
                            propertyLists.some(
                              (l) => l.list_name === currentListType.list_name
                            )
                          ) {
                            return propertyLists;
                          }
                          return [
                            ...propertyLists,
                            {
                              id: currentListType.id,
                              list_name: currentListType.list_name,
                            },
                          ];
                        })()}
                        keyFeatures={keyFeatures}
                        selectedPropertyList={
                          selectedPropertyList ||
                          previewProperty?.propertyListType?.list_name ||
                          ""
                        }
                        readOnly={false}
                        onPropertyListCreated={handlePropertyListCreated}
                        onChange={(fields: Record<string, any>) => {
                          const imageKeys = ["heroImage", "hero_image_url", "secondaryImage"];
                          const isNewLocalUpload = imageKeys.some((key) => {
                            const val = fields[key];
                            return (
                              typeof val === "string" &&
                              (val.startsWith("data:image/") || val.startsWith("blob:"))
                            );
                          });
                          if (isNewLocalUpload) {
                            showTemplateImageLoader();
                          }
                          const normalizedFields = { ...fields };
                          if (
                            normalizedFields.sqft !== undefined &&
                            normalizedFields.area === undefined
                          ) {
                            normalizedFields.area = normalizedFields.sqft;
                          }
                          setPropertyData((prev) => ({
                            ...prev,
                            ...normalizedFields,
                          }));
                          setDirtyFields((prev) => {
                            const next = new Set(prev);
                            Object.keys(normalizedFields || {}).forEach((k) => {
                              next.add(k);
                              if (k === "sqft") {
                                next.add("area");
                              }
                            });
                            return next;
                          });
                          setIsDirty(true);
                        }}
                        onDirtyChange={setIsDirty}
                        onPropertyListChange={handlePropertyListChange}
                      />
                    </div>
                  </div>
                </div>

                {/* Actions */}
                <div className="flex justify-between mt-6">
                  <Button
                    variant="outline"
                    onClick={handleCancelTemplateEdit}
                  >
                    Cancel
                  </Button>
                  {/* <Button
                    className="bg-green-600 hover:bg-green-700"
                    onClick={async () => {
                      // Show saving toast first
                      toast({
                        title: "Saving...",
                        description: "Saving updated data...",
                        duration: 1000
                      });

                      try {
                        await saveChanges(false);
                        setIsEditingTemplate(false);
                        setPreviewRefresh((p) => p + 1);
                        toast({
                          title: "Changes Saved",
                          description: "Your updates are applied to preview.",
                          variant: "success",
                          duration: 1000
                        });
                      } catch (error) {
                        toast({
                          title: "Save Failed",
                          description:
                            "Could not save your changes. Please try again.",
                          variant: "destructive",
                        });
                      }
                    }}
                  >
                    <CheckCircle className="mr-2 h-4 w-4" />
                    Save Changes & Preview
                  </Button> */}
                  <Button
                    className="bg-green-600 hover:bg-green-700"
                    disabled={isSaving}
                    onClick={async () => {
                      toast({
                        title: "Saving...",
                        description: "Saving updated data...",
                        duration: 1000
                      });

                      setIsSaving(true);
                      try {
                        await saveChanges(false);
                        setIsEditingTemplate(false);
                        setPreviewRefresh((p) => p + 1);
                        toast({
                          title: "Changes Saved",
                          description: "Your updates are applied to preview.",
                          variant: "success",
                          duration: 1000
                        });
                      } catch (error) {
                        toast({
                          title: "Save Failed",
                          description: "Could not save your changes. Please try again.",
                          variant: "destructive",
                        });
                      } finally {
                        setIsSaving(false);
                      }
                    }}
                  >
                    {isSaving ? (
                      <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    ) : (
                      <CheckCircle className="mr-2 h-4 w-4" />
                    )}
                    Save Changes & Preview
                  </Button>
                </div>
              </div>
            );
          }

          // =========================================================================
          // SEND PROOF EMAIL HANDLER - PROPERTY
          // =========================================================================
          const handleSendProofEmail = async () => {
            if (sendingProof) return;

            if (!subject || subject.trim() === "") {
              toast({
                title: "Subject Required",
                description: "Please enter an email subject before sending a proof.",
                variant: "destructive",
                duration: 1500,
              });
              return;
            }

            // ✅ MOVED HERE — feature check before setSendingProof(true)
            const propSourceCombined = [
              ...(propertyData?.features || []),
              ...((keyFeatures as any[]) || []),
              ...((currentProperty as any)?.features || []),
              ...((currentProperty as any)?.key_features || []),
              ...((currentProperty as any)?.keyFeatures || []),
              ...((originalKeyFeatures as any[]) || []),
            ];
            const propFeatures = propSourceCombined.filter((f: any) => {
              if (!f) return false;
              if (typeof f === "string") return f.trim() !== "";
              return (f.feature_name || f.name || "").toString().trim() !== "";
            });

            if (propFeatures.length === 0) {
              toast({
                title: "Add At Least One Feature",
                description: "Please add at least one key feature to the template before sending a proof.",
                variant: "destructive",
                duration: 1000,
              });
              return; // ✅ exits before setSendingProof(true)
            }

            // ✅ VALIDATION: Check if template has required photos
            if (activeTemplate) {
              const validationPhotos =
                Array.isArray((propertyData as any)?.photos) &&
                  (propertyData as any).photos.length > 0
                  ? (propertyData as any).photos
                  : Array.isArray(currentProperty?.photos) &&
                    currentProperty.photos.length > 0
                    ? currentProperty.photos
                    : selectedProperty?.photos || [];

              const mergedForValidation = {
                ...currentProperty,
                ...propertyData,
                heroImage:
                  (propertyData as any)?.heroImage ||
                  currentProperty?.image ||
                  currentProperty?.image_url ||
                  selectedProperty?.image ||
                  (propertyData as any)?.image ||
                  "",
                photos: validationPhotos,
                photo2: (propertyData as any)?.photo2 || validationPhotos[0] || "",
                photo3: (propertyData as any)?.photo3 || validationPhotos[1] || "",
                photo4: (propertyData as any)?.photo4 || validationPhotos[2] || "",
              } as any;

              const photoValidation = validateTemplatePhotos(activeTemplate, mergedForValidation);
              if (!photoValidation.valid) {
                toast({
                  title: "Photos Required",
                  description: photoValidation.message || "Please add photos to your template",
                  variant: "destructive",
                  duration: 3000,
                });
                return;
              }
            }

            setSendingProof(true);
            await new Promise((resolve) => setTimeout(resolve, 0));
            toast({
              title: "Sending proof email...",
              description: "Generating and sending your launch proof...",
              duration: 1000
            });

            // Ensure user's profile has required fields before sending proof
            try {
              const meRes = await axiosInstance.get(endpoints.me);
              const me = meRes.data || {};
              const missing: string[] = [];
              if (!me.first_name || String(me.first_name).trim() === "")
                missing.push("first name");
              if (!me.last_name || String(me.last_name).trim() === "")
                missing.push("last name");
              if (!me.company || String(me.company).trim() === "")
                missing.push("company");
              if (!me.avatar) missing.push("avatar");
              if (!me.company_logo) missing.push("company logo");

              if (missing.length > 0) {
                toast({
                  title: "Update Profile Required",
                  description: `Please update your profile first. Missing: ${missing.join(", ")}`,
                  variant: "destructive",
                  duration: 1000,
                });
                setSendingProof(false);
                return;
              }
            } catch (err) {
              console.warn("Could not fetch user profile before sending proof:", err);
              toast({
                title: "Profile Check Failed",
                description: "Could not verify your profile. Please try again.",
                variant: "destructive",
              });
              setSendingProof(false);
              return;
            }

            // Ensure we have the latest features from the backend for the selected property
            if (campaignType === "property" && selectedProperty?.id) {
              try {
                setLoadingFeatures(true);
                const res = await axiosInstance.get(endpoints.keyfeatures);
                const fetched = Array.isArray(res.data) ? res.data : [];
                const filtered = fetched.filter(
                  (f: any) => Number(f.propetyId) === Number(selectedProperty.id)
                );
                setKeyFeatures(filtered);
                setOriginalKeyFeatures([...filtered]);
              } catch (err) {
                console.warn("Failed to fetch features before sending proof:", err);
              } finally {
                setLoadingFeatures(false);
              }
            }

            try {
              let generatedImageUrl: string | null = null;

              if (activeTemplate && (currentProperty || propertyData)) {
                try {
                  let sessionHtml = null as string | null;
                  try {
                    sessionHtml = sessionStorage.getItem("campaign_template_html");
                  } catch (e) {
                    sessionHtml = null;
                  }

                  let renderedHtml: string | null =
                    (customDesign && (customDesign as any).html) ||
                    sessionHtml ||
                    (activeTemplate as any).html ||
                    null;

                  try {
                    const freshly = await captureTemplateHTML(activeTemplate, {
                      ...propertyData,
                      ...currentProperty,
                      keyFeatures,
                      propertyListType: propertyLists.find(
                        (l) => l.list_name === selectedPropertyList
                      ),
                    });
                    if (freshly) {
                      renderedHtml = freshly;
                      try {
                        sessionStorage.setItem("campaign_template_html", freshly);
                      } catch (e) {
                        // ignore storage errors
                      }
                    }
                  } catch (e) {
                    // if capture fails, we'll fall back to existing html
                  }

                  const payload = {
                    template_id: (activeTemplate as any).id,
                    property_id: currentProperty?.id || (propertyData as any)?.id || null,
                    html: renderedHtml,
                    property: currentProperty || propertyData,
                    subject: subject || "Your Launch Proof",
                    campaign_type: "property",
                  } as any;

                  const url = endpoints.email_proof;
                  await axiosInstance.post(url, payload);

                  setProofSentCount((c) => c + 1);
                  toast({
                    title: "Proof Email Sent!",
                    description: "Proof sent to your account email using the selected template.",
                    variant: "success",
                    duration: 1000
                  });
                  setSendingProof(false);
                  return;
                } catch (err) {
                  console.warn("Backend proof-send failed, falling back to image upload", {
                    status: (err as any)?.response?.status,
                    data: (err as any)?.response?.data,
                    error: err,
                  });
                }
              }

              // Fallback: Generate image and send
              if (activeTemplate) {
                const html = await captureTemplateHTML(activeTemplate, {
                  ...propertyData,
                  ...currentProperty,
                  keyFeatures,
                  propertyListType: propertyLists.find(
                    (l) => l.list_name === selectedPropertyList
                  ),
                });
                if (html) {
                  generatedImageUrl = await captureTemplateScreenshot(html);
                }
              }

              if (!generatedImageUrl) {
                toast({
                  title: "Error",
                  description: "Could not generate flyer image for proof",
                  variant: "destructive",
                  duration: 1000
                });
                setSendingProof(false);
                return;
              }

              let finalHtmlFallback = null;
              try {
                finalHtmlFallback =
                  (customDesign && (customDesign as any).html) ||
                  sessionStorage.getItem("campaign_template_html") ||
                  (activeTemplate as any)?.html ||
                  null;
              } catch (e) {
                finalHtmlFallback = (activeTemplate as any)?.html || null;
              }

              await axiosInstance.post(endpoints.email_proof, {
                image_url: generatedImageUrl,
                template_id: (activeTemplate as any)?.id || null,
                property_id: currentProperty?.id || (propertyData as any)?.id || null,
                html: finalHtmlFallback,
                property: currentProperty || propertyData,
                subject: subject || "Your Launch Proof",
                campaign_type: "property",
              });

              setProofSentCount((c) => c + 1);
              toast({
                title: "Proof Email Sent!",
                description: "Check your inbox for the launch proof.",
                variant: "success",
                duration: 2000
              });
            } catch (err: any) {
              console.error("Failed to send proof:", {
                status: err?.response?.status,
                data: err?.response?.data,
                error: err,
              });
              toast({
                title: "Failed",
                description: err.response?.data?.error || "Could not send proof email",
                variant: "destructive",
              });
            } finally {
              setSendingProof(false);
            }
          };
          // =========================================================================
          // PREVIEW MODE (READ-ONLY)
          // =========================================================================
          return (
            <div className="template-preview-page template-bottom-safe w-full">
              {/* Header */}
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-primary mb-2">
                  Preview Launch
                </h2>
                <p className="text-muted-foreground">
                  Review how your Launch will look
                </p>
                {isAutoAIMode && (
                  <div className="mt-3 inline-flex items-center gap-2 bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium">
                    <Wand2 className="h-4 w-4" />
                    Auto IQ Generated Template
                  </div>
                )}
              </div>

              {/* ================= Template Info ================= */}
              <div className="mb-12 rounded-xl ">
                {/* TOP ROW */}
                <div className="template-preview-toolbar mb-8 flex items-start justify-between gap-6 px-4 sm:px-6 border border-gray-200 rounded-lg p-5">
                  {/* LEFT: Email Subject */}
                  <div className="flex-1 max-w-xl">
                    <h3 className="text-lg font-semibold mb-3">
                      Email Subject
                    </h3>
                    <Input
                      value={subject}
                      onChange={(e) => {
                        const newSubject = e.target.value;
                        setSubject(newSubject);
                        // Also save immediately to sessionStorage
                        try {
                          sessionStorage.setItem("campaignSubject", newSubject);
                        } catch (err) {
                          console.warn("Could not save subject");
                        }
                      }}
                      placeholder="Enter email subject"
                      className="text-lg font-medium"
                    />
                    <p className="text-sm text-muted-foreground mt-2">
                      This subject will be used for your launch.
                    </p>
                  </div>

                  {/* RIGHT: ACTION BUTTONS */}
                  <div className="template-preview-actions mt-0 pt-1 sm:mt-9">
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => setIsEditingTemplate(true)}
                    >
                      <Pencil className="h-4 w-4" />
                      Edit Template
                    </Button>

                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => {
                        requestStepNavigation(3);
                      }}
                      className=""
                    >
                      <RefreshCw className="h-4 w-4" />
                      Change Template
                    </Button>
                  </div>
                </div>

                {/* Template Selector for Auto AI Mode */}
                {isAutoAIMode && (
                  <div className="mb-6 p-4 bg-purple-50 border border-purple-200 rounded-lg">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <Wand2 className="h-5 w-5 text-purple-600" />
                        <div>
                          <p className="font-medium text-purple-900">
                            Auto IQ Generated Template
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="template-preview-banner mb-4 sm:mb-6 rounded-lg border border-blue-200 bg-blue-50">
                  <p className="text-sm text-blue-800 flex flex-wrap items-start gap-1.5 p-4">
                    <AlertCircle className="h-4 w-4 mt-0.5 flex-shrink-0" />
                    <span>
                      This is a read-only preview. Click <strong>&quot;Edit Template&quot;</strong> to make changes.
                    </span>
                  </p>
                </div>

                {/* ================= PREVIEW (READ-ONLY) ================= */}
                <div
                  className="template-preview-frame relative cursor-pointer"
                  style={{ padding: 0, margin: 0, border: 'none', overflowX: 'auto', WebkitOverflowScrolling: 'touch', transform: 'rotateX(180deg)' }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toast({
                      title: "Preview Mode",
                      description:
                        "Please click the 'Edit Template' button to edit this template.",
                      variant: "default",
                      duration: 1000
                    });
                  }}
                >
                  {/* Preview Content - No interaction */}
                  <div className="template-preview-shell select-none" style={{ padding: 0, margin: 0, overflow: 'visible', display: 'block', width: '100%', minWidth: 'auto', maxWidth: 'none', transform: 'rotateX(180deg)' }}>
                    <TemplateComponent
                      key={`${previewRefresh}-${previewProperty.heroImage || previewProperty.image || ""}-${(previewProperty.photos || []).join(",")}`}
                      property={previewProperty}
                      propertyLists={propertyLists}
                      keyFeatures={keyFeatures}
                      selectedPropertyList={selectedPropertyList}
                      readOnly={true}
                    />
                  </div>
                </div>

              </div>

              {/* Send Proof Email Card */}
              <Card className="template-preview-card border border-blue-200 bg-blue-50/50">
                <CardContent className="p-4">
                  <div className="template-proof-row flex items-start gap-4">
                    <div className="template-proof-icon h-10 w-10 flex-shrink-0 rounded-full bg-blue-100 flex items-center justify-center">
                      <Mail className="h-5 w-5 text-blue-600" />
                    </div>

                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-blue-900 mb-1">
                        Send Proof Email
                      </h3>

                      <p className="text-sm text-blue-800 mb-4">
                        A proof copy of your launch will be sent to your email
                        for final review before launch.
                      </p>

                      <Button
                        size="sm"
                        onClick={handleSendProofEmail}
                        disabled={sendingProof}
                        className="bg-blue-600 hover:bg-blue-700 text-white shadow-sm"
                      >
                        {sendingProof ? (
                          <>
                            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                            Sending…
                          </>
                        ) : proofSentCount > 0 ? (
                          <>
                            <Mail className="mr-2 h-4 w-4" />
                            Resend Proof
                          </>
                        ) : (
                          <>
                            <Mail className="mr-2 h-4 w-4" />
                            Send Proof
                          </>
                        )}
                      </Button>

                      {proofSentCount > 0 && (
                        <div className="mt-3 flex items-center gap-2 text-sm text-green-700">
                          <CheckCircle2 className="h-4 w-4" />
                          <span>Proof email sent. Check your inbox.</span>
                        </div>
                      )}
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Final Approval Checkbox */}
              <Card className="template-preview-card mt-5 border border-amber-300 bg-amber-50/70">
                <CardContent className="p-4 sm:p-5">

                  <label className="flex items-start gap-3 sm:gap-4 cursor-pointer select-none">

                    {/* Checkbox */}
                    <div className="flex-shrink-0 pt-1">
                      <input
                        type="checkbox"
                        checked={isProofApproved}
                        onChange={(e) => setIsProofApproved(e.target.checked)}
                        className="
            h-4 w-4
            sm:h-5 sm:w-5
            rounded-md
            border-amber-400
            text-amber-600
            focus:ring-2
            focus:ring-amber-500
            flex-shrink-0
          "
                      />
                    </div>

                    {/* Text Content */}
                    <div className="min-w-0 flex-1">
                      <p
                        className="
            text-base
            sm:text-lg
            font-semibold
            text-amber-900
            leading-snug
            break-words
          "
                      >
                        I have reviewed and approve this proof as final
                      </p>

                      <p
                        className="
            mt-2
            text-sm
           
            text-amber-800
            leading-relaxed
            break-words
          "
                      >
                        By checking this box, you confirm that all content,
                        images, text, and details are correct and ready to be
                        sent.
                      </p>
                    </div>

                  </label>
                </CardContent>
              </Card>

              {/* Bottom Actions */}
              <div className="template-footer-actions mt-12 flex items-center justify-between gap-3">
                <Button
                  size="lg"
                  variant="outline"
                  onClick={() => {
                    requestStepNavigation(3);
                  }}
                >
                  <ArrowLeft className="mr-2 h-5 w-5" />
                  Back
                </Button>

                {/* Disabled: Old approval flow - now using direct Continue */}
                <Button
                  size="lg"
                  disabled={!(proofSentCount > 0 && isProofApproved) || !subject?.trim()}
                  onClick={async () => {
                    if (!subject || subject.trim() === "") {
                      toast({
                        title: "Subject Required",
                        description:
                          "Please enter an email subject before proceeding.",
                        variant: "destructive",
                      });
                      return;
                    }

                    if (proofSentCount === 0) {
                      toast({
                        title: "Proof Required",
                        description:
                          "Please send and review the proof email first.",
                        variant: "destructive",
                      });
                      return;
                    }

                    if (!isProofApproved) {
                      toast({
                        title: "Approval Required",
                        description:
                          "Please confirm you have reviewed and approved the proof.",
                        variant: "destructive",
                      });
                      return;
                    }

                    await saveChanges(true);
                  }}
                  className={`bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600
                    ${!(proofSentCount > 0 && isProofApproved)
                      ? "opacity-50 cursor-not-allowed"
                      : "hover:from-blue-500 hover:via-blue-600 hover:to-blue-700"
                    }
                  `}
                >
                  Looks Good – Continue
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>


                {/* <Button
                  size="lg"
                  onClick={async () => {
                    const isMultiPropertyMode = sessionStorage.getItem("isMultiPropertyMode") === "true";
                    const isMultiServiceMode = sessionStorage.getItem("isMultiServiceMode") === "true";
                    const isMultiMode = isMultiPropertyMode || isMultiServiceMode;

                    if (!isMultiMode && (!subject || subject.trim() === "")) {
                      toast({
                        title: "Subject Required",
                        description:
                          "Please enter an email subject before proceeding.",
                        variant: "destructive",
                        duration: 1000
                      });
                      return;
                    }
                    await saveChanges(true);
                  }}
                  className="bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 hover:from-blue-500 hover:via-blue-600 hover:to-blue-700 text-white transition"
                >
                  Looks Good – Continue
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button> */}

              </div>
            </div>
          );
        }


        if (campaignType === "service") {

          let currentServiceTemplate = selectedServiceTemplate;
          let currentService = selectedService;
          let currentServiceData = serviceData;

          // Restore template if lost
          if (!currentServiceTemplate) {
            try {
              const savedTemplateId = sessionStorage.getItem("selectedServiceTemplateId");
              if (savedTemplateId) {
                const foundTemplate = serviceTemplates.find(
                  (t) => String(t.id) === savedTemplateId
                );
                if (foundTemplate) {
                  currentServiceTemplate = foundTemplate;
                  setSelectedServiceTemplate(foundTemplate);

                }
              }
            } catch (e) {
              console.warn("Could not restore template from session");
            }
          }

          // Restore service data if lost
          if (!currentServiceData.title && !currentService) {
            try {
              const savedServiceData = sessionStorage.getItem("selectedServiceData");
              if (savedServiceData) {
                const parsedData = JSON.parse(savedServiceData);
                currentServiceData = parsedData;
                setServiceData(parsedData);

              }
            } catch (e) {
              console.warn("Could not restore serviceData from session");
            }
          }

          const TemplateComponent = currentServiceTemplate?.component;

          // =========================================================================
          // VALIDATION CHECKS
          // =========================================================================
          if (!currentServiceTemplate) {
            return (
              <div className="text-center py-20">
                <AlertCircle className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
                <p className="text-lg text-muted-foreground mb-2">No template selected.</p>
                <Button onClick={() => requestStepNavigation(3)} className="mt-4">
                  Go to Template Gallery
                </Button>
              </div>
            );
          }

          if (!currentServiceData.title && !currentService?.title) {
            return (
              <div className="text-center py-20">
                <AlertCircle className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
                <p className="text-lg text-muted-foreground mb-2">No service selected.</p>
                <Button onClick={() => requestStepNavigation(2)} className="mt-4">
                  Select a Service
                </Button>
              </div>
            );
          }

          // =========================================================================
          // BUILD PREVIEW SERVICE DATA - CRITICAL: Merge all sources properly
          // =========================================================================
          const computedPreviewServiceData = {
            // ID
            id: currentService?.id || currentServiceData.id,

            // Title - check serviceData first (edited), then selectedService
            title: currentServiceData.title || currentService?.title || "Untitled Service",

            // Headline
            headline: currentServiceData.headline || currentServiceData.title ||
              currentService?.headline || currentService?.title || "",

            // Service type - check multiple field names
            serviceType: currentServiceData.serviceType || currentServiceData.service_type ||
              currentService?.service_type || currentService?.serviceType || "",
            service_type: currentServiceData.serviceType || currentServiceData.service_type ||
              currentService?.service_type || currentService?.serviceType || "",

            // Description
            description: currentServiceData.description || currentService?.description || "",

            // Contact info
            phone: currentServiceData.phone || currentService?.phone || "",
            email: currentServiceData.email || currentService?.email || "",
            website: currentServiceData.website || currentService?.website || "",
            address: currentServiceData.address || currentService?.address || "",

            // Hero image - check multiple field names
            heroImage: (() => {
              // Check serviceData first
              if (currentServiceData.heroImage && currentServiceData.heroImage.trim() !== "") {
                return currentServiceData.heroImage;
              }
              if (currentServiceData.hero_image_url && currentServiceData.hero_image_url.trim() !== "") {
                return currentServiceData.hero_image_url;
              }
              if (currentServiceData.image && currentServiceData.image.trim() !== "") {
                return currentServiceData.image;
              }
              // Then check currentService
              if (currentService?.hero_image_url && currentService.hero_image_url.trim() !== "") {
                return currentService.hero_image_url;
              }
              if (currentService?.heroImage && currentService.heroImage.trim() !== "") {
                return currentService.heroImage;
              }
              if (currentService?.hero_image && currentService.hero_image.trim() !== "") {
                return currentService.hero_image;
              }
              if (currentService?.image && currentService.image.trim() !== "") {
                return currentService.image;
              }
              return "";
            })(),

            // Secondary image
            secondaryImage: secondaryImage || currentServiceData.secondaryImage ||
              currentService?.secondary_image || "",

            // Photos array
            photos: (() => {
              const heroImageCandidate =
                currentServiceData.heroImage ||
                currentServiceData.hero_image_url ||
                currentServiceData.image ||
                currentService?.hero_image_url ||
                currentService?.heroImage ||
                currentService?.hero_image ||
                currentService?.image ||
                "";

              if (Array.isArray(currentServiceData.photos) && currentServiceData.photos.length > 0) {
                return currentServiceData.photos.filter(
                  (p: string) =>
                    p &&
                    p.trim() !== "" &&
                    p.trim() !== heroImageCandidate
                );
              }
              if (Array.isArray(currentService?.photos) && currentService.photos.length > 0) {
                return currentService.photos.filter(
                  (p: string) =>
                    p &&
                    p.trim() !== "" &&
                    p.trim() !== heroImageCandidate
                );
              }
              return [];
            })(),

            // Features - CRITICAL: Ensure it's a string array
            features: (() => {
              // First try serviceData.features
              let rawFeatures = currentServiceData.features;

              // If empty, try currentService.features
              if (!rawFeatures || (Array.isArray(rawFeatures) && rawFeatures.length === 0)) {
                rawFeatures = currentService?.features;
              }

              if (!rawFeatures || !Array.isArray(rawFeatures)) {
                return [];
              }

              // Normalize to strings
              return rawFeatures
                .map((f: any) => {
                  if (typeof f === "string") return f.trim();
                  if (typeof f === "object" && f !== null) {
                    return (f.name || f.feature_name || "").trim();
                  }
                  return "";
                })
                .filter((f: string) => f.length > 0);
            })(),

            // Subject
            subject: subject || currentServiceData.subject || currentService?.subject || "",
          };

          const previewServiceData = servicePreviewSnapshot
            ? {
              ...servicePreviewSnapshot,
              secondaryImage:
                secondaryImage ||
                servicePreviewSnapshot.secondaryImage ||
                "",
              subject: subject || servicePreviewSnapshot.subject || "",
            }
            : computedPreviewServiceData;

          // =========================================================================
          // SEND PROOF EMAIL HANDLER - SERVICE
          // =========================================================================
          const handleSendServiceProofEmail = async () => {
            if (sendingProof) return;
            setSendingProof(true);

            // ✅ allow React render
            await new Promise((resolve) => setTimeout(resolve, 0));

            if (!subject || subject.trim() === "") {
              toast({
                title: "Subject Required",
                description: "Please enter an email subject before sending a proof.",
                variant: "destructive",
                duration: 1500,
              });
              setSendingProof(false);
              return;
            }
            // Profile validation
            try {
              const meRes = await axiosInstance.get(endpoints.me);
              const me = meRes.data || {};
              const missing: string[] = [];
              if (!me.first_name?.trim()) missing.push("first name");
              if (!me.last_name?.trim()) missing.push("last name");
              if (!me.company?.trim()) missing.push("company");
              if (!me.avatar) missing.push("avatar");
              if (!me.company_logo) missing.push("company logo");

              if (missing.length > 0) {
                toast({
                  title: "Update Profile Required",
                  description: `Missing: ${missing.join(", ")}`,
                  variant: "destructive",
                  duration: 1000
                });
                return;
              }
            } catch (err) {
              console.warn("Profile check failed:", err);
              toast({
                title: "Profile Check Failed",
                description: "Could not verify your profile. Please try again.",
                variant: "destructive",
              });
              return;
            }

            // Feature validation
            if (previewServiceData.features.length === 0) {
              toast({
                title: "Add At Least One Feature",
                description: "Please add at least one key feature before sending a proof.",
                variant: "destructive",
                duration: 1000
              });
              setSendingProof(false);
              return;
            }

            setSendingProof(true);
            await new Promise((resolve) => setTimeout(resolve, 0));
            toast({
              title: "Sending proof email...",
              description: "Generating your service campaign proof...",
              duration: 1000
            });

            try {
              // Use send_service_proof endpoint for service campaigns
              const payload: Record<string, any> = {
                template_id: currentServiceTemplate?.id,
                service_id: currentService?.id,
                service_data: previewServiceData,
                subject: subject || "Your Service Campaign Proof",
                campaign_type: "service", // ✅ Explicitly set campaign type
                features: previewServiceData.features,
                // Include additional service-specific data
                title: previewServiceData.title,
                headline: previewServiceData.headline,
                description: previewServiceData.description,
                service_type: previewServiceData.serviceType || previewServiceData.service_type,
                phone: previewServiceData.phone,
                email: previewServiceData.email,
                website: previewServiceData.website,
                address: previewServiceData.address,
                hero_image_url: previewServiceData.heroImage,
                secondary_image: previewServiceData.secondaryImage,
                photos: previewServiceData.photos,
              };

              if (currentServiceTemplate?.id) {
                payload.template_path = `services/template${currentServiceTemplate.id}.html`;
              }

              await axiosInstance.post(endpoints.send_service_proof, payload);

              setProofSentCount((c) => c + 1);
              toast({
                title: "Proof Email Sent!",
                description: "Check your inbox for your service campaign proof.",
                variant: "success",
                duration: 1000, //  2 seconds
              });

            } catch (err: any) {
              console.error("Service proof send failed:", err);
              toast({
                title: "Failed",
                description: err.response?.data?.error || "Could not send proof email.",
                variant: "destructive",
              });
            } finally {
              setSendingProof(false);
            }
          };

          // =========================================================================
          // EDIT MODE
          // =========================================================================
          if (isEditingTemplate) {
            return (
              <div className="w-full">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-bold text-primary">
                    Edit Template – {currentServiceTemplate?.name}
                  </h2>
                  <Button
                    variant="outline"
                    // onClick={() => {
                    //   if (confirmLeaveTemplateEdit()) {
                    //     setIsEditingTemplate(false);
                    //   }
                    // }}
                    onClick={handleCancelTemplateEdit}
                  >
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Cancel
                  </Button>
                </div>

                <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                  <p className="text-sm text-blue-800">
                    <strong>Editing Mode:</strong> Click on any field to edit it directly.
                  </p>
                </div>

                <div className="border rounded-xl overflow-hidden bg-white shadow-lg mb-8">
                  <div className="p-8 max-w-5xl mx-auto">
                    <div
                      className="template-fit-fixed-image relative"
                      onChangeCapture={handleTemplateImageInputChangeCapture}
                    >
                      {isTemplateImageLoading && (
                        <div className="absolute inset-0 z-20 flex items-center justify-center bg-white/80 backdrop-blur-sm">
                          <div className="flex flex-col items-center gap-2 rounded-2xl bg-white/90 p-4 shadow-lg">
                            <Loader2 className="h-10 w-10 animate-spin text-blue-600" />
                            <span className="text-sm font-medium text-slate-700">
                              Updating images...
                            </span>
                          </div>
                        </div>
                      )}
                      {TemplateComponent && (
                        <TemplateComponent
                          key={`edit-${previewRefresh}-${currentServiceTemplate?.id}-${previewServiceData.title}-${previewServiceData.description}-${previewServiceData.heroImage || ""}`}
                          serviceData={previewServiceData}
                          readOnly={false}
                          onChange={(updatedFields: Record<string, any>) => {
                            const imageKeys = ["heroImage", "hero_image_url", "secondaryImage"];
                            const isNewLocalUpload = imageKeys.some((key) => {
                              const val = updatedFields[key];
                              return (
                                typeof val === "string" &&
                                (val.startsWith("data:image/") || val.startsWith("blob:"))
                              );
                            });
                            if (isNewLocalUpload) {
                              showTemplateImageLoader();
                            }

                            if (updatedFields.secondaryImage !== undefined) {
                              setSecondaryImage(updatedFields.secondaryImage);
                            }

                            // Handle photos and photos_urls updates
                            if (updatedFields.photos !== undefined || updatedFields.photos_urls !== undefined) {
                              setServiceData((prev) => ({
                                ...prev,
                                photos: updatedFields.photos !== undefined ? updatedFields.photos : prev.photos,
                                photos_urls: updatedFields.photos_urls !== undefined ? updatedFields.photos_urls : prev.photos_urls,
                              }));
                            }

                            // Normalize features if updated
                            if (updatedFields.features && Array.isArray(updatedFields.features)) {
                              updatedFields.features = updatedFields.features
                                .map((f: any) => typeof f === "string" ? f : (f.name || f.feature_name || ""))
                                .filter((f: string) => f.trim() !== "");
                            }

                            // Remove secondaryImage from updatedFields since we handle it separately
                            const { secondaryImage, photos, photos_urls, ...restFields } = updatedFields;
                            setServiceData((prev) => ({ ...prev, ...restFields }));
                            setIsDirty(true);
                          }}
                          onDirtyChange={setIsDirty}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex justify-between">
                  <Button variant="outline" onClick={handleCancelServiceTemplateEdit}>
                    Cancel
                  </Button>
                  {/* <Button
                    className="bg-green-600 hover:bg-green-700"
                    onClick={async () => {
                      if (currentService?.id) {
                        await saveServiceChanges(false);
                      }
                      setIsEditingTemplate(false);
                      setPreviewRefresh((p) => p + 1);
                      toast({ title: "Changes Saved", duration: 1000 });
                    }}
                  >
                    <CheckCircle className="mr-2 h-4 w-4" />
                    Save Changes & Preview
                  </Button> */}
                  <Button
                    className="bg-green-600 hover:bg-green-700"
                    disabled={isSaving}
                    onClick={async () => {
                      setIsSaving(true);
                      try {
                        if (currentService?.id) {
                          const saved = await saveServiceChanges(false);
                          if (saved) {
                            setServicePreviewSnapshot(saved);
                          }
                        }
                        setIsEditingTemplate(false);
                        setPreviewRefresh((p) => p + 1);
                        setServiceEditSnapshot(null);
                        setServiceKeyFeaturesSnapshot([]);
                        setIsDirty(false);
                        setDirtyFields(new Set());
                        toast({ title: "Changes Saved", duration: 1000 });
                      } finally {
                        setIsSaving(false);
                      }
                    }}
                  >
                    {isSaving ? (
                      <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    ) : (
                      <CheckCircle className="mr-2 h-4 w-4" />
                    )}
                    Save Changes & Preview
                  </Button>
                </div>
              </div>
            );
          }

          // =========================================================================
          // PREVIEW MODE
          // =========================================================================
          return (
            <div className="template-preview-page template-bottom-safe w-full">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-primary mb-2">Preview Launch</h2>
                <p className="text-muted-foreground">
                  Review how your Launch will look </p>
              </div>

              <div className="mb-12 " style={{ paddingLeft: 0, paddingRight: 0 }}>
                {/* Subject & Actions */}
                {/* Subject & Actions */}
                <div className="border border-gray-200 rounded-2xl mb-8 bg-white shadow-sm p-5 sm:p-6">
                  <div className="flex flex-col gap-3">

                    {/* Email Subject Label */}
                    <label className="block text-[15px] sm:text-lg font-semibold text-slate-900">
                      Email Subject
                    </label>

                    {/* Subject Input + Buttons on same row */}
                    <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap">

                      <Input
                        value={subject}
                        onChange={(e) => {
                          setSubject(e.target.value);
                          sessionStorage.setItem("campaignSubject", e.target.value);
                        }}
                        placeholder="Enter email subject"
                        className="
        flex-1 min-w-0
        h-10 sm:h-12
        rounded-xl
        border border-slate-300
        bg-white
        px-4
        text-sm sm:text-base
        shadow-sm
        transition-all
        focus-visible:ring-2
        focus-visible:ring-black
        focus-visible:border-black
        placeholder:text-slate-400
      "
                      />

                      <Button
                        size="sm"
                        variant="outline"
                        className="
        h-10 sm:h-12
        rounded-xl
        border-slate-300
        bg-white
        px-3 sm:px-5
        text-sm font-medium
        hover:bg-slate-50
        hover:border-slate-400
        transition-all
        whitespace-nowrap
        shrink-0
      "
                        // onClick={() => {
                        //   setServiceEditSnapshot({
                        //     ...serviceData,
                        //     features: Array.isArray(serviceData.features) ? [...serviceData.features] : [],
                        //     photos: Array.isArray(serviceData.photos) ? [...serviceData.photos] : [],
                        //     photos_urls: Array.isArray(serviceData.photos_urls) ? [...serviceData.photos_urls] : [],
                        //   });
                        //   setServiceKeyFeaturesSnapshot(
                        //     Array.isArray(serviceData.features) ? [...serviceData.features] : []
                        //   );
                        //   setServicePreviewSnapshot(null);
                        //   setIsEditingTemplate(true);
                        // }}
                        onClick={() => {
                          setServiceEditSnapshot({
                            ...serviceData,
                            features: Array.isArray(serviceData.features) ? [...serviceData.features] : [],
                            photos: Array.isArray(serviceData.photos) ? [...serviceData.photos] : [],
                            photos_urls: Array.isArray(serviceData.photos_urls) ? [...serviceData.photos_urls] : [],
                          });
                          setServiceKeyFeaturesSnapshot(Array.isArray(serviceData.features) ? [...serviceData.features] : []);
                          setServicePreviewSnapshot(null);
                          setIsEditingTemplate(true);
                        }}
                      >
                        <Pencil className="mr-1 sm:mr-2 h-4 w-4" />
                        <span className="hidden xs:inline">Edit Template</span>
                        <span className="xs:hidden">Edit Template</span>
                      </Button>

                      <Button
                        size="sm"
                        variant="outline"
                        className="
        h-10 sm:h-12
        rounded-xl
        border-slate-300
        bg-white
        px-3 sm:px-5
        text-sm font-medium
        hover:bg-slate-50
        hover:border-slate-400
        transition-all
        whitespace-nowrap
        shrink-0
      "
                        onClick={() => requestStepNavigation(3)}
                      >
                        <RefreshCw className="mr-1 sm:mr-2 h-4 w-4" />
                        <span className="hidden xs:inline">Change Template</span>
                        <span className="xs:hidden">Change Template</span>
                      </Button>

                    </div>
                  </div>
                </div>

                {/* Template Preview */}
                <div className="template-preview-banner mb-4 sm:mb-6 rounded-lg border border-blue-200 bg-blue-50">
                  <p className="text-sm text-blue-800 flex flex-wrap items-start gap-1.5 p-4">
                    <AlertCircle className="h-4 w-4 mt-0.5 flex-shrink-0" />
                    <span>
                      This is a read-only preview. Click <strong>&quot;Edit Template&quot;</strong> to make changes.
                    </span>
                  </p>
                </div>

                <div
                  className="template-preview-frame relative cursor-pointer overflow-x-auto rounded-xl border"
                  style={{ padding: 0, margin: 0, overflowX: 'auto', overflowY: 'hidden' }}
                  onClick={() => toast({ title: "Preview Mode", description: "Click 'Edit Template' to make changes.", duration: 1000 })}
                >
                  <div className="service-template-clean template-preview-shell select-none"
                    style={{ padding: 0, margin: 0, display: 'block', width: '100%' }}>
                    {TemplateComponent && (
                      <TemplateComponent
                        key={`preview-${previewRefresh}-${currentServiceTemplate?.id}-${previewServiceData.title}-${previewServiceData.description}-${previewServiceData.heroImage || ""}-${(previewServiceData.features || []).join("|")}`}
                        serviceData={previewServiceData}
                        readOnly={true}
                      />
                    )}
                  </div>
                </div>

              </div>

              {/* Proof Email */}
              <Card className="template-preview-card border border-blue-200 bg-blue-50/50">
                <CardContent className="p-4">
                  <div className="template-proof-row flex items-start gap-4">
                    <div className="template-proof-icon h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center">
                      <Mail className="h-5 w-5 text-blue-600" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-blue-900 mb-1">Send Proof Email</h3>
                      <p className="text-sm text-blue-800 mb-4">A proof copy of your launch will be sent to your email
                        for final review before launch..</p>
                      {proofSentCount > 0 && (
                        <div className="flex items-center gap-2 mb-3 text-green-700">
                          <CheckCircle2 className="h-5 w-5" />
                          <span>Sent: {proofSentCount}</span>
                        </div>
                      )}
                      <Button
                        size="sm"
                        onClick={handleSendServiceProofEmail}
                        disabled={sendingProof}
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                      >
                        {sendingProof ? (
                          <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Sending…</>
                        ) : (
                          <><Mail className="mr-2 h-4 w-4" />{proofSentCount > 0 ? "Resend" : "Send"} Proof</>
                        )}
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Approval */}
              <Card className="template-preview-card mt-5 border border-amber-300 bg-amber-50/70">
                <CardContent className="p-5">
                  <label className="flex items-start gap-3 sm:gap-4 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={isProofApproved}
                      onChange={(e) => setIsProofApproved(e.target.checked)}
                      className="mt-1 h-5 w-5 shrink-0 flex-none accent-amber-600"
                    />

                    <div className="min-w-0">
                      <p className="text-base sm:text-lg font-semibold text-amber-900 mb-1 leading-snug">
                        I have reviewed and approve this proof as final
                      </p>

                      <p className="text-sm text-amber-800 leading-relaxed">
                        By checking this box, you confirm that all content,
                        images, text, and details are correct and ready to be
                        sent.
                      </p>
                    </div>
                  </label>
                </CardContent>
              </Card>

              {/* Actions */}
              <div className="template-footer-actions mt-12 flex justify-between gap-3">
                <Button size="lg" variant="outline" onClick={() => requestStepNavigation(3)}>
                  <ArrowLeft className="mr-2 h-5 w-5" />
                  Back
                </Button>

                <Button
                  size="lg"
                  disabled={!(proofSentCount > 0 && isProofApproved) || !subject?.trim()}
                  onClick={async () => {
                    if (!subject || subject.trim() === "") {
                      toast({
                        title: "Subject Required",
                        description:
                          "Please enter an email subject before proceeding.",
                        variant: "destructive",
                      });
                      return;
                    }

                    if (proofSentCount === 0) {
                      toast({
                        title: "Proof Required",
                        description:
                          "Please send and review the proof email first.",
                        variant: "destructive",
                      });
                      return;
                    }

                    if (!isProofApproved) {
                      toast({
                        title: "Approval Required",
                        description:
                          "Please confirm you have reviewed and approved the proof.",
                        variant: "destructive",
                      });
                      return;
                    }

                    await saveChanges(true);
                  }}
                  className={`bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600
                    ${!(proofSentCount > 0 && isProofApproved)
                      ? "opacity-50 cursor-not-allowed"
                      : "hover:from-blue-500 hover:via-blue-600 hover:to-blue-700"
                    }
                  `}
                >
                  Looks Good – Continue
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>

                {/* Send Campaign Button */}
                {/* <Button
                  size="lg"
                  onClick={async () => {
                    if (!subject?.trim()) {
                      toast({ title: "Subject Required", variant: "destructive", duration: 1000 });
                      return;
                    }
                    if (previewServiceData.features.length === 0) {
                      toast({ title: "Features Required", description: "Add at least one feature.", variant: "destructive", duration: 1000 });
                      return;
                    }
                    await saveServiceCampaignData(true);
                  }}
                  className="bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 hover:from-blue-500 hover:via-blue-600 hover:to-blue-700 text-white"
                >
                  Looks Good – Continue
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>  */}

              </div>
            </div>
          );
        }

        // If we reach here and no return happened, something went wrong
        return null;

      // =========================================================================
      // STEP 5: Dataset Selection (Property / Service)
      // =========================================================================
      case 5:
        // Unified recipients selection for both Property and Service campaigns
        if (campaignType === "property" || campaignType === "service") {
          const selectedHubCount =
            (sendTo.database ? selectedDatasets.length : 0) +
            (sendTo.mycontacts ? selectedCustomDatasets.length : 0);

          return (
            <div className="w-full max-w-5xl mx-auto">
              <h2 className="text-2xl font-bold text-primary mb-8 text-center">
                Select Recipients
              </h2>

              {/*  NEW: Trial status badge (shows only when user is in an active trial) */}
              {(user as any)?.is_in_active_trial && (
                <>
                  {/* Non-paid plan trial users */}
                  {!(user as any)?.stripe_subscription_id && !(user as any)?.plan ? (
                    <div className="mb-6 p-4 border-l-4 border-orange-400 bg-orange-50 rounded-lg">
                      <div className="flex items-start gap-3">
                        <AlertCircle className="h-5 w-5 text-orange-600 flex-shrink-0 mt-0.5" />
                        <div className="flex-1">
                          <p className="text-sm font-semibold text-orange-900">
                            Free Trial - {(user as any)?.remaining_trial_campaigns ?? 0} of {(user as any)?.trial_campaigns_limit ?? 2} Launches Remaining
                          </p>
                          <p className="text-xs text-orange-700 mt-1">
                            Your free 7-day trial gives you {(user as any)?.trial_campaigns_limit ?? 2} launches. {(user as any)?.remaining_trial_campaigns === 1
                              ? "This is your last launch!"
                              : (user as any)?.remaining_trial_campaigns === 0
                                ? "You've reached your trial limit."
                                : ""}
                          </p>
                          {(user as any)?.remaining_trial_campaigns === 0 && (
                            <Button
                              size="sm"
                              variant="link"
                              className="mt-2 text-orange-700 underline p-0 h-auto"
                              onClick={() => setShowPricingModal(true)}
                            >
                              Upgrade to Pro →
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    // Paid plan users in trial (will be charged once trial launches are exhausted)
                    <div className="mb-6 p-4 border-l-4 border-blue-400 bg-blue-50 rounded-lg">
                      <div className="flex items-start gap-3">
                        <Info className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                        <div className="flex-1">
                          <p className="text-sm font-semibold text-blue-900">
                            Free Trial Active - {(user as any)?.remaining_trial_campaigns ?? 0} Launches Remaining
                          </p>
                          <p className="text-xs text-blue-700 mt-1">
                            {(user as any)?.remaining_trial_campaigns > 0
                              ? `Your next ${(user as any)?.remaining_trial_campaigns} launches are free as part of your trial.`
                              : "Your trial launches are exhausted. Additional launches will be charged according to your plan."}
                          </p>
                          {/* {(user as any)?.remaining_trial_campaigns === 0 && (
                            <div className="mt-3">
                              <Button
                                size="sm"
                                variant="outline"
                                onClick={handleTrialPayNow}
                              >
                                Pay Now
                              </Button>
                            </div>
                          )} */}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* Send To Radio Buttons */}
              <div className="mb-8">
                <p className="text-sm font-medium mb-3">Send To</p>

                <div className="flex flex-col sm:flex-row gap-6">
                  {/* LaunchIQ Database (requires a plan) */}
                  <label
                    className={`flex items-center gap-2 ${!planDetails?.plan || isOnFreeTrial ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                  >
                    <input
                      type="checkbox"
                      name="sendTo_database"
                      checked={sendTo.database}
                      disabled={!planDetails?.plan || isOnFreeTrial}
                      onChange={() => {
                        if (!planDetails?.plan) {
                          setShowAddOnModalType("campaign");
                          return;
                        }

                        setSendTo((s) => {
                          const newValue = !s.database;

                          if (!newValue) {
                            setSelectedDatasets([]);
                          }

                          return { ...s, database: newValue };
                        });
                      }}
                      className="w-4 h-4 text-primary"
                    />

                    <span className="font-medium">LaunchIQ Database</span>
                    {!planDetails?.plan && (
                      <Badge className="bg-blue-100 text-blue-800 text-xs ml-2">Requires Plan</Badge>
                    )}
                    {isOnFreeTrial && (
                      <Badge className="bg-yellow-100 text-yellow-800 text-xs ml-2">Trial: Use My Hubs</Badge>
                    )}
                  </label>

                  {/* Choose your Hub (ALWAYS visible) */}
                  <label
                    className={`flex items-center gap-2 ${hasHubAccess
                      ? "cursor-pointer"
                      : "cursor-not-allowed opacity-50"
                      }`}
                    onClick={(e) => {
                      if (!hasHubAccess) {
                        e.preventDefault();
                        setShowUpgradeModal(true);
                      }
                    }}
                  >
                    <input
                      type="checkbox"
                      name="sendTo_mycontacts"
                      checked={sendTo.mycontacts}
                      disabled={!hasHubAccess}
                      onChange={(e) => {
                        if (!hasHubAccess) return;

                        // Simply toggle the mycontacts state without triggering draft save
                        setSendTo((s) => {
                          const newValue = !s.mycontacts;

                          // Clear selected custom datasets if unchecking
                          if (!newValue) {
                            setSelectedCustomDatasets([]);
                          }

                          return { ...s, mycontacts: newValue };
                        });

                        // If you need to scroll to the hub section, do it after state update
                        if (!sendTo.mycontacts && hubSectionRef.current) {
                          setTimeout(() => {
                            hubSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
                          }, 100);
                        }
                      }}
                      className="w-4 h-4 text-primary"
                    />

                    <span className="font-medium flex items-center gap-2">
                      My Hubs
                      {!hasHubAccess && (
                        <Badge className="bg-blue-100 text-blue-800 text-xs">
                          Pro Feature
                        </Badge>
                      )}
                    </span>
                  </label>
                </div>

                {/* Optional upgrade info box */}
                {!hasHubAccess && (
                  <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                    <p className="text-sm text-blue-900 flex items-center gap-2">
                      <Sparkles className="h-4 w-4" />
                      <strong>Want to send to your own contacts?</strong>
                      Upgrade to Pro to unlock "Choose your Hub".
                    </p>

                    <Button
                      size="sm"
                      variant="link"
                      className="mt-2 text-blue-700 underline p-0 h-auto"
                      onClick={() => setShowUpgradeModal(true)}
                    >
                      View Plans →
                    </Button>
                  </div>
                )}

                {isOnFreeTrial && (
                  <div className="mt-4 rounded-lg border border-yellow-200 bg-yellow-50 p-4">
                    <p className="flex items-start gap-2 text-sm text-yellow-900 leading-relaxed">
                      <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />

                      <span>
                        During your free trial, sending is limited
                        to <span className="font-semibold">My Hubs</span>.
                        {/* After the trial ends on{" "}
                        <span className="font-semibold">
                          {trialEndDate?.toLocaleDateString()}
                        </span>
                        , purchase a plan to access{" "}
                        <span className="font-semibold">LaunchIQ Database</span>. */}
                      </span>
                    </p>
                  </div>
                )}
              </div>

              <div
                className={
                  sendTo.database && sendTo.mycontacts
                    ? "flex flex-col gap-6"
                    : ""
                }
              >
                {/* LaunchIQ Database Section */}
                {sendTo.database && (
                  <div>
                    {/* Info Box */}
                    <div className="mb-4 p-4 border-2 border-dashed border-muted rounded-lg bg-muted/20">
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        <strong>
                          Hubs organize agents or recipients by city. Select the
                          option that best fits your launch needs.
                        </strong>
                      </p>
                      <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
                        <strong>Note:</strong> Many agents subscribe to multiple
                        hubs.
                        {/* <span className="text-primary underline cursor-pointer ml-1">
                          Please see our FAQ page for more details.
                        </span> */}
                      </p>
                    </div>

                    <div className="mb-6 w-full max-w-sm">
                      <label
                        htmlFor="state-select"
                        className="block text-sm font-semibold text-gray-700 mb-2"
                      >
                        Select State
                      </label>

                      <div className="relative" ref={dropdownRef}>
                        {/* Dropdown Toggle Button */}
                        <button
                          type="button"
                          onClick={() => setIsOpen(!isOpen)}
                          className={`
                        w-full
                        px-4 py-3
                        text-left
                        text-base
                        bg-white
                        border
                        rounded-lg
                        shadow-sm
                        transition-all
                        duration-200
                        flex
                        items-center
                        justify-between
                        ${isOpen
                              ? "border-blue-500 ring-2 ring-blue-200 shadow-md"
                              : "border-gray-300 hover:border-gray-400"
                            }
                        ${selectedState ? "text-gray-900" : "text-gray-500"}
                        focus:outline-none
                      `}
                        >
                          <span className="truncate">{selectedStateLabel}</span>

                          <svg
                            className={`w-5 h-5 text-gray-500 transition-transform duration-200 flex-shrink-0 ml-2 ${isOpen ? "transform rotate-180" : ""
                              }`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </button>

                        {/* Dropdown Menu */}
                        {isOpen && (
                          <div className="absolute z-50 w-full mt-2 bg-white border border-gray-200 rounded-lg shadow-xl max-h-80 overflow-hidden">
                            {/* Search Input */}
                            <div className="p-3 border-b border-gray-200 bg-gray-50">
                              <div className="relative">
                                <input
                                  ref={searchInputRef}
                                  type="text"
                                  placeholder="Search states..."
                                  value={searchQuery}
                                  onChange={(e) =>
                                    setSearchQuery(e.target.value)
                                  }
                                  className="
                              w-full
                              pl-10
                              pr-4
                              py-2
                              text-sm
                              border
                              border-gray-300
                              rounded-lg
                              focus:outline-none
                              focus:ring-2
                              focus:ring-blue-500
                              focus:border-blue-500
                            "
                                />
                                <svg
                                  className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                  />
                                </svg>
                              </div>
                            </div>

                            {/* Options List */}
                            <div className="overflow-y-auto max-h-64">
                              {filteredStates.length === 0 ? (
                                <div className="px-4 py-8 text-center text-sm text-gray-500">
                                  No states found
                                </div>
                              ) : (
                                <ul className="py-1">
                                  {filteredStates.map((state) => {
                                    const isSelected =
                                      selectedState === state.value;
                                    const isPlaceholder = state.value === "";

                                    return (
                                      <li key={state.value}>
                                        <button
                                          type="button"
                                          onClick={() =>
                                            !isPlaceholder &&
                                            handleSelect(state)
                                          }
                                          disabled={isPlaceholder}
                                          className={`
                                      w-full
                                      px-4
                                      py-2.5
                                      text-left
                                      text-sm
                                      transition-colors
                                      flex
                                      items-center
                                      justify-between
                                      ${isPlaceholder
                                              ? "text-gray-400 cursor-not-allowed bg-gray-50"
                                              : isSelected
                                                ? "bg-blue-50 text-blue-700 font-medium"
                                                : "text-gray-900 hover:bg-gray-100"
                                            }
                                    `}
                                        >
                                          <span>{state.label}</span>

                                          {isSelected && (
                                            <svg
                                              className="w-5 h-5 text-blue-600"
                                              fill="none"
                                              stroke="currentColor"
                                              viewBox="0 0 24 24"
                                            >
                                              <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M5 13l4 4L19 7"
                                              />
                                            </svg>
                                          )}
                                        </button>
                                      </li>
                                    );
                                  })}
                                </ul>
                              )}
                            </div>

                            {/* Footer (Optional) */}
                            {selectedState && (
                              <div className="p-3 border-t border-gray-200 bg-gray-50">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSelectedState("");
                                    setSearchQuery("");
                                  }}
                                  className="text-sm text-red-600 hover:text-red-700 font-medium transition-colors"
                                >
                                  Clear selection
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {/* Selected State Display (Optional) */}
                      {/* {selectedState && (
                        <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                          <p className="text-sm text-blue-700 mt-1">
                            <span className="font-medium">
                              Hubs remaining:
                            </span>{" "}
                            {associationsRemaining === null
                              ? "0"
                              : associationsRemaining}
                          </p>
                        </div>
                      )} */}
                    </div>

                    {/* Loading Associations Indicator */}
                    {selectedState && loadingStateAssociations && (
                      <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                        <div className="flex items-center justify-center gap-3">
                          <div className="animate-spin">
                            <svg
                              className="w-5 h-5 text-blue-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 12a8 8 0 018-8"
                              />
                            </svg>
                          </div>
                          <div className="text-left">
                            <p className="text-sm font-medium text-blue-900">
                              Loading hubs...
                            </p>
                            <p className="text-xs text-blue-700 mt-1">
                              This may take a few seconds
                            </p>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Suggested Top 3 Nearby Counties - Loading State */}
                    {selectedState && suggestingCounties && (
                      <div className="mb-6 p-4 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-lg">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className="animate-spin">
                              <svg
                                className="w-5 h-5 text-amber-600"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M4 12a8 8 0 018-8"
                                />
                              </svg>
                            </div>
                            <p className="text-sm font-medium text-amber-900">
                              Finding top 3 nearby counties for your property...
                            </p>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Suggested Top 3 Nearby Counties - Results */}
                    {selectedState && countySuggestions.length > 0 && !suggestingCounties && (
                      <div className="mb-6">
                        <div className="mb-4 p-4 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-lg">
                          <p className="text-sm font-semibold text-amber-900 flex items-center gap-2">
                            Top 3 Suggested Hubs Near Your Property
                          </p>
                          <p className="text-xs text-amber-700 mt-2">
                            Based on property location - Click "Add" to select any hub
                          </p>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                          {countySuggestions.map((countyName, idx) => {
                            const countyData = agentLists.find((c) => c.name === countyName);
                            if (!countyData) return null;

                            const countyId = String(countyData.id);
                            const isSelected = selectedDatasets.some((x) => String(x) === countyId);
                            const count = countyData.agent_count ?? 0;

                            return (
                              <div
                                key={`suggestion-${countyName}-${idx}`}
                                className={`relative border-2 rounded-lg p-4 transition-all duration-200 ${isSelected
                                  ? "bg-blue-50 border-blue-300 shadow-md"
                                  : "bg-white border-amber-200 hover:border-amber-300 hover:shadow-sm"
                                  }`}
                              >
                                {isSelected && (
                                  <div className="absolute -top-2 -right-2 w-5 h-5 bg-green-500 rounded-full flex items-center justify-center shadow">
                                    <svg
                                      className="w-3 h-3 text-white"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                )}
                                <h4 className="font-semibold text-gray-900 mb-2 text-sm">
                                  {countyName}
                                </h4>
                                <p className="text-xs text-gray-600 mb-3 flex items-center gap-1">
                                  <svg
                                    className="w-3.5 h-3.5"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M17 20h5v-2a3 3 0 00-5.856-1.487M15 10a3 3 0 11-6 0 3 3 0 016 0z"
                                    />
                                  </svg>
                                  {count.toLocaleString()} agents
                                </p>
                                <button
                                  type="button"
                                  onClick={() => {
                                    if (isSelected) {
                                      handleRemoveDataset(countyId);
                                    } else {
                                      handleAddDataset(countyId);
                                    }
                                  }}
                                  className={`w-full text-sm font-medium py-2 rounded transition-colors ${isSelected
                                    ? "bg-red-100 text-red-700 hover:bg-red-200"
                                    : "bg-amber-100 text-amber-700 hover:bg-amber-200"
                                    }`}
                                >
                                  {isSelected ? "Remove" : "Add"}
                                </button>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}

                    {/* Associations List - Only show if state is selected AND there are associations AND not loading */}
                    {selectedState && agentLists.length > 0 && !loadingStateAssociations && (
                      <div className="max-h-80 overflow-y-auto border rounded-lg bg-gradient-to-br from-slate-50 to-gray-50 p-6 mb-8 shadow-sm">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                          {(() => {
                            // Deduplicate by ID - only show first occurrence of each ID
                            const seenIds = new Set<string>();
                            return agentLists
                              .filter((list) =>
                                list.name
                                  .toLowerCase()
                                  .includes(associationSearchQuery.toLowerCase())
                              )
                              .filter((list) => {
                                const id = String(list.id);
                                if (seenIds.has(id)) return false;
                                seenIds.add(id);
                                return true;
                              })
                              .map((list) => {
                                const listId = String(list.id);
                                const isSelected = selectedDatasets.some((x) => String(x) === listId);
                                const count = list.agent_count ?? list.count ?? 0;

                                return (
                                  <div
                                    key={listId}
                                    className={`
                              group relative border rounded-xl p-5 transition-all duration-200 cursor-pointer
                              ${isSelected
                                        ? "bg-blue-50 border-blue-300 shadow-md ring-2 ring-blue-200"
                                        : "bg-white border-gray-200 hover:border-blue-300 hover:shadow-md hover:-translate-y-0.5"
                                      }
                            `}
                                  >
                                    {/* Selection Indicator */}
                                    {isSelected && (
                                      <div className="absolute -top-2 -right-2 w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center shadow-lg">
                                        <svg
                                          className="w-4 h-4 text-white"
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={3}
                                            d="M5 13l4 4L19 7"
                                          />
                                        </svg>
                                      </div>
                                    )}

                                    <div className="h-full">
                                      <div className="flex flex-col h-full">

                                        {/* Top Content */}
                                        <div className="flex flex-col space-y-3">

                                          {/* Header */}
                                          <div className="flex items-start justify-between gap-2">
                                            <div className="flex-1 min-w-0">
                                              <h3
                                                className={`font-semibold text-sm break-words ${isSelected ? "text-blue-900" : "text-black-900"
                                                  }`}
                                              >
                                                {list.name}
                                              </h3>
                                            </div>
                                          </div>

                                          {/* Count Badge */}
                                          <div className="flex items-center gap-2">
                                            <div
                                              className={`
            inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium
            ${isSelected
                                                  ? "bg-blue-100 text-blue-700"
                                                  : "bg-gray-100 text-gray-700"
                                                }
          `}
                                            >
                                              <svg
                                                className="w-3.5 h-3.5"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                              >
                                                <path
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeWidth={2}
                                                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                                                />
                                              </svg>
                                              <span>{count.toLocaleString()} agents</span>
                                            </div>
                                          </div>

                                        </div>

                                        {/* Button (Always Bottom) */}
                                        <div className="mt-auto pt-3">
                                          <Button
                                            size="sm"
                                            variant={isSelected ? "destructive" : "default"}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              isSelected
                                                ? handleRemoveDataset(listId)
                                                : handleAddDataset(listId);
                                            }}
                                            className={`
          w-full transition-all duration-200 font-medium
          ${isSelected
                                                ? "bg-red-500 hover:bg-red-600 text-white shadow-sm"
                                                : "bg-blue-600 hover:bg-blue-700 text-white shadow-sm"
                                              }
        `}
                                          >
                                            {isSelected ? (
                                              <span className="flex items-center justify-center gap-2">
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                </svg>
                                                Remove
                                              </span>
                                            ) : (
                                              <span className="flex items-center justify-center gap-2">
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                                </svg>
                                                Add
                                              </span>
                                            )}
                                          </Button>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                );
                              });
                          })()}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* My Contacts Section – Only shows custom agent datasets when My Hub access exists */}
                {sendTo.mycontacts && customAgentLists.length > 0 && hasHubAccess && (
                  <div ref={hubSectionRef}>
                    <div className="mb-6 p-4 border-2 border-dashed border-muted rounded-lg bg-muted/20">
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        <strong>
                          Select from your custom agent hub below.
                        </strong>
                      </p>
                    </div>
                    <h3 className="text-lg font-semibold mb-4">
                      Your Agent Datasets
                    </h3>
                    <div className="max-h-80 overflow-y-auto border rounded-lg bg-muted/5 p-4">
                      <div className="space-y-3">
                        {customAgentLists.map((list) => (
                          <DatasetCard
                            key={list.id}
                            name={list.name}
                            count={list.agent_count ?? list.count ?? 0}
                            isSelected={selectedCustomDatasets.includes(list.id)}
                            onAdd={() => handleAddCustomDataset(list.id)}
                            onRemove={() => handleRemoveCustomDataset(list.id)}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Navigation Buttons */}
              <div className="flex justify-between pt-10">
                <Button variant="outline" onClick={() => requestStepNavigation(4)}>
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Back
                </Button>
                <Button
                  onClick={async () => {
                    try {
                      setPlanLoading(true);

                      const isInActiveTrial = user?.is_in_active_trial === true;
                      const remainingTrialCampaigns = (user as any)?.remaining_trial_campaigns ?? 0;

                      if (isInActiveTrial && !user?.plan && remainingTrialCampaigns <= 0) {
                        toast({
                          title: "Free Trial Limit Reached",
                          description: `You've used all ${user?.trial_campaigns_limit ?? 0} free trial launches. Please upgrade or pay now to continue.`,
                          variant: "destructive",
                          duration: 3000,
                        });

                        if (user?.stripe_subscription_id) {
                          setShowTrialPaymentModal(true);
                        } else {
                          setShowPricingModal(true);
                        }

                        setPlanLoading(false);
                        return;
                      }

                      // Do not consume a trial launch at Step 5.
                      // This is only validation before moving to Step 6.
                      setTrialValidated(true);
                      setPlanLoading(false);
                      setCurrentStep(6);
                    } catch (err: any) {
                      console.error("Failed to validate trial on Step 5:", err);
                      setPlanLoading(false);
                      toast({ title: "Error", description: "Could not validate trial status. Try again.", variant: "destructive" });
                    }
                  }}
                  disabled={
                    !(
                      (sendTo.database && selectedDatasets.length > 0) ||
                      (sendTo.mycontacts && selectedCustomDatasets.length > 0)
                    )
                  }
                  className={
                    !(
                      (sendTo.database && selectedDatasets.length > 0) ||
                      (sendTo.mycontacts && selectedCustomDatasets.length > 0)
                    )
                      ? "bg-gray-400 cursor-not-allowed text-white"
                      : "bg-blue-600 hover:bg-blue-700 text-white"
                  }
                >
                  <span>Continue</span>
                  {selectedHubCount > 0 && (
                    <span className="ml-2 inline-flex min-w-6 items-center justify-center rounded-full bg-white px-2 py-0.5 text-xs font-semibold text-amber-950 shadow-sm">
                      {selectedHubCount}
                    </span>
                  )}
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </div>

              {/* Save Draft Dialog */}
              <Dialog
                open={showSaveDraftDialog}
                onOpenChange={setShowSaveDraftDialog}
              >
                <DialogContent className="sm:max-w-2xl w-[95vw] max-h-[90vh] overflow-y-auto rounded-2xl border-0 p-0 shadow-2xl bg-white">

                  {/* Header */}
                  <div className="px-6 pt-6 pb-4 border-b bg-gradient-to-r from-blue-50 to-indigo-50 rounded-t-2xl">
                    <DialogHeader>
                      <DialogTitle className="flex items-center gap-3 text-2xl font-bold text-gray-900">
                        <div className="p-2 rounded-xl bg-blue-100">
                          <Save className="h-5 w-5 text-blue-600" />
                        </div>

                        Save Your Progress?
                      </DialogTitle>

                      <DialogDescription className="text-gray-600 text-sm mt-2 leading-relaxed">
                        Would you like to save this campaign as a draft before proceeding to payment?
                      </DialogDescription>
                    </DialogHeader>
                  </div>

                  {/* Body */}
                  <div className="p-6 space-y-5">

                    {/* Main Card */}
                    <div className="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">

                      <div className="p-5">
                        <div className="flex flex-col sm:flex-row gap-5">

                          {/* Image */}
                          {campaignType === "property" ? (
                            <div className="w-full sm:w-32 h-32 rounded-xl overflow-hidden bg-gray-100 flex-shrink-0">
                              {propertyData?.heroImage || selectedProperty?.image ? (
                                <img
                                  src={propertyData?.heroImage || selectedProperty?.image}
                                  alt="Property"
                                  className="w-full h-full object-cover"
                                />
                              ) : (
                                <div className="w-full h-full flex items-center justify-center bg-blue-100">
                                  <Home className="h-10 w-10 text-blue-400" />
                                </div>
                              )}
                            </div>
                          ) : (
                            <div className="w-full sm:w-32 h-32 rounded-xl overflow-hidden bg-gray-100 flex-shrink-0">
                              {serviceData?.heroImage || selectedService?.image ? (
                                <img
                                  src={serviceData?.heroImage || selectedService?.image}
                                  alt="Service"
                                  className="w-full h-full object-cover"
                                />
                              ) : (
                                <div className="w-full h-full flex items-center justify-center bg-blue-100">
                                  <Briefcase className="h-10 w-10 text-blue-400" />
                                </div>
                              )}
                            </div>
                          )}

                          {/* Content */}
                          <div className="flex-1 min-w-0">

                            {campaignType === "property" ? (
                              <>
                                <h3 className="text-xl font-bold text-gray-900 break-words">
                                  {propertyData?.headline ||
                                    selectedProperty?.title ||
                                    "Your Property"}
                                </h3>

                                {(propertyData?.address ||
                                  selectedProperty?.address) && (
                                    <div className="flex items-start gap-2 mt-3 text-gray-600">
                                      <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />

                                      <span className="text-sm leading-relaxed break-words">
                                        {propertyData?.address ||
                                          selectedProperty?.address}
                                      </span>
                                    </div>
                                  )}

                                {(propertyData?.price ||
                                  selectedProperty?.price) && (
                                    <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-green-50 px-4 py-2 text-green-700 font-semibold">
                                      <DollarSign className="h-4 w-4" />

                                      {new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 0,
                                      }).format(
                                        propertyData?.price ||
                                        selectedProperty?.price
                                      )}
                                    </div>
                                  )}
                              </>
                            ) : (
                              <>
                                <h3 className="text-xl font-bold text-gray-900 break-words">
                                  {serviceData?.title ||
                                    selectedService?.title ||
                                    "Your Service"}
                                </h3>

                                {serviceData?.serviceType && (
                                  <p className="mt-2 text-sm text-gray-600">
                                    {serviceData.serviceType}
                                  </p>
                                )}

                                <div className="mt-4 space-y-2 text-sm text-gray-700">
                                  {serviceData?.phone && (
                                    <p>
                                      Phone:
                                      <span className="font-medium ml-1">
                                        {serviceData.phone}
                                      </span>
                                    </p>
                                  )}

                                  {serviceData?.email && (
                                    <p>
                                      Email:
                                      <span className="font-medium ml-1">
                                        {serviceData.email}
                                      </span>
                                    </p>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                        {/* Bottom Details */}
                        <div className="mt-6 border-t pt-5 space-y-4">

                          {subject && (
                            <div className="flex items-start gap-3 text-sm">
                              <Mail className="h-4 w-4 text-gray-400 mt-0.5" />

                              <div>
                                <p className="text-gray-500">Subject</p>

                                <p className="font-medium text-gray-900 break-words">
                                  {subject}
                                </p>
                              </div>
                            </div>
                          )}

                          {selectedTemplate && (
                            <div className="flex items-start gap-3 text-sm">
                              <Layout className="h-4 w-4 text-gray-400 mt-0.5" />

                              <div>
                                <p className="text-gray-500">Template</p>

                                <p className="font-medium text-gray-900">
                                  {selectedTemplate.name}
                                </p>
                              </div>
                            </div>
                          )}

                          <div className="flex items-start gap-3 text-sm">
                            <Users className="h-4 w-4 text-gray-400 mt-0.5" />

                            <div>
                              <p className="text-gray-500">Recipients</p>

                              <p className="font-medium text-gray-900">
                                {selectedDatasets.length +
                                  selectedCustomDatasets.length}{" "}
                                list(s) selected
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Info Box */}
                    <div className="rounded-2xl border border-blue-100 bg-gradient-to-r from-blue-50 to-indigo-50 p-4">
                      <div className="flex items-start gap-3">
                        <div className="p-1 rounded-full bg-white shadow-sm">
                          <CheckCircle className="h-4 w-4 text-blue-600" />
                        </div>

                        <p className="text-sm leading-relaxed text-blue-900">
                          Saving your draft allows you to continue later without losing your
                          launch details, template selection, and recipient preferences.
                        </p>
                      </div>
                    </div>

                    {/* Footer */}
                    <DialogFooter className="flex-col-reverse sm:flex-row gap-3 pt-2">

                      <Button
                        variant="outline"
                        onClick={handleContinueWithoutSaving}
                        className="w-full sm:w-auto h-11 px-6 rounded-xl"
                      >
                        Skip & Continue
                      </Button>

                      <Button
                        onClick={handleSaveDraftBeforePayment}
                        disabled={isDraftSaving}
                        className="w-full sm:w-auto h-11 px-6 rounded-xl bg-blue-600 hover:bg-blue-700"
                      >
                        {isDraftSaving ? (
                          <>
                            <Loader2 className="h-4 w-4 animate-spin mr-2" />
                            Saving...
                          </>
                        ) : (
                          <>
                            <Save className="h-4 w-4 mr-2" />
                            Save Draft & Continue
                          </>
                        )}
                      </Button>
                    </DialogFooter>
                  </div>
                </DialogContent>
              </Dialog>

              {/* Upgrade Modal */}
              <Dialog
                open={showUpgradeModal}
                onOpenChange={setShowUpgradeModal}
              >
                <DialogContent className="sm:max-w-md">
                  <DialogHeader>
                    <DialogTitle>Upgrade Required</DialogTitle>
                    <DialogDescription>
                      My Hub is a premium feature available only on Pro or Pro+
                      plans.
                    </DialogDescription>
                  </DialogHeader>

                  <div className="py-4">
                    <p className="text-sm text-muted-foreground">
                      Unlock advanced contact management, launches, analytics,
                      and more.
                    </p>
                  </div>

                  <DialogFooter className="flex justify-between">
                    <Button
                      variant="outline"
                      onClick={() => setShowUpgradeModal(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={() => {
                        setShowSaveDraftDialog(false);
                        setShowUpgradeModal(false);
                        navigate("/settings?tab=subscription");
                      }}
                    >
                      View Plans
                    </Button>
                  </DialogFooter>
                </DialogContent>
              </Dialog>
            </div>
          );
        }

        // Non-property campaign type (fallback)
        return (
          <div className="w-full max-w-5xl mx-auto">
            <h2 className="text-2xl font-bold text-primary mb-8 text-center">
              Select Recipients
            </h2>

            {/* Send To Radio Buttons */}
            <div className="mb-8">
              <p className="text-sm font-medium mb-3">Send To</p>

              <div className="flex flex-col sm:flex-row gap-6">
                {/* LaunchIQ Database (requires a plan) */}
                <label
                  className={`flex items-center gap-2 ${!planDetails?.plan ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                >
                  <input
                    type="checkbox"
                    name="sendTo_database"
                    checked={sendTo.database}
                    disabled={!planDetails?.plan}
                    onChange={() => {
                      if (!planDetails?.plan) {
                        setShowAddOnModalType("campaign");
                        return;
                      }

                      setSendTo((s) => {
                        const newValue = !s.database;

                        if (!newValue) {
                          setSelectedDatasets([]);
                        }

                        return { ...s, database: newValue };
                      });
                    }}
                    className="w-4 h-4 text-primary"
                  />

                  <span className="font-medium">LaunchIQ Database</span>
                  {!planDetails?.plan && (
                    <Badge className="bg-blue-100 text-blue-800 text-xs ml-2">Requires Plan</Badge>
                  )}
                </label>

                {/* Choose your Hub (ALWAYS visible) */}
                <label
                  className={`flex items-center gap-2 ${hasHubAccess
                    ? "cursor-pointer"
                    : "cursor-not-allowed opacity-50"
                    }`}
                  onClick={(e) => {
                    if (!hasHubAccess) {
                      e.preventDefault();
                      setShowUpgradeModal(true);
                    }
                  }}
                >
                  <input
                    type="checkbox"
                    name="sendTo_mycontacts"
                    checked={sendTo.mycontacts}
                    disabled={!hasHubAccess}
                    onChange={(e) => {
                      if (!hasHubAccess) return;
                      handleHubCheckboxChange(e.target.checked);
                    }}
                    className="w-4 h-4 text-primary"
                  />

                  <span className="font-medium flex items-center gap-2">
                    My Hubs
                    {!hasHubAccess && (
                      <Badge className="bg-blue-100 text-blue-800 text-xs">
                        Pro Feature
                      </Badge>
                    )}
                  </span>
                </label>
              </div>

              {/* Optional upgrade info box */}
              {!hasHubAccess && (
                <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                  <p className="text-sm text-blue-900 flex items-center gap-2">
                    <Sparkles className="h-4 w-4" />
                    <strong>Want to send to your own contacts?</strong>
                    Upgrade to Pro to unlock "Choose your Hub".
                  </p>

                  <Button
                    size="sm"
                    variant="link"
                    className="mt-2 text-blue-700 underline p-0 h-auto"
                    onClick={() => setShowUpgradeModal(true)}
                  >
                    View Plans →
                  </Button>
                </div>
              )}
            </div>

            <div
              className={
                sendTo.database && sendTo.mycontacts
                  ? "flex flex-col gap-6"
                  : ""
              }
            >
              {/* LaunchIQ Database Section */}
              {sendTo.database && (
                <div>
                  {/* Info Box */}
                  <div className="mb-6 p-4 border-2 border-dashed border-muted rounded-lg bg-muted/20">
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      <strong>
                        Agents in our database are broken down by the
                        hub they belong to. Select the hub you
                        want to send to.
                      </strong>
                    </p>
                    <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
                      <strong>Note:</strong> Many agents subscribe to multiple
                      hubs.
                      {/* <span className="text-primary underline cursor-pointer ml-1">
                        Please see our FAQ page for more details.
                      </span> */}
                    </p>
                  </div>

                  <div className="mb-6 w-full max-w-sm">
                    <label
                      htmlFor="state-select"
                      className="block text-sm font-semibold text-gray-700 mb-2"
                    >
                      Select State
                    </label>

                    <div className="relative" ref={dropdownRef}>
                      {/* Dropdown Toggle Button */}
                      <button
                        type="button"
                        onClick={() => setIsOpen(!isOpen)}
                        className={`
                    w-full
                    px-4 py-3
                    text-left
                    text-base
                    bg-white
                    border
                    rounded-lg
                    shadow-sm
                    transition-all
                    duration-200
                    flex
                    items-center
                    justify-between
                    ${isOpen
                            ? "border-blue-500 ring-2 ring-blue-200 shadow-md"
                            : "border-gray-300 hover:border-gray-400"
                          }
                    ${selectedState ? "text-gray-900" : "text-gray-500"}
                    focus:outline-none
                  `}
                      >
                        <span className="truncate">{selectedStateLabel}</span>

                        <svg
                          className={`w-5 h-5 text-gray-500 transition-transform duration-200 flex-shrink-0 ml-2 ${isOpen ? "transform rotate-180" : ""
                            }`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </button>

                      {/* Dropdown Menu */}
                      {isOpen && (
                        <div className="absolute z-50 w-full mt-2 bg-white border border-gray-200 rounded-lg shadow-xl max-h-80 overflow-hidden">
                          {/* Search Input */}
                          <div className="p-3 border-b border-gray-200 bg-gray-50">
                            <div className="relative">
                              <input
                                ref={searchInputRef}
                                type="text"
                                placeholder="Search states..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="
                            w-full
                            pl-10
                            pr-4
                            py-2
                            text-sm
                            border
                            border-gray-300
                            rounded-lg
                            focus:outline-none
                            focus:ring-2
                            focus:ring-blue-500
                            focus:border-blue-500
                          "
                              />
                              <svg
                                className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                />
                              </svg>
                            </div>
                          </div>

                          {/* Options List */}
                          <div className="overflow-y-auto max-h-64">
                            {filteredStates.length === 0 ? (
                              <div className="px-4 py-8 text-center text-sm text-gray-500">
                                No states found
                              </div>
                            ) : (
                              <ul className="py-1">
                                {filteredStates.map((state) => {
                                  const isSelected =
                                    selectedState === state.value;
                                  const isPlaceholder = state.value === "";

                                  return (
                                    <li key={state.value}>
                                      <button
                                        type="button"
                                        onClick={() =>
                                          !isPlaceholder && handleSelect(state)
                                        }
                                        disabled={isPlaceholder}
                                        className={`
                                    w-full
                                    px-4
                                    py-2.5
                                    text-left
                                    text-sm
                                    transition-colors
                                    flex
                                    items-center
                                    justify-between
                                    ${isPlaceholder
                                            ? "text-gray-400 cursor-not-allowed bg-gray-50"
                                            : isSelected
                                              ? "bg-blue-50 text-blue-700 font-medium"
                                              : "text-gray-900 hover:bg-gray-100"
                                          }
                                  `}
                                      >
                                        <span>{state.label}</span>

                                        {isSelected && (
                                          <svg
                                            className="w-5 h-5 text-blue-600"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth={2}
                                              d="M5 13l4 4L19 7"
                                            />
                                          </svg>
                                        )}
                                      </button>
                                    </li>
                                  );
                                })}
                              </ul>
                            )}
                          </div>

                          {/* Footer (Optional) */}
                          {selectedState && (
                            <div className="p-3 border-t border-gray-200 bg-gray-50">
                              <button
                                type="button"
                                onClick={() => {
                                  setSelectedState("");
                                  setSearchQuery("");
                                }}
                                className="text-sm text-red-600 hover:text-red-700 font-medium transition-colors"
                              >
                                Clear selection
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Selected State Display (Optional) */}
                    {selectedState && (
                      <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                        <p className="text-sm text-blue-700 mt-1">
                          <span className="font-medium">
                            Hubs remaining:
                          </span>{" "}
                          {associationsRemaining === null
                            ? "Unlimited"
                            : associationsRemaining}
                        </p>
                      </div>
                    )}

                  </div>

                  {/* Suggested Top 3 Nearby Counties - Loading State */}
                  {selectedState && suggestingCounties && (
                    <div className="mb-6 p-4 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-lg">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <div className="animate-spin">
                            <svg
                              className="w-5 h-5 text-amber-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 12a8 8 0 018-8"
                              />
                            </svg>
                          </div>
                          <p className="text-sm font-medium text-amber-900">
                            Finding top 3 nearby counties for your service...
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Suggested Top 3 Nearby Counties - Results */}
                  {selectedState && countySuggestions.length > 0 && !suggestingCounties && (
                    <div className="mb-6">
                      <div className="mb-4 p-4 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-lg">
                        <p className="text-sm font-semibold text-amber-900 flex items-center gap-2">
                          <svg
                            className="w-5 h-5 text-amber-600"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                          Top 3 Suggested Hubs Near Your Location
                        </p>
                        <p className="text-xs text-amber-700 mt-2">
                          Based on service territory - Click "Add" to select any hub
                        </p>
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                        {countySuggestions.map((countyName, idx) => {
                          const countyData = agentLists.find((c) => c.name === countyName);
                          if (!countyData) return null;

                          const countyId = String(countyData.id);
                          const isSelected = selectedDatasets.some((x) => String(x) === countyId);
                          const count = countyData.agent_count ?? 0;

                          return (
                            <div
                              key={`suggestion-${countyName}-${idx}`}
                              className={`relative border-2 rounded-lg p-4 transition-all duration-200 ${isSelected
                                ? "bg-blue-50 border-blue-300 shadow-md"
                                : "bg-white border-amber-200 hover:border-amber-300 hover:shadow-sm"
                                }`}
                            >
                              {isSelected && (
                                <div className="absolute -top-2 -right-2 w-5 h-5 bg-green-500 rounded-full flex items-center justify-center shadow">
                                  <svg
                                    className="w-3 h-3 text-white"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </div>
                              )}
                              <h4 className="font-semibold text-gray-900 mb-2 text-sm">
                                {countyName}
                              </h4>
                              <p className="text-xs text-gray-600 mb-3 flex items-center gap-1">
                                <svg
                                  className="w-3.5 h-3.5"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M17 20h5v-2a3 3 0 00-5.856-1.487M15 10a3 3 0 11-6 0 3 3 0 016 0z"
                                  />
                                </svg>
                                {count.toLocaleString()} agents
                              </p>
                              <button
                                type="button"
                                onClick={() => {
                                  if (isSelected) {
                                    handleRemoveDataset(countyId);
                                  } else {
                                    handleAddDataset(countyId);
                                  }
                                }}
                                className={`w-full text-sm font-medium py-2 rounded transition-colors ${isSelected
                                  ? "bg-red-100 text-red-700 hover:bg-red-200"
                                  : "bg-amber-100 text-amber-700 hover:bg-amber-200"
                                  }`}
                              >
                                {isSelected ? "Remove" : "Add"}
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Associations List - Only show if state is selected AND there are associations */}
                  {selectedState && agentLists.length > 0 && (
                    <div className="max-h-80 overflow-y-auto border rounded-lg bg-gradient-to-br from-slate-50 to-gray-50 p-6 mb-8 shadow-sm">
                      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        {(() => {
                          // Deduplicate by ID - only show first occurrence of each ID
                          const seenIds = new Set<string>();
                          return agentLists
                            .filter((list) =>
                              list.name
                                .toLowerCase()
                                .includes(associationSearchQuery.toLowerCase())
                            )
                            .filter((list) => {
                              const id = String(list.id);
                              if (seenIds.has(id)) return false;
                              seenIds.add(id);
                              return true;
                            })
                            .map((list) => {
                              const listId = String(list.id);
                              const isSelected = selectedDatasets.some((x) => String(x) === listId);
                              const count = list.agent_count ?? list.count ?? 0;

                              return (
                                <div
                                  key={listId}
                                  className={`
                            group relative border rounded-xl p-5 transition-all duration-200 cursor-pointer
                            ${isSelected
                                      ? "bg-blue-50 border-blue-300 shadow-md ring-2 ring-blue-200"
                                      : "bg-white border-gray-200 hover:border-blue-300 hover:shadow-md hover:-translate-y-0.5"
                                    }
                          `}
                                >
                                  {/* Selection Indicator */}
                                  {isSelected && (
                                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center shadow-lg">
                                      <svg
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={3}
                                          d="M5 13l4 4L19 7"
                                        />
                                      </svg>
                                    </div>
                                  )}

                                  <div className="flex flex-col space-y-3">
                                    {/* Header */}
                                    <div className="flex items-start justify-between gap-2">
                                      <div className="flex-1 min-w-0">
                                        <h3
                                          className={`font-semibold text-sm truncate ${isSelected
                                            ? "text-blue-900"
                                            : "text-gray-900"
                                            }`}
                                        >
                                          {list.name}
                                        </h3>
                                      </div>
                                    </div>

                                    {/* Count Badge */}
                                    <div className="flex items-center gap-2">
                                      <div
                                        className={`
                                  inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium
                                  ${isSelected
                                            ? "bg-blue-100 text-blue-700"
                                            : "bg-gray-100 text-gray-700"
                                          }
                                `}
                                      >
                                        <svg
                                          className="w-3.5 h-3.5"
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                                          />
                                        </svg>
                                        <span>
                                          {count.toLocaleString()} agents
                                        </span>
                                      </div>
                                    </div>

                                    {/* Action Button */}
                                    <Button
                                      size="sm"
                                      variant={isSelected ? "destructive" : "default"}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        isSelected
                                          ? handleRemoveDataset(listId)
                                          : handleAddDataset(listId);
                                      }}
                                      className={`
                                w-full transition-all duration-200 font-medium
                                ${isSelected
                                          ? "bg-red-500 hover:bg-red-600 text-white shadow-sm"
                                          : "bg-blue-600 hover:bg-blue-700 text-white shadow-sm"
                                        }
                              `}
                                    >
                                      {isSelected ? (
                                        <span className="flex items-center justify-center gap-2">
                                          <svg
                                            className="w-4 h-4"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth={2}
                                              d="M6 18L18 6M6 6l12 12"
                                            />
                                          </svg>
                                          Remove
                                        </span>
                                      ) : (
                                        <span className="flex items-center justify-center gap-2">
                                          <svg
                                            className="w-4 h-4"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth={2}
                                              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                            />
                                          </svg>
                                          Add
                                        </span>
                                      )}
                                    </Button>
                                  </div>
                                </div>
                              );
                            });
                        })()}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* My Contacts Section – Only shows custom agent datasets when My Hub access exists */}
              {sendTo.mycontacts && customAgentLists.length > 0 && hasHubAccess && (
                <div ref={hubSectionRef}>
                  <div className="mb-6 p-4 border-2 border-dashed border-muted rounded-lg bg-muted/20">
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      <strong>
                        Select from your custom agent datasets below.
                      </strong>
                    </p>
                  </div>
                  <h3 className="text-lg font-semibold mb-4">
                    Your Agent Datasets
                  </h3>
                  <div className="max-h-80 overflow-y-auto border rounded-lg bg-muted/5 p-4">
                    <div className="space-y-3">
                      {customAgentLists.map((list) => (
                        <DatasetCard
                          key={list.id}
                          name={list.name}
                          count={list.agent_count ?? list.count ?? 0}
                          isSelected={selectedCustomDatasets.includes(list.id)}
                          onAdd={() => handleAddCustomDataset(list.id)}
                          onRemove={() => handleRemoveCustomDataset(list.id)}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Navigation Buttons */}
            <div className="flex justify-between pt-10">
              <Button variant="outline" onClick={() => requestStepNavigation(4)}>
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back
              </Button>

              <Button
                onClick={() => {
                  setShowSaveDraftDialog(true);
                }}
                disabled={
                  !(
                    (sendTo.database && selectedDatasets.length > 0) ||
                    (sendTo.mycontacts && selectedCustomDatasets.length > 0)
                  )
                }
                className={
                  !(
                    (sendTo.database && selectedDatasets.length > 0) ||
                    (sendTo.mycontacts && selectedCustomDatasets.length > 0)
                  )
                    ? "bg-gray-400 cursor-not-allowed text-white"
                    : "bg-blue-600 hover:bg-blue-700 text-white"
                }
              >
                <span>Continue to Payment</span>
                {selectedHubCount > 0 && (
                  <span className="ml-2 inline-flex min-w-6 items-center justify-center rounded-full bg-amber-300 px-2 py-0.5 text-xs font-semibold text-amber-950 shadow-sm">
                    {selectedHubCount}
                  </span>
                )}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </div>

            {/* Upgrade Modal */}
            <Dialog open={showUpgradeModal} onOpenChange={setShowUpgradeModal}>
              <DialogContent className="sm:max-w-md">
                <DialogHeader>
                  <DialogTitle>Upgrade Required</DialogTitle>
                  <DialogDescription>
                    My Hub is a premium feature available only on Pro or Pro+
                    plans.
                  </DialogDescription>
                </DialogHeader>

                <div className="py-4">
                  <p className="text-sm text-muted-foreground">
                    Unlock advanced contact management, launches, analytics, and
                    more.
                  </p>
                </div>

                <DialogFooter className="flex justify-between">
                  <Button
                    variant="outline"
                    onClick={() => setShowUpgradeModal(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => {
                      setShowSaveDraftDialog(false);
                      setShowUpgradeModal(false);
                      navigate("/settings?tab=subscription");
                    }}
                  >
                    View Plans
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          </div>
        );
      // =========================================================================
      // STEP 6: Campaign Summary (Property) OR Campaign Summary (Service)
      // =========================================================================
      case 6:
        const { recommendations: bestTimes, factors: analysisFactors } =
          calculateBestSendTimes;

        // Current moment + minimum allowed schedule (we compare in UTC instants, but the UI is in the user's timezone)
        const nowUtc = new Date();
        const minDateTimeUtc = new Date(nowUtc.getTime() - 30 * 1000);

        // `datetime-local` min value in the selected timezone
        const minDateTimeString = toDateInputValue(nowUtc.toISOString());

        const isDateInPast = (() => {
          if (isRecurringCampaign) return false;
          if (!selectedDateTime) return false;
          const selectedUtcIso = localToUtcIso(selectedDateTime);
          if (!selectedUtcIso) return false;
          return new Date(selectedUtcIso) < minDateTimeUtc;
        })();

        const recurringFirstSendDateTime =
          scheduleOption === "later" ? selectedDateTime : recurringStartDateTime;

        // Handler for datetime change with user-timezone validation
        const handleDateTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const selectedValue = e.target.value;
          const selectedUtcIso = localToUtcIso(selectedValue);

          if (!selectedUtcIso) {
            toast({
              title: "Invalid Date",
              description: "Please select a valid date and time.",
              variant: "destructive",
              duration: 1000,
            });
            setSelectedDateTime("");
            return;
          }

          if (!isRecurringCampaign && new Date(selectedUtcIso) < minDateTimeUtc) {
            toast({
              title: "Invalid Date",
              description: "You cannot schedule a launch in the past.",
              variant: "destructive",
              duration: 1000,
            });
            setSelectedDateTime(""); // Clear invalid selection
            return;
          }

          setSelectedDateTime(selectedValue);
        };

        return (
          <div className="w-full max-w-4xl mx-auto space-y-8">
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-primary text-center">
                Schedule Your Launch
              </h2>
              <p className="text-muted-foreground">
                AI-analyzed optimal times based on your {campaignType} data
              </p>
              <p className="text-xs text-muted-foreground mt-2">
                ⏰ Times displayed in{" "}
                <strong>{effectiveTimezone} (Your Timezone)</strong>
              </p>
            </div>

            {/* Current Time Display in User's Timezone */}
            {/* <Card className="border border-blue-200 bg-blue-50/50">
              <CardContent className="p-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <Calendar className="h-5 w-5 text-blue-600" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-blue-900">
                      Current Time ({userTimezone || "UTC"})
                    </p>
                    <p className="text-lg font-bold text-blue-700">
                      {formatDateTime(new Date().toISOString(), {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: '2-digit',
                        second: '2-digit',
                        timeZoneName: 'short'
                      })}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card> */}

            {/* Timezone Info & Update */}
            {/* {userTimezone && (
              <Card className="border border-amber-200 bg-amber-50/50">
                <CardContent className="p-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <Clock className="h-5 w-5 text-amber-600" />
                    </div>
                    <div className="flex-1">
                      <p className="text-sm font-semibold text-amber-900">
                        ✓ Timezone Auto-Detected
                      </p>
                      <p className="text-sm text-amber-800 mt-1">
                        Your timezone is set to <strong>{userTimezone}</strong>. 
                        {userTimezone === "UTC" ? 
                          " Times are shown in UTC." 
                          : " All times are calculated for your location."}
                      </p>
                      <p className="text-xs text-amber-700 mt-2">
                        To update your timezone,{" "}
                        <button
                          onClick={() => navigate("/settings?tab=profile", { replace: false })}
                          className="underline font-semibold hover:text-amber-900"
                        >
                          visit Account Settings
                        </button>
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )} */}



            <Card className="border border-blue-200 bg-blue-50/50">
              <CardContent className="p-4">
                <div className="flex items-start gap-3">

                  {/* Icon */}
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <Calendar className="h-5 w-5 text-blue-600" />
                  </div>

                  <div className="flex-1">

                    {/* Current Time */}
                    <p className="text-sm font-semibold text-blue-900">
                      Current Time ({effectiveTimezone})
                    </p>
                    <p className="text-lg font-bold text-blue-700">
                      {formatDateTime(new Date().toISOString(), {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: '2-digit',
                        second: '2-digit',
                        timeZoneName: 'short'
                      })}
                    </p>

                    {/* Divider */}
                    {userTimezone && (
                      <div className="mt-3 pt-3 border-t border-blue-200">

                        <div className="flex items-start gap-2">
                          <Clock className="h-4 w-4 text-amber-600 mt-1" />

                          <div>
                            <p className="text-sm font-semibold text-amber-900">
                              {/* ✓ Timezone Auto-Detected */}
                              Timezone

                            </p>

                            <p className="text-sm text-amber-800 mt-1">
                              Your timezone is set to <strong>{effectiveTimezone}</strong>.
                              {effectiveTimezone === "UTC"
                                ? " Times are shown in UTC."
                                : " All times are calculated for your location."}
                            </p>

                            <p className="text-xs text-amber-700 mt-2">
                              To update your timezone,{" "}
                              <button
                                onClick={() =>
                                  navigate("/settings?tab=profile", { replace: false })
                                }
                                className="underline font-semibold hover:text-amber-900"
                              >
                                visit Account Settings
                              </button>
                            </p>
                          </div>
                        </div>

                      </div>
                    )}

                  </div>
                </div>
              </CardContent>
            </Card>

            {/* AI Analysis Summary */}
            <Card className="border-2 border-blue-200 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 shadow-lg">
              <CardHeader className="pb-4">
                <div className="flex items-center gap-3">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 shadow-lg shadow-blue-500/30">
                    <Sparkles className="h-6 w-6 text-white" />
                  </div>
                  <div className="flex-1">
                    <CardTitle className="text-xl font-bold bg-gradient-to-r from-blue-700 to-indigo-700 bg-clip-text text-transparent">
                      Send Time Recommendation using{" "}
                      <span className="text-red">Auto IQ</span>
                    </CardTitle>

                    <p className="text-sm text-muted-foreground">
                      Dynamically calculated based on your data in {effectiveTimezone}
                    </p>
                  </div>
                </div>

                {/* Analysis Factors */}
                {analysisFactors.length > 0 && (
                  <div className="mt-4 flex flex-wrap gap-2">
                    {analysisFactors.map((factor, idx) => (
                      <Badge
                        key={idx}
                        variant="secondary"
                        className="bg-white/80 text-xs"
                      >
                        {factor}
                      </Badge>
                    ))}
                  </div>
                )}
              </CardHeader>

              <CardContent className="space-y-3">
                {bestTimes.slice(0, 3).map((time, index) => {
                  const isSelected =
                    selectedDateTime === time.inputValue &&
                    scheduleOption === "later";
                  const isFirst = index === 0;

                  return (
                    <div
                      key={time.id}
                      onClick={() => {
                        setScheduleOption("later");
                        setSelectedDateTime(time.inputValue);
                      }}
                      className={`
                        relative p-4 rounded-xl border-2 cursor-pointer transition-all duration-200
                        ${isSelected
                          ? "border-blue-500 bg-blue-50 shadow-md ring-2 ring-blue-500/20"
                          : isFirst
                            ? "border-green-300 bg-white hover:border-green-400 hover:shadow-md"
                            : "border-gray-200 bg-white hover:border-blue-300 hover:shadow-md"
                        }
                      `}
                    >
                      {/* Selected Indicator */}
                      {isSelected && (
                        <div className="absolute top-3 right-3">
                          <div className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center">
                            <Check className="h-4 w-4 text-white" />
                          </div>
                        </div>
                      )}

                      <div className="flex items-center gap-4">
                        {/* Details */}
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-1 flex-wrap">
                            <p className="text-base font-semibold text-foreground">
                              {time.dayName} at {time.formattedTime}
                            </p>
                            <span className="inline-block bg-blue-100 text-blue-700 text-xs px-2 py-1 rounded-md font-medium">
                              {effectiveTimezone || time.userTimezone || "UTC"}
                            </span>
                          </div>

                          <p className="text-sm text-muted-foreground line-clamp-2">
                            {time.reason}
                          </p>

                          <p className="text-xs text-muted-foreground mt-2">
                            📅 {time.formattedDate} | 🕐 {effectiveTimezone || time.userTimezone || "UTC"}
                          </p>
                        </div>

                        {/* Category */}
                        <Badge
                          variant="outline"
                          className="hidden sm:flex text-xs whitespace-nowrap"
                        >
                          {time.category}
                        </Badge>
                      </div>
                    </div>
                  );
                })}
              </CardContent>
            </Card>

            {/* Manual Option */}
            <Card className="border shadow-sm">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-lg">
                  <Calendar className="h-5 w-5 text-primary" />
                  Or Choose Custom Time
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="flex items-center gap-6">
                  <label className="flex items-center gap-3 cursor-pointer group">
                    <input
                      type="radio"
                      name="scheduleOption"
                      checked={scheduleOption === "now"}
                      onChange={() => {
                        setScheduleOption("now");
                        setSelectedDateTime("");
                        // Keep applied recurring when switching back to Send Now
                        if (!recurringReviewConfirmed && !isRecurringCampaign) {
                          setCheckoutData(null);
                          setRecurringEndDate("");
                          setCustomRecurringDates([]);
                          setPaymentAmount(0);
                          setRecurringReviewAmount(0);
                          setShowPaymentForm(false);
                        }
                      }}
                      className="w-4 h-4 text-primary"
                    />
                    <div>
                      <span className="font-medium">Send Now</span>


                    </div>
                  </label>

                  <label className="flex items-center gap-3 cursor-pointer group">
                    <input
                      type="radio"
                      name="scheduleOption"
                      checked={scheduleOption === "later"}
                      onChange={() => {
                        setScheduleOption("later");
                        // ✅ Reset checkout data when switching to "Schedule Later"
                        setCheckoutData(null);
                        setPaymentAmount(0);
                        setRecurringReviewAmount(0);
                        setRecurringReviewConfirmed(false);
                        setShowPaymentForm(false);
                      }}
                      className="w-4 h-4 text-primary"
                    />
                    <div>
                      <span className="font-medium">Schedule Later </span>
                    </div>
                  </label>
                </div>



                <div className="space-y-6">
                  {/* Recurring Option Button (available for both Send Now and Schedule Later) */}

                  {scheduleOption === "later" && (
                    <div className="space-y-2">
                      <Label
                        htmlFor="scheduled-datetime"
                        className="text-sm font-medium"
                      >
                        Select Date &amp; Time ({timezone})
                      </Label>
                      <input
                        id="scheduled-datetime"
                        type="datetime-local"
                        value={selectedDateTime}
                        onChange={handleDateTimeChange}
                        min={minDateTimeString || undefined}
                        className={`
                            w-full border rounded-lg px-4 py-3 
                            focus:ring-2 focus:ring-primary/20 
                            transition-all duration-200
                            ${isDateInPast
                            ? "border-red-500 focus:ring-red-200"
                            : "border-gray-300 focus:border-primary"
                          }
                          `}
                      />
                      <p className="text-xs text-muted-foreground">
                        We’ll save this in UTC in the database.
                      </p>
                    </div>
                  )}


                  <div className="space-y-3">
                    <div className="flex items-center gap-3 flex-wrap">
                      <Button
                        type="button"
                        disabled={scheduleOption === "later" && !selectedDateTime}
                        onClick={() => {
                          // Open recurring modal
                          setShowRecurringModal(true);
                        }}
                        className={`flex items-center gap-2 transition-all duration-200 ${scheduleOption === "later" && !selectedDateTime
                          ? "bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white"
                          : isRecurringCampaign
                            ? "bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white shadow-lg shadow-blue-500/30"
                            : "bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white shadow-md hover:shadow-lg"
                          }`}
                        title=""
                      >
                        {isRecurringCampaign && <CheckCircle className="h-4 w-4" />}
                        {!isRecurringCampaign && <RefreshCw className="h-4 w-4" />}
                        {isRecurringCampaign
                          ? `Recurring (${getRecurrenceTypeDisplayLabel(recurrenceType)})`
                          : "Set Recurring Schedule"}
                      </Button>

                      {/* When send now is selected, allow removing recurring without opening the modal */}
                      {/* {scheduleOption === "now" && isRecurringCampaign && (
                      <div className="flex flex-col gap-2 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                        <p className="text-sm text-yellow-800">
                          A recurring schedule is currently enabled for this send. Remove it if you want a one‑time send.
                        </p>
                        <Button
                          type="button"
                          variant="outline"
                          className="text-sm"
                          onClick={resetRecurring}
                        >
                          Remove Recurring
                        </Button>
                      </div>
                    )}  */}



                      {/* <div className="flex gap-3">
                      <Button
                        type="button"
                        onClick={() => {
                          // Open recurring modal
                          setShowRecurringModal(true);
                        }}
                        className={`flex items-center gap-2 transition-all duration-200 ${isRecurringCampaign
                          ? "bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white shadow-lg shadow-blue-500/30"
                          : "bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white shadow-md hover:shadow-lg"
                          }`}
                        title=""
                      >
                        {isRecurringCampaign && <CheckCircle className="h-4 w-4" />}
                        {!isRecurringCampaign && <RefreshCw className="h-4 w-4" />}
                        {isRecurringCampaign
                          ? `Recurring (${getRecurrenceTypeDisplayLabel(recurrenceType)})`
                          : "Set Recurring Schedule"}
                      </Button>


                    </div> */}



                      {/* Show recurring schedule info if enabled */}
                      {isRecurringCampaign && (
                        <div className="mt-3 p-4 bg-blue-50 border border-blue-200 rounded-lg w-full">
                          <div className="flex justify-between items-start mb-3 gap-2">
                            <p className="text-blue-900 font-semibold text-sm">
                              Recurring Schedule
                            </p>
                            <Button
                              type="button"
                              onClick={resetRecurring}
                              className="h-auto py-1 px-2 text-xs bg-red-500 hover:bg-red-600 text-white flex-shrink-0"
                            >
                              <X className="h-3 w-3 mr-1" />
                              Remove Recurring
                            </Button>
                          </div>
                          <p className="text-blue-900 text-xs mb-2">
                            <strong>Type:</strong> {getRecurrenceTypeDisplayLabel(recurrenceType)}
                          </p>
                          {recurrenceType !== "custom" && selectedDateTime && (
                            <p className="text-blue-800 text-xs mb-2">
                              <strong>First Send:</strong> {formatUtcDisplay(selectedDateTime)}
                            </p>
                          )}
                          {recurringEndDate && recurrenceType !== "custom" && (
                            <p className="text-blue-800 text-xs mb-2">
                              <strong>Ends:</strong> {formatUtcDisplay(recurringEndDate)}
                            </p>
                          )}
                          {recurrenceType === "custom" && customRecurringDates.length > 0 && (
                            <div>
                              <p className="text-blue-900 text-xs font-semibold mb-2">
                                Selected Send Dates:
                              </p>
                              <div className="space-y-1">
                                {customRecurringDates.map((date, idx) => (
                                  <p key={idx} className="text-blue-700 text-xs flex items-center gap-2">
                                    <Calendar className="h-3 w-3 flex-shrink-0" />
                                    <span>{formatUtcDisplay(date)}</span>
                                  </p>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                      {/* UTC Info message */}
                      <div className="mt-3 flex items-start gap-2 p-3 bg-blue-50 border border-blue-200 rounded-lg mt-3 w-full">
                        <Info className="h-4 w-4 text-blue-600 shrink-0 mt-0.5" />
                        <div className="text-xs text-blue-800">
                          <p className="font-semibold mb-1 mt-1 w-full">You must accept the checkbox to continue with either “Send Now” or recurring scheduling and proceed with the launch. </p>
                          {/* <ul className="list-disc list-inside space-y-1">
                            <li>Past UTC dates are automatically disabled</li>
                            <li>
                              Current UTC time:{" "}
                              <strong>
                                {nowUtc
                                  .toUTCString()
                                  .split(" ")
                                  .slice(4, 5)
                                  .join(" ")}
                              </strong>
                            </li>
                          </ul> */}
                        </div>
                      </div>

                      {/* Error message if date is in past */}
                      {/* {isDateInPast && (
                        <div className="mt-3 flex items-start gap-2 p-3 bg-red-50 border border-red-300 rounded-lg animate-in slide-in-from-top-2">
                          <AlertTriangle className="h-4 w-4 text-red-600 shrink-0 mt-0.5" />
                          <p className="text-xs text-red-800">
                            <strong>Error:</strong> The selected UTC date and
                            time is in the past. Please choose a future UTC date
                            and time.
                          </p>
                        </div>
                      )} */}

                      {/* Success message if valid future date */}
                    </div>

                    {/* Existing Payment Info */}
                    <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg text-sm">
                      <p className="text-xs text-blue-900 font-semibold">
                        ℹ️ Payment Summary Available on Next Step
                      </p>
                      <p className="text-xs text-blue-800 mt-2">
                        Click "Continue" below to review all charges and extra hubs/launch's on the complete payment page (Step 7).
                      </p>
                    </div>


                    {/* Terms */}
                    <div className="flex items-start gap-3 pt-4 border-t">
                      <input
                        type="checkbox"
                        id="acceptTerms"
                        checked={acceptedTerms}
                        onChange={(e) => setAcceptedTerms(e.target.checked)}
                        className="w-5 h-5 mt-0.5 rounded"
                      />
                      <label
                        htmlFor="acceptTerms"
                        className="text-sm text-muted-foreground cursor-pointer"
                      >
                        I accept the preview and confirm all details are accurate. I
                        understand times are shown in my timezone and saved in UTC.
                      </label>
                    </div>

                  </div> {/* closes space-y-3 */}
                </div>   {/* closes space-y-6 */}

              </CardContent>
            </Card>

            {/* Navigation */}
            <div className="flex justify-between items-center pt-4">
              <Button
                variant="outline"
                size="lg"
                onClick={() => requestStepNavigation(5)}
              >
                <ArrowLeft className="mr-2 h-5 w-5" />
                Back
              </Button>

              <Button
                size="lg"
                onClick={() => handleStep6Continue()}
                disabled={
                  !acceptedTerms ||
                  (sendTo.database &&
                    selectedDatasets.length === 0 &&
                    !sendTo.mycontacts) ||
                  (sendTo.mycontacts &&
                    selectedCustomDatasets.length === 0 &&
                    !sendTo.database)
                }
                className="bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white px-8"
              >
                Continue
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </div>

            <Dialog
              open={showRecurringModal}
              onOpenChange={(open) => {
                // Prevent closing via ESC / outside click
                if (!open) return;
                setShowRecurringModal(open);
              }}
            >
              <DialogContent
                className="
      w-[95vw]
      sm:max-w-2xl

      max-h-[90vh]

      overflow-y-auto
      overflow-x-visible

      rounded-2xl

      p-4
      sm:p-6

      z-[9999]
    "
                onEscapeKeyDown={(e) => e.preventDefault()}
                onPointerDownOutside={(e) => e.preventDefault()}
              >
                <DialogHeader>
                  <DialogTitle className="flex items-center gap-2 text-lg sm:text-xl bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                    <RefreshCw className="h-5 w-5 text-blue-600" />
                    Configure Recurring Schedule
                  </DialogTitle>

                  <DialogDescription className="text-sm sm:text-base">
                    Choose how often your launch should repeat and when it should end
                  </DialogDescription>
                </DialogHeader>

                <div className="space-y-6 py-4 overflow-x-hidden">
                  {/* Recurrence Type */}
                  <div className="space-y-3">
                    <Label className="text-base font-semibold">
                      How often should the launch repeat?
                    </Label>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {[
                        {
                          value: "daily" as const,
                          label: "Every day",
                          description: "Every day",
                        },
                        {
                          value: "weekly" as const,
                          label: "Every week",
                          description: "Every week",
                        },
                        {
                          value: "monthly" as const,
                          label: "Every month",
                          description: "Every month",
                        },
                        {
                          value: "custom" as const,
                          label: "Custom Dates",
                          description: "Select specific dates",
                        },
                      ].map((option) => (
                        <button
                          key={option.value}
                          type="button"
                          onClick={() => setRecurrenceType(option.value)}
                          className={`
                p-4
                rounded-xl
                border-2
                transition-all
                text-left

                ${recurrenceType === option.value
                              ? "border-blue-500 bg-blue-50"
                              : "border-gray-200 bg-white hover:border-blue-300"
                            }
              `}
                        >
                          <div className="font-semibold text-sm">
                            {option.label}
                          </div>

                          <div className="text-xs text-gray-600 mt-1">
                            {option.description}
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* First Send Date & Time */}
                  {recurrenceType !== "custom" && (
                    <div className="space-y-3 p-4 bg-blue-50 border-2 border-blue-200 rounded-xl">
                      <Label className="text-base font-semibold text-blue-900">
                        First Send Date & Time ({effectiveTimezone})
                      </Label>

                      {scheduleOption === "later" ? (
                        <div className="space-y-2">
                          <input
                            type="datetime-local"
                            value={selectedDateTime}
                            min={minDateTimeString}
                            onChange={(e) => {
                              const v = e.target.value;
                              const utc = localToUtcIso(v) || v;
                              if (!utc || new Date(utc) < new Date(Date.now() - 30 * 1000)) {
                                toast({ title: "Invalid Date", description: "You cannot schedule a launch in the past.", variant: "destructive", duration: 1500 });
                                setSelectedDateTime("");
                                return;
                              }
                              setSelectedDateTime(v);
                            }}
                            onClick={(e) => {
                              const target =
                                e.currentTarget as HTMLInputElement;

                              if (target.showPicker) {
                                target.showPicker();
                              }
                            }}
                            className="
                  w-full
                  min-h-[50px]

                  rounded-xl
                  border
                  border-blue-200

                  bg-white

                  px-4
                  py-3

                  text-sm
                  text-slate-900

                  shadow-sm

                  outline-none

                  transition-all
                  duration-200

                  focus:border-blue-500
                  focus:ring-4
                  focus:ring-blue-100

                  cursor-pointer

                  appearance-none

                  relative
                  z-[9999]

                  [&::-webkit-calendar-picker-indicator]:opacity-100
                  [&::-webkit-calendar-picker-indicator]:cursor-pointer
                  [&::-webkit-calendar-picker-indicator]:absolute
                  [&::-webkit-calendar-picker-indicator]:right-3
                  [&::-webkit-calendar-picker-indicator]:top-1/2
                  [&::-webkit-calendar-picker-indicator]:-translate-y-1/2
                  [&::-webkit-calendar-picker-indicator]:pointer-events-auto
                "
                          />

                          {/* <p className="text-xs text-blue-700 font-medium">
                            ⏰ Times shown in{" "}
                            <strong>{effectiveTimezone}</strong>.
                           
                          </p> */}
                          <strong className="text-xs text-blue-700 font-medium">Please Select Time 2 minutes later before scheduling </strong>
                        </div>
                      ) : (
                        <div className="space-y-2">
                          <input
                            type="datetime-local"
                            value={recurringStartDateTime}
                            min={minDateTimeString}
                            onChange={(e) => {
                              const v = e.target.value;
                              const utc = localToUtcIso(v) || v;
                              if (!utc || new Date(utc) < new Date(Date.now() - 30 * 1000)) {
                                toast({ title: "Invalid Date", description: "You cannot schedule a launch in the past.", variant: "destructive", duration: 1500 });
                                setRecurringStartDateTime("");
                                return;
                              }
                              setRecurringStartDateTime(v);
                            }}
                            onClick={(e) => {
                              const target =
                                e.currentTarget as HTMLInputElement;

                              if (target.showPicker) {
                                target.showPicker();
                              }
                            }}
                            className="
                  w-full
                  min-h-[50px]

                  rounded-xl
                  border
                  border-blue-200

                  bg-white

                  px-4
                  py-3

                  text-sm
                  text-slate-900

                  shadow-sm

                  outline-none

                  transition-all
                  duration-200

                  focus:border-blue-500
                  focus:ring-4
                  focus:ring-blue-100

                  cursor-pointer

                  appearance-none

                  relative
                  z-[9999]

                  [&::-webkit-calendar-picker-indicator]:opacity-100
                  [&::-webkit-calendar-picker-indicator]:cursor-pointer
                  [&::-webkit-calendar-picker-indicator]:absolute
                  [&::-webkit-calendar-picker-indicator]:right-3
                  [&::-webkit-calendar-picker-indicator]:top-1/2
                  [&::-webkit-calendar-picker-indicator]:-translate-y-1/2
                  [&::-webkit-calendar-picker-indicator]:pointer-events-auto
                "
                          />

                          {/* <p className="text-xs text-blue-700 font-medium">
                            ⏰ Times shown in{" "}
                            <strong>{effectiveTimezone}</strong>.
                          </p> */}
                          <strong className="text-xs text-blue-700 font-medium">Please Select Time 2 minutes later before scheduling </strong>
                        </div>
                      )}
                    </div>
                  )}

                  {/* End Date */}
                  {recurrenceType !== "custom" && (
                    <div className="space-y-3 p-4 bg-amber-50 border-2 border-amber-200 rounded-xl">
                      <Label className="text-base font-semibold text-amber-900">
                        End Date
                      </Label>

                      <div className="space-y-2">
                        <input
                          type="date"
                          value={recurringEndDate}
                          min={recurringStartDateTime ? recurringStartDateTime.substring(0, 10) : minDateTimeString?.substring(0, 10) || ""}
                          onChange={(e) => {
                            const v = e.target.value;
                            if (!v) {
                              setRecurringEndDate("");
                              return;
                            }
                            
                            // Check if end date is in the past
                            const endDateTime = new Date(`${v}T23:59:59`);
                            const now = new Date();
                            if (endDateTime < now) {
                              toast({ title: "Invalid Date", description: "You cannot set an end date in the past.", variant: "destructive", duration: 1500 });
                              setRecurringEndDate("");
                              return;
                            }
                            
                            // Check if end date is before start date
                            if (recurringStartDateTime) {
                              const startDate = recurringStartDateTime.substring(0, 10);
                              if (v < startDate) {
                                toast({ title: "Invalid End Date", description: "End date must be on or after the first send date.", variant: "destructive", duration: 2000 });
                                setRecurringEndDate("");
                                return;
                              }
                            }
                            setRecurringEndDate(v);
                          }}
                          onClick={(e) => {
                            const target =
                              e.currentTarget as HTMLInputElement;

                            if (target.showPicker) {
                              target.showPicker();
                            }
                          }}
                          className="
                w-full
                min-h-[50px]

                rounded-xl
                border
                border-amber-300

                bg-white

                px-4
                py-3

                text-sm
                text-slate-900

                shadow-sm

                outline-none

                transition-all
                duration-200

                focus:border-amber-500
                focus:ring-4
                focus:ring-amber-100

                cursor-pointer

                appearance-none

                relative
                z-[9999]

                [&::-webkit-calendar-picker-indicator]:opacity-100
                [&::-webkit-calendar-picker-indicator]:cursor-pointer
                [&::-webkit-calendar-picker-indicator]:absolute
                [&::-webkit-calendar-picker-indicator]:right-3
                [&::-webkit-calendar-picker-indicator]:top-1/2
                [&::-webkit-calendar-picker-indicator]:-translate-y-1/2
                [&::-webkit-calendar-picker-indicator]:pointer-events-auto
              "
                        />

                        <p className="text-xs text-amber-700 font-medium">
                          ⏰ Launch will repeat until this date is reached. Sends will use the time from first send date.
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Custom Dates */}
                  {recurrenceType === "custom" && (
                    <div className="space-y-4 p-4 bg-indigo-50 border-2 border-indigo-200 rounded-xl">
                      <Label className="text-base font-semibold text-indigo-900">
                        Select Send Dates ({effectiveTimezone})
                      </Label>

                      <div className="space-y-2">
                        <label
                          htmlFor="custom-recurring-datetime"
                          className="text-xs font-semibold text-indigo-900"
                        >
                          Date & Time
                        </label>

                        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                          <input
                            id="custom-recurring-datetime"
                            type="datetime-local"
                            value={customRecurringDateTime}
                            min={minDateTimeString || undefined}
                            onChange={(e) => {
                              const v = e.target.value;
                              const utc = localToUtcIso(v) || v;
                              if (utc && new Date(utc) < new Date(Date.now() - 30 * 1000)) {
                                toast({ title: "Invalid Date", description: "You cannot add a past date.", variant: "destructive", duration: 1500 });
                                setCustomRecurringDateTime("");
                                return;
                              }
                              setCustomRecurringDateTime(v);
                            }}
                            onClick={(e) => {
                              const target =
                                e.currentTarget as HTMLInputElement;

                              if (target.showPicker) {
                                target.showPicker();
                              }
                            }}
                            className="
                  w-full
                  min-h-[50px]

                  rounded-xl
                  border
                  border-indigo-200

                  bg-white

                  px-4
                  py-3

                  text-sm
                  text-slate-900

                  shadow-sm

                  outline-none

                  transition-all
                  duration-200

                  focus:border-indigo-500
                  focus:ring-4
                  focus:ring-indigo-100

                  cursor-pointer

                  appearance-none

                  relative
                  z-[9999]

                  [&::-webkit-calendar-picker-indicator]:opacity-100
                  [&::-webkit-calendar-picker-indicator]:cursor-pointer
                  [&::-webkit-calendar-picker-indicator]:absolute
                  [&::-webkit-calendar-picker-indicator]:right-3
                  [&::-webkit-calendar-picker-indicator]:top-1/2
                  [&::-webkit-calendar-picker-indicator]:-translate-y-1/2
                  [&::-webkit-calendar-picker-indicator]:pointer-events-auto
                "
                          />

                          <Button
                            type="button"
                            disabled={!customRecurringDateTime}
                            onClick={() => {
                              if (!customRecurringDateTime) return;

                              setCustomRecurringDates(
                                sortDateStringsAscending([
                                  ...customRecurringDates,
                                  customRecurringDateTime,
                                ])
                              );

                              setCustomRecurringDateTime("");
                            }}
                            className="
                  min-h-[50px]
                  w-full
                  sm:w-auto

                  shrink-0

                  rounded-xl

                  bg-indigo-600
                  hover:bg-indigo-700

                  px-5

                  text-white
                  font-medium

                  transition-all

                  disabled:opacity-50
                  disabled:cursor-not-allowed
                "
                          >
                            <Plus className="mr-2 h-4 w-4" />
                            Add
                          </Button>
                        </div>
                      </div>

                      {/* Selected Dates */}
                      <div className="space-y-2">
                        {customRecurringDates.length === 0 && (
                          <p className="text-sm text-indigo-700 italic py-2">
                            No dates selected yet.
                          </p>
                        )}

                        {customRecurringDates.map((date, idx) => (
                          <div
                            key={idx}
                            className="
                  flex
                  items-center
                  justify-between
                  gap-2

                  p-3

                  bg-white

                  rounded-xl

                  border
                  border-indigo-200
                "
                          >
                            <span className="text-sm font-medium text-indigo-900 break-all">
                              {formatUtcDisplay(date)}
                            </span>

                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() =>
                                setCustomRecurringDates(
                                  customRecurringDates.filter(
                                    (_, i) => i !== idx
                                  )
                                )
                              }
                              className="hover:bg-red-50 shrink-0"
                            >
                              <X className="h-4 w-4 text-red-500" />
                            </Button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <DialogFooter className="flex flex-col sm:flex-row gap-3 mt-3">
                  <Button
                    type="button"
                    variant="outline"
                    className="w-full sm:w-auto"
                    onClick={() => setShowRecurringModal(false)}
                  >
                    Cancel
                  </Button>

                  <Button
                    type="button"
                    className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white"
                    onClick={applyRecurringSchedule}
                  >
                    Apply Recurring Schedule
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>

            {/* ========== STEP NAVIGATION CONFIRMATION DIALOG ========== */}
            {/* <Dialog
              open={stepClickTarget !== null}
                onOpenChange={(open) => {
    if (!open) handleCancelStepNav();
  }}
>
  <DialogContent className="sm:max-w-sm rounded-2xl p-0 overflow-hidden">
    <div className="px-6 pt-6 pb-4">
      <DialogHeader>
        <DialogTitle className="text-lg font-semibold text-gray-900">
          Navigate to another step?
        </DialogTitle>
        <DialogDescription className="mt-2 text-sm text-gray-600 leading-relaxed">
          Going to a different step will discard any unsaved changes
          and reset progress. Are you sure you want to continue?
        </DialogDescription>
      </DialogHeader>
    </div>
    <div className="flex items-center justify-end gap-3 px-6 pb-6">
      <Button
        variant="outline"
        onClick={handleCancelStepNav}
        className="min-w-[88px]"
      >
        Cancel
      </Button>
      <Button
        onClick={handleConfirmStepNav}
        className="min-w-[120px] bg-red-600 hover:bg-red-700 text-white"
      >
        Yes, Continue
      </Button>
    </div>
  </DialogContent>
</Dialog> */}

            {/* ========== CHECKOUT MODAL ========== */}
            <Dialog
              open={showCheckoutModal}
              onOpenChange={(open) => {
                //  Only allow closing via Back/Save buttons
                if (!open) {
                  // Prevent closing via ESC or outside click
                  return;
                }
                setShowCheckoutModal(open);
              }}
            >
              <DialogContent
                className="sm:max-w-2xl max-h-[90vh] overflow-y-auto"
                // FIX: Prevent closing via ESC key
                onEscapeKeyDown={(e) => e.preventDefault()}
                // FIX: Prevent closing via clicking outside the modal
                onPointerDownOutside={(e) => e.preventDefault()}
              >
                <DialogHeader>
                  <DialogTitle className="flex items-center gap-2 text-xl bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">
                    <ShoppingCart className="h-5 w-5 text-green-600" />
                    {hasRecurringCheckoutData ? "Review Your Recurring Launch" : "Review Your Extra HUb"}
                  </DialogTitle>
                  <DialogDescription>
                    {hasRecurringCheckoutData ? "Review charges before confirming your recurring launch" : "Review charges before confirming your extra hub"}
                  </DialogDescription>
                </DialogHeader>

                {checkoutData && (
                  <div className="space-y-4 py-4">
                    {hasRecurringCheckoutData && (
                      <div className="flex justify-end">
                        <Button
                          type="button"
                          variant="ghost"
                          size="sm"
                          onClick={() => {
                            setIsRecurringCampaign(false);
                            setRecurringReviewConfirmed(false);
                            setShowCheckoutModal(false);
                            setShowRecurringModal(true);
                          }}
                          className="text-blue-600 hover:text-blue-700 hover:bg-blue-100 text-xs h-auto px-2 py-1"
                        >
                          Edit Recurring
                        </Button>
                      </div>
                    )}
                    {renderPaymentSummaryCard("modal", hasRecurringCheckoutData)}
                    <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-xs text-amber-800">
                      <strong>Note:</strong> Each send includes 1 hub. Charges only apply to launches not covered by credits and any extra hubs selected for that send.
                    </div>
                    {false && (
                      <>
                        {/* Campaign/Send Summary - Conditional based on recurring or send now */}
                        {isRecurringCampaign ? (
                          <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                            <div className="flex justify-between items-start mb-3">
                              <p className="text-sm font-semibold text-blue-900">Launch Summaryfdhgfh</p>
                              <Button
                                type="button"
                                variant="ghost"
                                size="sm"
                                onClick={() => {
                                  setIsRecurringCampaign(false);
                                  setShowCheckoutModal(false);
                                  setShowRecurringModal(true);
                                }}
                                className="text-blue-600 hover:text-blue-700 hover:bg-blue-100 text-xs h-auto px-2 py-1"
                              >
                                Edit Recurring
                              </Button>
                            </div>
                            <div className="space-y-2 text-sm text-blue-800">
                              <div className="flex justify-between">
                                <span>Recurrence Type:</span>
                                <span className="font-semibold capitalize">{checkoutData.recurrenceType}</span>
                              </div>
                              <div className="flex justify-between">
                                <span>Start Date:</span>
                                <span className="font-semibold">{formatUtcDisplay(checkoutData.firstDate)}</span>
                              </div>
                              <div className="flex justify-between">
                                <span>End Date:</span>
                                <span className="font-semibold">{formatUtcDisplay(checkoutData.endDate)}</span>
                              </div>
                              <div className="flex justify-between">
                                <span>Total Sends:</span>
                                <span className="font-semibold">{checkoutData.recurringCount}</span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                            <p className="text-sm font-semibold text-blue-900 mb-3">Send Summary</p>
                            <div className="space-y-2 text-sm text-blue-800">
                              <div className="flex justify-between">
                                <span>Send Option:</span>
                                <span className="font-semibold">Send Now (Immediate)</span>
                              </div>
                              <div className="flex justify-between">
                                <span>Sent At:</span>
                                <span className="font-semibold">{new Date().toUTCString().replace("GMT", "UTC")}</span>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Recipients & Associations */}
                        <div className="p-4 bg-purple-50 border border-purple-200 rounded-lg">
                          <p className="text-sm font-semibold text-purple-900 mb-3">Recipients & Hub</p>
                          <div className="space-y-2 text-sm text-purple-800">
                            <div className="flex justify-between">
                              <span>LaunchIQ Database Hubs:</span>
                              <span className="font-semibold">
                                {sendTo.database ? selectedDatasets.length : 0}
                              </span>
                            </div>
                            <div className="flex justify-between">
                              <span>Your Agent Datasets (My Hubs):</span>
                              <span className="font-semibold">
                                {sendTo.mycontacts ? selectedCustomDatasets.length : 0}
                              </span>
                            </div>
                            <div className="flex justify-between">
                              <span>Default Hub (Included):</span>
                              <span className="font-semibold">1</span>
                            </div>
                            {checkoutData.extraAssociationsCount > 0 && (
                              <div className="flex justify-between text-orange-700 font-semibold pt-2 border-t border-purple-200">
                                <span>Extra LaunchIQ Hubs (billable):</span>
                                <span>{checkoutData.extraAssociationsCount}</span>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Selected Dates (for custom recurrence) */}
                        {checkoutData.recurrenceType === "custom" && checkoutData.customRecurringDates.length > 0 && (
                          <div className="p-4 bg-indigo-50 border border-indigo-200 rounded-lg">
                            <p className="text-sm font-semibold text-indigo-900 mb-3">Custom Send Dates</p>
                            <div className="space-y-1 max-h-32 overflow-y-auto">
                              {checkoutData.customRecurringDates.map((date, idx) => (
                                <div key={idx} className="text-xs text-indigo-700 flex items-center gap-1">
                                  <Calendar className="h-3 w-3" />
                                  {formatUtcDisplay(date)}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Pricing Breakdown */}
                        <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg">
                          <p className="text-sm font-semibold text-gray-900 mb-3">Pricing Breakdown</p>

                          <div className="space-y-2 text-sm">
                            {isRecurringCampaign ? (
                              (() => {
                                const totalSends = Number(checkoutData.recurringCount) || 1;
                                const totalSelected = Number(checkoutData.selectedAssociations ?? 0);
                                const remainingCamps = remainingCampaigns ?? 0;

                                const freeLaunches = Math.min(Math.max(remainingCamps, 0), totalSends);
                                const paidLaunches = Math.max(0, totalSends - freeLaunches);

                                // 1 hub is included with each launch (free or paid)
                                const includedHubsPerSend = totalSelected > 0 ? 1 : 0;
                                const extraHubsPerSend = Math.max(0, totalSelected - includedHubsPerSend);

                                const day1PaidLaunch = remainingCamps > 0 ? 0 : 1;
                                const paidLaunchesAfterDay1 = Math.max(0, paidLaunches - day1PaidLaunch);

                                const remainingSends = Math.max(0, totalSends - 1);

                                const effectiveOneTimePlan =
                                  Boolean(checkoutData.selectedOneTimePlan) || Boolean(selectedOneTimePlan);
                                const effectiveOneTimePrice =
                                  checkoutData.oneTimePlanPrice || selectedOneTimePrice;

                                const billing = calculateBillingDetails({
                                  totalSelected,
                                  totalSends,
                                  remainingCamps,
                                  extraLaunchCredits: extraLaunchCredits ?? 0,
                                  isOneTimePlan: effectiveOneTimePlan,
                                  oneTimePlanPrice: effectiveOneTimePrice,
                                });

                                const day1Charge = (day1PaidLaunch * campaignAddOnPrice) + (extraHubsPerSend * associationAddOnPrice);

                                const remainingDaysCharge = (paidLaunchesAfterDay1 * campaignAddOnPrice) + (remainingSends * extraHubsPerSend * associationAddOnPrice);

                                const totalCharge = billing.totalCharge;

                                return (
                                  <>
                                    <div className="flex justify-between text-gray-700 font-semibold">
                                      <span>Day 1 Charge:</span>
                                      <span>${day1Charge.toFixed(2)}</span>
                                    </div>

                                    <div className="ml-4 text-xs text-gray-600 pb-2 space-y-1">
                                      <div>
                                        {day1PaidLaunch > 0
                                          ? `$${(campaignAddOnPrice)} for 1 launch`
                                          : `${freeLaunches} launch${totalSends !== 1 ? "es" : ""} covered by your remaining credits`}
                                      </div>
                                      {extraHubsPerSend > 0 ? (
                                        <div>
                                          ${((extraHubsPerSend) * (associationAddOnPrice)).toFixed(2)} for {extraHubsPerSend} extra hub{extraHubsPerSend !== 1 ? "s" : ""} (Day 1)
                                        </div>
                                      ) : (
                                        <div>1 hub included with the launch</div>
                                      )}
                                      <div>
                                        Credits applied: {freeLaunches}/{totalSends} launches
                                      </div>
                                    </div>

                                    {totalSends > 1 && (
                                      <>
                                        <div className="border-t border-gray-300 pt-2 mt-2"></div>
                                        <div className="flex justify-between text-gray-700 font-semibold">
                                          <span>Days 2-{totalSends}:</span>
                                          <span>${remainingDaysCharge.toFixed(2)}</span>
                                        </div>
                                        <div className="ml-4 text-xs text-gray-600 pb-2 space-y-1">
                                          {paidLaunchesAfterDay1 > 0 && (
                                            <div>
                                              ${(paidLaunchesAfterDay1 * campaignAddOnPrice).toFixed(2)} for {paidLaunchesAfterDay1} remaining paid launch{paidLaunchesAfterDay1 !== 1 ? "es" : ""}
                                            </div>
                                          )}
                                          {extraHubsPerSend > 0 && (
                                            <div>
                                              ${(remainingSends * extraHubsPerSend * associationAddOnPrice).toFixed(2)} for extra hubs ({remainingSends} sends × {extraHubsPerSend} extra hub × ${associationAddOnPrice})
                                            </div>
                                          )}
                                          {paidLaunchesAfterDay1 === 0 && extraHubsPerSend === 0 && (
                                            <div>No additional charges</div>
                                          )}
                                        </div>
                                      </>
                                    )}

                                    <div className="border-t border-gray-300 pt-2 mt-3 flex justify-between">
                                      <span className="font-bold text-gray-900">Total Amount:</span>
                                      <span className="text-lg font-bold text-green-600">
                                        ${totalCharge.toFixed(2)}
                                      </span>
                                    </div>
                                  </>
                                );
                              })()
                            ) : (
                              <>
                                {/* Send Now Pricing - Day 1 only */}
                                <div className="flex justify-between text-gray-700 font-semibold">
                                  <span>Launch:</span>
                                  <span className={checkoutData.campaignNeedsPayment ? "" : "text-green-600"}>
                                    {checkoutData.campaignNeedsPayment ? `$${campaignAddOnPrice}` : "Free (included)"}
                                  </span>
                                </div>
                                <div className="ml-4 text-xs text-gray-600 mb-2">
                                  {checkoutData.campaignNeedsPayment
                                    ? "1 campaign (no free campaigns left)"
                                    : "1 campaign included in your plan"}
                                </div>

                                {checkoutData.extraAssociationsCount > 0 ? (
                                  <>
                                    <div className="border-t border-gray-300 pt-2 mt-2"></div>
                                    {(() => {
                                      const totalExtraHubs = checkoutData.extraAssociationsCount;
                                      const extraHubsCredit = extraHubsCredit || 0;
                                      const extraHubsCreditUsed = Math.min(extraHubsCredit, totalExtraHubs);
                                      const extraHubsToCharge = totalExtraHubs - extraHubsCreditUsed;
                                      const extraHubCharge = extraHubsToCharge * associationAddOnPrice;

                                      return (
                                        <>
                                          {extraHubsCreditUsed > 0 && (
                                            <div className="flex justify-between text-gray-700 font-semibold mb-2">
                                              <span>Extra Hubs:</span>
                                              <span>${extraHubCharge.toFixed(2)}</span>
                                            </div>
                                          )}
                                          {extraHubsCreditUsed === 0 && (
                                            <div className="flex justify-between text-gray-700 font-semibold mb-2">
                                              <span>Extra Hubs:</span>
                                              <span>${extraHubCharge.toFixed(2)}</span>
                                            </div>
                                          )}
                                          <div className="ml-4 text-xs text-gray-600 pb-2 space-y-1">
                                            <div>
                                              Total needed: {totalExtraHubs} extra hub{totalExtraHubs !== 1 ? 's' : ''}
                                            </div>
                                            {extraHubsCreditUsed > 0 && (
                                              <div className="text-emerald-700 font-semibold">
                                                -{extraHubsCreditUsed} covered by extra hub credits
                                              </div>
                                            )}
                                            {extraHubsToCharge > 0 && (
                                              <div>
                                                {extraHubsToCharge} extra hub{extraHubsToCharge !== 1 ? 's' : ''} × ${associationAddOnPrice} = ${extraHubCharge.toFixed(2)}
                                              </div>
                                            )}
                                            {extraHubsCreditUsed > 0 && extraHubsToCharge === 0 && (
                                              <div className="text-emerald-700 font-semibold">
                                                ✓ Fully covered by credits - No charge
                                              </div>
                                            )}
                                          </div>
                                        </>
                                      );
                                    })()}

                                    {/* Total */}
                                    <div className="border-t border-gray-300 pt-2 mt-3 flex justify-between">
                                      <span className="font-bold text-gray-900">Day 1 Total:</span>
                                      <span className="text-lg font-bold text-green-600">
                                        ${(() => {
                                          const totalExtraHubs = checkoutData.extraAssociationsCount;
                                          const extraHubsCredit = extraHubsCredit || 0;
                                          const extraHubsCreditUsed = Math.min(extraHubsCredit, totalExtraHubs);
                                          const extraHubsToCharge = totalExtraHubs - extraHubsCreditUsed;
                                          const extraHubCharge = extraHubsToCharge * associationAddOnPrice;
                                          return ((checkoutData.campaignNeedsPayment ? campaignAddOnPrice : 0) + extraHubCharge).toFixed(2);
                                        })()}
                                      </span>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="border-t border-gray-300 pt-2 mt-3 flex justify-between">
                                      <span className="font-bold text-gray-900">Day 1 Total:</span>
                                      <span className="text-lg font-bold text-green-600">
                                        ${(checkoutData.campaignNeedsPayment ? (campaignAddOnPrice) : 0).toFixed(2)}
                                      </span>
                                    </div>
                                    {!checkoutData.campaignNeedsPayment && (
                                      <div className="text-xs text-green-700 mt-1">
                                        ✓ No charge - 1 Launch and 1 hub included in your plan
                                      </div>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        </div>

                        {/* Terms */}
                        <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
                          <p className="text-xs text-amber-800">
                            <strong>Note:</strong> {isRecurringCampaign
                              ? "We apply your remaining launch credits across all scheduled sends. Each launch includes 1 hub free; you only pay for extra launches and extra hubs."
                              : "Each launch includes 1 hub free; you only pay for extra launches (if no credits) and extra hubs."}
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                )}

                <DialogFooter className="flex gap-3">
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => {
                      if (hasRecurringCheckoutData) {
                        // Going back to recurring modal
                        setRecurringReviewConfirmed(false);
                        setShowCheckoutModal(false);
                        setShowRecurringModal(true);
                      } else {
                        // Going back from extra associations review - reset and close
                        setShowCheckoutModal(false);
                        setCheckoutData(null);
                        setRecurringReviewAmount(0);
                        setRecurringReviewConfirmed(false);
                      }
                    }}
                  >
                    Back
                  </Button>
                  <Button
                    type="button"
                    disabled={isProcessingCheckout}
                    onClick={() => {
                      // Calculate the total payment amount based on checkout data
                      let totalCharge = 0;

                      if (checkoutData) {
                        const totalSelected = Number(checkoutData.selectedAssociations ?? 0);
                        const totalSends =
                          hasRecurringCheckoutData && checkoutData.recurringCount
                            ? Number(checkoutData.recurringCount) || 1
                            : 1;

                        const billing = calculateBillingDetails({
                          totalSelected,
                          totalSends,
                          remainingCamps: remainingCampaigns ?? 0,
                          extraHubsCredit: extraHubsCredit || 0,
                          extraLaunchCredits: extraLaunchCredits ?? 0,
                          isOneTimePlan: checkoutData.selectedOneTimePlan || selectedOneTimePlan,
                          oneTimePlanPrice: checkoutData.oneTimePlanPrice || selectedOneTimePrice,
                        });

                        totalCharge = billing.totalCharge;
                      }

                      setIsRecurringCampaign(hasRecurringCheckoutData);
                      setPaymentAmount(totalCharge);
                      setRecurringReviewAmount(totalCharge);
                      setRecurringReviewConfirmed(true);
                      setCheckoutData((prev: any) =>
                        prev
                          ? {
                            ...prev,
                            reviewTotalCharge: totalCharge,
                            reviewConfirmed: true,
                          }
                          : prev
                      );
                      setShowPaymentForm(totalCharge > 0);
                      setNeedsPayment(totalCharge > 0);
                      setShowCheckoutModal(false);
                      // Stay on step 6 - let the step 6 Continue button handle step advancement
                    }}
                    className="bg-green-600 hover:bg-green-700 text-white"
                  >
                    Save & Continue
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          </div>
        );

      // =========================================================================
      // STEP 7: Complete Payment (NEW CHECKOUT STEP)
      // =========================================================================
      case 7: {
        const currentPaymentAmount = getCheckoutPaymentAmount();
        return (
          <div className="w-full max-w-2xl mx-auto">
            {/* Header */}
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4">
                <CreditCard className="h-8 w-8 text-blue-600" />
              </div>
              <h2 className="text-2xl font-bold text-primary text-center">
                Complete Payment
              </h2>
              <p className="text-gray-600">
                Enter your payment details to proceed with your launch
              </p>
            </div>

            {/* Pricing Breakdown */}
            {checkoutData && (
              <>
                {renderPaymentSummaryCard("page")}
                {false && (
                  <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg mb-6">
                    <p className="text-sm font-semibold text-gray-900 mb-3">Pricing Breakdown</p>
                    <div className="space-y-2 text-sm">
                      {(() => {
                        const totalSelected = Number(checkoutData.selectedAssociations ?? 0);
                        const totalSends =
                          isRecurringCampaign && checkoutData.recurringCount
                            ? Number(checkoutData.recurringCount) || 1
                            : 1;

                        const remainingCamps = remainingCampaigns ?? 0;
                        const campaignUnitPrice = campaignAddOnPrice;
                        const associationUnitPrice = associationAddOnPrice;
                        const freeLaunches = Math.min(Math.max(remainingCamps, 0), totalSends);
                        const paidLaunches = Math.max(0, totalSends - freeLaunches);

                        const includedHubsPerSend = totalSelected > 0 ? 1 : 0;
                        const extraHubsPerSend = Math.max(0, totalSelected - includedHubsPerSend);

                        const day1PaidLaunch = remainingCamps > 0 ? 0 : 1;
                        const paidLaunchesAfterDay1 = Math.max(0, paidLaunches - day1PaidLaunch);
                        const remainingSends = Math.max(0, totalSends - 1);

                        const effectiveOneTimePlan =
                          Boolean(checkoutData.selectedOneTimePlan) || Boolean(selectedOneTimePlan);
                        const effectiveOneTimePrice =
                          checkoutData.oneTimePlanPrice || selectedOneTimePrice;

                        const billing = calculateBillingDetails({
                          totalSelected,
                          totalSends,
                          remainingCamps: remainingCampaigns ?? 0,
                          extraLaunchCredits: extraLaunchCredits ?? 0,
                          isOneTimePlan: effectiveOneTimePlan,
                          oneTimePlanPrice: effectiveOneTimePrice,
                        });

                        const day1Charge = effectiveOneTimePlan
                          ? effectiveOneTimePrice + (extraHubsPerSend * associationUnitPrice)
                          : (day1PaidLaunch * campaignUnitPrice) + (extraHubsPerSend * associationUnitPrice);

                        const remainingDaysCharge = effectiveOneTimePlan
                          ? (remainingSends * campaignUnitPrice) + (remainingSends * extraHubsPerSend * associationUnitPrice)
                          : (paidLaunchesAfterDay1 * campaignUnitPrice) + (remainingSends * extraHubsPerSend * associationUnitPrice);

                        const totalCharge = billing.totalCharge;

                        return (
                          <>
                            {effectiveOneTimePlan && (
                              <div className="flex justify-between text-gray-700 font-semibold">
                                <span>One-Time Plan Price:</span>
                                <span>${effectiveOneTimePrice.toFixed(2)}</span>
                              </div>
                            )}

                            <div className="flex justify-between text-gray-700 font-semibold">
                              <span>Day 1 Charge:</span>
                              <span>${day1Charge.toFixed(2)}</span>
                            </div>

                            {/* Detailed explanation like the recurring review modal */}
                            <div className="ml-4 text-xs text-gray-600 pb-2 space-y-1">
                              <div>
                                {effectiveOneTimePlan
                                  ? `$${effectiveOneTimePrice.toFixed(2)} for one-time plan`
                                  : day1PaidLaunch > 0
                                    ? `$${campaignAddOnPrice} for 1 launch`
                                    : `${totalSends} launch${totalSends !== 1 ? "es" : ""} covered by your remaining credits`}
                              </div>
                              {extraHubsPerSend > 0 ? (
                                <div>
                                  ${((extraHubsPerSend) * (associationUnitPrice)).toFixed(2)} for {extraHubsPerSend} extra hub{extraHubsPerSend !== 1 ? "s" : ""} (Day 1)
                                </div>
                              ) : (
                                <div>1 hub included with the launch</div>
                              )}
                              <div>
                                Credits applied: {freeLaunches}/{totalSends} launches
                              </div>
                            </div>

                            {isRecurringCampaign && totalSends > 1 && (
                              <>
                                <div className="border-t border-gray-300 pt-2 mt-2"></div>
                                <div className="flex justify-between text-gray-700 font-semibold">
                                  <span>Days 2-{totalSends}:</span>
                                  <span>${remainingDaysCharge.toFixed(2)}</span>
                                </div>
                                <div className="ml-4 text-xs text-gray-600 pb-2 space-y-1">
                                  {effectiveOneTimePlan ? (
                                    <>
                                      <div>
                                        ${(remainingSends * campaignUnitPrice + remainingSends * extraHubsPerSend * associationAddOnPrice).toFixed(2)} for {remainingSends} paid launches and {extraHubsPerSend} extra hub{extraHubsPerSend !== 1 ? "s" : ""} each
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {paidLaunchesAfterDay1 > 0 && (
                                        <div>
                                          ${(paidLaunchesAfterDay1 * campaignAddOnPrice).toFixed(2)} for {paidLaunchesAfterDay1} paid launch{paidLaunchesAfterDay1 !== 1 ? "es" : ""}
                                        </div>
                                      )}
                                      {extraHubsPerSend > 0 && (
                                        <div>
                                          ${(remainingSends * extraHubsPerSend * associationAddOnPrice).toFixed(2)} for extra hubs ({remainingSends} sends × {extraHubsPerSend} extra hub × ${associationAddOnPrice})
                                        </div>
                                      )}
                                      {paidLaunchesAfterDay1 === 0 && extraHubsPerSend === 0 && (
                                        <div>No additional charges</div>
                                      )}
                                    </>
                                  )}
                                </div>
                              </>
                            )}

                            <div className="border-t border-gray-300 pt-2 mt-3 flex justify-between">
                              <span className="font-bold text-gray-900">Total Amount:</span>
                              <span className="text-lg font-bold text-green-600">
                                ${totalCharge.toFixed(2)}
                              </span>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </div>
                )}
              </>
            )}

            {/* Terms */}
            {false && isRecurringCampaign && checkoutData && (
              <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg mb-6">
                <p className="text-xs text-amber-800">
                  <strong>Note:</strong> We apply your remaining launch credits across all scheduled sends. Each launch includes 1 hub free; you only pay for extra launches and extra hubs.
                </p>
              </div>
            )}

            {/* ✅ ADD-ON DETAILS DISPLAY */}
            {/* {checkoutData && (
              <Card className="mb-6 bg-blue-50 border-blue-200">
                <CardHeader>
                  <CardTitle className="text-lg">Add-On Details</CardTitle>
                </CardHeader>
                <CardContent className="space-y-3">
                  <div className="flex justify-between">
                    <span className="text-gray-700">Selected Hub:</span>
                    <span className="font-semibold">
                      {checkoutData.selectedAssociations}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-700">Extra Hub:</span>
                    <span className="font-semibold">
                      {checkoutData.extraAssociationsCount}
                    </span>
                  </div>
                  {isRecurringCampaign && (
                    <>
                      <div className="flex justify-between">
                        <span className="text-gray-700">Recurrence:</span>
                        <span className="font-semibold capitalize">
                          {checkoutData.recurrenceType}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-700">Total Sends:</span>
                        <span className="font-semibold">
                          {checkoutData.recurringCount}
                        </span>
                      </div>
                    </>
                  )}
                </CardContent>
              </Card>
            )} */}

            {/* 🎯 COMPREHENSIVE PAYMENT REVIEW SECTION */}
            {/* <Card className="mb-6 bg-gradient-to-br from-purple-50 to-indigo-50 border-2 border-purple-200 rounded-xl">
              <CardHeader className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-t-lg">
                <CardTitle className="text-xl flex items-center gap-2">
                  <CreditCard className="h-5 w-5" />
                  Payment Summary
                </CardTitle>
              </CardHeader>
              <CardContent className="p-6">
                <div className="space-y-4">
                  {/* Extra Campaigns Section */}
            {/* {checkoutData?.campaignNeedsPayment && (
                    <div className="bg-white rounded-lg p-4 border border-purple-200">
                      <div className="flex justify-between items-start mb-2">
                        <div>
                          <p className="font-semibold text-gray-900">Extra Launch</p>
                          <p className="text-xs text-gray-600 mt-1">Additional launch beyond your plan limit</p>
                        </div>
                        <div className="text-right">
                          <p className="text-2xl font-bold text-purple-600">1</p>
                        </div>
                      </div>
                      <div className="bg-gray-50 rounded px-3 py-2 flex justify-between text-sm">
                        <span className="text-gray-700">
                          1 Launch × ${campaignAddOnPrice}
                        </span>
                        <span className="font-semibold text-gray-900">
                          ${(campaignAddOnPrice).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  )} */}

            {/* Extra Associations Section */}
            {/* {checkoutData?.extraAssociationsCount > 0 && (
                    <div className="bg-white rounded-lg p-4 border border-indigo-200">
                      <div className="flex justify-between items-start mb-2">
                        <div>
                          <p className="font-semibold text-gray-900">Extra Hub</p>
                          <p className="text-xs text-gray-600 mt-1">Additional hub beyond your plan limit</p>
                        </div>
                        <div className="text-right">
                          <p className="text-2xl font-bold text-indigo-600">
                            {checkoutData.extraAssociationsCount}
                          </p>
                        </div>
                      </div>
                      <div className="bg-gray-50 rounded px-3 py-2 flex justify-between text-sm">
                        <span className="text-gray-700">
                          {checkoutData.extraAssociationsCount} hub{checkoutData.extraAssociationsCount !== 1 ? 's' : ''} × ${associationAddOnPrice}
                        </span>
                        <span className="font-semibold text-gray-900">
                          ${(checkoutData.extraAssociationsCount * (associationAddOnPrice)).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  )} */}

            {/* Total Amount */}
            {/* <div className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg p-4 border-2 border-purple-400">
                    <div className="flex justify-between items-center">
                      <span className="text-lg font-semibold">Total Amount Due</span>
                      <div className="text-right">
                        <p className="text-4xl font-bold">
                          ${paymentAmount?.toFixed(2) || '0.00'}
                        </p>
                        <p className="text-xs text-purple-100 mt-1">Charged to your card</p>
                      </div>
                    </div>
                  </div> */}

            {/* Breakdown Details */}
            {/* <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                    <p className="text-xs font-semibold text-gray-700 mb-3 uppercase tracking-wide">Breakdown</p>
                    <div className="space-y-2 text-sm">
                      {checkoutData?.campaignNeedsPayment && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Launch:</span>
                          <span className="text-gray-900">
                            1 × ${campaignAddOnPrice} = ${(campaignAddOnPrice).toFixed(2)}
                          </span>
                        </div>
                      )}
                      {checkoutData?.extraAssociationsCount > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-600">Hub:</span>
                          <span className="text-gray-900">
                            {checkoutData.extraAssociationsCount} × ${associationAddOnPrice} = ${(checkoutData.extraAssociationsCount * (associationAddOnPrice)).toFixed(2)}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </CardContent> */}
            {/* </Card>  */}

            {/* Payment Form */}
            {showPaymentForm && currentPaymentAmount > 0 ? (
              <Card className="bg-white rounded-xl border border-gray-200 mb-6">
                <CardContent className="p-8">
                  <StripePaymentForm
                    amount={currentPaymentAmount}
                    campaignId={selectedProperty?.id || undefined}
                    purchaseType={isRecurringCampaign ? "recurring_campaign" : "campaign_payment"}
                    onPaymentSuccess={async (paymentIntentId) => {
                      try {
                        // ✅ NEW: Save add-on purchase details after payment
                        const campaignNeedsPayment = checkoutData?.campaignNeedsPayment || false;
                        const addonType = campaignNeedsPayment
                          ? (isRecurringCampaign ? 'recurring_campaign' : 'campaign_bundle')
                          : 'association';

                        await axiosInstance.post(`/campaign/save-addon-purchase/`, {
                          payment_intent_id: paymentIntentId,
                          addon_type: addonType,
                          selected_associations: checkoutData?.selectedAssociations || 0,
                          extra_associations_count: checkoutData?.extraAssociationsCount || 0,
                          recurring_type: checkoutData?.recurrenceType || null,
                          recurring_count: checkoutData?.recurringCount || 1,
                          first_date: checkoutData?.firstDate || new Date().toISOString(),
                          end_date: checkoutData?.endDate || null,
                          total_amount: currentPaymentAmount,
                        });

                      } catch (err) {
                        console.error('Save add-on purchase error:', err);
                      }

                      // NEW: Record extra association usage for monthly tracking
                      if (checkoutData?.extraAssociationsCount && checkoutData.extraAssociationsCount > 0) {
                        try {
                          const now = new Date();
                          await axiosInstance.post(`/campaign/record-extra-associations/`, {
                            payment_intent_id: paymentIntentId,
                            count: checkoutData.extraAssociationsCount,
                            month: now.getMonth() + 1,
                            year: now.getFullYear(),
                            schedule_option: scheduleOption,
                            campaign_type: campaignType,
                          });

                        } catch (err) {
                          console.error('Record extra associations error:', err);
                        }
                      }

                      try {
                        // Persist payment server-side by calling confirm endpoint
                        await axiosInstance.post(`/campaign/confirm-payment/`, {
                          payment_intent_id: paymentIntentId,
                          campaign_id: checkoutData?.campaign_id || null,
                          purchase_type: isRecurringCampaign ? "recurring_campaign" : "campaign_payment",
                        });
                      } catch (err) {
                        console.error('Confirm payment API error:', err);
                      }

                      try {
                        const meRes = await axiosInstance.get(endpoints.me);
                        const updatedUser = meRes.data?.user ?? meRes.data;
                        setUser(updatedUser);
                        setPlanDetails(updatedUser);
                        setRemainingCampaigns(updatedUser.get_remaining_campaigns || 0);
                        setRemainingAssociations(updatedUser.remaining_associations || 0);
                        localStorage.setItem("has_plan", updatedUser.plan ? "true" : "false");
                        setSelectedPricingPlan(null);
                      } catch (err) {
                        console.error("Failed to refresh user after one-time plan purchase:", err);
                      }

                      // ✅ NEW: Extract session ID from current URL and call verify_payment
                      const params = new URLSearchParams(window.location.search);
                      const sessionId = params.get("session_id");
                      if (sessionId) {
                        try {
                          const verifyRes = await axiosInstance.get(`${endpoints.verify_payment}?session_id=${sessionId}`);
                          if (verifyRes.data.success) {
                          }
                        } catch (err) {
                          console.error("Failed to verify payment at success:", err);
                        }
                      }

                      setIsRecurringCampaign(Boolean(checkoutData?.recurrenceType));
                      setPaymentCompleted(true);
                      setPaymentIntentId(paymentIntentId);
                      toast({
                        title: "✓ Payment Successful",
                        description: "Your payment has been processed and add-on details have been saved.",
                        variant: "default",
                        duration: 2000
                      });
                      setShowPaymentForm(false);
                      // await handleSaveDraftBeforePayment();
                      setCurrentStep(8);
                    }}
                    onPaymentError={(error) => {
                      toast({
                        title: "Payment Failed",
                        description: error,
                        variant: "destructive",
                      });
                    }}
                  />
                </CardContent>
              </Card>
            ) : currentPaymentAmount <= 0 ? (
              <Card className="bg-white rounded-xl border border-gray-200 mb-6">
                <CardContent className="p-8 text-center">
                  <p className="text-sm text-gray-600 mb-4">
                    Your launch credits cover this send. No payment is due.
                  </p>
                  {/* <Button
                    type="button"
                    className="bg-green-600 hover:bg-green-700 text-white"
                    onClick={() => {
                      setShowPaymentForm(false);
                      setNeedsPayment(false);
                      setCurrentStep(8);
                    }}
                  >
                    Continue
                  </Button> */}
                </CardContent>
              </Card>
            ) : (
              <div className="text-center py-8">
                <p className="text-gray-600">Loading payment form...</p>
              </div>
            )}

            {/* Navigation */}
            <div className="flex justify-between items-center pt-6 border-t">
              <Button
                variant="outline"
                size="lg"
                onClick={() => requestStepNavigation(6)}
              >
                <ArrowLeft className="mr-2 h-5 w-5" />
                Back
              </Button>

              {currentPaymentAmount <= 0 && (
                <Button
                  type="button"
                  size="lg"
                  className="bg-green-600 hover:bg-green-700 text-white"
                  onClick={() => {
                    setShowPaymentForm(false);
                    setNeedsPayment(false);
                    setCurrentStep(8);
                  }}
                >
                  Continue
                </Button>
              )}
            </div>
          </div>
        );
      }

      // =========================================================================
      // STEP 8: Final Preview & Send with Dynamic Engagement Predictions
      // =========================================================================
      case 8: {
        const localPredictions = calculateEngagementPredictions;
        const predictions = aiPrediction
          ? {
            ...localPredictions,
            engagementScore: engagementScore !== null ? engagementScore : localPredictions.engagementScore,
            openRate: aiPrediction.open_rate,
            clickRate: aiPrediction.click_rate,
            estimatedOpens: Math.round(recipientCount * (aiPrediction.open_rate / 100)),
            estimatedClicks: Math.round(recipientCount * (aiPrediction.click_rate / 100)),
            insights: [aiPrediction.explanation || "AI prediction applied", ...(localPredictions.insights || [])],
          }
          : {
            ...localPredictions,
            engagementScore: engagementScore !== null ? engagementScore : localPredictions.engagementScore,
          };

        return (
          <div className="w-full max-w-4xl mx-auto space-y-6 sm:space-y-8">
            {/* Header */}
            <div className="text-center mb-6 sm:mb-8">
              <div className="inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-red-100 mb-4">
                <Sparkles className="h-7 w-7 sm:h-8 sm:w-8 text-[#ff1f1f]" />
              </div>
              <h2 className="text-2xl font-bold text-primary mb-8 text-center">
                You're All Set to Launch!
              </h2>
            </div>

            {/* Payment Status Message */}
            {/* {needsPayment && paymentCompleted && (
              <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4 sm:p-5">
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <h3 className="font-semibold text-green-900">Payment Confirmed</h3>
                    <p className="text-sm text-green-800 mt-1">
                      Your payment for 1 campaign (${campaignAddOnPrice}) + {recipientCount} association{recipientCount !== 1 ? 's' : ''} ({recipientCount} × ${associationAddOnPrice} = ${(recipientCount * associationAddOnPrice).toFixed(2)}) has been processed successfully. Total: ${(campaignAddOnPrice + (recipientCount * associationAddOnPrice)).toFixed(2)}.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {!needsPayment && (
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 sm:p-5">
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <h3 className="font-semibold text-blue-900">Free Campaign</h3>
                    <p className="text-sm text-blue-800 mt-1">
                      Your first campaign and {recipientCount} association{recipientCount !== 1 ? 's are' : ' is'} included free with your plan! (Remaining Campaigns: {remainingCampaigns}, Extra Hub Credits: {extraHubsCredit})
                    </p>
                  </div>
                </div>
              </div>
            )} */}

            <Card className="bg-white rounded-xl sm:rounded-2xl border border-gray-200 overflow-hidden">
              <CardContent className="p-6 sm:p-8">
                {/* AI Powered Badge */}
                <div className="flex justify-center mb-6">
                  <div
                    className="
          inline-flex items-center gap-2
          px-6 py-3
          rounded-full
          bg-gradient-to-r from-blue-50 to-indigo-50
          border border-blue-200
          text-blue-700
          text-sm sm:text-base font-semibold
        "
                  >
                    <Sparkles className="h-4 w-4 text-blue-600" />
                    <span>
                      AI-powered predictions based on{" "}
                      <span className="font-bold text-blue-800">
                        {recipientCount.toLocaleString()}
                      </span>{" "}
                      {recipientCount === 1 ? "contact" : "contacts"}
                    </span>
                    {recipientCount === 0 && (
                      <span className="text-xs text-red-600 ml-2">⚠️ No recipients selected</span>
                    )}
                  </div>
                </div>

                {/* Main Score + Metrics */}
                <div className="flex flex-col items-center gap-8">
                  {/* Top Score Section */}
                  <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10 w-full max-w-3xl">
                    {/* Big Score Circle */}
                    <div className="flex items-center gap-5">
                      <div className="relative shrink-0">
                        <div
                          className="
                w-24 h-24 sm:w-28 sm:h-28 rounded-full
                bg-gradient-to-br from-blue-600 to-indigo-600
                flex items-center justify-center
                shadow-lg
              "
                        >
                          {aiLoading ? (
                            <div className="flex flex-col items-center justify-center">
                              <div className="animate-spin rounded-full h-8 w-8 border-2 border-white border-t-transparent"></div>
                              <span className="text-xs text-white mt-2 font-semibold">AI...</span>
                            </div>
                          ) : (
                            <span className="text-3xl sm:text-4xl font-extrabold text-white">
                              {predictions.engagementScore}%
                            </span>
                          )}
                        </div>
                        <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-md border border-gray-200">
                          {aiLoading ? (
                            <div className="animate-pulse h-5 w-5 bg-blue-400 rounded-full"></div>
                          ) : (
                            <CheckCircle2 className="h-5 w-5 text-emerald-600" />
                          )}
                        </div>
                      </div>

                      <div>
                        <p className="text-2xl sm:text-3xl font-bold text-gray-900">
                          {aiLoading ? "Calculating..." : "Excellent Engagement Score"}
                        </p>
                        <p className="text-sm text-gray-600 mt-1">
                          {aiLoading ? "AI is analyzing your campaign..." : "AI insights generated from your current contact data"}
                        </p>
                      </div>
                    </div>

                    {/* Metrics Cards */}
                    <div className="flex gap-4 sm:gap-6">
                      <div className="min-w-[110px] text-center px-5 py-4 bg-gradient-to-b from-gray-50 to-white rounded-xl border border-gray-200 shadow-sm">
                        <p className="text-3xl font-bold text-blue-600">
                          {predictions.openRate.toFixed(1)}%
                        </p>
                        <p className="text-sm font-medium text-gray-600 mt-1">Open Rate</p>
                      </div>

                      <div className="min-w-[110px] text-center px-5 py-4 bg-gradient-to-b from-gray-50 to-white rounded-xl border border-gray-200 shadow-sm">
                        <p className="text-3xl font-bold text-emerald-600">
                          {predictions.clickRate.toFixed(1)}%
                        </p>
                        <p className="text-sm font-medium text-gray-600 mt-1">Click Rate</p>
                      </div>
                    </div>
                  </div>

                  {/* ── Disclaimer (moved here - bottom center) ── */}
                  <div className="w-full max-w-2xl mt-2">
                    <div
                      className="
            bg-gradient-to-r from-gray-50/80 to-white/60
            backdrop-blur-sm
            border border-gray-200/70
            rounded-lg
            px-5 py-3.5
            text-sm text-gray-600
            italic
            flex items-start gap-3
            shadow-sm
          "
                    >
                      <Info className="mt-0.5 h-5 w-5 text-gray-400 flex-shrink-0" />
                      <p className="leading-relaxed">
                        {aiPrediction?.disclaimer ||
                          "This rating is an AI-generated estimate based on available data and should be considered a suggestion, not a definitive or guaranteed outcome."}
                      </p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* LAUNCH SUMMARY */}
            <Card className="bg-white rounded-xl sm:rounded-2xl border border-gray-200 transition-all duration-300 ease-out">
              <CardHeader className="pb-4">
                <CardTitle className="flex items-center gap-3">
                  <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-red-100">
                    <FileText className="h-4 w-4 text-[#ff1f1f]" />
                  </span>
                  <span className="text-lg sm:text-xl font-bold text-gray-900">
                    Launch Summary
                  </span>
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-0">
                <div className="space-y-4">
                  <div className="flex items-center justify-between py-3 border-b border-gray-100">
                    <span className="text-sm text-gray-600">Launch Type</span>
                    <span className="font-semibold text-gray-900 capitalize">
                      {campaignType}
                    </span>
                  </div>

                  <div className="flex items-center justify-between py-3 border-b border-gray-100">
                    <span className="text-sm text-gray-600">
                      {campaignType === "property" ? "Property" : "Service"}
                    </span>
                    <span className="font-semibold text-gray-900 truncate ">
                      {campaignType === "property"
                        ? selectedProperty?.title ||
                        propertyData.headline ||
                        "N/A"
                        : serviceData.title || serviceData.serviceType || "N/A"}
                    </span>
                  </div>

                  <div className="flex items-center justify-between py-3 border-b border-gray-100">
                    <span className="text-sm text-gray-600">Recipients</span>
                    <span className="font-semibold text-blue-600">
                      {recipientCount.toLocaleString()} contacts
                    </span>
                  </div>

                  <div className="flex items-center justify-between py-3 border-b border-gray-100">
                    <span className="text-sm text-gray-600">Send To</span>
                    <div className="text-right">
                      {sendTo.database && (
                        <span className="font-semibold text-gray-900 block">
                          LaunchIQ Database ({selectedDatasets.length}{" "}
                          hubs)
                        </span>
                      )}
                      {sendTo.mycontacts && (
                        <span className="font-semibold text-gray-900 block">
                          My Hubs ({selectedCustomDatasets.length} lists)
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="flex items-center justify-between py-3 border-b border-gray-100">
                    <span className="text-sm text-gray-600">Schedule</span>
                    <span className="font-semibold text-gray-900">
                      {scheduleOption === "now"
                        ? "Send Immediately"
                        : getEffectiveFirstScheduleDate()
                          ? formatUtcDisplay(getEffectiveFirstScheduleDate())
                          : "Scheduled"}
                    </span>
                  </div>

                  <div className="flex items-center justify-between py-3">
                    <span className="text-sm text-gray-600">
                      Predicted Opens
                    </span>
                    <span className="font-semibold text-emerald-600">
                      {predictions.estimatedOpens.toLocaleString()} (
                      {predictions.openRate.toFixed(1)}%)
                    </span>
                  </div>

                  {/* Billing Information */}
                  <div className="border-t border-gray-100 pt-4 mt-4">
                    <div className="flex items-center justify-between">
                      {/* <span className="text-sm font-semibold text-gray-900">
                        {needsPayment ? "Billing" : "Campaign Cost"}
                      </span> */}
                      {/* <div className="text-right">
                        {!needsPayment ? (
                          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-50 border border-green-200">
                            <CheckCircle2 className="h-4 w-4 text-green-600" />
                            <span className="text-sm font-semibold text-green-700">Free</span>
                          </span>
                        ) : paymentCompleted ? (
                          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-50 border border-green-200">
                            <CheckCircle2 className="h-4 w-4 text-green-600" />
                            <span className="text-sm font-semibold text-green-700">Paid</span>
                          </span>
                        ) : (
                          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-50 border border-amber-200">
                            <AlertCircle className="h-4 w-4 text-amber-600" />
                            <span className="text-sm font-semibold text-amber-700">Payment Pending</span>
                          </span>
                        )}
                      </div> */}
                    </div>

                    {/* {needsPayment && (
                      <div className="mt-3 space-y-2 text-sm">
                        <div className="flex items-center justify-between text-gray-600">
                          <span>1 Launch</span>
                          <span className="font-medium">${campaignAddOnPrice.toFixed(2)}</span>
                        </div>
                        <div className="flex items-center justify-between text-gray-600">
                          <span>{recipientCount} Association{recipientCount !== 1 ? 's' : ''}</span>
                          <span className="font-medium">${(recipientCount * associationAddOnPrice).toFixed(2)}</span>
                        </div>
                        <div className="border-t border-gray-200 pt-2 flex items-center justify-between font-semibold text-gray-900">
                          <span>Total</span>
                          <span>${(campaignAddOnPrice + (recipientCount * associationAddOnPrice)).toFixed(2)}</span>
                        </div>
                      </div>
                    )} */}
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* NAVIGATION */}
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-4">
              <Button
                variant="outline"
                onClick={() => requestStepNavigation(6)}
                size="lg"
                className="w-full sm:w-auto border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={currentStep === 8}
                title={currentStep === 8 ? "Step 8 is locked - use Launch to continue" : ""}
              >
                <ArrowLeft className="mr-2 h-5 w-5" />
                Back
              </Button>

              <Button
                className="
                  w-full sm:w-auto
                  bg-gradient-to-r from-blue-600 to-indigo-600
                  hover:from-blue-700 hover:to-indigo-700
                  text-white px-8 sm:px-12 py-5 sm:py-6
                  text-base sm:text-lg rounded-full
                  shadow-lg shadow-blue-500/30
                  transition-all duration-300 hover:shadow-xl hover:-translate-y-0.5
                "
                onClick={async () => {
                  if (!acceptedTerms) {
                    toast({
                      title: "Error",
                      description: "Please accept the terms.",
                      variant: "destructive",
                    });
                    return;
                  }

                  if (scheduleOption === "now") {
                    await handleSendCampaign(new Date().toISOString());
                  } else {
                    await handleSendCampaign();
                  }
                  // NOTE: Do NOT call setCurrentStep(9) here!
                  // handleSendCampaign will navigate to step 9 only if campaign creation succeeds
                }}
                disabled={planLoading || countLoading || recipientCount === 0 || (needsPayment && !paymentCompleted)}
                size="lg"
                title={needsPayment && !paymentCompleted ? "Complete payment before launching" : ""}
              >
                {planLoading || countLoading ? (
                  <>
                    <Loader2 className="mr-2 h-5 w-5 animate-spin" />
                    Processing...
                  </>
                ) : (
                  <>
                    <Send className="mr-2 h-5 w-5" />
                    Launch
                  </>
                )}
              </Button>
            </div>
          </div>
        );
      }

      // =========================================================================
      // STEP 9: Launch Success Confirmation
      // =========================================================================
      case 9:
        return (
          <div className="w-full max-w-4xl mx-auto space-y-6 py-8 px-2 sm:px-0">

            {/* Success Icon + Header */}
            <div className="text-center space-y-3">
              <div className="mx-auto w-20 h-20 sm:w-24 sm:h-24 bg-green-100 rounded-full flex items-center justify-center">
                <CheckCircle className="h-12 w-12 sm:h-16 sm:w-16 text-green-600" />
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold text-primary">
                See Your Results
              </h2>
              <p className="text-base sm:text-lg text-muted-foreground">
                Your launch has been created successfully!
              </p>
            </div>

            {/* You Will Receive Card */}
            <Card className="border shadow-sm">
              <CardContent className="p-4 sm:p-8 space-y-4 sm:space-y-6">
                <div className="flex items-center gap-3">
                  <Mail className="h-5 w-5 sm:h-6 sm:w-6 text-primary flex-shrink-0" />
                  <h3 className="text-lg sm:text-xl font-semibold">You Will Receive</h3>
                </div>

                <div className="space-y-4 ml-0 sm:ml-9">

                  {/* Purchase Confirmation */}
                  <div className="flex items-start gap-3">
                    <CheckCircle className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <div className="min-w-0">
                      <p className="font-medium text-sm sm:text-base">Purchase Confirmation Email</p>
                      <p className="text-xs sm:text-sm text-muted-foreground">
                        Sent immediately with your order details
                      </p>
                    </div>
                  </div>

                  {/* Launch Notification */}
                  <div className="flex items-start gap-3">
                    <CheckCircle className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <div className="min-w-0">
                      <p className="font-medium text-sm sm:text-base">Launch Notification</p>
                      <p className="text-xs sm:text-sm text-muted-foreground">
                        Sent when your Launch goes live
                      </p>
                    </div>
                  </div>

                  {/* 24-Hour Click Results */}
                  <div className="flex items-start gap-3">
                    {isProUser ? (
                      <CheckCircle className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                    ) : (
                      <XCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" />
                    )}
                    <div className="min-w-0">
                      {/* Title + badge on same line, badge wraps below if needed */}
                      <div className="flex flex-wrap items-center gap-1.5 mb-0.5">
                        <p className="font-medium text-sm sm:text-base">24-Hour Click Results Report</p>
                        {!isProUser && (
                          <Badge className="bg-blue-100 text-blue-800 text-xs whitespace-nowrap flex-shrink-0">
                            Pro Benefit
                          </Badge>
                        )}
                      </div>
                      <p className="text-xs sm:text-sm text-muted-foreground">
                        Detailed analytics sent 24 hours after launch
                      </p>
                    </div>
                  </div>

                  {/* SMS Notifications */}
                  <div className="flex items-start gap-3">
                    {isProUser ? (
                      <CheckCircle className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                    ) : (
                      <XCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" />
                    )}
                    <div className="min-w-0">
                      <div className="flex flex-wrap items-center gap-1.5 mb-0.5">
                        <p className="font-medium text-sm sm:text-base">SMS Notifications</p>
                        {!isProUser && (
                          <Badge className="bg-blue-100 text-blue-800 text-xs whitespace-nowrap flex-shrink-0">
                            Pro Benefit
                          </Badge>
                        )}
                      </div>
                      <p className="text-xs sm:text-sm text-muted-foreground">
                        You'll also receive SMS notifications for launch and results
                      </p>
                    </div>
                  </div>

                </div>
              </CardContent>
            </Card>

            {/* Launch Summary Card */}
            <Card className="border shadow-sm">
              <CardHeader className="pb-2 sm:pb-4">
                <CardTitle className="text-center text-lg sm:text-xl">Launch Summary</CardTitle>
              </CardHeader>
              <CardContent className="space-y-0 px-4 sm:px-6 pb-4 sm:pb-6">

                {/* Replace grid-cols-2 with explicit rows — label stacks above value on xs */}
                {[
                  {
                    label: "Launch Type",
                    value: <span className="capitalize">{campaignType}</span>,
                  },
                  {
                    label: campaignType === "service" ? "Service" : "Property",
                    value:
                      campaignType === "service"
                        ? serviceData.title || selectedService?.title || serviceData.serviceType || "N/A"
                        : selectedProperty?.title || propertyData.headline || "N/A",
                  },
                  {
                    label: "Template",
                    value: selectedServiceTemplate?.name || "Property Template",
                  },
                  {
                    label: "Recipients",
                    value: `${recipientCount.toLocaleString()} contacts`,
                  },
                  {
                    label: "Schedule",
                    value:
                      scheduleOption === "now"
                        ? isRecurringCampaign
                          ? `Recurring (${getRecurrenceTypeDisplayLabel(recurrenceType)})`
                          : "Sent Immediately"
                        : getEffectiveFirstScheduleDate()
                          ? formatUtcDisplay(getEffectiveFirstScheduleDate())
                          : "Scheduled for Later",
                  },
                ].map(({ label, value }, i) => (
                  <div
                    key={i}
                    className={`flex items-start justify-between gap-4 py-3 ${i !== 0 ? "border-t border-border" : ""
                      }`}
                  >
                    {/* Label — fixed width so values always align */}
                    <span className="text-sm sm:text-base text-muted-foreground flex-shrink-0 w-24 sm:w-32">
                      {label}:
                    </span>
                    {/* Value — min-w-0 + break-words so long strings wrap instead of overflow */}
                    <span className="text-sm sm:text-base font-semibold text-right break-words min-w-0">
                      {value}
                    </span>
                  </div>
                ))}

              </CardContent>
            </Card>

            {/* Action Buttons */}
            <div className="flex flex-col items-center gap-4 pb-4">
              <Button
                size="lg"
                className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white px-10 py-5 text-base sm:text-lg"
                onClick={() => {
                  setHasUnsavedChanges(false);
                  setPaymentCompleted(false);
                  setShowPaymentForm(false);
                  setPaymentIntentId(null);
                  navigate("/dashboard");
                }}
              >
                Go back to Dashboard
              </Button>

              <Button
                variant="link"
                size="lg"
                className="text-sm sm:text-base"
                onClick={() => {
                  setHasUnsavedChanges(false);
                  setCurrentStep(1);
                  setCampaignType(null);
                  setSelectedProperty(null);
                  setSelectedTemplate(null);
                  setSelectedDatasets([]);
                  setSelectedCustomDatasets([]);
                  setSubject("");
                  setAcceptedTerms(false);
                  setScheduleOption("now");
                  setSelectedDateTime("");
                  setProofSentCount(0);
                  setIsProofApproved(false);
                  setIsDirty(false);
                  toast({ title: "Starting New Launch", variant: "default" });
                  navigate("/builder");
                }}
              >
                Build another launch
              </Button>
            </div>

          </div>
        );

      default:
        return null;
    }
  };

  const DatasetCard: React.FC<{
    name: string;
    count: number;
    isSelected: boolean;
    onAdd: () => void;
    onRemove: () => void;
  }> = ({ name, count, isSelected, onAdd, onRemove }) => (
    <div
      className={`
      border rounded-lg p-4 transition-all duration-200
      ${isSelected
          ? "bg-primary/10 border-primary shadow-md ring-2 ring-primary/20"
          : "bg-background border-border hover:shadow-sm hover:border-primary/40"
        }
    `}
    >
      <div className="flex items-center justify-between">
        <span className="text-primary font-medium">
          {name} –{" "}
          <strong className="text-foreground">{count.toLocaleString()}</strong>
        </span>
        <Button
          variant={isSelected ? "destructive" : "default"}
          size="sm"
          onClick={isSelected ? onRemove : onAdd}
          className="min-w-20"
        >
          {isSelected ? "Remove" : "Add"}
        </Button>
      </div>
    </div>
  );

  const SummaryField: React.FC<{
    label: string;
    value: string;
    capitalize?: boolean;
  }> = ({ label, value, capitalize = false }) => (
    <div>
      <Label className="text-sm font-medium text-muted-foreground">
        {label}
      </Label>
      <p
        className={`text-primary font-semibold ${capitalize ? "capitalize" : ""
          }`}
      >
        {value}
      </p>
    </div>
  );
  const handleRegisterMobileToggle = useCallback((fn: () => void) => {
    setMobileMenuToggle(() => fn);
  }, []);

  // ───────────────────────── Guided (quiz) builder glue ─────────────────────────
  // The quiz screens only render/collect answers. Everything below reuses the
  // same state and rules as the classic screens.
  const switchBuilderUi = (mode: "quiz" | "classic") => {
    setUiMode(mode);
    try {
      localStorage.setItem("builder_ui_mode", mode);
    } catch (e) {
      /* preference is optional */
    }
  };

  const quizSetPropertyMulti = (on: boolean) => {
    setIsMultipleTemplateMode(on);
    if (!on) {
      try {
        sessionStorage.removeItem("isMultiPropertyMode");
        sessionStorage.removeItem("multiSelectedProperties");
        sessionStorage.removeItem("multiSelectedTemplateIds");
      } catch (e) { }
      setSelectedMultipleTemplates([]);
      setMultiSelectedProperties([]);
      setMultipleTemplatePropertyData(null);
      setIsAutoAIMode(false);
      setAutoAITemplateId(null);
      setSelectedTemplate(null);
    }
  };

  const quizSetServiceMulti = (on: boolean) => {
    setIsMultipleServiceTemplateMode(on);
    if (!on) {
      try {
        sessionStorage.removeItem("isMultiServiceMode");
        sessionStorage.removeItem("multiSelectedServices");
        sessionStorage.removeItem("multiSelectedServiceTemplateIds");
      } catch (e) { }
      setSelectedMultipleServiceTemplates([]);
      setMultiSelectedServices([]);
    }
  };

  const quizSelectPropertyTemplate = (template: any) => {
    try {
      sessionStorage.removeItem("isMultiPropertyMode");
      sessionStorage.removeItem("multiSelectedProperties");
      sessionStorage.removeItem("multiSelectedTemplateIds");
    } catch (e) { }
    setSelectedMultipleTemplates([]);
    setMultiSelectedProperties([]);
    setMultipleTemplatePropertyData(null);
    setIsMultipleTemplateMode(false);
    setSelectedTemplate({ ...template });
    setIsAutoAIMode(false);
    setAutoAITemplateId(null);
    try {
      sessionStorage.setItem("selectedTemplateId", String(template.id));
    } catch (e) { }
  };

  const quizTemplateContinue = () => {
    if (campaignType === "service") {
      if (!selectedServiceTemplate) {
        toast({
          title: "Select a Template",
          description: "Please select a template before continuing.",
          variant: "destructive",
          duration: 1000,
        });
        return;
      }
      try {
        sessionStorage.removeItem("isMultiServiceMode");
        sessionStorage.removeItem("multiSelectedServices");
        sessionStorage.removeItem("multiSelectedServiceTemplateIds");
      } catch (e) { }
      setSelectedMultipleServiceTemplates([]);
      setMultiSelectedServices([]);
      setIsMultipleServiceTemplateMode(false);
      setCurrentStep(4);
      return;
    }
    if (!selectedTemplate) {
      toast({
        title: "Select a Template",
        description: "Please select a template before continuing.",
        variant: "destructive",
        duration: 1000,
      });
      return;
    }
    if (!selectedProperty) {
      toast({
        title: "No Property Selected",
        description: "Please go back and select a property first.",
        variant: "destructive",
      });
      requestStepNavigation(2);
      return;
    }
    try {
      sessionStorage.removeItem("isMultiPropertyMode");
      sessionStorage.removeItem("multiSelectedProperties");
      sessionStorage.removeItem("multiSelectedTemplateIds");
    } catch (e) { }
    setSelectedMultipleTemplates([]);
    setMultiSelectedProperties([]);
    setMultipleTemplatePropertyData(null);
    setIsMultipleTemplateMode(false);
    setIsAutoAIMode(false);
    setAutoAITemplateId(null);
    setCurrentStep(4);
  };

  /** Same validation as the classic "Continue" on the recipients step. */
  const quizAudienceFinish = () => {
    try {
      setPlanLoading(true);
      const isInActiveTrial = user?.is_in_active_trial === true;
      const remainingTrialCampaigns = (user as any)?.remaining_trial_campaigns ?? 0;

      if (isInActiveTrial && !user?.plan && remainingTrialCampaigns <= 0) {
        toast({
          title: "Free Trial Limit Reached",
          description: `You've used all ${user?.trial_campaigns_limit ?? 0} free trial launches. Please upgrade or pay now to continue.`,
          variant: "destructive",
          duration: 3000,
        });
        if (user?.stripe_subscription_id) {
          setShowTrialPaymentModal(true);
        } else {
          setShowPricingModal(true);
        }
        setPlanLoading(false);
        return;
      }

      // Do not consume a trial launch here; this is only validation before step 6.
      setTrialValidated(true);
      setPlanLoading(false);
      setCurrentStep(6);
    } catch (err: any) {
      setPlanLoading(false);
      toast({
        title: "Error",
        description: "Could not validate trial status. Try again.",
        variant: "destructive",
      });
    }
  };

  // ── Guided schedule (step 6) glue: same rules as the classic radios/buttons ──
  const quizChooseSendNow = () => {
    setScheduleOption("now");
    setSelectedDateTime("");
    // Keep an applied recurring schedule when switching back to Send Now
    if (!recurringReviewConfirmed && !isRecurringCampaign) {
      setCheckoutData(null);
      setRecurringEndDate("");
      setCustomRecurringDates([]);
      setPaymentAmount(0);
      setRecurringReviewAmount(0);
      setShowPaymentForm(false);
    }
  };

  const quizChooseSchedule = () => {
    if (scheduleOption === "later") return;
    setScheduleOption("later");
    // Reset checkout data when switching to "Schedule Later"
    setCheckoutData(null);
    setPaymentAmount(0);
    setRecurringReviewAmount(0);
    setRecurringReviewConfirmed(false);
    setShowPaymentForm(false);
  };

  const quizFormatDisplay = (value: string) =>
    value
      ? formatDateTime(value, {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit",
          timeZoneName: "short",
        })
      : "";

  const quizFormatNow = () =>
    formatDateTime(new Date().toISOString(), {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });

  const quizScheduleCanContinue =
    acceptedTerms &&
    !(
      sendTo.database &&
      selectedDatasets.length === 0 &&
      !sendTo.mycontacts
    ) &&
    !(
      sendTo.mycontacts &&
      selectedCustomDatasets.length === 0 &&
      !sendTo.database
    );

  const quizNode = (
    <>
      <ConfigQuiz
        currentStep={currentStep}
        campaignType={campaignType}
        isMultipleTemplateMode={isMultipleTemplateMode}
        isMultipleServiceTemplateMode={isMultipleServiceTemplateMode}
        renderClassic={renderStepContent}
        needsClassicDialogs={
          (currentStep === 5 && (showSaveDraftDialog || showUpgradeModal)) ||
          (currentStep === 6 && showCheckoutModal)
        }
        onExit={() => navigate("/dashboard")}
        onSwitchToClassic={() => switchBuilderUi("classic")}
        goToStep={(n) => requestStepNavigation(n)}
        type={{
          campaignType,
          onSelectType: handleCampaignTypeSelect,
          hasDraft,
          propertyDraft,
          serviceDraft,
          draft,
          setDraft,
          setCampaignType,
          showDraftPreview,
          setShowDraftPreview,
          isDraftLoading,
          isDraftDeleting,
          onUseDraft: handleUseDraft,
          onDeleteDraft: handleDeleteDraft,
          launchSteps,
        }}
        property={{
          properties,
          loadingProperties,
          setMultiMode: quizSetPropertyMulti,
          onSelect: handlePropertySelect,
          onAdd: handlePropertyAdd,
          onDelete: handlePropertyDelete,
          setCampaignSubject: setSubject,
          getPropertyExpiry,
          formatExpiryMessage,
          userPlan,
          onEnhancedImageUpdate: (payload) =>
            handleEnhancedImageUpdate("property", payload as any),
          getFullUrl,
        }}
        service={{
          services: savedServices,
          loadingServices,
          setMultiMode: quizSetServiceMulti,
          onSelect: handleServiceSelect,
          onAdd: handleServiceAdd,
          onDelete: handleServiceDelete,
          setCampaignSubject: setSubject,
          onEnhancedImageUpdate: (payload) =>
            handleEnhancedImageUpdate("service", payload as any),
          getFullUrl,
        }}
        template={{
          propertyTemplates: MANUAL_PROPERTY_TEMPLATES,
          serviceTemplates,
          selectedPropertyTemplateId: selectedTemplate?.id ?? null,
          selectedServiceTemplateId: selectedServiceTemplate?.id ?? null,
          onSelectPropertyTemplate: quizSelectPropertyTemplate,
          onSelectServiceTemplate: handleSelectServiceTemplate,
          onContinue: quizTemplateContinue,
          PropertyTemplatePreview,
          ServiceTemplatePreview,
        }}
        audience={{
          sendTo,
          setSendTo,
          hasPlan: !!planDetails?.plan,
          isOnFreeTrial,
          hasHubAccess,
          openCampaignAddOn: () => setShowAddOnModalType("campaign"),
          openUpgrade: () => setShowUpgradeModal(true),
          stateOptions,
          statesLoading,
          selectedState,
          setSelectedState,
          agentLists,
          loadingStateAssociations,
          countySuggestions,
          suggestingCounties,
          selectedDatasets,
          setSelectedDatasets,
          onAddDataset: handleAddDataset,
          onRemoveDataset: handleRemoveDataset,
          customAgentLists,
          selectedCustomDatasets,
          setSelectedCustomDatasets,
          onAddCustom: handleAddCustomDataset,
          onRemoveCustom: handleRemoveCustomDataset,
          user,
          planLoading,
          onFinish: quizAudienceFinish,
          onManageHubs: () => navigate("/agent"),
        }}
        schedule={{
          scheduleOption,
          selectedDateTime,
          setSelectedDateTime,
          onChooseNow: quizChooseSendNow,
          onChooseLater: quizChooseSchedule,
          onPickRecommended: (value: string) => {
            setScheduleOption("later");
            setSelectedDateTime(value);
          },
          bestTimes: calculateBestSendTimes.recommendations,
          analysisFactors: calculateBestSendTimes.factors,
          effectiveTimezone,
          formatDisplay: quizFormatDisplay,
          formatNow: quizFormatNow,
          minDateTime: toDateInputValue(new Date().toISOString()),
          localToUtcIso,
          onChangeTimezone: () =>
            navigate("/settings?tab=profile", { replace: false }),
          isRecurringCampaign,
          recurrenceType,
          setRecurrenceType,
          recurringStartDateTime,
          setRecurringStartDateTime,
          recurringEndDate,
          setRecurringEndDate,
          customRecurringDates,
          setCustomRecurringDates,
          sortDates: sortDateStringsAscending,
          recurringCount: checkoutData?.recurringCount ?? null,
          buildRecurring: buildRecurringCheckoutData,
          applyRecurring: applyRecurringSchedule,
          removeRecurring: resetRecurring,
          showRecurringModal,
          setShowRecurringModal,
          acceptedTerms,
          setAcceptedTerms,
          canContinue: quizScheduleCanContinue,
          onContinue: handleStep6Continue,
        }}
      />
      <BotLauncher />
    </>
  );

  return (
    <div className="flex items-start min-h-screen">
      {uiMode === "quiz" ? (
        quizNode
      ) : (
      <>
      <Sidebar
        registerMobileToggle={handleRegisterMobileToggle}
        currentStep={currentStep}
        onLogoutAttemptOnStep8={() => {
          setPendingNavigation('/');
          setShowCompleteLaunchDialog(true);
        }}
        onCollapsedChange={setIsSidebarCollapsed}
      />

      <main className="flex min-w-0 flex-1 flex-col overflow-x-hidden">
        {/* Header */}
        <PageHeader
          // title="Launch Wizard"
          // description="Create your marketing launch in simple steps"
          mobileMenuOffset={true}
          onMenuClick={mobileMenuToggle ?? undefined}
          currentStep={currentStep}
          onLogoutAttemptOnStep8={() => {
            setPendingNavigation('/');
            setShowCompleteLaunchDialog(true);
          }}
        />

        <div className="flex justify-end px-3 pt-3 sm:px-4 lg:px-6">
          <Button
            variant="outline"
            size="sm"
            onClick={() => switchBuilderUi("quiz")}
            className="gap-1.5 rounded-full"
          >
            <Sparkles className="h-4 w-4" />
            Try the guided builder
          </Button>
        </div>

        {/* Main Content */}
        <div className="flex-1 overflow-x-hidden bg-white">
          <div className="mx-auto w-full max-w-7xl px-3 py-3 sm:px-4 sm:py-5 lg:px-6 lg:py-8">
            {/* Grid wrapper - change xl to lg */}
            {/* Grid wrapper */}
            <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-[64px_minmax(0,1fr)] xl:grid-cols-[280px_minmax(0,1fr)]">

              <aside className="hidden lg:flex lg:flex-col h-fit overflow-hidden rounded-xl border bg-white lg:p-2 xl:p-4 shadow-sm">
                <h3 className="hidden xl:block mb-3 text-base font-semibold">Launch Steps</h3>

                {/* Progress Bar */}
                <div className="hidden xl:block mb-4 h-2 w-full rounded-full bg-gray-200">
                  <div
                    className="bg-blue-600 h-2 rounded-full transition-all duration-500"
                    style={{ width: `${(currentStep / launchSteps.length) * 100}%` }}
                  />
                </div>

                {/* Step List */}
                <div className="flex flex-col gap-1">
                  {launchSteps.map((stepItem, index) => {
                    const stepNumber = index + 1;
                    const isActive = currentStep === stepNumber;
                    const isCompleted = currentStep > stepNumber;

                    return (
                      <div
                        key={stepNumber}
                        onClick={() => {
                          if (currentStep === stepNumber) return;
                          // Block all backward navigation when on step 9
                          if (currentStep === 9) return;
                          if (stepNumber > currentStep) {
                            toast({
                              title: "Complete Current Step First",
                              description: "Please finish the current step before moving forward.",
                              variant: "destructive",
                              duration: 1000,
                            });
                            return;
                          }
                          requestStepNavigation(stepNumber, undefined, true);
                        }}
                        className={`
    flex items-center justify-center xl:justify-start gap-2 rounded-lg lg:px-1 xl:px-2 py-2.5 transition-all
    ${isActive ? "bg-blue-50" : "hover:bg-gray-100"}
    ${stepNumber > currentStep ? "cursor-not-allowed opacity-70" : "cursor-pointer"}
  `}
                      >
                        {/* Circle */}
                        <div
                          className={`
                flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-xs font-bold
                ${isCompleted ? "bg-green-500 text-white"
                              : isActive ? "bg-blue-600 text-white"
                                : "bg-gray-300 text-gray-600"}
              `}
                        >
                          {isCompleted ? "✓" : stepNumber}
                        </div>

                        {/* Text - no truncate, allow wrap */}
                        {/* Text - hidden on lg, visible on xl+ */}
                        <div className="hidden xl:block min-w-0 flex-1">
                          <p className={`text-xs font-semibold leading-tight ${isActive ? "text-blue-900" : "text-gray-800"} ${stepNumber > currentStep ? "opacity-60" : ""}`}>
                            {stepItem.title}
                          </p>
                          <p className={`text-[10px] leading-tight text-muted-foreground mt-0.5 ${stepNumber > currentStep ? "opacity-50" : ""}`}>
                            {stepItem.subtitle}
                          </p>
                        </div>

                        {isActive && <ChevronRight className="hidden xl:block h-4 w-4 text-blue-600 flex-shrink-0" />}
                      </div>
                    );
                  })}
                </div>
              </aside>

              {/* Mobile/Tablet indicator - hidden on lg+ */}
              <div className="lg:hidden w-full">
                {/* Scrollable circles row */}
                <div className="flex items-center gap-3 rounded-xl border bg-white px-4 py-3 shadow-sm mb-4">
                  <div className="grid grid-cols-9 w-full gap-1">
                    {launchSteps.map((stepItem, index) => {
                      const stepNumber = index + 1;
                      const isActive = currentStep === stepNumber;
                      const isCompleted = currentStep > stepNumber;

                      return (
                        <div
                          key={stepNumber}
                          onClick={() => {
                            if (currentStep === stepNumber) return;
                            if (stepNumber > currentStep) return;
                            requestStepNavigation(stepNumber, undefined, true);
                          }}
                          className="flex flex-col items-center gap-1 cursor-pointer"
                        >
                          <div
                            className={`
      flex h-8 w-8 mx-auto items-center justify-center rounded-full text-xs font-bold transition-all
      ${isCompleted ? "bg-green-500 text-white"
                                : isActive ? "bg-blue-600 text-white ring-2 ring-blue-300"
                                  : "bg-gray-200 text-gray-500"}
    `}
                          >
                            {isCompleted ? "✓" : stepNumber}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Current step name + progress */}
                <div className="rounded-xl border bg-white px-4 py-3 shadow-sm mb-4">
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                      <div className="flex h-7 w-7 items-center justify-center rounded-full bg-blue-600 text-white text-xs font-bold">
                        {currentStep}
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-gray-900">
                          {launchSteps[currentStep - 1]?.title}
                        </p>
                        <p className="text-xs text-muted-foreground">
                          {launchSteps[currentStep - 1]?.subtitle}
                        </p>
                      </div>
                    </div>
                    <span className="text-xs text-muted-foreground font-medium">
                      {currentStep}/{launchSteps.length}
                    </span>
                  </div>
                  {/* Progress bar */}
                  <div className="h-1.5 w-full rounded-full bg-gray-200">
                    <div
                      className="h-1.5 rounded-full bg-blue-600 transition-all duration-500"
                      style={{ width: `${(currentStep / launchSteps.length) * 100}%` }}
                    />
                  </div>
                </div>
              </div>

              {/* Step Content */}
              <section className="w-full min-w-0 self-start overflow-x-hidden rounded-xl border bg-white px-3 pt-3 pb-4 sm:px-4 sm:pt-5 sm:pb-5">
                {renderStepContent()}
              </section>

            </div>
          </div>
        </div>
        {/* <CallingBot />
        <Chatbot /> */}
        <BotLauncher />
      </main>
      </>
      )}

      {/* Add-On Modal (association vs campaign) */}
      {/* <Dialog
        open={showAddOnModalType !== null}
        onOpenChange={(open) => {
          if (!open) setShowAddOnModalType(null);
        }}
      >
        <DialogContent className="max-w-2xl w-full">
          <DialogHeader>
            <DialogTitle>
              {showAddOnModalType === "association"
                ? "Association Add-Ons"
                : "Campaign Add-Ons & Upgrades"}
            </DialogTitle>
            <DialogDescription>
              {showAddOnModalType === "association"
                ? "You have no remaining association credits for this month. Purchase an association add-on to continue sending campaigns to more associations."
                : "You've reached your campaign sending limit. Upgrade your plan or buy a campaign add-on to send more launches."}
            </DialogDescription>
          </DialogHeader>

          <div className="mt-4">
            {showAddOnModalType === "association" ? (
              // association-specific add-ons (separate component)
              <AssociationAddOn />
            ) : (
              // campaign upgrades - show pricing component for plan upgrades
              <Pricing />
            )}
          </div>

          <div className="flex justify-end mt-4">
            <Button
              variant="outline"
              onClick={() => setShowAddOnModalType(null)}
            >
              Close
            </Button>
          </div>
        </DialogContent>
      </Dialog> */}


      <Dialog
        open={showAddOnModalType === "campaign"}
        onOpenChange={(open) => !open && setShowAddOnModalType(null)}
      >
        <DialogContent className="max-w-7xl w-full max-h-[95vh] overflow-y-auto p-0 border-none bg-transparent shadow-none">

          <div className="bg-background rounded-xl p-6">
            <Pricing
              inModal
              onPlanSelected={async (selectedPlan, checkoutUrl) => {
                const isOneTimeSelected = Boolean(selectedPlan?.is_one_time) ||
                  selectedPlan?.billing_cycle === "one_time" ||
                  /one[-_ ]?time/i.test(selectedPlan?.name || "");

                if (checkoutUrl && isOneTimeSelected) {
                  window.location.href = checkoutUrl;
                  return;
                }

                if (checkoutUrl && !isOneTimeSelected) {
                  sessionStorage.setItem("pendingCheckoutUrl", checkoutUrl);
                }

                if (isOneTimeSelected && selectedPlan && !checkoutUrl) {
                  try {
                    const { data: refreshedUserRaw } = await axiosInstance.get(endpoints.me);
                    const refreshedUser = refreshedUserRaw?.user ?? refreshedUserRaw;
                    setUser(refreshedUser);
                    setPlanDetails(refreshedUser);
                    // Keep the local credit balances used for billing in sync —
                    // without this, the just-activated free launch isn't reflected
                    // until a full page reload, and the payment step wrongly
                    // charges for what should be the free included launch.
                    setRemainingCampaigns(refreshedUser.get_remaining_campaigns || 0);
                    setExtraHubsCredit(refreshedUser.extra_hubs_credit || 0);
                    setExtraLaunchCredits(refreshedUser.extra_launch_credits || 0);
                    localStorage.setItem("user", JSON.stringify(refreshedUser));
                    localStorage.setItem("has_plan", refreshedUser.plan ? "true" : "false");
                    sessionStorage.setItem("user", JSON.stringify(refreshedUser));
                    window.dispatchEvent(new Event("user-updated"));
                  } catch (err) {
                    console.error("Failed to refresh user after one-time plan activation:", err);
                  }
                  setSelectedPricingPlan(selectedPlan);
                }

                setShowAddOnModalType(null);
                handleBuyPlanClick();
              }}
            />
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        open={showTrialPaymentModal}
        onOpenChange={(open) => {
          if (!open) setShowTrialPaymentModal(false);
        }}
      >
        <DialogContent className="sm:max-w-xl rounded-2xl p-0 overflow-hidden flex flex-col max-h-[90vh]">
          <div className="p-8 sm:p-10 space-y-7 overflow-y-auto flex-1">
            <DialogHeader className="space-y-4 text-left">
              <div className="flex items-center gap-4">
                <div className="h-12 w-12 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center">
                  <AlertTriangle className="h-6 w-6" />
                </div>
                <DialogTitle className="text-2xl font-semibold text-gray-900">
                  Activate your subscription?
                </DialogTitle>
              </div>
              <DialogDescription className="text-lg leading-8 text-gray-600">
                Your free trial send limit has been reached. Activating your subscription will unlock your full plan credits so you can continue sending without interruption.
              </DialogDescription>
            </DialogHeader>

            {(() => {
              const totalSends = pendingTrialActivation?.totalSends || 1;
              const trialCredits = pendingTrialActivation?.trialCredits || 0;
              const planCredits = pendingTrialActivation?.planCredits || 0;
              const combinedCredits = trialCredits + planCredits;
              const planCreditsUsed = Math.min(planCredits, Math.max(0, totalSends - trialCredits));
              const paidExtraSends = Math.max(0, totalSends - combinedCredits);
              const totalCreditsApplied = Math.min(totalSends, combinedCredits);

              return (
                <>
                  <div className="rounded-xl bg-stone-50 p-6 space-y-4">
                    <p className="text-sm font-semibold uppercase tracking-wide text-stone-500">
                      Free Trial Summary
                    </p>
                    <div className="space-y-3 text-lg">
                      <div className="flex items-center justify-between gap-4">
                        <span className="text-stone-700">Free trial limit</span>
                        <span className="font-semibold text-stone-900">
                          {trialCredits} send{trialCredits === 1 ? "" : "s"}
                        </span>
                      </div>
                      <div className="flex items-center justify-between gap-4">
                        <span className="text-stone-700">Plan Launch available</span>
                        <span className="font-semibold text-stone-900">
                          {planCredits} send{planCredits === 1 ? "" : "s"}
                        </span>
                      </div>
                      <div className="flex items-center justify-between gap-4">
                        <span className="text-stone-700">Total selected</span>
                        <span className="font-semibold text-stone-900">
                          {totalSends} send{totalSends === 1 ? "" : "s"}
                        </span>
                      </div>
                      <div className="border-t border-stone-200 pt-4 flex items-center justify-between gap-4">
                        <span className="font-semibold text-amber-800">Total Launch used</span>
                        <span className="font-semibold text-amber-800">
                          {totalCreditsApplied} send
                          {totalCreditsApplied === 1 ? "" : "s"}
                        </span>
                      </div>
                      {paidExtraSends > 0 && (
                        <div className="flex items-center justify-between gap-4">
                          <span className="font-semibold text-red-700">Extra sends require payment</span>
                          <span className="font-semibold text-red-700">
                            {paidExtraSends} send{paidExtraSends === 1 ? "" : "s"}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="rounded-xl bg-blue-100 p-5 flex items-start gap-3 text-blue-700">
                    <Info className="h-5 w-5 mt-1 shrink-0" />
                    {/* <p className="text-base leading-7">
                      Your free trial activates your plan immediately. {trialCredits} trial send{trialCredits === 1 ? " is" : "s are"} free, {planCreditsUsed} send{planCreditsUsed === 1 ? "" : "s"} will be deducted from your plan credits{paidExtraSends > 0 ? `, and ${paidExtraSends} extra send${paidExtraSends === 1 ? "" : "s"} will continue to payment.` : "."}
                    </p> */}
                    <p className="text-base leading-7">
                      Once activated, your full plan credits will be available immediately and all plan features will be unlocked.
                    </p>
                  </div>
                </>
              );
            })()}

            <DialogFooter className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Button
                type="button"
                variant="outline"
                className="h-14 text-base font-semibold"
                onClick={() => {
                  setShowTrialPaymentModal(false);
                  setPendingTrialActivation(null);
                  if (scheduleOption === "later") {
                    setShowRecurringModal(true);
                  }
                }}
                disabled={trialPaymentLoading}
              >
                No, go back
              </Button>
              <Button
                type="button"
                className="h-14 bg-orange-600 hover:bg-orange-700 text-white text-base font-semibold"
                onClick={handleEndTrialNow}
                disabled={trialPaymentLoading}
              >
                {trialPaymentLoading ? "Processing..." : "Yes, activate now"}
              </Button>
            </DialogFooter>
          </div>
        </DialogContent>
      </Dialog>

      {/* ========== PROFILE INCOMPLETE NOTIFICATION MODAL ========== */}
      <Dialog open={showProfileIncompleteModal} onOpenChange={setShowProfileIncompleteModal}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-lg bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              <AlertCircle className="h-5 w-5 text-blue-600" />
              Complete Your Profile
            </DialogTitle>
            <DialogDescription>
              Welcome! To get the most out of LaunchIQ, please complete your profile.
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-4">
            <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-sm font-semibold text-blue-900 mb-3">Missing Information:</p>
              <ul className="space-y-2">
                {missingProfileFields.map((field, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-blue-800">
                    <div className="h-2 w-2 rounded-full bg-blue-500" />
                    {field}
                  </li>
                ))}
              </ul>
            </div>

            <p className="text-sm text-gray-600">
              Complete these details in your profile settings so we can properly display your information in your launches.
            </p>
          </div>

          <DialogFooter className="flex gap-3">
            <Button
              type="button"
              variant="outline"
              onClick={() => setShowProfileIncompleteModal(false)}
            >
              Later
            </Button>
            <Button
              type="button"
              onClick={() => {
                setShowProfileIncompleteModal(false);
                // Navigate to settings with profile tab
                window.location.href = '/settings?tab=profile';
              }}
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              Go to Profile Settings
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog
        open={showCompleteLaunchDialog}
        onOpenChange={(open) => {
          if (!open) cancelCompleteLaunchLeave();
        }}
      >
        <DialogContent className="sm:max-w-md rounded-2xl">
          <DialogHeader>
            <DialogTitle>Complete Your Launch</DialogTitle>
            <DialogDescription>
              You’ve completed the payment, but your launch has not been sent yet. Leaving this step now may interrupt the process, and your launch will remain incomplete until you return and click “Launch.”
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="flex gap-3">
            <Button type="button" variant="outline" onClick={cancelCompleteLaunchLeave} className="bg-blue-600 hover:bg-blue-700 hover:text-white text-white">
              Stay Here
            </Button>
            {/* <Button type="button" onClick={confirmCompleteLaunchLeave} className="bg-blue-600 hover:bg-blue-700 text-white">
              Leave Anyway
            </Button> */}
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* ========== LEAVE PAGE - SAVE DRAFT DIALOG ========== */}
      <Dialog open={showLeaveDraftDialog} onOpenChange={(open) => {
        if (!open) {
          resetLeaveDraftDialogState();
        }
      }}>
        <DialogContent
          onCloseAutoFocus={(event) => event.preventDefault()}
          className="w-[95vw] max-w-xl p-0 overflow-hidden rounded-2xl border border-gray-200 shadow-xl bg-white max-h-[90vh] overflow-y-auto"
        >
          {/* Header with gradient background */}
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-4 sm:px-6 py-4 sm:py-5">
            <div className="flex items-center gap-2 sm:gap-3">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
                <AlertTriangle className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
              </div>
              <div className="min-w-0">
                <DialogTitle className="text-lg sm:text-xl font-bold text-white truncate">
                  Save Your Progress?
                </DialogTitle>
                <DialogDescription className="text-blue-100 mt-0.5 text-sm">
                  Don't lose your campaign progress
                </DialogDescription>
              </div>
            </div>
          </div>

          <div className="px-4 sm:px-6 py-4 sm:py-5 overflow-y-auto">
            {/* Current Step Indicator */}
            <div className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 bg-blue-50 rounded-xl border border-blue-100 mb-4 sm:mb-5">
              <div className="relative flex-shrink-0">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-blue-600 flex items-center justify-center shadow-lg">
                  <span className="text-white font-bold text-lg sm:text-xl">{draftStepToSave}</span>
                </div>
                <div className="absolute -bottom-1 -right-1 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-white border-2 border-blue-500 flex items-center justify-center">
                  <span className="text-[10px] sm:text-xs font-bold text-blue-600">/{launchSteps.length}</span>
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-gray-900 text-base sm:text-lg truncate">
                  {launchSteps[draftStepToSave - 1]?.title || 'Unknown Step'}
                </p>
                <p className="text-xs sm:text-sm text-gray-500 truncate">
                  {launchSteps[draftStepToSave - 1]?.subtitle || ''}
                </p>
                {/* Progress bar */}
                <div className="mt-2 w-full bg-gray-200 rounded-full h-1.5">
                  <div
                    className="bg-blue-600 h-1.5 rounded-full transition-all duration-500"
                    style={{ width: `${(draftStepToSave / launchSteps.length) * 100}%` }}
                  />
                </div>
              </div>
            </div>

            {/* What will be saved - Card Grid */}
            <div className="mb-4 sm:mb-5">
              <div className="flex items-center gap-2 mb-2 sm:mb-3">
                <FileText className="h-4 w-4 text-gray-500 flex-shrink-0" />
                <p className="text-xs sm:text-sm font-semibold text-gray-700">Your saved progress includes:</p>
              </div>

              {/* Responsive Grid: 1 column on mobile, 2 columns on sm+ */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {/* Campaign Type */}
                {campaignType && (
                  <div className="flex items-center gap-2 sm:gap-2.5 p-2.5 sm:p-3 bg-white rounded-lg border border-gray-100 shadow-sm">
                    <div className={`w-7 h-7 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${campaignType === 'property' ? 'bg-blue-100' : 'bg-purple-100'
                      }`}>
                      {campaignType === 'property' ? (
                        <Home className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-blue-600" />
                      ) : (
                        <Briefcase className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-purple-600" />
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[10px] sm:text-xs text-gray-500">Type</p>
                      <p className="text-xs sm:text-sm font-medium text-gray-900 capitalize truncate">{campaignType}</p>
                    </div>
                    <CheckCircle className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 flex-shrink-0" />
                  </div>
                )}

                {/* Property/Service - Show based on step */}
                {draftStepToSave >= 2 && campaignType === 'property' && (selectedProperty || propertyData?.headline) && (
                  <div className="flex items-center gap-2 sm:gap-2.5 p-2.5 sm:p-3 bg-white rounded-lg border border-gray-100 shadow-sm">
                    <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-emerald-100 flex items-center justify-center flex-shrink-0">
                      <MapPin className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-emerald-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[10px] sm:text-xs text-gray-500">Property</p>
                      <p className="text-xs sm:text-sm font-medium text-gray-900 truncate">
                        {propertyData?.headline || selectedProperty?.title || 'Selected'}
                      </p>
                    </div>
                    <CheckCircle className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 flex-shrink-0" />
                  </div>
                )}

                {draftStepToSave >= 2 && campaignType === 'service' && (selectedService || serviceData?.title) && (
                  <div className="flex items-center gap-2 sm:gap-2.5 p-2.5 sm:p-3 bg-white rounded-lg border border-gray-100 shadow-sm">
                    <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0">
                      <Briefcase className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-purple-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[10px] sm:text-xs text-gray-500">Service</p>
                      <p className="text-xs sm:text-sm font-medium text-gray-900 truncate">
                        {serviceData?.title || selectedService?.title || 'Selected'}
                      </p>
                    </div>
                    <CheckCircle className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 flex-shrink-0" />
                  </div>
                )}

                {/* Template */}
                {draftStepToSave >= 3 && (selectedTemplate || selectedServiceTemplate) && (
                  <div className="flex items-center gap-2 sm:gap-2.5 p-2.5 sm:p-3 bg-white rounded-lg border border-gray-100 shadow-sm">
                    <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-pink-100 flex items-center justify-center flex-shrink-0">
                      <Layout className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-pink-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[10px] sm:text-xs text-gray-500">Template</p>
                      <p className="text-xs sm:text-sm font-medium text-gray-900 truncate">
                        {selectedTemplate?.name || selectedServiceTemplate?.name}
                      </p>
                    </div>
                    <CheckCircle className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 flex-shrink-0" />
                  </div>
                )}

                {/* Subject */}
                {draftStepToSave >= 4 && subject && subject.trim() !== "" && (
                  <div className="flex items-center gap-2 sm:gap-2.5 p-2.5 sm:p-3 bg-white rounded-lg border border-gray-100 shadow-sm">
                    <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-amber-100 flex items-center justify-center flex-shrink-0">
                      <Mail className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-amber-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[10px] sm:text-xs text-gray-500">Subject</p>
                      <p className="text-xs sm:text-sm font-medium text-gray-900 truncate">
                        {subject.length > 20 ? subject.substring(0, 20) + '...' : subject}
                      </p>
                    </div>
                    <CheckCircle className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 flex-shrink-0" />
                  </div>
                )}

                {/* Key Features */}
                {draftStepToSave >= 4 && keyFeatures && keyFeatures.length > 0 && (
                  <div className="flex items-center gap-2 sm:gap-2.5 p-2.5 sm:p-3 bg-white rounded-lg border border-gray-100 shadow-sm">
                    <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-cyan-100 flex items-center justify-center flex-shrink-0">
                      <Star className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-cyan-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[10px] sm:text-xs text-gray-500">Features</p>
                      <p className="text-xs sm:text-sm font-medium text-gray-900">{keyFeatures.length} items</p>
                    </div>
                    <CheckCircle className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 flex-shrink-0" />
                  </div>
                )}

                {/* Recipients */}
                {draftStepToSave >= 5 && (selectedDatasets.length > 0 || selectedCustomDatasets.length > 0) && (
                  <div className="flex items-center gap-2 sm:gap-2.5 p-2.5 sm:p-3 bg-white rounded-lg border border-gray-100 shadow-sm">
                    <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-indigo-100 flex items-center justify-center flex-shrink-0">
                      <Users className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-indigo-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[10px] sm:text-xs text-gray-500">Recipients</p>
                      <p className="text-xs sm:text-sm font-medium text-gray-900">
                        {selectedDatasets.length + selectedCustomDatasets.length} list(s)
                      </p>
                    </div>
                    <CheckCircle className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 flex-shrink-0" />
                  </div>
                )}

                {/* Schedule */}
                {draftStepToSave >= 6 && (
                  <div className="flex items-center gap-2 sm:gap-2.5 p-2.5 sm:p-3 bg-white rounded-lg border border-gray-100 shadow-sm">
                    <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-teal-100 flex items-center justify-center flex-shrink-0">
                      <Calendar className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-teal-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[10px] sm:text-xs text-gray-500">Schedule</p>
                      <p className="text-xs sm:text-sm font-medium text-gray-900">
                        {scheduleOption === 'now' ? 'Send Now' : 'Scheduled'}
                      </p>
                    </div>
                    <CheckCircle className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 flex-shrink-0" />
                  </div>
                )}

                {/* Payment */}
                {draftStepToSave >= 7 && (
                  <div className="flex items-center gap-2 sm:gap-2.5 p-2.5 sm:p-3 bg-white rounded-lg border border-gray-100 shadow-sm">
                    <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-green-100 flex items-center justify-center flex-shrink-0">
                      <CreditCard className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[10px] sm:text-xs text-gray-500">Payment</p>
                      <p className="text-xs sm:text-sm font-medium text-gray-900">
                        {paymentCompleted ? 'Completed' : 'Pending'}
                      </p>
                    </div>
                    <CheckCircle className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 flex-shrink-0" />
                  </div>
                )}
              </div>
            </div>

            {/* Info & Warning Boxes */}
            <div className="space-y-2 sm:space-y-3">
              {/* Success Info */}
              <div className="flex items-start gap-2 sm:gap-3 p-3 sm:p-4 bg-blue-50 rounded-xl border border-blue-200">
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                  <Save className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600" />
                </div>
                <div className="min-w-0">
                  <p className="text-xs sm:text-sm font-semibold text-blue-800">Your draft will be saved</p>
                  <p className="text-xs sm:text-sm text-blue-700 mt-0.5">
                    Continue from <strong>Step {draftStepToSave}</strong> anytime from your Drafts.
                  </p>
                </div>
              </div>

              {/* Warning */}
              <div className="flex items-start gap-2 sm:gap-3 p-3 sm:p-4 bg-red-50 rounded-xl border border-red-200">
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
                  <XCircle className="h-4 w-4 sm:h-5 sm:w-5 text-red-600" />
                </div>
                <div className="min-w-0">
                  <p className="text-xs sm:text-sm font-semibold text-red-800">Don't lose your work</p>
                  <p className="text-xs sm:text-sm text-red-700 mt-0.5">
                    Leaving without saving will delete all progress.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Footer with Actions - Stacked on mobile */}
          <div className="px-4 sm:px-6 py-3 sm:py-4 bg-gray-50 border-t flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
            {/* Mobile: Primary action first, Desktop: Last */}
            <div className="order-1 sm:order-3 w-full sm:w-auto">
              <Button
                onClick={handleSaveDraftOnLeave}
                disabled={isDraftSaving}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white shadow-lg text-sm sm:text-base"
              >
                {isDraftSaving ? (
                  <>
                    <Loader2 className="h-4 w-4 animate-spin mr-2" />
                    Saving...
                  </>
                ) : (
                  <>
                    <Save className="h-4 w-4 mr-2" />
                    Save & Leave
                  </>
                )}
              </Button>
            </div>

            {/* Spacer - Desktop only */}
            <div className="hidden sm:block sm:flex-1 sm:order-2" />

            {/* Secondary actions */}
            <div className="order-2 sm:order-1 flex gap-2 w-full sm:w-auto">
              <Button
                variant="outline"
                onClick={handleCancelLeaveDraft}
                className="flex-1 sm:flex-none text-sm sm:text-base"
              >
                <ArrowLeft className="h-4 w-4 mr-1 sm:mr-2" />
                <span className="hidden xs:inline">Stay</span>
                <span className="xs:hidden">Back</span>
              </Button>

              <Button
                type="button"
                variant="ghost"
                onClick={() => {
                  console.log('[Discard & Leave Button] Clicked');
                  handleLeaveWithoutSaving();
                }}
                className="flex-1 sm:flex-none text-red-600 hover:text-red-700 hover:bg-red-50 text-sm sm:text-base"
              >
                <Trash2 className="h-4 w-4 mr-1 sm:mr-2" />
                Discard
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      {/* ========== DRAFT OVERWRITE WARNING DIALOG ========== */}
      <Dialog open={showDraftOverwriteDialog} onOpenChange={(open) => {
        if (!open) handleCancelDraftOverwrite();
      }}>
        <DialogContent className="w-[95vw] max-w-xl max-h-[90vh] p-0 overflow-hidden rounded-2xl border shadow-xl bg-white">

          {/* Header */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-500 px-6 py-5">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-full bg-white/20 flex items-center justify-center">
                <AlertTriangle className="h-5 w-5 text-white" />
              </div>
              <div>
                <DialogTitle className="text-lg font-semibold text-white">
                  Overwrite Existing Draft?
                </DialogTitle>
                <DialogDescription className="text-blue-100 text-sm mt-0.5">
                  You already have a saved draft for this campaign.
                </DialogDescription>
              </div>
            </div>
          </div>

          <div className="px-6 py-6 space-y-5 max-h-[65vh] overflow-y-auto">

            {/* Existing Draft */}
            {existingDraftInfo && (
              <div className="p-4 bg-gray-50 border rounded-xl">
                <div className="flex items-start gap-3">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${existingDraftInfo.type === 'property' ? 'bg-blue-100' : 'bg-purple-100'
                    }`}>
                    {existingDraftInfo.type === 'property' ? (
                      <Home className="h-5 w-5 text-blue-600" />
                    ) : (
                      <Briefcase className="h-5 w-5 text-purple-600" />
                    )}
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <Badge variant="secondary" className="text-xs">
                        {existingDraftInfo.type === 'property' ? 'Property' : 'Service'} Draft
                      </Badge>
                      <Badge className="bg-gray-200 text-gray-700 text-xs">
                        Step {existingDraftInfo.step}
                      </Badge>
                    </div>

                    <h4 className="font-medium text-gray-900 truncate">
                      {existingDraftInfo.title}
                    </h4>

                    {existingDraftInfo.updatedAt && (
                      <p className="text-xs text-gray-500 mt-1 flex items-center gap-1">
                        <Clock className="h-3 w-3" />
                        Updated {existingDraftInfo.updatedAt}
                      </p>
                    )}

                    <div className="mt-3">
                      <div className="flex justify-between text-xs text-gray-500 mb-1">
                        <span>Progress</span>
                        <span>{existingDraftInfo.step}/{launchSteps.length}</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-1.5">
                        <div
                          className="bg-blue-500 h-1.5 rounded-full"
                          style={{ width: `${(existingDraftInfo.step / launchSteps.length) * 100}%` }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Warning */}
            <div className="flex gap-3 p-4 bg-red-50 border border-red-200 rounded-xl">
              <XCircle className="h-5 w-5 text-red-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-red-800">
                  This will permanently replace your existing draft.
                </p>
                <p className="text-sm text-red-700 mt-1">
                  Your previous progress cannot be recovered.
                </p>
              </div>
            </div>

            {/* New Draft Info */}
            <div className="flex gap-3 p-4 bg-blue-50 border border-blue-200 rounded-xl">
              <Save className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-blue-800">
                  New draft to be saved
                </p>
                <p className="text-sm text-blue-700 mt-1">
                  {campaignType === 'property'
                    ? (propertyData?.headline || selectedProperty?.title || 'Current Property Campaign')
                    : (serviceData?.title || selectedService?.title || 'Current Service Campaign')
                  } — Step {currentStep}
                </p>
              </div>
            </div>

            {/* Tip */}
            <p className="text-xs text-gray-500">
              You can only have one draft per campaign type.
            </p>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 bg-gray-50 border-t flex flex-col sm:flex-row gap-3">

            <Button
              variant="outline"
              onClick={handleCancelDraftOverwrite}
              className="w-full sm:w-auto"
            >
              Cancel
            </Button>

            <Button
              variant="ghost"
              onClick={() => {
                setShowDraftOverwriteDialog(false);
                setPendingDraftSaveCallback(null);

                if (existingDraftInfo?.type === 'property' && propertyDraft) {
                  setDraft(propertyDraft);
                  setShowDraftPreview(true);
                } else if (existingDraftInfo?.type === 'service' && serviceDraft) {
                  setDraft(serviceDraft);
                  setShowDraftPreview(true);
                }

                setExistingDraftInfo(null);
              }}
              className="w-full sm:w-auto text-blue-600 hover:bg-blue-50"
            >
              Use Existing Draft
            </Button>

            <div className="flex-1 hidden sm:block" />

            <Button
              onClick={handleConfirmDraftOverwrite}
              disabled={isDraftSaving}
              className="w-full sm:w-auto bg-red-600 hover:bg-red-700 text-white"
            >
              {isDraftSaving ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin mr-2" />
                  Saving...
                </>
              ) : (
                "Overwrite & Save"
              )}
            </Button>
          </div>

        </DialogContent>
      </Dialog>
      <Dialog
        open={stepClickTarget !== null}
        onOpenChange={(open) => {
          if (!open) handleCancelStepNav();
        }}
      >
        <DialogContent
          className="
    w-[calc(100vw-48px)]
    max-w-[520px]
    rounded-2xl
    bg-white
    p-5
    sm:p-6
    shadow-xl
    border-0
  "

        >
          <DialogHeader className="space-y-3">
            <DialogTitle
              className="
          text-center
          text-lg
          sm:text-xl
          font-semibold
          text-[#14213D]
        "
            >
              Navigate to another step?
            </DialogTitle>

            <DialogDescription
              className="
          text-center
          text-sm
          sm:text-base
          leading-7
          text-[#667085]
        "
            >
              Going to a different step will discard any unsaved
              changes and reset progress. Are you sure you want
              to continue?
            </DialogDescription>
          </DialogHeader>

          <div
            className="
        mt-6
        flex
        flex-col
        sm:flex-row
        gap-3
      "
          >
            <Button
              variant="outline"
              onClick={handleCancelStepNav}
              className="
          w-full
          h-12
          rounded-xl
          text-base
        "
            >
              Cancel
            </Button>

            <Button
              onClick={handleConfirmStepNav}
              className="
          w-full
          h-12
          rounded-xl
          bg-red-600
          hover:bg-red-700
          text-white
          text-base
        "
            >
              Yes, Continue
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        open={showTemplateEditLeaveModal}
        onOpenChange={(open) => {
          if (!open) handleTemplateEditModalStay();
        }}
      >
        <DialogContent
          className="
      w-[calc(100vw-48px)]
      max-w-[520px]
      rounded-2xl
      bg-white
      p-5
      sm:p-6
      shadow-xl
      border-0
    "
        >
          <button
            type="button"
            onClick={handleTemplateEditModalStay}
            aria-label="Close"
            className="
        absolute
        top-4
        right-4
        rounded-xl
        p-2
        text-[#667085]
        hover:bg-gray-100
        hover:text-[#14213D]
        transition-colors
        
        custom-close-btn
      "
          >
            <X className="h-5 w-5" />
          </button>

          <DialogHeader className="space-y-3">
            <DialogTitle
              className="
          text-center
          text-lg
          sm:text-xl
          font-semibold
          text-[#14213D]
        "
            >
              Unsaved Changes
            </DialogTitle>

            <DialogDescription
              className="
          text-center
          text-sm
          sm:text-base
          leading-7
          text-[#667085]
        "
            >
              You have unsaved changes. Do you want to save your changes before leaving this page?
            </DialogDescription>
          </DialogHeader>

          <div
            className="
        mt-6
        flex
        flex-col
        sm:flex-row
        gap-3
      "
          >
            <Button
              variant="outline"
              onClick={handleTemplateEditModalDiscard}
              className="
          w-full
          h-12
          rounded-xl
          text-base
          border-red-200
          text-red-600
          hover:bg-red-50
        "
            >
              Discard
            </Button>

            <Button
              onClick={handleTemplateEditModalSave}
              className="
          w-full
          h-12
          rounded-xl
          bg-blue-600
          hover:bg-blue-700
          text-white
          text-base
        "
              disabled={isSavingTemplateEditLeave}
            >
              {isSavingTemplateEditLeave ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Saving...
                </>
              ) : (
                "Save & Leave"
              )}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

    </div>
  );
}
